
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6c95"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6c95"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("96HUf", function(module, exports) {

$parcel$export(module.exports, "resetSceneButton", function () { return $6a16bb76f73d4368$export$8da03248cdcfe1a3; });
$parcel$export(module.exports, "viewer", function () { return $6a16bb76f73d4368$export$7dea6024c4894e8e; });
$parcel$export(module.exports, "data", function () { return $6a16bb76f73d4368$export$4051a07651545597; });

var $emWKU = parcelRequire("emWKU");

var $d94HJ = parcelRequire("d94HJ");
const $6a16bb76f73d4368$var$panoElement = document.getElementById("pano");
const $6a16bb76f73d4368$export$8da03248cdcfe1a3 = document.getElementById("request-view-reset");
const $6a16bb76f73d4368$var$viewerOpts = {
    controls: {
        mouseViewMode: "drag",
        scrollZoom: true
    }
};
const $6a16bb76f73d4368$export$7dea6024c4894e8e = new $d94HJ.Viewer($6a16bb76f73d4368$var$panoElement, $6a16bb76f73d4368$var$viewerOpts);
var $6a16bb76f73d4368$var$e, $6a16bb76f73d4368$var$view;
// const tourLinkHotspot = SCENES[0].linkHotspots[0]
const $6a16bb76f73d4368$var$tourInfoHotspot = (0, $emWKU.SCENES)[0].infoHotspots[0];
// const tourLinkHotspotLookToValues = {
//     yaw: tourLinkHotspot?.yaw,
//     pitch: tourLinkHotspot?.pitch,
//     rotation: tourLinkHotspot?.rotation
// };
const $6a16bb76f73d4368$var$tourLookToInfoHotspot = {
    yaw: $6a16bb76f73d4368$var$tourInfoHotspot?.yaw,
    pitch: $6a16bb76f73d4368$var$tourInfoHotspot?.pitch,
    rotation: $6a16bb76f73d4368$var$tourInfoHotspot?.rotation
};
const $6a16bb76f73d4368$export$4051a07651545597 = {
    scenes: (0, $emWKU.SCENES),
    name: `Pampered Chef - ${"Fall 2024"} VR Kitchen`,
    settings: {
        mouseViewMode: "drag",
        autorotateEnabled: false,
        fullscreenButton: false
    },
    tourParams: {
        tourSection1: $6a16bb76f73d4368$var$tourLookToInfoHotspot
    }
};

});
parcelRegister("emWKU", function(module, exports) {

$parcel$export(module.exports, "SCENES", function () { return $a760b26c56c09f66$export$d3112996f706f1c; });

var $cy4lp = parcelRequire("cy4lp");
const $a760b26c56c09f66$export$d3112996f706f1c = [
    (0, $cy4lp.KITCHEN_ISLAND)
];

});
parcelRegister("cy4lp", function(module, exports) {

$parcel$export(module.exports, "KITCHEN_ISLAND", function () { return $922c07b81080a7a2$export$c7323ca0efd38c6; });
const $922c07b81080a7a2$export$c7323ca0efd38c6 = {
    id: "2-kitchen-island",
    name: "Kitchen Island",
    levels: [
        {
            tileSize: 256,
            size: 256,
            fallbackOnly: true
        },
        {
            tileSize: 512,
            size: 512
        },
        {
            tileSize: 512,
            size: 1024
        },
        {
            tileSize: 512,
            size: 2048
        }
    ],
    faceSize: 2048,
    initialViewParameters: {
        yaw: -0.0005943935503509579,
        pitch: 0.6074701054373062,
        fov: 1.1252406777618285
    },
    linkHotspots: [],
    infoHotspots: [
        {
            class: "intro-starter",
            yaw: -0.6296041741844114,
            pitch: 0.6541907464738905,
            title: "Stoneware Starter Set",
            text: `
				<div class="multi-product-container">
					<div class="multi-product-wrapper">
						<section class="section">
							<ul class="multi-product-list">
								<h3 class="section-title">Stoneware Starter Set <b>(#100292)</b></h3>
									You can make perfect pizzas every time with the Pizza Stone, create easy 
									sheet-pan dinners on the Stone Bar Pan, and bake delicious banana bread 
									in the Stone Loaf Pan.
									<br/><br/>
									Great for new cooks, first-time homeowners, college students, and empty 
									nesters ready to refresh their kitchen!
							</ul>
						</section>
					</div>
				</div>
			`,
            images: [
                `<img width="640" alt="vrk-fall24-kitchen-stoneware-set-02.jpg" src="https://pamperedchef.widen.net/content/5k85rti50a/jpeg/vrk-fall24-kitchen-stoneware-set-02.jpg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="vrk-fall24-kitchen-stoneware-set-03.jpg" src="https://pamperedchef.widen.net/content/ravvaott1o/jpeg/vrk-fall24-kitchen-stoneware-set-03.jpg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="vrk-fall24-kitchen-stoneware-set-04.jpg" src="https://pamperedchef.widen.net/content/i5mhy2gmca/jpeg/vrk-fall24-kitchen-stoneware-set-04.jpg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`
            ],
            videos: [
                `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe src="https://pamperedchef.widen.net/view/video/vdtkygdz1k/video-tiktok-homemade-pizza-dough-usca.mp4?u=intbhg" webkitallowfullscreen mozallowfullscreen allowfullscreen title="Video for &quot;video-tiktok-homemade-pizza-dough-usca.mp4&quot;" frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>`
            ]
        },
        {
            yaw: 0.09754898793619304,
            pitch: 0.5661444781747988,
            title: "Cutlery Basics Set",
            text: `
				<div class="multi-product-container">
					<div class="multi-product-wrapper">
						<section class="section">
							<ul class="multi-product-list">
								<h3 class="section-title">Cutlery Basics Set <b>(#101419)</b></h3>
									All the essential cutting tools new kitchens need. First, you need a few 
									different size cutting boards for any prep task. Then, a variety of knife sizes 
									and styles for a variety of foods\u{2014}the right knife for the job makes a 
									difference! And lastly, quality steak knives for enjoying those heartier meals.
									<br/><br/>
									Great for new cooks, first-time homeowners, college students, and empty 
									nesters ready to refresh their kitchen!
							</ul>
						</section>
					</div>
				</div>
			`,
            images: [
                `<img width="640" alt="vrk-fall24-kitchen-cutlery-set-02.jpg" src="https://pamperedchef.widen.net/content/wykkhg3wsy/jpeg/vrk-fall24-kitchen-cutlery-set-02.jpg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="vrk-fall24-kitchen-cutlery-set-03.jpg" src="https://pamperedchef.widen.net/content/wx4mk7xtbl/jpeg/vrk-fall24-kitchen-cutlery-set-03.jpg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="vrk-fall24-kitchen-cutlery-set-04.jpg" src="https://pamperedchef.widen.net/content/geiplrrpwa/jpeg/vrk-fall24-kitchen-cutlery-set-04.jpg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`
            ],
            videos: [
                `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe src="https://pamperedchef.widen.net/view/video/i5bgiz0xtk/video-product-ss23-coated-knife-set-social-loop-usca.mp4?u=intbhg" webkitallowfullscreen mozallowfullscreen allowfullscreen title="Video for &quot;video-product-ss23-coated-knife-set-social-loop-usca.mp4&quot;" frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>`
            ]
        },
        {
            yaw: 0.5808080655022643,
            pitch: 0.5253043154516455,
            title: "Cookie Baking Set",
            text: `
				<div class="multi-product-container">
					<div class="multi-product-wrapper">
						<section class="section">
							<ul class="multi-product-list">
								<h3 class="section-title">Cookie Baking Set <b>(#101420)</b></h3>
									The perfect way to get into baking or stock your kitchen with quality baking 
									essentials.
									With two heavy-duty <b>Cookie Sheets</b> to bake up a storm, a <b>Medium Scoop</b> 
									for perfectly portioned cookies, two <b>Stackable Cooling Racks</b> for cooling 
									and decorating, and a <b>Teal Mini Nylon Serving Spatula</b> to easy move and 
									serve your delicious creations.
									<br/><br/>
									Great for new cooks, first-time homeowners, college students, and empty 
									nesters ready to refresh their kitchen!
							</ul>
						</section>
					</div>
				</div>
			`,
            images: [
                `<img width="640" alt="vrk-fall24-kitchen-cookie-set-01.jpg" src="https://pamperedchef.widen.net/content/pc6wlek2rl/jpeg/vrk-fall24-kitchen-cookie-set-01.jpg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="vrk-fall24-kitchen-cookie-set-02.jpg" src="https://pamperedchef.widen.net/content/w7jlkmo6mj/jpeg/vrk-fall24-kitchen-cookie-set-02.jpg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="vrk-fall24-kitchen-cookie-set-03.jpg" src="https://pamperedchef.widen.net/content/hdyfi7vkuo/jpeg/vrk-fall24-kitchen-cookie-set-03.jpg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="vrk-fall24-kitchen-cookie-set-04.jpg" src="https://pamperedchef.widen.net/content/ht3kkgfuhi/jpeg/vrk-fall24-kitchen-cookie-set-04.jpg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`
            ]
        },
        {
            yaw: -0.3836619982848326,
            pitch: 0.20475223119669828,
            title: "Utensil Starter Set",
            text: `
				<div class="multi-product-container">
					<div class="multi-product-wrapper">
						<section class="section">
							<ul class="multi-product-list">
								<h3 class="section-title">Utensil Starter Set <b>(#101418)</b></h3>
									Every cook needs quality kitchen essentials. This set has a mix of durable, 
									silicone basics, along with a few multi-functional tools that make it super 
									easy to do many tasks with just one tool, and less dishes! All together, they 
									easily fit into the compact and sleek utensil holder that looks great on any 
									counter.
									<br/><br/>
									Great for new cooks, first-time homeowners, college students, and empty 
									nesters ready to refresh their kitchen!
							</ul>
						</section>
					</div>
				</div>
			`,
            images: [
                `<img width="640" alt="vrk-fall24-kitchen-utensil-set-03.jpg" src="https://pamperedchef.widen.net/content/i1ld1kj2xl/jpeg/vrk-fall24-kitchen-utensil-set-03.jpg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="vrk-fall24-kitchen-utensil-set-04.jpg" src="https://pamperedchef.widen.net/content/q2trshiakq/jpeg/vrk-fall24-kitchen-utensil-set-04.jpg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`
            ],
            videos: [
                `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe src="https://pamperedchef.widen.net/view/video/sqzih8dnsq/video-product-whisk-tongs-usca.mp4?u=intbhg" webkitallowfullscreen mozallowfullscreen allowfullscreen title="Video for &quot;video-product-whisk-tongs-usca.mp4&quot;" frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>`,
                `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe src="https://pamperedchef.widen.net/view/video/lfpki6ejpx/video-product-mix-n-chop-spatula-2022-4x5-usca.mp4?u=intbhg" webkitallowfullscreen mozallowfullscreen allowfullscreen title="Video for &quot;video-product-mix-n-chop-spatula-2022-4x5-usca.mp4&quot;" frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>`
            ]
        },
        {
            yaw: 0.012833724448508832,
            pitch: 0.11378186415693747,
            title: "Brilliance Cookware Set",
            text: `
				<div class="multi-product-container">
					<div class="multi-product-wrapper">
						<section class="section">
							<ul class="multi-product-list">
								<h3 class="section-title">5-Piece Brilliance Nonstick Cookware Set <b>(#100772)</b></h3>
									Start your cookware collection or add a pop of color to it with this five-piece 
									set! It includes all the basic pieces you'll need to make delicious, no-fuss 
									meals every day. With high-quality nonstick coatings on the inside and 
									outside of this cookware, you can be sure your food will slide right out\u{2014}and 
									because it's dishwasher-safe, cleanup has never been easier.
									<br/><br/>
									Great for new cooks, first-time homeowners, college students, and empty 
									nesters ready to refresh their kitchen!
							</ul>
						</section>
					</div>
				</div>
			`,
            images: [
                `<img width="640" alt="vrk-fall24-kitchen-cookware-03.jpg" src="https://pamperedchef.widen.net/content/w0jqaqoecm/jpeg/vrk-fall24-kitchen-cookware-set-03.jpg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="vrk-fall24-kitchen-cookware-04.jpg" src="https://pamperedchef.widen.net/content/dr4o1v9mzw/jpeg/vrk-fall24-kitchen-cookware-set-04.jpg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`
            ],
            videos: [
                `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe src="https://pamperedchef.widen.net/view/video/qmzocoozsq/video-tiktok-how-to-cook-and-brown-ground-beef-usca.mp4?u=intbhg" webkitallowfullscreen mozallowfullscreen allowfullscreen title="Video for &quot;video-tiktok-how-to-cook-and-brown-ground-beef-usca.mp4&quot;" frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>`,
                `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe src="https://pamperedchef.widen.net/view/video/b0ae5frcvx/video-tiktok-how-to-make-a-perfect-omelet-in-5-minutes-usca.mp4?u=intbhg" webkitallowfullscreen mozallowfullscreen allowfullscreen title="Video for &quot;video-tiktok-how-to-make-a-perfect-omelet-in-5-minutes-usca.mp4&quot;" frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>`
            ]
        }
    ]
};

});


parcelRegister("d94HJ", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";






































































module.exports = {
    // Stages.
    WebGlStage: (parcelRequire("jgcBG")),
    CssStage: (parcelRequire("kgURn")),
    FlashStage: (parcelRequire("lUg8r")),
    // Renderers.
    WebGlCubeRenderer: (parcelRequire("b7h3a")),
    WebGlFlatRenderer: (parcelRequire("6yDfP")),
    WebGlEquirectRenderer: (parcelRequire("iIThc")),
    CssCubeRenderer: (parcelRequire("48tXO")),
    CssFlatRenderer: (parcelRequire("aYyo6")),
    FlashCubeRenderer: (parcelRequire("aK6y2")),
    FlashFlatRenderer: (parcelRequire("51qT1")),
    registerDefaultRenderers: (parcelRequire("kjZKr")),
    // Geometries.
    CubeGeometry: (parcelRequire("4QGnk")),
    FlatGeometry: (parcelRequire("l1BkT")),
    EquirectGeometry: (parcelRequire("bI46y")),
    // Views.
    RectilinearView: (parcelRequire("63xsq")),
    FlatView: (parcelRequire("9iOfn")),
    // Sources.
    ImageUrlSource: (parcelRequire("3vK5M")),
    SingleAssetSource: (parcelRequire("lEiVO")),
    // Assets.
    StaticAsset: (parcelRequire("4Qk7S")),
    DynamicAsset: (parcelRequire("iB2Tl")),
    // Texture store.
    TextureStore: (parcelRequire("8U6hQ")),
    // Layer.
    Layer: (parcelRequire("gouN9")),
    // Render loop.
    RenderLoop: (parcelRequire("h0UOQ")),
    // Controls.
    KeyControlMethod: (parcelRequire("kniT1")),
    DragControlMethod: (parcelRequire("efdW7")),
    QtvrControlMethod: (parcelRequire("kjQCu")),
    ScrollZoomControlMethod: (parcelRequire("fCy8Y")),
    PinchZoomControlMethod: (parcelRequire("2cyzb")),
    VelocityControlMethod: (parcelRequire("joYne")),
    ElementPressControlMethod: (parcelRequire("b7OCs")),
    Controls: (parcelRequire("rtmgR")),
    Dynamics: (parcelRequire("bqWZD")),
    // High-level API.
    Viewer: (parcelRequire("kkazn")),
    Scene: (parcelRequire("9kjMi")),
    // Hotspots.
    Hotspot: (parcelRequire("028gl")),
    HotspotContainer: (parcelRequire("a3AC3")),
    // Effects.
    colorEffects: (parcelRequire("j8BiC")),
    // Miscellaneous functions.
    registerDefaultControls: (parcelRequire("9aEkC")),
    autorotate: (parcelRequire("eoK70")),
    // Utility functions.
    util: {
        async: (parcelRequire("11mTq")),
        cancelize: (parcelRequire("bMUVO")),
        chain: (parcelRequire("61A4i")),
        clamp: (parcelRequire("eCQUD")),
        clearOwnProperties: (parcelRequire("2Xxut")),
        cmp: (parcelRequire("3nhrd")),
        compose: (parcelRequire("arsG2")),
        convertFov: (parcelRequire("hmySL")),
        decimal: (parcelRequire("asoyN")),
        defaults: (parcelRequire("9eJDl")),
        defer: (parcelRequire("9aPxp")),
        degToRad: (parcelRequire("82Ddh")),
        delay: (parcelRequire("7OILR")),
        dom: (parcelRequire("dBMHD")),
        extend: (parcelRequire("iozi5")),
        hash: (parcelRequire("4j7qz")),
        inherits: (parcelRequire("Yar88")),
        mod: (parcelRequire("iZgBB")),
        noop: (parcelRequire("exIfG")),
        now: (parcelRequire("azWbw")),
        once: (parcelRequire("9ZuRa")),
        pixelRatio: (parcelRequire("lNra6")),
        radToDeg: (parcelRequire("jSacE")),
        real: (parcelRequire("0OTzd")),
        retry: (parcelRequire("2uuGq")),
        tween: (parcelRequire("28mhx")),
        type: (parcelRequire("fXp6t"))
    },
    // Expose dependencies for clients to use.
    dependencies: {
        bowser: (parcelRequire("W9Vbx")),
        glMatrix: (parcelRequire("d1IHX")),
        eventEmitter: (parcelRequire("6mia6")),
        hammerjs: (parcelRequire("bTkIC"))
    }
};

});
parcelRegister("jgcBG", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $7wjV9 = parcelRequire("7wjV9");

var $5k1DD = parcelRequire("5k1DD");

var $dfwu4 = parcelRequire("dfwu4");

var $W9Vbx = parcelRequire("W9Vbx");

var $Yar88 = parcelRequire("Yar88");

var $lNra6 = parcelRequire("lNra6");

var $6InGT = parcelRequire("6InGT");

var $dBMHD = parcelRequire("dBMHD");
var $e0594a60b4b76785$require$setAbsolute = $dBMHD.setAbsolute;

var $dBMHD = parcelRequire("dBMHD");
var $e0594a60b4b76785$require$setFullSize = $dBMHD.setFullSize;

var $2Xxut = parcelRequire("2Xxut");
var $e0594a60b4b76785$var$debug = typeof MARZIPANODEBUG !== "undefined" && MARZIPANODEBUG.webGl;
// Browser-specific workarounds.
var $e0594a60b4b76785$var$browserQuirks = {
    // Whether to use texImage2D instead of texSubImage2D when repainting an
    // existing texture from a video element. On most browsers texSubImage2D is
    // faster, but on Chrome the performance degrades significantly. See:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=612542
    videoUseTexImage2D: $W9Vbx.chrome
};
function $e0594a60b4b76785$var$initWebGlContext(canvas, opts) {
    var options = {
        alpha: true,
        premultipliedAlpha: true,
        antialias: !!(opts && opts.antialias),
        preserveDrawingBuffer: !!(opts && opts.preserveDrawingBuffer)
    };
    if ($e0594a60b4b76785$var$debug && typeof WebGLDebugUtils !== "undefined") {
        console.log("Using WebGL lost context simulator");
        canvas = WebGLDebugUtils.makeLostContextSimulatingCanvas(canvas);
    }
    // Keep support/WebGl.js in sync with this.
    var gl = canvas.getContext && (canvas.getContext("webgl", options) || canvas.getContext("experimental-webgl", options));
    if (!gl) throw new Error("Could not get WebGL context");
    if ($e0594a60b4b76785$var$debug && typeof WebGLDebugUtils !== "undefined") {
        gl = WebGLDebugUtils.makeDebugContext(gl);
        console.log("Using WebGL debug context");
    }
    return gl;
}
/**
 * @class WebGlStage
 * @extends Stage
 * @classdesc
 *
 * A {@link Stage} implementation using WebGl.
 *
 * @param {Object} opts
 * @param {boolean} [opts.antialias=false]
 * @param {boolean} [opts.preserveDrawingBuffer=false]
 * @param {boolean} [opts.generateMipmaps=false]
 *
 * The `antialias` and `preserveDrawingBuffer` options control the WebGL
 * context attributes of the same name. The `alpha` and `premultipliedAlpha`
 * WebGL context attributes are set to their default true value and cannot
 * be overriden; this allows semitransparent textures to be composited with
 * the page. See:
 * https://www.khronos.org/registry/webgl/specs/1.0/#WEBGLCONTEXTATTRIBUTES
 *
 * The `generateMipmaps` option controls texture mipmap generation. Mipmaps
 * may improve rendering quality, at the cost of increased memory usage.
 * Due to technical limitations, they are only generated for textures whose
 * dimensions are a power of two. See:
 * https://www.khronos.org/webgl/wiki/WebGL_and_OpenGL_Differences#Non-Power_of_Two_Texture_Support
 *
 * Also see the available {@link Stage} options.
 */ function $e0594a60b4b76785$var$WebGlStage(opts) {
    opts = opts || {};
    var self = this;
    this.constructor.super_.call(this, opts);
    this._generateMipmaps = opts.generateMipmaps != null ? opts.generateMipmaps : false;
    this._loader = new $5k1DD(this);
    this._domElement = document.createElement("canvas");
    $e0594a60b4b76785$require$setAbsolute(this._domElement);
    $e0594a60b4b76785$require$setFullSize(this._domElement);
    this._gl = $e0594a60b4b76785$var$initWebGlContext(this._domElement, opts);
    this._handleContextLoss = function() {
        self.emit("webglcontextlost");
        self._gl = null;
    };
    // Handle WebGl context loss.
    this._domElement.addEventListener("webglcontextlost", this._handleContextLoss);
    // WebGl renderers are singletons for a given stage. This list stores the
    // existing renderers so they can be reused across layers with the same
    // geometry and view type.
    this._rendererInstances = [];
}
$Yar88($e0594a60b4b76785$var$WebGlStage, $7wjV9);
/**
 * Destructor.
 */ $e0594a60b4b76785$var$WebGlStage.prototype.destroy = function() {
    this._domElement.removeEventListener("webglcontextlost", this._handleContextLoss);
    // Delegate clearing own properties to the Stage destructor.
    this.constructor.super_.prototype.destroy.call(this);
};
$e0594a60b4b76785$var$WebGlStage.supported = function() {
    return $dfwu4();
};
/**
 * Returns the underlying DOM element.
 *
 * @return {Element}
 */ $e0594a60b4b76785$var$WebGlStage.prototype.domElement = function() {
    return this._domElement;
};
/**
 * Returns the underlying WebGL rendering context.
 *
 * @return {WebGLRenderingContext }
 */ $e0594a60b4b76785$var$WebGlStage.prototype.webGlContext = function() {
    return this._gl;
};
$e0594a60b4b76785$var$WebGlStage.prototype.setSizeForType = function() {
    // Update the size of the canvas coordinate space.
    //
    // The size is obtained by taking the stage dimensions, which are set in CSS
    // pixels, and multiplying them by the device pixel ratio. Crucially, this
    // must be the only place where the WebGL rendering pipeline accesses the
    // pixel ratio; subsequent uses should reference the `drawingBufferWidth` and
    // `drawingBufferHeight` properties on the WebGLRenderingContext. Failing to
    // do so will break the rendering if the pixel ratio changes but the stage
    // size does not, e.g. when moving the window across screens.
    var ratio = $lNra6();
    this._domElement.width = ratio * this._width;
    this._domElement.height = ratio * this._height;
};
$e0594a60b4b76785$var$WebGlStage.prototype.loadImage = function(url, rect, done) {
    return this._loader.loadImage(url, rect, done);
};
$e0594a60b4b76785$var$WebGlStage.prototype.maxTextureSize = function() {
    return this._gl.getParameter(this._gl.MAX_TEXTURE_SIZE);
};
$e0594a60b4b76785$var$WebGlStage.prototype.validateLayer = function(layer) {
    var tileSize = layer.geometry().maxTileSize();
    var maxTextureSize = this.maxTextureSize();
    if (tileSize > maxTextureSize) throw new Error("Layer has level with tile size larger than maximum texture size (" + tileSize + " vs. " + maxTextureSize + ")");
};
$e0594a60b4b76785$var$WebGlStage.prototype.createRenderer = function(Renderer) {
    var rendererInstances = this._rendererInstances;
    for(var i = 0; i < rendererInstances.length; i++){
        if (rendererInstances[i] instanceof Renderer) return rendererInstances[i];
    }
    var renderer = new Renderer(this._gl);
    rendererInstances.push(renderer);
    return renderer;
};
$e0594a60b4b76785$var$WebGlStage.prototype.destroyRenderer = function(renderer) {
    var rendererInstances = this._rendererInstances;
    if (this._renderers.indexOf(renderer) < 0) {
        renderer.destroy();
        var index = rendererInstances.indexOf(renderer);
        if (index >= 0) rendererInstances.splice(index, 1);
    }
};
$e0594a60b4b76785$var$WebGlStage.prototype.startFrame = function() {
    var gl = this._gl;
    if (!gl) throw new Error("Bad WebGL context - maybe context was lost?");
    // Set the WebGL viewport.
    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    // Clear framebuffer.
    gl.clearColor(0.0, 0.0, 0.0, 0.0);
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
    // Enable depth testing.
    gl.enable(gl.DEPTH_TEST);
    // Enable blending. ONE and ONE_MINUS_SRC_ALPHA are the right choices for
    // premultiplied textures.
    gl.enable(gl.BLEND);
    gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
};
$e0594a60b4b76785$var$WebGlStage.prototype.endFrame = function() {};
$e0594a60b4b76785$var$WebGlStage.prototype.takeSnapshot = function(options) {
    // Validate passed argument
    if (typeof options !== "object" || options == null) options = {};
    var quality = options.quality;
    // Set default quality if it is not passed
    if (typeof quality == "undefined") quality = 75;
    // Throw if quality is of invlid type or out of bounds
    if (typeof quality !== "number" || quality < 0 || quality > 100) throw new Error("WebGLStage: Snapshot quality needs to be a number between 0 and 100");
    // Canvas method "toDataURL" needs to be called in the same
    // context as where the actual rendering is done. Hence this.
    this.render();
    // Return the snapshot
    return this._domElement.toDataURL("image/jpeg", quality / 100);
};
$e0594a60b4b76785$var$WebGlStage.type = $e0594a60b4b76785$var$WebGlStage.prototype.type = "webgl";
function $e0594a60b4b76785$var$WebGlTexture(stage, tile, asset) {
    this._stage = stage;
    this._gl = stage._gl;
    this._texture = null;
    this._timestamp = null;
    this._width = this._height = null;
    this.refresh(tile, asset);
}
$e0594a60b4b76785$var$WebGlTexture.prototype.refresh = function(tile, asset) {
    var gl = this._gl;
    var stage = this._stage;
    var texture;
    // Check whether the texture needs to be updated.
    var timestamp = asset.timestamp();
    if (timestamp === this._timestamp) return;
    // Get asset element.
    var element = asset.element();
    // Get asset dimensions.
    var width = asset.width();
    var height = asset.height();
    if (width !== this._width || height !== this._height) {
        // If the texture dimensions have changed since the last refresh, create
        // a new texture with the correct size.
        // Check if texture dimensions would exceed the maximum texture size.
        var maxSize = stage.maxTextureSize();
        if (width > maxSize) throw new Error("Texture width larger than max size (" + width + " vs. " + maxSize + ")");
        if (height > maxSize) throw new Error("Texture height larger than max size (" + height + " vs. " + maxSize + ")");
        // Delete the current texture if it exists.
        // This is necessary for Chrome on Android. If it isn't done the textures
        // do not render when the size changes.
        if (this._texture) gl.deleteTexture(texture);
        // The texture must be premultiplied by alpha to ensure correct blending of
        // semitransparent textures. For details, see:
        // http://www.realtimerendering.com/blog/gpus-prefer-premultiplication/
        texture = this._texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, element);
    } else {
        // If the texture dimensions remain the same, repaint the existing texture.
        // Repainting with texSubImage2D is usually faster than with texImage2D,
        // except in the case noted in browserQuirks.
        texture = this._texture;
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
        gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, true);
        if (element instanceof HTMLVideoElement && $e0594a60b4b76785$var$browserQuirks.videoUseTexImage2D) gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, element);
        else gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, gl.RGBA, gl.UNSIGNED_BYTE, element);
    }
    // Generate mipmap if the corresponding stage option is set and the texture
    // dimensions are powers of two.
    if (stage._generateMipmaps && $6InGT(width) && $6InGT(height)) {
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
        gl.generateMipmap(gl.TEXTURE_2D);
    } else {
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    }
    // Clamp texture to edges.
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    // Unbind texture.
    gl.bindTexture(gl.TEXTURE_2D, null);
    // Update texture dimensions and timestamp.
    this._timestamp = timestamp;
    this._width = width;
    this._height = height;
};
$e0594a60b4b76785$var$WebGlTexture.prototype.destroy = function() {
    if (this._texture) this._gl.deleteTexture(this._texture);
    $2Xxut(this);
};
$e0594a60b4b76785$var$WebGlStage.TextureClass = $e0594a60b4b76785$var$WebGlStage.prototype.TextureClass = $e0594a60b4b76785$var$WebGlTexture;
module.exports = $e0594a60b4b76785$var$WebGlStage;

});
parcelRegister("7wjV9", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $6mia6 = parcelRequire("6mia6");

var $hluEj = parcelRequire("hluEj");

var $8pjZz = parcelRequire("8pjZz");

var $11mTq = parcelRequire("11mTq");

var $bMUVO = parcelRequire("bMUVO");

var $2Xxut = parcelRequire("2Xxut");

var $bYEal = parcelRequire("bYEal");
function $579af966673ff6bc$var$forwardTileCmp(t1, t2) {
    return t1.cmp(t2);
}
function $579af966673ff6bc$var$reverseTileCmp(t1, t2) {
    return -t1.cmp(t2);
}
/**
 * Signals that the stage has been rendered.
 *
 * @param {boolean} stable Whether all tiles were successfully rendered without
 *     missing textures or resorting to fallbacks.
 * @event Stage#renderComplete
 */ /**
 * Signals that the contents of the stage have been invalidated and must be
 * rendered again.
 *
 * This is used by the {@link RenderLoop} implementation.
 *
 * @event Stage#renderInvalid
 */ /**
 * @interface Stage
 * @classdesc
 *
 * A Stage is a container with the ability to render a stack of
 * {@link Layer layers}.
 *
 * This is a superclass containing logic that is common to all implementations;
 * it should never be instantiated directly. Instead, use one of the
 * subclasses: {@link WebGlStage}, {@link CssStage} or {@link FlashStage}.
 *
 * @param {Object} opts
 * @param {boolean} [opts.progressive=false]
 *
 * Options listed here may be passed into the `opts` constructor argument of
 * subclasses.
 *
 * The `progressive` option controls whether resolution levels are loaded in
 * order, from lowest to highest. This results in a more pleasing effect when
 * zooming past several levels in a large panoramas, but consumes additional
 * bandwidth.
 */ function $579af966673ff6bc$var$Stage(opts) {
    this._progressive = !!(opts && opts.progressive);
    // The list of layers in display order (background to foreground).
    this._layers = [];
    // The list of renderers; the i-th renderer is for the i-th layer.
    this._renderers = [];
    // The lists of tiles to load and render, populated during render().
    this._tilesToLoad = [];
    this._tilesToRender = [];
    // Temporary tile lists.
    this._tmpVisible = [];
    this._tmpChildren = [];
    // Cached stage dimensions.
    // Start with zero, which inhibits rendering until setSize() is called.
    this._width = 0;
    this._height = 0;
    // Temporary variable for rect.
    this._tmpRect = {};
    // Temporary variable for size.
    this._tmpSize = {};
    // Work queue for createTexture.
    this._createTextureWorkQueue = new $hluEj();
    // Function to emit event when render parameters have changed.
    this._emitRenderInvalid = this._emitRenderInvalid.bind(this);
    // The renderer registry maps each geometry/view pair into the respective
    // Renderer class.
    this._rendererRegistry = new $bYEal();
}
$6mia6($579af966673ff6bc$var$Stage);
/**
 * Destructor.
 */ $579af966673ff6bc$var$Stage.prototype.destroy = function() {
    this.removeAllLayers();
    $2Xxut(this);
};
/**
 * Registers a {@link Renderer} for the given {@link Geometry} and {@link View}
 * type.
 *
 * The {@link registerDefaultRenderers} utility function may be used to
 * register all known renderers for a stage type into that stage. Most users
 * will not need to register renderers, as {@link Viewer} does it for them.
 *
 * @param {string} geometryType The geometry type, as given by
 *     {@link Geometry#type}.
 * @param {string} viewType The view type, as given by {@link View#type}.
 * @param {*} Renderer The renderer class.
 */ $579af966673ff6bc$var$Stage.prototype.registerRenderer = function(geometryType, viewType, Renderer) {
    return this._rendererRegistry.set(geometryType, viewType, Renderer);
};
/**
 * Returns the underlying DOM element.
 *
 * Must be overridden by subclasses.
 *
 * @return {Element}
 */ $579af966673ff6bc$var$Stage.prototype.domElement = function() {
    throw new Error("Stage implementation must override domElement");
};
/**
 * Get the stage width.
 * @return {number}
 */ $579af966673ff6bc$var$Stage.prototype.width = function() {
    return this._width;
};
/**
 * Get the stage height.
 * @return {number}
 */ $579af966673ff6bc$var$Stage.prototype.height = function() {
    return this._height;
};
/**
 * Get the stage dimensions. If an argument is supplied, it is filled in with
 * the result and returned. Otherwise, a fresh object is filled in and returned.
 *
 * @param {Size=} size
 */ $579af966673ff6bc$var$Stage.prototype.size = function(size) {
    size = size || {};
    size.width = this._width;
    size.height = this._height;
    return size;
};
/**
 * Set the stage dimensions.
 *
 * This contains the size update logic common to all stage types. Subclasses
 * must define the {@link Stage#setSizeForType} method to perform their own
 * logic.
 *
 * @param {Size} size
 */ $579af966673ff6bc$var$Stage.prototype.setSize = function(size) {
    this._width = size.width;
    this._height = size.height;
    this.setSizeForType(); // must be defined by subclasses.
    this.emit("resize");
    this._emitRenderInvalid();
};
/**
 * Call {@link Stage#setSize} instead.
 *
 * This contains the size update logic specific to a stage type. It is called by
 * {@link Stage#setSize} after the base class has been updated to reflect the
 * new size, but before any events are emitted.
 *
 * @param {Size} size
 */ $579af966673ff6bc$var$Stage.prototype.setSizeForType = function(size) {
    throw new Error("Stage implementation must override setSizeForType");
};
/**
 * Loads an {@link Asset} from an image.
 * @param {string} url The image URL.
 * @param {?Rect} rect A {@link Rect} describing a portion of the image, or null
 *     to use the full image.
 * @param {function(?Error, Asset)} done The callback.
 * @return {function()} A function to cancel loading.
 */ $579af966673ff6bc$var$Stage.prototype.loadImage = function() {
    throw new Error("Stage implementation must override loadImage");
};
$579af966673ff6bc$var$Stage.prototype._emitRenderInvalid = function() {
    this.emit("renderInvalid");
};
/**
 * Verifies that the layer is valid for this stage, throwing an exception
 * otherwise.
 *
 * @param {Layer} layer
 * @throws {Error} If the layer is not valid for this stage.
 */ $579af966673ff6bc$var$Stage.prototype.validateLayer = function(layer) {
    throw new Error("Stage implementation must override validateLayer");
};
/**
 * Returns a list of all {@link Layer layers} belonging to the stage. The
 * returned list is in display order, background to foreground.
 * @return {Layer[]}
 */ $579af966673ff6bc$var$Stage.prototype.listLayers = function() {
    // Return a copy to prevent unintended mutation by the caller.
    return [].concat(this._layers);
};
/**
 * Return whether a {@link Layer layer} belongs to the stage.
 * @param {Layer} layer
 * @return {boolean}
 */ $579af966673ff6bc$var$Stage.prototype.hasLayer = function(layer) {
    return this._layers.indexOf(layer) >= 0;
};
/**
 * Adds a {@link Layer layer} into the stage.
 * @param {Layer} layer The layer to add.
 * @param {number|undefined} i The optional position, where 0 ≤ i ≤ n and n is
 *     the current number of layers. The default is n, which inserts at the
 *     top of the display stack.
 * @throws An error if the layer already belongs to the stage or if the position
 *     is invalid.
 */ $579af966673ff6bc$var$Stage.prototype.addLayer = function(layer, i) {
    if (this._layers.indexOf(layer) >= 0) throw new Error("Layer already in stage");
    if (i == null) i = this._layers.length;
    if (i < 0 || i > this._layers.length) throw new Error("Invalid layer position");
    this.validateLayer(layer); // must be defined by subclasses.
    var geometryType = layer.geometry().type;
    var viewType = layer.view().type;
    var rendererClass = this._rendererRegistry.get(geometryType, viewType);
    if (!rendererClass) throw new Error("No " + this.type + " renderer avaiable for " + geometryType + " geometry and " + viewType + " view");
    var renderer = this.createRenderer(rendererClass);
    this._layers.splice(i, 0, layer);
    this._renderers.splice(i, 0, renderer);
    // Listeners for render invalid.
    layer.addEventListener("viewChange", this._emitRenderInvalid);
    layer.addEventListener("effectsChange", this._emitRenderInvalid);
    layer.addEventListener("fixedLevelChange", this._emitRenderInvalid);
    layer.addEventListener("textureStoreChange", this._emitRenderInvalid);
    this._emitRenderInvalid();
};
/**
 * Moves a {@link Layer layer} into a different position in the display stack.
 * @param {Layer} layer The layer to move.
 * @param {number} i The position, where 0 ≤ i ≤ n-1 and n is the current number
 *     of layers.
 * @throws An error if the layer does not belong to the stage or if the position
 *     is invalid.
 */ $579af966673ff6bc$var$Stage.prototype.moveLayer = function(layer, i) {
    var index = this._layers.indexOf(layer);
    if (index < 0) throw new Error("No such layer in stage");
    if (i < 0 || i >= this._layers.length) throw new Error("Invalid layer position");
    layer = this._layers.splice(index, 1)[0];
    var renderer = this._renderers.splice(index, 1)[0];
    this._layers.splice(i, 0, layer);
    this._renderers.splice(i, 0, renderer);
    this._emitRenderInvalid();
};
/**
 * Removes a {@link Layer} from the stage.
 * @param {Layer} layer The layer to remove.
 * @throws An error if the layer does not belong to the stage.
 */ $579af966673ff6bc$var$Stage.prototype.removeLayer = function(layer) {
    var index = this._layers.indexOf(layer);
    if (index < 0) throw new Error("No such layer in stage");
    var removedLayer = this._layers.splice(index, 1)[0];
    var renderer = this._renderers.splice(index, 1)[0];
    this.destroyRenderer(renderer);
    removedLayer.removeEventListener("viewChange", this._emitRenderInvalid);
    removedLayer.removeEventListener("effectsChange", this._emitRenderInvalid);
    removedLayer.removeEventListener("fixedLevelChange", this._emitRenderInvalid);
    removedLayer.removeEventListener("textureStoreChange", this._emitRenderInvalid);
    this._emitRenderInvalid();
};
/**
 * Removes all {@link Layer layers} from the stage.
 */ $579af966673ff6bc$var$Stage.prototype.removeAllLayers = function() {
    while(this._layers.length > 0)this.removeLayer(this._layers[0]);
};
/**
 * Called before a frame is rendered.
 *
 * Must be overridden by subclasses.
 */ $579af966673ff6bc$var$Stage.prototype.startFrame = function() {
    throw new Error("Stage implementation must override startFrame");
};
/**
 * Called after a frame is rendered.
 *
 * Must be overridden by subclasses.
 */ $579af966673ff6bc$var$Stage.prototype.endFrame = function() {
    throw new Error("Stage implementation must override endFrame");
};
/**
 * Render the current frame. Usually called from a {@link RenderLoop}.
 *
 * This contains the rendering logic common to all stage types. Subclasses
 * define the startFrame() and endFrame() methods to perform their own logic.
 */ $579af966673ff6bc$var$Stage.prototype.render = function() {
    var i, j;
    var tilesToLoad = this._tilesToLoad;
    var tilesToRender = this._tilesToRender;
    var stableStage = true;
    var stableLayer;
    // Get the stage dimensions.
    var width = this._width;
    var height = this._height;
    var rect = this._tmpRect;
    var size = this._tmpSize;
    if (width <= 0 || height <= 0) return;
    this.startFrame(); // defined by subclasses
    // Signal start of frame to the texture stores.
    for(i = 0; i < this._layers.length; i++)this._layers[i].textureStore().startFrame();
    // Render layers.
    for(i = 0; i < this._layers.length; i++){
        var layer = this._layers[i];
        var effects = layer.effects();
        var view = layer.view();
        var textureStore = layer.textureStore();
        var renderer = this._renderers[i];
        var depth = this._layers.length - i;
        var tile, texture;
        // Convert the rect effect into a normalized rect.
        // TODO: avoid doing this on every frame.
        $8pjZz(width, height, effects && effects.rect, rect);
        if (rect.width <= 0 || rect.height <= 0) continue;
        // Update the view size.
        size.width = rect.width * this._width;
        size.height = rect.height * this._height;
        view.setSize(size);
        // Signal start of layer to the renderer.
        renderer.startLayer(layer, rect);
        // We render with both alpha blending and depth testing enabled. Thus, when
        // rendering a subsequent pixel at the same location than an existing one,
        // the subsequent pixel gets discarded unless it has smaller depth, and is
        // otherwise composited with the existing pixel.
        //
        // When using fallback tiles to fill a gap in the preferred resolution
        // level, we prefer higher resolution fallbacks to lower resolution ones.
        // However, where fallbacks overlap, we want higher resolution ones to
        // prevail, and we don't want multiple fallbacks to be composited with each
        // other, as that would produce a bad result when semitransparent textures
        // are involved.
        //
        // In order to achieve this within the constraints of alpha blending and
        // depth testing, the depth of a tile must be inversely proportional to its
        // resolution, and higher-resolution tiles must be rendered before lower-
        // resolution ones.
        // Collect the lists of tiles to load and render.
        stableLayer = this._collectTiles(layer, textureStore);
        // Mark all the tiles whose textures must be loaded.
        // This will either trigger loading (for textures not yet loaded) or
        // prevent unloading (for textures already loaded).
        for(j = 0; j < tilesToLoad.length; j++){
            tile = tilesToLoad[j];
            textureStore.markTile(tile);
        }
        // Render tiles.
        for(j = 0; j < tilesToRender.length; j++){
            tile = tilesToRender[j];
            texture = textureStore.texture(tile);
            renderer.renderTile(tile, texture, layer, depth);
        }
        layer.emit("renderComplete", stableLayer);
        if (!stableLayer) stableStage = false;
        // Signal end of layer to the renderer.
        renderer.endLayer(layer, rect);
    }
    // Signal end of frame to the texture stores.
    for(i = 0; i < this._layers.length; i++)this._layers[i].textureStore().endFrame();
    this.endFrame(); // defined by subclasses
    this.emit("renderComplete", stableStage);
};
$579af966673ff6bc$var$Stage.prototype._collectTiles = function(layer, textureStore) {
    var tilesToLoad = this._tilesToLoad;
    var tilesToRender = this._tilesToRender;
    var tmpVisible = this._tmpVisible;
    tilesToLoad.length = 0;
    tilesToRender.length = 0;
    tmpVisible.length = 0;
    layer.visibleTiles(tmpVisible);
    var isStable = true;
    for(var i = 0; i < tmpVisible.length; i++){
        var tile = tmpVisible[i];
        var needsFallback;
        this._collectTileToLoad(tile);
        if (textureStore.texture(tile)) {
            // The preferred texture is available.
            // No fallback is required.
            needsFallback = false;
            this._collectTileToRender(tile);
        } else {
            // The preferred texture is unavailable.
            // Collect children for rendering as a fallback.
            needsFallback = this._collectChildren(tile, textureStore);
            isStable = false;
        }
        // Collect all parents for loading, and the closest parent for rendering if
        // a fallback is required.
        this._collectParents(tile, textureStore, needsFallback);
    }
    // Sort tiles to load in ascending resolution order.
    tilesToLoad.sort($579af966673ff6bc$var$forwardTileCmp);
    // Sort tiles to render in descending resolution order.
    tilesToRender.sort($579af966673ff6bc$var$reverseTileCmp);
    return isStable;
};
$579af966673ff6bc$var$Stage.prototype._collectChildren = function(tile, textureStore) {
    var tmpChildren = this._tmpChildren;
    var needsFallback = true;
    // Fall back as many levels as necessary on single-child geometries, but do
    // not go beyond immediate children on multiple-child geometries, to avoid
    // exploring an exponential number of tiles.
    do {
        tmpChildren.length = 0;
        if (!tile.children(tmpChildren)) break;
        needsFallback = false;
        for(var i = 0; i < tmpChildren.length; i++){
            tile = tmpChildren[i];
            if (textureStore.texture(tile)) {
                this._collectTileToLoad(tile);
                this._collectTileToRender(tile);
            } else needsFallback = true;
        }
    }while (needsFallback && tmpChildren.length === 1);
    return needsFallback;
};
$579af966673ff6bc$var$Stage.prototype._collectParents = function(tile, textureStore, needsFallback) {
    // Recursively visit parent tiles until:
    //   - all parents have been marked for loading, if progressive rendering is
    //     enabled; and
    //   - at least one parent has been marked for both loading and rendering, if
    //     a fallback is required.
    var needsLoading = this._progressive;
    while((needsLoading || needsFallback) && (tile = tile.parent()) != null){
        if (needsFallback) {
            if (textureStore.texture(tile)) {
                this._collectTileToRender(tile);
                needsFallback = false;
            } else if (!this._progressive) continue;
        }
        if (!this._collectTileToLoad(tile)) needsLoading = false;
    }
    return needsFallback;
};
$579af966673ff6bc$var$Stage.prototype._collectTileToLoad = function(tile) {
    return this._collectTileIntoList(tile, this._tilesToLoad);
};
$579af966673ff6bc$var$Stage.prototype._collectTileToRender = function(tile) {
    return this._collectTileIntoList(tile, this._tilesToRender);
};
$579af966673ff6bc$var$Stage.prototype._collectTileIntoList = function(tile, tileList) {
    // TODO: Investigate whether it's worth it to make this better than O(n²).
    var found = false;
    for(var i = 0; i < tileList.length; i++)if (tile.equals(tileList[i])) {
        found = true;
        break;
    }
    if (!found) tileList.push(tile);
    return !found;
};
/**
 * Create a texture for the given tile and asset. Called by {@link TextureStore}.
 * @param {Tile} tile
 * @param {Asset} asset
 * @param {Function} done
 */ $579af966673ff6bc$var$Stage.prototype.createTexture = function(tile, asset, done) {
    var self = this;
    function makeTexture() {
        return new self.TextureClass(self, tile, asset);
    }
    var fn = $bMUVO($11mTq(makeTexture));
    return this._createTextureWorkQueue.push(fn, function(err, texture) {
        done(err, tile, asset, texture);
    });
};
/**
 * The stage type, used to determine the appropriate renderer for a given
 * geometry and view.
 *
 * Known values are `"webgl"`, `"css"` and `"flash"`.
 *
 * See also {@link Stage#registerRenderer}.
 *
 * @property {string}
 * @name Stage#type
 */ module.exports = $579af966673ff6bc$var$Stage;

});
parcelRegister("6mia6", function(module, exports) {
"use strict";
/**
 * @class
 * @classdesc Minimalistic event emitter mixin.
 */ function $4a12e2b927a9c278$var$EventEmitter() {}
/**
 * Registers an event listener for the specified event. If the listener has
 * already been registered for the event, this is a no-op.
 *
 * @param {string} name The event name.
 * @param {function} fn The listener function.
 */ $4a12e2b927a9c278$var$EventEmitter.prototype.addEventListener = function(name, fn) {
    var eventMap = this.__events = this.__events || {};
    var handlerList = eventMap[name] = eventMap[name] || [];
    if (handlerList.indexOf(fn) < 0) handlerList.push(fn);
};
/**
 * Unregisters an event listener from the specified event. If the listener
 * hasn't been registered for the event, this is a no-op.
 *
 * @param {string} name The event name.
 * @param {function} fn The listener function.
 */ $4a12e2b927a9c278$var$EventEmitter.prototype.removeEventListener = function(name, fn) {
    var eventMap = this.__events = this.__events || {};
    var handlerList = eventMap[name];
    if (handlerList) {
        var index = handlerList.indexOf(fn);
        if (index >= 0) handlerList.splice(index, 1);
    }
};
/**
 * Emits an event, causing all registered event listeners for that event to be
 * called in registration order.
 *
 * @param {string} name The event name.
 * @param {...*} var_args Arguments to call listeners with.
 */ $4a12e2b927a9c278$var$EventEmitter.prototype.emit = function(name, var_args) {
    var eventMap = this.__events = this.__events || {};
    var handlerList = eventMap[name];
    var args = Array.prototype.slice.call(arguments, 1);
    if (handlerList) for(var i = 0; i < handlerList.length; i++){
        var fn = handlerList[i];
        fn.apply(this, args);
    }
};
/**
 * Mixes in {@link EventEmitter} into a constructor function.
 *
 * @param {function} ctor The constructor function.
 */ function $4a12e2b927a9c278$var$eventEmitter(ctor) {
    for(var prop in $4a12e2b927a9c278$var$EventEmitter.prototype)if ($4a12e2b927a9c278$var$EventEmitter.prototype.hasOwnProperty(prop)) ctor.prototype[prop] = $4a12e2b927a9c278$var$EventEmitter.prototype[prop];
}
module.exports = $4a12e2b927a9c278$var$eventEmitter;

});

parcelRegister("hluEj", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $azWbw = parcelRequire("azWbw");
function $ca0c2c24c302e94b$var$WorkTask(fn, cb) {
    this.fn = fn;
    this.cb = cb;
    this.cfn = null;
}
function $ca0c2c24c302e94b$var$WorkQueue(opts) {
    this._queue = [];
    this._delay = opts && opts.delay || 0;
    this._paused = opts && !!opts.paused || false;
    this._currentTask = null;
    this._lastFinished = null;
}
$ca0c2c24c302e94b$var$WorkQueue.prototype.length = function() {
    return this._queue.length;
};
$ca0c2c24c302e94b$var$WorkQueue.prototype.push = function(fn, cb) {
    var task = new $ca0c2c24c302e94b$var$WorkTask(fn, cb);
    var cancel = this._cancel.bind(this, task);
    // Push the task into the queue.
    this._queue.push(task);
    // Run the task if idle.
    this._next();
    return cancel;
};
$ca0c2c24c302e94b$var$WorkQueue.prototype.pause = function() {
    if (!this._paused) this._paused = true;
};
$ca0c2c24c302e94b$var$WorkQueue.prototype.resume = function() {
    if (this._paused) {
        this._paused = false;
        this._next();
    }
};
$ca0c2c24c302e94b$var$WorkQueue.prototype._start = function(task) {
    // Consistency check.
    if (this._currentTask) throw new Error("WorkQueue: called start while running task");
    // Mark queue as busy, so that concurrent tasks wait.
    this._currentTask = task;
    // Execute the task.
    var finish = this._finish.bind(this, task);
    task.cfn = task.fn(finish);
    // Detect when a non-cancellable function has been queued.
    if (typeof task.cfn !== "function") throw new Error("WorkQueue: function is not cancellable");
};
$ca0c2c24c302e94b$var$WorkQueue.prototype._finish = function(task) {
    var args = Array.prototype.slice.call(arguments, 1);
    // Consistency check.
    if (this._currentTask !== task) throw new Error("WorkQueue: called finish on wrong task");
    // Call the task callback on the return values.
    task.cb.apply(null, args);
    // Mark as not busy and record task finish time, then advance to next task.
    this._currentTask = null;
    this._lastFinished = $azWbw();
    this._next();
};
$ca0c2c24c302e94b$var$WorkQueue.prototype._cancel = function(task) {
    var args = Array.prototype.slice.call(arguments, 1);
    if (this._currentTask === task) // Cancel running task. Because cancel passes control to the _finish
    // callback we passed into fn, the cleanup logic will be handled there.
    task.cfn.apply(null, args);
    else {
        // Remove task from queue.
        var pos = this._queue.indexOf(task);
        if (pos >= 0) {
            this._queue.splice(pos, 1);
            task.cb.apply(null, args);
        }
    }
};
$ca0c2c24c302e94b$var$WorkQueue.prototype._next = function() {
    if (this._paused) // Do not start tasks while paused.
    return;
    if (!this._queue.length) // No tasks to run.
    return;
    if (this._currentTask) // Will be called again when the current task finishes.
    return;
    if (this._lastFinished != null) {
        var elapsed = $azWbw() - this._lastFinished;
        var remaining = this._delay - elapsed;
        if (remaining > 0) {
            // Too soon. Run again after the inter-task delay.
            setTimeout(this._next.bind(this), remaining);
            return;
        }
    }
    // Run the next task.
    var task = this._queue.shift();
    this._start(task);
};
module.exports = $ca0c2c24c302e94b$var$WorkQueue;

});
parcelRegister("azWbw", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
function $7b3a4e9666ec5414$var$getNow() {
    if (typeof performance !== "undefined" && performance.now) return function performanceNow() {
        return performance.now();
    };
    return function dateNow() {
        return Date.now();
    };
}
module.exports = $7b3a4e9666ec5414$var$getNow();

});


parcelRegister("8pjZz", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
/**
 * Converts a {@link RectSpec} into an equivalent {@link Rect}.
 *
 * A {@link RectSpec} is a convenient user API format, providing default values
 * and the flexibility of specifying absolute, relative or mixed dimensions.
 *
 * A {@link Rect} is a more convenient format for the rendering pipeline. It is
 * always expressed in normalized coordinates, and all its properties are
 * guaranteed to be present.
 *
 * @param {number} totalWidth The total width of the rendering area in pixels.
 * @param {number} totalHeight The total height of the rendering area in pixels.
 * @param {RectSpec} spec The input spec, defaulting to the full rendering area
 *     if null or undefined.
 * @param {Rect} result The output spec. If the argument is present, it is
 *     filled in and returned; otherwise, a fresh object is returned.
 */ function $61f02a8aab9e7b97$var$calcRect(totalWidth, totalHeight, spec, result) {
    result = result || {};
    var width;
    if (spec != null && spec.absoluteWidth != null) width = spec.absoluteWidth / totalWidth;
    else if (spec != null && spec.relativeWidth != null) width = spec.relativeWidth;
    else width = 1;
    var height;
    if (spec && spec.absoluteHeight != null) height = spec.absoluteHeight / totalHeight;
    else if (spec != null && spec.relativeHeight != null) height = spec.relativeHeight;
    else height = 1;
    var x;
    if (spec != null && spec.absoluteX != null) x = spec.absoluteX / totalWidth;
    else if (spec != null && spec.relativeX != null) x = spec.relativeX;
    else x = 0;
    var y;
    if (spec != null && spec.absoluteY != null) y = spec.absoluteY / totalHeight;
    else if (spec != null && spec.relativeY != null) y = spec.relativeY;
    else y = 0;
    result.x = x;
    result.y = y;
    result.width = width;
    result.height = height;
    return result;
}
module.exports = $61f02a8aab9e7b97$var$calcRect;

});

parcelRegister("11mTq", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
// Transform a synchronous function into an asynchronous one.
function $0be7a4830ed170c4$var$async(fn) {
    return function asynced(done) {
        var err, ret;
        try {
            ret = fn();
        } catch (e) {
            err = e;
        } finally{
            if (err) done(err);
            else done(null, ret);
        }
    };
}
module.exports = $0be7a4830ed170c4$var$async;

});

parcelRegister("bMUVO", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $9ZuRa = parcelRequire("9ZuRa");
// A cancelable function is an asynchronous function (i.e., one whose last
// argument is a callback receiving an error plus zero or more return values)
// that (synchronously) returns a cancel() function. Calling cancel() should
// abort the asynchronous operation and call the callback with the arguments
// that were passed into cancel(). Calling cancel() twice, as with callbacks,
// is not guaranteed to be safe.
// Wrap a non-cancellable asynchronous function into a cancelable one.
//
// Calling cancel() on the returned function will not interrupt the execution
// of the original function; it will merely ignore its return value.
//
// Usually, instead of wrapping your function, you want to implement cancel()
// yourself in order to have some abort logic. This utility function provides a
// straighforward solution for cases in which no custom abort logic is required.
function $895056c8173cbb2b$var$cancelize(fn) {
    return function cancelized() {
        if (!arguments.length) throw new Error("cancelized: expected at least one argument");
        var args = Array.prototype.slice.call(arguments, 0);
        var done = args[args.length - 1] = $9ZuRa(args[args.length - 1]);
        function cancel() {
            done.apply(null, arguments);
        }
        fn.apply(null, args);
        return cancel;
    };
}
module.exports = $895056c8173cbb2b$var$cancelize;

});
parcelRegister("9ZuRa", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
function $7461bf0c47673714$var$once(fn) {
    var called = false;
    var value;
    return function onced() {
        if (!called) {
            called = true;
            value = fn.apply(null, arguments);
        }
        return value;
    };
}
module.exports = $7461bf0c47673714$var$once;

});


parcelRegister("2Xxut", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
// Sets an object's own properties to undefined. This may be called by
// destructors to avoid retaining references and help detect incorrect use of
// destroyed instances.
function $227b11fe472f7d56$var$clearOwnProperties(obj) {
    for(var prop in obj)if (obj.hasOwnProperty(prop)) obj[prop] = undefined;
}
module.exports = $227b11fe472f7d56$var$clearOwnProperties;

});

parcelRegister("bYEal", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
/**
 * @class RendererRegistry
 * @classdesc
 *
 * A RendererRegistry maps pairs of {@link Geometry} and {@link View} type into
 * the appropriate {@link Renderer} class. It is used by a {@link Stage} to
 * determine the appropriate renderer for a {@link Layer}.
 *
 * See also {@link Stage#registerRenderer}.
 */ function $8b847468f6b3fd4c$var$RendererRegistry() {
    this._renderers = {};
}
/**
 * Registers a renderer for the given geometry and view type.
 * @param {string} geometryType The geometry type, as given by
 *     {@link Geometry#type}.
 * @param {string} viewType The view type, as given by {@link View#type}.
 * @param {*} Renderer The renderer class.
 */ $8b847468f6b3fd4c$var$RendererRegistry.prototype.set = function(geometryType, viewType, Renderer) {
    if (!this._renderers[geometryType]) this._renderers[geometryType] = {};
    this._renderers[geometryType][viewType] = Renderer;
};
/**
 * Retrieves the renderer for the given geometry and view type.
 * @param {string} geometryType The geometry type, as given by
 *     {@link Geometry#type}.
 * @param {string} viewType The view type, as given by {@link View#type}.
 * @param {*} Renderer The renderer class, or null if no such renderer has been
 * registered.
 */ $8b847468f6b3fd4c$var$RendererRegistry.prototype.get = function(geometryType, viewType) {
    var Renderer = this._renderers[geometryType] && this._renderers[geometryType][viewType];
    return Renderer || null;
};
module.exports = $8b847468f6b3fd4c$var$RendererRegistry;

});


parcelRegister("5k1DD", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $4Qk7S = parcelRequire("4Qk7S");

var $1Cfry = parcelRequire("1Cfry");

var $9ZuRa = parcelRequire("9ZuRa");
// N.B. HtmlImageLoader is broken on IE8 for images that require resizing, due
// to the unavailable HTML5 canvas element and the naturalWidth/naturalHeight
// properties of image elements. This is currently not a problem because the
// HTML-based renderers (WebGL and CSS) do not work on IE8 anyway. It could
// become a problem in the future if we decide to support CSS rendering of flat
// panoramas on IE8.
// TODO: Move the load queue into the loader.
/**
 * @class HtmlImageLoader
 * @implements ImageLoader
 * @classdesc
 *
 * A {@link Loader} for HTML images.
 *
 * @param {Stage} stage The stage which is going to request images to be loaded.
 */ function $3e00175a50caf80a$var$HtmlImageLoader(stage) {
    if (stage.type !== "webgl" && stage.type !== "css") throw new Error("Stage type incompatible with loader");
    this._stage = stage;
}
/**
 * Loads an {@link Asset} from an image.
 * @param {string} url The image URL.
 * @param {?Rect} rect A {@link Rect} describing a portion of the image, or null
 *     to use the full image.
 * @param {function(?Error, Asset)} done The callback.
 * @return {function()} A function to cancel loading.
 */ $3e00175a50caf80a$var$HtmlImageLoader.prototype.loadImage = function(url, rect, done) {
    var img = new Image();
    // Allow cross-domain image loading.
    // This is required to be able to create WebGL textures from images fetched
    // from a different domain. Note that setting the crossorigin attribute to
    // 'anonymous' will trigger a CORS preflight for cross-domain requests, but no
    // credentials (cookies or HTTP auth) will be sent; to do so, the attribute
    // would have to be set to 'use-credentials' instead. Unfortunately, this is
    // not a safe choice, as it causes requests to fail when the response contains
    // an Access-Control-Allow-Origin header with a wildcard. See the section
    // "Credentialed requests and wildcards" on:
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS
    img.crossOrigin = "anonymous";
    var x = rect && rect.x || 0;
    var y = rect && rect.y || 0;
    var width = rect && rect.width || 1;
    var height = rect && rect.height || 1;
    done = $9ZuRa(done);
    img.onload = function() {
        if (x === 0 && y === 0 && width === 1 && height === 1) done(null, new $4Qk7S(img));
        else {
            x *= img.naturalWidth;
            y *= img.naturalHeight;
            width *= img.naturalWidth;
            height *= img.naturalHeight;
            var canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            var context = canvas.getContext("2d");
            context.drawImage(img, x, y, width, height, 0, 0, width, height);
            done(null, new $4Qk7S(canvas));
        }
    };
    img.onerror = function() {
        // TODO: is there any way to distinguish a network error from other
        // kinds of errors? For now we always return NetworkError since this
        // prevents images to be retried continuously while we are offline.
        done(new $1Cfry("Network error: " + url));
    };
    img.src = url;
    function cancel() {
        img.onload = img.onerror = null;
        img.src = "";
        done.apply(null, arguments);
    }
    return cancel;
};
module.exports = $3e00175a50caf80a$var$HtmlImageLoader;

});
parcelRegister("4Qk7S", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $h87tj = parcelRequire("h87tj");

var $6mia6 = parcelRequire("6mia6");

var $2Xxut = parcelRequire("2Xxut");
var $386ba157d397599a$var$propertyMap = {
    HTMLImageElement: [
        "naturalWidth",
        "naturalHeight"
    ],
    HTMLCanvasElement: [
        "width",
        "height"
    ],
    ImageBitmap: [
        "width",
        "height"
    ]
};
/**
 * @class StaticAsset
 * @implements Asset
 * @classdesc
 *
 * An immutable {@link Asset} compatible with {@link WebGlStage} and
 * {@link CssStage}.
 *
 * @param {HTMLImageElement|HTMLCanvasElement|ImageBitmap} element The
 *     underlying pixel source.
 * @throws If the pixel source is unsupported.
 */ function $386ba157d397599a$var$StaticAsset(element) {
    var supported = false;
    for(var type in $386ba157d397599a$var$propertyMap)if ($h87tj[type] && element instanceof $h87tj[type]) {
        supported = true;
        this._widthProp = $386ba157d397599a$var$propertyMap[type][0];
        this._heightProp = $386ba157d397599a$var$propertyMap[type][1];
        break;
    }
    if (!supported) throw new Error("Unsupported pixel source");
    this._element = element;
}
$6mia6($386ba157d397599a$var$StaticAsset);
/**
 * Destructor.
 */ $386ba157d397599a$var$StaticAsset.prototype.destroy = function() {
    $2Xxut(this);
};
$386ba157d397599a$var$StaticAsset.prototype.element = function() {
    return this._element;
};
$386ba157d397599a$var$StaticAsset.prototype.width = function() {
    return this._element[this._widthProp];
};
$386ba157d397599a$var$StaticAsset.prototype.height = function() {
    return this._element[this._heightProp];
};
$386ba157d397599a$var$StaticAsset.prototype.timestamp = function() {
    return 0;
};
$386ba157d397599a$var$StaticAsset.prototype.isDynamic = function() {
    return false;
};
module.exports = $386ba157d397599a$var$StaticAsset;

});
parcelRegister("h87tj", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
// The global object.
var $c788fac48c2ce4e4$var$globalObject = function() {
    if (typeof window !== "undefined") return window;
    if (typeof self !== "undefined") return self;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    return null;
}();
module.exports = $c788fac48c2ce4e4$var$globalObject;

});


parcelRegister("1Cfry", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $Yar88 = parcelRequire("Yar88");
/**
 * @class NetworkError
 * @extends {Error}
 * @classdesc
 *
 * Signals an error that occurred while fetching a URL. This is used by
 * {@link Loader loaders} to distinguish network failures from other errors.
 */ function $12d551cd80a2a729$var$NetworkError(message) {
    // See: https://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript
    this.constructor.super_.apply(this, arguments);
    this.message = message;
}
$Yar88($12d551cd80a2a729$var$NetworkError, Error);
module.exports = $12d551cd80a2a729$var$NetworkError;

});
parcelRegister("Yar88", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
// Make ctor a subclass of superCtor.
// Do not depend on ES5 Object.create semantics because of older browsers.
function $0b4db3332be99d71$var$inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function() {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
}
module.exports = $0b4db3332be99d71$var$inherits;

});



parcelRegister("dfwu4", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
// Detect WebGl support.
// Keep stages/WebGl.js in sync with this.
function $9a55dfbeb821c235$var$checkWebGlSupported() {
    var canvas = document.createElement("canvas");
    var gl = canvas.getContext && (canvas.getContext("webgl") || canvas.getContext("experimental-webgl"));
    return !!gl;
}
// Cache result.
var $9a55dfbeb821c235$var$supported;
function $9a55dfbeb821c235$var$webGlSupported() {
    if ($9a55dfbeb821c235$var$supported !== undefined) return $9a55dfbeb821c235$var$supported;
    return $9a55dfbeb821c235$var$supported = $9a55dfbeb821c235$var$checkWebGlSupported();
}
module.exports = $9a55dfbeb821c235$var$webGlSupported;

});

parcelRegister("W9Vbx", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    return function(e) {
        var t = {};
        function r(i) {
            if (t[i]) return t[i].exports;
            var n = t[i] = {
                i: i,
                l: !1,
                exports: {}
            };
            return e[i].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, i) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: i
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var i = Object.create(null);
            if (r.r(i), Object.defineProperty(i, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var n in e)r.d(i, n, (function(t) {
                return e[t];
            }).bind(null, n));
            return i;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i = r(18), n = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, i) {
                    void 0 === i && (i = !1);
                    var n = e.getVersionPrecision(t), s = e.getVersionPrecision(r), o = Math.max(n, s), a = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = o - e.getVersionPrecision(t), i = t + new Array(r + 1).join(".0");
                        return e.map(i.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(i && (a = o - Math.min(n, s)), o -= 1; o >= a;){
                        if (u[0][o] > u[1][o]) return 1;
                        if (u[0][o] === u[1][o]) {
                            if (o === a) return 0;
                            o -= 1;
                        } else if (u[0][o] < u[1][o]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, i = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)i.push(t(e[r]));
                    return i;
                }, e.getBrowserAlias = function(e) {
                    return i.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return i.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = n, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(91)) && i.__esModule ? i : {
                default: i
            }, s = r(18);
            function o(e, t) {
                for(var r = 0; r < t.length; r++){
                    var i = t[r];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
                }
            }
            var a = function() {
                function e() {}
                var t, r, i;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new n.default(e, t);
                }, e.parse = function(e) {
                    return new n.default(e).getResult();
                }, t = e, i = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, i && o(t, i), e;
            }();
            t.default = a, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i = u(r(92)), n = u(r(93)), s = u(r(94)), o = u(r(95)), a = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = i.default.find(function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = n.default.find(function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = s.default.find(function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return Object.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, i = 0, n = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var o = e[t];
                        "string" == typeof o ? (n[t] = o, s += 1) : "object" == typeof o && (r[t] = o, i += 1);
                    }), i > 0) {
                        var o = Object.keys(r), a = o.find(function(e) {
                            return t.isOS(e);
                        });
                        if (a) {
                            var u = this.satisfies(r[a]);
                            if (void 0 !== u) return u;
                        }
                        var d = o.find(function(e) {
                            return t.isPlatform(e);
                        });
                        if (d) {
                            var c = this.satisfies(r[d]);
                            if (void 0 !== c) return c;
                        }
                    }
                    if (s > 0) {
                        var f = Object.keys(n).find(function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== f) return this.compareVersion(n[f]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), i = e.toLowerCase(), n = a.default.getBrowserTypeByAlias(i);
                    return t && n && (i = n.toLowerCase()), i === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, i = !1, n = this.getBrowserVersion();
                    if ("string" == typeof n) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (i = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (i = !0, r = e.substr(1)), t.indexOf(a.default.compareVersions(n, r, i)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e) {
                    return this.isBrowser(e) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, o = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = n.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = n.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = n.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = n.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = n.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = n.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = n.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = n.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = n.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = n.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = n.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = n.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = n.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = n.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = n.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = n.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = n.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = n.default.getFirstMatch(s, e) || n.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = n.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = n.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = n.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = n.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = n.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = n.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = n.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = n.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: n.default.getFirstMatch(t, e),
                            version: n.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = o, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            }, s = r(18);
            var o = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = n.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = n.default.getMacOSVersionName(t), i = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (i.versionName = r), i;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = n.default.getAndroidVersionName(t), i = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (i.versionName = r), i;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || n.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || n.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = o, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            }, s = r(18);
            var o = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = o, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            }, s = r(18);
            var o = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = n.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = n.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = n.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = n.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = n.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = o, e.exports = t.default;
        }
    });
});

});

parcelRegister("lNra6", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
var $fde33e6418df4cd4$var$defaultPixelRatio = 1;
function $fde33e6418df4cd4$var$pixelRatio() {
    if (typeof window !== "undefined") {
        if (window.devicePixelRatio) return window.devicePixelRatio;
        else {
            var screen = window.screen;
            if (screen && screen.deviceXDPI && screen.logicalXDPI) return screen.deviceXDPI / screen.logicalXDPI;
            else if (screen && screen.systemXDPI && screen.logicalXDPI) return screen.systemXDPI / screen.logicalXDPI;
        }
    }
    return $fde33e6418df4cd4$var$defaultPixelRatio;
}
module.exports = $fde33e6418df4cd4$var$pixelRatio;

});

parcelRegister("6InGT", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
// Returns whether n is a power of two.
function $4e393aa11a91fd82$var$ispot(n) {
    return (n & n - 1) == 0;
}
module.exports = $4e393aa11a91fd82$var$ispot;

});

parcelRegister("dBMHD", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
function $9e84826b89c9752f$var$prefixProperty(property) {
    var style = document.documentElement.style;
    var prefixList = [
        "Moz",
        "Webkit",
        "Khtml",
        "O",
        "ms"
    ];
    for(var i = 0; i < prefixList.length; i++){
        var prefix = prefixList[i];
        var capitalizedProperty = property[0].toUpperCase() + property.slice(1);
        var prefixedProperty = prefix + capitalizedProperty;
        if (prefixedProperty in style) return prefixedProperty;
    }
    return property;
}
function $9e84826b89c9752f$var$getWithVendorPrefix(property) {
    var prefixedProperty = $9e84826b89c9752f$var$prefixProperty(property);
    return function getPropertyWithVendorPrefix(element) {
        return element.style[prefixedProperty];
    };
}
function $9e84826b89c9752f$var$setWithVendorPrefix(property) {
    var prefixedProperty = $9e84826b89c9752f$var$prefixProperty(property);
    return function setPropertyWithVendorPrefix(element, val) {
        return element.style[prefixedProperty] = val;
    };
}
var $9e84826b89c9752f$var$setTransform = $9e84826b89c9752f$var$setWithVendorPrefix("transform");
var $9e84826b89c9752f$var$setTransformOrigin = $9e84826b89c9752f$var$setWithVendorPrefix("transformOrigin");
function $9e84826b89c9752f$var$setNullTransform(element) {
    $9e84826b89c9752f$var$setTransform(element, "translateZ(0)");
}
function $9e84826b89c9752f$var$setNullTransformOrigin(element) {
    $9e84826b89c9752f$var$setTransformOrigin(element, "0 0 0");
}
function $9e84826b89c9752f$var$setAbsolute(element) {
    element.style.position = "absolute";
}
function $9e84826b89c9752f$var$setPixelPosition(element, x, y) {
    element.style.left = x + "px";
    element.style.top = y + "px";
}
function $9e84826b89c9752f$var$setPixelSize(element, width, height) {
    element.style.width = width + "px";
    element.style.height = height + "px";
}
function $9e84826b89c9752f$var$setNullSize(element) {
    element.style.width = element.style.height = 0;
}
function $9e84826b89c9752f$var$setFullSize(element) {
    element.style.width = element.style.height = "100%";
}
function $9e84826b89c9752f$var$setOverflowHidden(element) {
    element.style.overflow = "hidden";
}
function $9e84826b89c9752f$var$setOverflowVisible(element) {
    element.style.overflow = "visible";
}
function $9e84826b89c9752f$var$setNoPointerEvents(element) {
    element.style.pointerEvents = "none";
}
function $9e84826b89c9752f$var$setBlocking(element) {
    element.style.backgroundColor = "#000";
    element.style.opacity = "0";
    element.style.filter = "alpha(opacity=0)";
}
module.exports = {
    prefixProperty: $9e84826b89c9752f$var$prefixProperty,
    getWithVendorPrefix: $9e84826b89c9752f$var$getWithVendorPrefix,
    setWithVendorPrefix: $9e84826b89c9752f$var$setWithVendorPrefix,
    setTransform: $9e84826b89c9752f$var$setTransform,
    setTransformOrigin: $9e84826b89c9752f$var$setTransformOrigin,
    setNullTransform: $9e84826b89c9752f$var$setNullTransform,
    setNullTransformOrigin: $9e84826b89c9752f$var$setNullTransformOrigin,
    setAbsolute: $9e84826b89c9752f$var$setAbsolute,
    setPixelPosition: $9e84826b89c9752f$var$setPixelPosition,
    setPixelSize: $9e84826b89c9752f$var$setPixelSize,
    setNullSize: $9e84826b89c9752f$var$setNullSize,
    setFullSize: $9e84826b89c9752f$var$setFullSize,
    setOverflowHidden: $9e84826b89c9752f$var$setOverflowHidden,
    setOverflowVisible: $9e84826b89c9752f$var$setOverflowVisible,
    setNoPointerEvents: $9e84826b89c9752f$var$setNoPointerEvents,
    setBlocking: $9e84826b89c9752f$var$setBlocking
};

});


parcelRegister("kgURn", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $7wjV9 = parcelRequire("7wjV9");

var $5k1DD = parcelRequire("5k1DD");

var $3owNE = parcelRequire("3owNE");

var $W9Vbx = parcelRequire("W9Vbx");

var $Yar88 = parcelRequire("Yar88");

var $dBMHD = parcelRequire("dBMHD");
var $ec21687300627257$require$setAbsolute = $dBMHD.setAbsolute;

var $dBMHD = parcelRequire("dBMHD");
var $ec21687300627257$require$setFullSize = $dBMHD.setFullSize;

var $dBMHD = parcelRequire("dBMHD");
var $ec21687300627257$require$setNullTransformOrigin = $dBMHD.setNullTransformOrigin;

var $2Xxut = parcelRequire("2Xxut");
// Browser-specific workarounds.
var $ec21687300627257$var$browserQuirks = {
    // On most browsers we need to pad the tile edges with repeated pixels so
    // that the borders between neighboring tiles aren't apparent.
    // On iOS this isn't required, but we must disable it because the padding is
    // incorrectly rendered on top of the neighboring tile.
    padSize: $W9Vbx.ios ? 0 : 3,
    // In order to prevent fallback tiles from overlapping their children, iOS
    // requires smaller zoom levels to be placed below larger zoom levels in
    // the CSS 3D coordinate space.
    reverseLevelDepth: $W9Vbx.ios,
    // A null transform on the layer element is required so that transitions
    // between layers work on iOS.
    useNullTransform: $W9Vbx.ios,
    // On Webkit and Gecko browsers, some tiles become invisible at certain
    // angles, usually non-floor tiles when looking straight down. Setting the
    // translateZ following the perspective transform to a slightly larger value
    // than the latter seems to work around this glitch.
    perspectiveNudge: $W9Vbx.webkit || $W9Vbx.gecko ? 0.001 : 0
};
/**
 * @class CssStage
 * @extends Stage
 * @classdesc
 *
 * A {@link Stage} implementation using CSS 3D Transforms.
 *
 * @param {Object} opts
 *
 * Also see the available {@link Stage} options.
 */ function $ec21687300627257$var$CssStage(opts) {
    this.constructor.super_.call(this, opts);
    this._loader = new $5k1DD(this);
    this._domElement = document.createElement("div");
    $ec21687300627257$require$setAbsolute(this._domElement);
    $ec21687300627257$require$setFullSize(this._domElement);
// N.B. the CSS stage requires device adaptation to be configured through
// the <meta name="viewport"> tag on the containing document.
// Failure to do so will cause clipping and padding bugs to occur,
// at least on iOS <= 7.
}
$Yar88($ec21687300627257$var$CssStage, $7wjV9);
/**
 * Destructor.
 */ $ec21687300627257$var$CssStage.prototype.destroy = function() {
    // Delegate clearing own properties to the Stage destructor.
    this.constructor.super_.prototype.destroy.call(this);
};
$ec21687300627257$var$CssStage.supported = function() {
    return $3owNE();
};
/**
 * Returns the underlying DOM element.
 *
 * @return {Element}
 */ $ec21687300627257$var$CssStage.prototype.domElement = function() {
    return this._domElement;
};
$ec21687300627257$var$CssStage.prototype.setSizeForType = function() {};
$ec21687300627257$var$CssStage.prototype.loadImage = function(url, rect, done) {
    return this._loader.loadImage(url, rect, done);
};
$ec21687300627257$var$CssStage.prototype.validateLayer = function(layer) {
    return; // always valid
};
$ec21687300627257$var$CssStage.prototype.createRenderer = function(Renderer) {
    return new Renderer(this._domElement, $ec21687300627257$var$browserQuirks);
};
$ec21687300627257$var$CssStage.prototype.destroyRenderer = function(renderer) {
    renderer.destroy();
};
$ec21687300627257$var$CssStage.prototype.startFrame = function() {};
$ec21687300627257$var$CssStage.prototype.endFrame = function() {};
$ec21687300627257$var$CssStage.prototype.takeSnapshot = function() {
    throw new Error("CssStage: takeSnapshot not implemented");
};
$ec21687300627257$var$CssStage.type = $ec21687300627257$var$CssStage.prototype.type = "css";
function $ec21687300627257$var$CssTexture(stage, tile, asset) {
    var canvas = document.createElement("canvas");
    $ec21687300627257$require$setAbsolute(canvas);
    $ec21687300627257$require$setNullTransformOrigin(canvas);
    this._canvas = canvas;
    this._timestamp = null;
    this.refresh(tile, asset);
}
$ec21687300627257$var$CssTexture.prototype.refresh = function(tile, asset) {
    // Check whether the texture needs to be updated.
    var timestamp = asset.timestamp();
    if (timestamp === this._timestamp) return;
    this._timestamp = timestamp;
    var canvas = this._canvas;
    var ctx = canvas.getContext("2d");
    // Get asset element.
    var element = asset.element();
    // Get tile dimensions.
    var tileWidth = tile.width();
    var tileHeight = tile.height();
    // Get padding sizes.
    var padSize = $ec21687300627257$var$browserQuirks.padSize;
    var padTop = tile.padTop() ? padSize : 0;
    var padBottom = tile.padBottom() ? padSize : 0;
    var padLeft = tile.padLeft() ? padSize : 0;
    var padRight = tile.padRight() ? padSize : 0;
    // Set canvas size.
    canvas.width = padLeft + tileWidth + padRight;
    canvas.height = padTop + tileHeight + padBottom;
    // Draw image.
    ctx.drawImage(element, padLeft, padTop, tileWidth, tileHeight);
    var i;
    // Draw top padding.
    for(i = 0; i < padTop; i++)ctx.drawImage(canvas, padLeft, padTop, tileWidth, 1, padLeft, i, tileWidth, 1);
    // Draw left padding.
    for(i = 0; i < padLeft; i++)ctx.drawImage(canvas, padLeft, padTop, 1, tileHeight, i, padTop, 1, tileHeight);
    // Draw bottom padding.
    for(i = 0; i < padBottom; i++)ctx.drawImage(canvas, padLeft, padTop + tileHeight - 1, tileWidth, 1, padLeft, padTop + tileHeight + i, tileWidth, 1);
    // Draw right padding.
    for(i = 0; i < padRight; i++)ctx.drawImage(canvas, padLeft + tileWidth - 1, padTop, 1, tileHeight, padLeft + tileWidth + i, padTop, 1, tileHeight);
};
$ec21687300627257$var$CssTexture.prototype.destroy = function() {
    // TODO: investigate whether keeping a pool of canvases instead of
    // creating new ones on demand improves performance.
    $2Xxut(this);
};
$ec21687300627257$var$CssStage.TextureClass = $ec21687300627257$var$CssStage.prototype.TextureClass = $ec21687300627257$var$CssTexture;
module.exports = $ec21687300627257$var$CssStage;

});
parcelRegister("3owNE", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $dBMHD = parcelRequire("dBMHD");
var $278d0e5ef4071395$require$prefixProperty = $dBMHD.prefixProperty;
// Detect CSS 3D transforms support. Adapted from Modernizr.
function $278d0e5ef4071395$var$checkCssSupported() {
    // First, check if the 'perspective' CSS property or a vendor-prefixed
    // variant is available.
    var perspectiveProperty = $278d0e5ef4071395$require$prefixProperty("perspective");
    var el = document.createElement("div");
    var supported = typeof el.style[perspectiveProperty] !== "undefined";
    // Certain versions of Chrome disable 3D transforms even though the CSS
    // property exists. In those cases, we use the following media query,
    // which only succeeds if the feature is indeed enabled.
    if (supported && perspectiveProperty === "WebkitPerspective") {
        var id = "__marzipano_test_css3d_support__";
        var st = document.createElement("style");
        st.textContent = "@media(-webkit-transform-3d){#" + id + "{height: 3px;})";
        document.getElementsByTagName("head")[0].appendChild(st);
        el.id = id;
        document.body.appendChild(el);
        // The offsetHeight seems to be different than 3 at some zoom levels on
        // Chrome (and maybe other browsers). Test for > 0 instead.
        supported = el.offsetHeight > 0;
        st.parentNode.removeChild(st);
        el.parentNode.removeChild(el);
    }
    return supported;
}
// Cache result.
var $278d0e5ef4071395$var$supported;
function $278d0e5ef4071395$var$cssSupported() {
    if ($278d0e5ef4071395$var$supported !== undefined) return $278d0e5ef4071395$var$supported;
    return $278d0e5ef4071395$var$supported = $278d0e5ef4071395$var$checkCssSupported();
}
module.exports = $278d0e5ef4071395$var$cssSupported;

});


parcelRegister("lUg8r", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $7wjV9 = parcelRequire("7wjV9");

var $54X95 = parcelRequire("54X95");

var $1IPfd = parcelRequire("1IPfd");

var $hluEj = parcelRequire("hluEj");

var $Yar88 = parcelRequire("Yar88");

var $9aPxp = parcelRequire("9aPxp");

var $dBMHD = parcelRequire("dBMHD");
var $ff2b580a383d48d8$require$setAbsolute = $dBMHD.setAbsolute;

var $dBMHD = parcelRequire("dBMHD");
var $ff2b580a383d48d8$require$setFullSize = $dBMHD.setFullSize;

var $dBMHD = parcelRequire("dBMHD");
var $ff2b580a383d48d8$require$setBlocking = $dBMHD.setBlocking;

var $2Xxut = parcelRequire("2Xxut");
// Default Flash wmode.
var $ff2b580a383d48d8$var$defaultWMode = "transparent";
// Default Flash SWF path. By default, expect the SWF to be named marzipano.swf
// and located in the same directory as the current script. The default path
// may be overridden by passing the `swfPath` option into the Viewer or Stage
// constructor.
var $ff2b580a383d48d8$var$defaultSwfPath = function() {
    var script = document.currentScript;
    if (!script) {
        // This will produce the wrong result if the current script is loaded with
        // the `async` or `defer` options, or exec'ed from a string. The user is
        // expected to supply a custom `swfPath` in these cases.
        var scripts = document.getElementsByTagName("script");
        script = scripts.length ? scripts[scripts.length - 1] : null;
    }
    if (!script) return null;
    var path = script.src;
    var slash = path.lastIndexOf("/");
    if (slash >= 0) path = path.slice(0, slash + 1);
    else path = "";
    return path + "marzipano.swf";
}();
// Callbacks must be exposed in a global object to be called from Flash.
// The global object maps each stage ID into the respective callbacks.
// To prevent multiple Marzipano instances from clobbering the callbacks
// for each other's stages, the next available stage ID must be shared among
// the instances. We cache this value in a special property of the global
// callback object.
var $ff2b580a383d48d8$var$callbackObjectName = "MarzipanoFlashCallbackMap";
if (!($ff2b580a383d48d8$var$callbackObjectName in window)) window[$ff2b580a383d48d8$var$callbackObjectName] = {
    __next: 0
};
// Get the next available Flash stage ID.
function $ff2b580a383d48d8$var$nextFlashStageId() {
    return window[$ff2b580a383d48d8$var$callbackObjectName].__next++;
}
// Names of the callbacks called from Flash. Presently there is only one.
var $ff2b580a383d48d8$var$callbackNames = [
    "imageLoaded"
];
// Browser-specific workarounds.
var $ff2b580a383d48d8$var$flashQuirks = {
    // How many repeated pixels to add around tile edges to suppress visible seams.
    padSize: 3
};
/**
 * @class FlashStage
 * @extends Stage
 * @classdesc
 *
 * A {@link Stage} implementation using Flash.
 *
 * @param {Object} opts
 * @param {string} [opts.wmode='transparent']
 * @param {string} [opts.swfPath]
 *
 * The `wmode` option controls transparency, layering and compositing of the
 * Flash element into the web page. For more information see:
 * http://helpx.adobe.com/flash/kb/flash-object-embed-tag-attributes.html
 *
 * The `swfPath` option denotes the path to the `marzipano.swf` file. It
 * defaults to the location of `marzipano.js` by looking for a script tag with
 * that name.
 *
 * Also see the available {@link Stage} options.
 */ function $ff2b580a383d48d8$var$FlashStage(opts) {
    this.constructor.super_.call(this, opts);
    this._wmode = opts && opts.wmode || $ff2b580a383d48d8$var$defaultWMode;
    this._swfPath = opts && opts.swfPath || $ff2b580a383d48d8$var$defaultSwfPath;
    if (!$ff2b580a383d48d8$var$defaultSwfPath) throw new Error("Missing SWF path");
    // Setup JavaScript callbacks to be called from Flash land when
    // asynchronous operations terminate.
    this._flashStageId = $ff2b580a383d48d8$var$nextFlashStageId();
    this._callbacksObj = window[$ff2b580a383d48d8$var$callbackObjectName][this._flashStageId] = {};
    this._stageCallbacksObjVarName = $ff2b580a383d48d8$var$callbackObjectName + "[" + this._flashStageId + "]";
    this._callbackListeners = {};
    for(var i = 0; i < $ff2b580a383d48d8$var$callbackNames.length; i++)this._callbacksObj[$ff2b580a383d48d8$var$callbackNames[i]] = this._callListeners($ff2b580a383d48d8$var$callbackNames[i]);
    this._loader = new $54X95(this);
    // Queue for loadImage calls.
    // The queue starts paused so that loadImage calls occurring before Flash
    // is ready do not start right away (as they would fail).
    // TODO: This is awkward. The stage must signal that it's ready to load
    // images, but queuing should otherwise be implemented by the loader.
    this._loadImageQueue = new $hluEj();
    this._loadImageQueue.pause();
    // Whether flash is ready to be called from JavaScript.
    this._flashReady = false;
    // Add an ID to each renderer/layer, so that it can be identified within
    // the ActionScript program.
    this._nextLayerId = 0;
    // Create the DOM elements.
    var elements = $ff2b580a383d48d8$var$createDomElements(this._swfPath, this._flashStageId, this._stageCallbacksObjVarName);
    this._domElement = elements.root;
    this._blockingElement = elements.blocking;
    this._flashElement = elements.flash;
    // Wake up the render loop when we are ready (only after element is added to the DOM)
    this._checkReadyTimer = setInterval(this._checkReady.bind(this), 50);
}
$Yar88($ff2b580a383d48d8$var$FlashStage, $7wjV9);
/**
 * Destructor.
 */ $ff2b580a383d48d8$var$FlashStage.prototype.destroy = function() {
    window[$ff2b580a383d48d8$var$callbackObjectName][this._flashStageId] = null;
    if (this._checkReadyTimer != null) clearInterval(this._checkReadyTimer);
    // Delegate clearing own properties to the Stage destructor.
    this.constructor.super_.prototype.destroy.call(this);
};
$ff2b580a383d48d8$var$FlashStage.supported = function() {
    return $1IPfd();
};
/**
 * Returns the underlying DOM element.
 * @return {Element}
 */ $ff2b580a383d48d8$var$FlashStage.prototype.domElement = function() {
    return this._domElement;
};
/**
 * Returns the underlying Flash element.
 * @return {Element}
 */ $ff2b580a383d48d8$var$FlashStage.prototype.flashElement = function() {
    return this._flashElement;
};
$ff2b580a383d48d8$var$FlashStage.prototype.setSizeForType = function() {};
$ff2b580a383d48d8$var$FlashStage.prototype.loadImage = function(url, rect, done) {
    // TODO: Move the queuing into the loader, which avoids this nonsense.
    var loadFn = this._loader.loadImage.bind(this._loader, url, rect);
    return this._loadImageQueue.push(loadFn, done);
};
$ff2b580a383d48d8$var$FlashStage.prototype.validateLayer = function(layer) {
    return; // always valid
};
$ff2b580a383d48d8$var$FlashStage.prototype.addFlashCallbackListener = function(callbackName, f) {
    this._callbackListeners[callbackName] = this._callbackListeners[callbackName] || [];
    this._callbackListeners[callbackName].push(f);
};
$ff2b580a383d48d8$var$FlashStage.prototype.removeFlashCallbackListener = function(callbackName, f) {
    var listeners = this._callbackListeners[callbackName] || [];
    var index = listeners.indexOf(f);
    if (index >= 0) listeners.splice(index, 1);
};
$ff2b580a383d48d8$var$FlashStage.prototype._callListeners = function(callbackName) {
    var self = this;
    return function callListeners() {
        var listeners = self._callbackListeners[callbackName] || [];
        for(var i = 0; i < listeners.length; i++){
            // JavaScript executed on calls from Flash does not throw exceptions.
            // Executing the callback in a new stack frame fixes this.
            var listener = listeners[i];
            $9aPxp(listener, arguments);
        }
    };
};
$ff2b580a383d48d8$var$FlashStage.prototype._checkReady = function() {
    if (!this._flashElement || !this._flashElement.isReady || !this._flashElement.isReady()) // Not ready yet.
    return false;
    // Mark as ready.
    this._flashReady = true;
    // Disable interval timer.
    clearTimeout(this._checkReadyTimer);
    this._checkReadyTimer = null;
    // Resume image loading queue.
    this._loadImageQueue.resume();
    // Force next render.
    this.emit("renderInvalid");
    return true;
};
function $ff2b580a383d48d8$var$createDomElements(swfPath, id, stageCallbacksObjVarName) {
    var rootElement = document.createElement("div");
    $ff2b580a383d48d8$require$setAbsolute(rootElement);
    $ff2b580a383d48d8$require$setFullSize(rootElement);
    // The Flash object must have `id` and `name` attributes, otherwise
    // ExternalInterface calls will not work.
    var elementId = "marzipano-flash-stage-" + id;
    var objectStr = '<object id="' + elementId + '" name="' + elementId + '" type="application/x-shockwave-flash" data="' + swfPath + '">';
    var paramsStr = "";
    paramsStr += '<param name="movie" value="' + swfPath + '" />';
    paramsStr += '<param name="allowscriptaccess" value="always" />';
    paramsStr += '<param name="flashvars" value="callbacksObjName=' + stageCallbacksObjVarName + '" />';
    paramsStr += '<param name="wmode" value="transparent" />';
    objectStr += paramsStr;
    objectStr += "</object>";
    // Embed Flash into the DOM.
    // Adding children into an <object> element doesn't work, so we create a
    // temporary element and set its innerHTML.
    var tmpElement = document.createElement("div");
    tmpElement.innerHTML = objectStr;
    var flashElement = tmpElement.firstChild;
    $ff2b580a383d48d8$require$setAbsolute(flashElement);
    $ff2b580a383d48d8$require$setFullSize(flashElement);
    rootElement.appendChild(flashElement);
    // Create blocking element to prevent events from being caught by Flash.
    var blockingElement = document.createElement("div");
    $ff2b580a383d48d8$require$setAbsolute(blockingElement);
    $ff2b580a383d48d8$require$setFullSize(blockingElement);
    $ff2b580a383d48d8$require$setBlocking(blockingElement);
    rootElement.appendChild(blockingElement);
    return {
        root: rootElement,
        flash: flashElement,
        blocking: blockingElement
    };
}
$ff2b580a383d48d8$var$FlashStage.prototype.createRenderer = function(Renderer) {
    return new Renderer(this._flashElement, ++this._nextLayerId, $ff2b580a383d48d8$var$flashQuirks);
};
$ff2b580a383d48d8$var$FlashStage.prototype.destroyRenderer = function(renderer) {
    renderer.destroy();
};
$ff2b580a383d48d8$var$FlashStage.prototype.startFrame = function() {};
$ff2b580a383d48d8$var$FlashStage.prototype.endFrame = function() {};
$ff2b580a383d48d8$var$FlashStage.prototype.takeSnapshot = function(options) {
    // Validate argument.
    if (typeof options !== "object" || options == null) options = {};
    var quality = options.quality;
    // Set default quality if it is not passed in.
    if (typeof quality == "undefined") quality = 75;
    // Throw if quality is of invlid type or out of bounds.
    if (typeof quality !== "number" || quality < 0 || quality > 100) throw new Error("FlashStage: Snapshot quality needs to be a number between 0 and 100");
    // Return the snapshot by executing a flash-exported method.
    return this._flashElement.takeSnapshot(quality);
};
$ff2b580a383d48d8$var$FlashStage.type = $ff2b580a383d48d8$var$FlashStage.prototype.type = "flash";
function $ff2b580a383d48d8$var$FlashTexture(stage, tile, asset) {
    // Get image id.
    var imageId = asset.element();
    // Get tile dimensions.
    var tileWidth = tile.width();
    var tileHeight = tile.height();
    // Get padding sizes.
    var padSize = $ff2b580a383d48d8$var$flashQuirks.padSize;
    var padTop = tile.padTop() ? padSize : 0;
    var padBottom = tile.padBottom() ? padSize : 0;
    var padLeft = tile.padLeft() ? padSize : 0;
    var padRight = tile.padRight() ? padSize : 0;
    var textureId = stage._flashElement.createTexture(imageId, tileWidth, tileHeight, padTop, padBottom, padLeft, padRight);
    this._stage = stage;
    this._textureId = textureId;
}
$ff2b580a383d48d8$var$FlashTexture.prototype.refresh = function(tile, asset) {
// TODO: This is required for the Flash stage to support dynamic textures.
// However, there are currently no dynamic textures that work with the
// Flash stage.
};
$ff2b580a383d48d8$var$FlashTexture.prototype.destroy = function() {
    this._stage._flashElement.destroyTexture(this._textureId);
    $2Xxut(this);
};
$ff2b580a383d48d8$var$FlashStage.TextureClass = $ff2b580a383d48d8$var$FlashStage.prototype.TextureClass = $ff2b580a383d48d8$var$FlashTexture;
module.exports = $ff2b580a383d48d8$var$FlashStage;

});
parcelRegister("54X95", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $3S0Tf = parcelRequire("3S0Tf");

var $1Cfry = parcelRequire("1Cfry");

var $9ZuRa = parcelRequire("9ZuRa");
// TODO: Move the load queue into the loader.
/**
 * @class FlashImageLoader
 * @implements ImageLoader
 * @classdesc
 *
 * A {@link Loader} for Flash images.
 *
 * @param {Stage} stage The stage which is going to request images to be loaded.
 */ function $3b2b348b66bf18e8$var$FlashImageLoader(stage) {
    if (stage.type !== "flash") throw new Error("Stage type incompatible with loader");
    this._stage = stage;
}
/**
 * Loads an {@link Asset} from an image.
 * @param {string} url The image URL.
 * @param {?Rect} rect A {@link Rect} describing a portion of the image, or null
 *     to use the full image.
 * @param {function(?Error, Asset)} done The callback.
 * @return {function()} A function to cancel loading.
 */ $3b2b348b66bf18e8$var$FlashImageLoader.prototype.loadImage = function(url, rect, done) {
    var stage = this._stage;
    var flashElement = stage.flashElement();
    var x = rect && rect.x || 0;
    var y = rect && rect.y || 0;
    var width = rect && rect.width || 1;
    var height = rect && rect.height || 1;
    var imageId = flashElement.loadImage(url, width, height, x, y);
    done = $9ZuRa(done);
    // TODO: use a single callback for all imageLoaded events.
    function callback(err, callbackId) {
        // There is a single callback for all load events, so make sure this
        // is the right one.
        if (callbackId !== imageId) return;
        stage.removeFlashCallbackListener("imageLoaded", callback);
        // TODO: is there any way to distinguish a network error from other
        // kinds of errors? For now we always return NetworkError since this
        // prevents images to be retried continuously while we are offline.
        if (err) done(new $1Cfry("Network error: " + url));
        else done(null, new $3S0Tf(flashElement, imageId));
    }
    stage.addFlashCallbackListener("imageLoaded", callback);
    function cancel() {
        flashElement.cancelImage(imageId);
        stage.removeFlashCallbackListener("imageLoaded", callback);
        done.apply(null, arguments);
    }
    return cancel;
};
module.exports = $3b2b348b66bf18e8$var$FlashImageLoader;

});
parcelRegister("3S0Tf", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $6mia6 = parcelRequire("6mia6");

var $2Xxut = parcelRequire("2Xxut");
/**
 * @class FlashAsset
 * @implements Asset
 * @classdesc
 *
 * An immutable {@link Asset} compatible with {@link FlashStage}.
 * 
 * The asset's underlying pixel source is a unique image ID associated with
 * a Flash application.
 *
 * @param {Element} flashElement The HTML element for the Flash application.
 * @param {number} imageId The unique image ID inside the Flash application.
 */ function $2d171afb078671be$var$FlashAsset(flashElement, imageId) {
    this._flashElement = flashElement;
    this._imageId = imageId;
}
$6mia6($2d171afb078671be$var$FlashAsset);
/**
 * Destructor.
 */ $2d171afb078671be$var$FlashAsset.prototype.destroy = function() {
    this._flashElement.unloadImage(this._imageId);
    $2Xxut(this);
};
$2d171afb078671be$var$FlashAsset.prototype.element = function() {
    return this._imageId;
};
$2d171afb078671be$var$FlashAsset.prototype.width = function() {
    // Not actually used anywhere.
    return 0;
};
$2d171afb078671be$var$FlashAsset.prototype.height = function() {
    // Not actually used anywhere.
    return 0;
};
$2d171afb078671be$var$FlashAsset.prototype.timestamp = function() {
    return 0;
};
$2d171afb078671be$var$FlashAsset.prototype.isDynamic = function() {
    return false;
};
module.exports = $2d171afb078671be$var$FlashAsset;

});


parcelRegister("1IPfd", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
// Detect supported Flash version. Returns [major, minor, rev] or null.
// Adapted from https://code.google.com/p/swfobject
function $1411a68d9347b03f$var$detectFlashVersion() {
    var playerVersion = null;
    var plugins = navigator.plugins;
    var mimeTypes = navigator.mimeTypes;
    var d = null;
    if (plugins && plugins["Shockwave Flash"] && mimeTypes && mimeTypes["application/x-shockwave-flash"] && mimeTypes["application/x-shockwave-flash"].enabledPlugin) {
        d = plugins["Shockwave Flash"].description;
        d = d.replace(/^.*\s+(\S+\s+\S+$)/, "$1");
        playerVersion = [
            0,
            0,
            0
        ];
        playerVersion[0] = parseInt(d.replace(/^(.*)\..*$/, "$1"), 10);
        playerVersion[1] = parseInt(d.replace(/^.*\.(.*)\s.*$/, "$1"), 10);
        playerVersion[2] = /[a-zA-Z]/.test(d) ? parseInt(d.replace(/^.*[a-zA-Z]+(.*)$/, "$1"), 10) : 0;
    } else if (window.ActiveXObject) try {
        var a = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
        if (a && (d = a.GetVariable("$version"))) {
            d = d.split(" ")[1].split(",");
            playerVersion = [
                parseInt(d[0], 10),
                parseInt(d[1], 10),
                parseInt(d[2], 10)
            ];
        }
    } catch (e) {}
    return playerVersion;
}
// Flash support detection.
function $1411a68d9347b03f$var$checkFlashSupported() {
    var version = $1411a68d9347b03f$var$detectFlashVersion();
    // Only support 10.1 and above. Flash 10.0 does not work for some reason.
    return version && (version[0] >= 11 || version[0] === 10 && version[1] >= 1);
}
// Cache result.
var $1411a68d9347b03f$var$supported;
function $1411a68d9347b03f$var$flashSupported() {
    if ($1411a68d9347b03f$var$supported !== undefined) return $1411a68d9347b03f$var$supported;
    return $1411a68d9347b03f$var$supported = $1411a68d9347b03f$var$checkFlashSupported();
}
module.exports = $1411a68d9347b03f$var$flashSupported;

});

parcelRegister("9aPxp", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
function $6add06942ae41107$var$defer(fn, args) {
    function deferred() {
        if (args && args.length > 0) fn.apply(null, args);
        else fn();
    }
    setTimeout(deferred, 0);
}
module.exports = $6add06942ae41107$var$defer;

});


parcelRegister("b7h3a", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $bKQXE = parcelRequire("bKQXE");

var $Yar88 = parcelRequire("Yar88");
/**
 * @class WebGlCubeRenderer
 * @implements Renderer
 * @classdesc
 *
 * A renderer for {@link CubeGeometry} and {@link RectilinearView}, appropriate
 * for a {@link WebGlStage}.
 *
 * Most users do not need to instantiate this class. Renderers are created and
 * destroyed by {@link Stage} as necessary.
 */ function $817d92f1c56df95d$var$WebGlCubeRenderer() {
    this.constructor.super_.apply(this, arguments);
}
$Yar88($817d92f1c56df95d$var$WebGlCubeRenderer, $bKQXE);
module.exports = $817d92f1c56df95d$var$WebGlCubeRenderer;

});
parcelRegister("bKQXE", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $c3mW8 = parcelRequire("c3mW8");
var $fwwPx = parcelRequire("fwwPx");
var $88ed1296090d26cd$require$mat4 = $c3mW8;

var $c3mW8 = parcelRequire("c3mW8");
var $fwwPx = parcelRequire("fwwPx");
var $88ed1296090d26cd$require$vec3 = $fwwPx;

var $2Xxut = parcelRequire("2Xxut");

var $3KYUN = parcelRequire("3KYUN");
var $88ed1296090d26cd$var$createConstantBuffers = $3KYUN.createConstantBuffers;
var $88ed1296090d26cd$var$destroyConstantBuffers = $3KYUN.destroyConstantBuffers;
var $88ed1296090d26cd$var$createShaderProgram = $3KYUN.createShaderProgram;
var $88ed1296090d26cd$var$destroyShaderProgram = $3KYUN.destroyShaderProgram;
var $88ed1296090d26cd$var$enableAttributes = $3KYUN.enableAttributes;
var $88ed1296090d26cd$var$disableAttributes = $3KYUN.disableAttributes;
var $88ed1296090d26cd$var$setViewport = $3KYUN.setViewport;
var $88ed1296090d26cd$var$setupPixelEffectUniforms = $3KYUN.setupPixelEffectUniforms;
var $88ed1296090d26cd$var$setDepth = $3KYUN.setDepth;
var $88ed1296090d26cd$var$setTexture = $3KYUN.setTexture;

var $o1WjV = parcelRequire("o1WjV");

var $7d8BE = parcelRequire("7d8BE");
var $88ed1296090d26cd$var$vertexIndices = [
    0,
    1,
    2,
    0,
    2,
    3
];
var $88ed1296090d26cd$var$vertexPositions = [
    -0.5,
    -0.5,
    0.0,
    0.5,
    -0.5,
    0.0,
    0.5,
    0.5,
    0.0,
    -0.5,
    0.5,
    0.0
];
var $88ed1296090d26cd$var$textureCoords = [
    0.0,
    0.0,
    1.0,
    0.0,
    1.0,
    1.0,
    0.0,
    1.0
];
var $88ed1296090d26cd$var$attribList = [
    "aVertexPosition",
    "aTextureCoord"
];
var $88ed1296090d26cd$var$uniformList = [
    "uDepth",
    "uOpacity",
    "uSampler",
    "uProjMatrix",
    "uViewportMatrix",
    "uColorOffset",
    "uColorMatrix"
];
function $88ed1296090d26cd$var$WebGlBaseRenderer(gl) {
    this.gl = gl;
    // The projection matrix positions the tiles in world space.
    // We compute it in Javascript because lack of precision in the vertex shader
    // causes seams to appear between adjacent tiles at large zoom levels.
    this.projMatrix = $88ed1296090d26cd$require$mat4.create();
    // The viewport matrix responsible for viewport clamping.
    // See setViewport() for an explanation of how it works.
    this.viewportMatrix = $88ed1296090d26cd$require$mat4.create();
    // Translation and scale vectors for tiles.
    this.translateVector = $88ed1296090d26cd$require$vec3.create();
    this.scaleVector = $88ed1296090d26cd$require$vec3.create();
    this.constantBuffers = $88ed1296090d26cd$var$createConstantBuffers(gl, $88ed1296090d26cd$var$vertexIndices, $88ed1296090d26cd$var$vertexPositions, $88ed1296090d26cd$var$textureCoords);
    this.shaderProgram = $88ed1296090d26cd$var$createShaderProgram(gl, $o1WjV, $7d8BE, $88ed1296090d26cd$var$attribList, $88ed1296090d26cd$var$uniformList);
}
$88ed1296090d26cd$var$WebGlBaseRenderer.prototype.destroy = function() {
    $88ed1296090d26cd$var$destroyConstantBuffers(this.gl, this.constantBuffers);
    $88ed1296090d26cd$var$destroyShaderProgram(this.gl, this.shaderProgram);
    $2Xxut(this);
};
$88ed1296090d26cd$var$WebGlBaseRenderer.prototype.startLayer = function(layer, rect) {
    var gl = this.gl;
    var shaderProgram = this.shaderProgram;
    var constantBuffers = this.constantBuffers;
    var viewportMatrix = this.viewportMatrix;
    gl.useProgram(shaderProgram);
    $88ed1296090d26cd$var$enableAttributes(gl, shaderProgram);
    $88ed1296090d26cd$var$setViewport(gl, layer, rect, viewportMatrix);
    gl.uniformMatrix4fv(shaderProgram.uViewportMatrix, false, viewportMatrix);
    gl.bindBuffer(gl.ARRAY_BUFFER, constantBuffers.vertexPositions);
    gl.vertexAttribPointer(shaderProgram.aVertexPosition, 3, gl.FLOAT, gl.FALSE, 0, 0);
    gl.bindBuffer(gl.ARRAY_BUFFER, constantBuffers.textureCoords);
    gl.vertexAttribPointer(shaderProgram.aTextureCoord, 2, gl.FLOAT, gl.FALSE, 0, 0);
    $88ed1296090d26cd$var$setupPixelEffectUniforms(gl, layer.effects(), {
        opacity: shaderProgram.uOpacity,
        colorOffset: shaderProgram.uColorOffset,
        colorMatrix: shaderProgram.uColorMatrix
    });
};
$88ed1296090d26cd$var$WebGlBaseRenderer.prototype.endLayer = function(layer, rect) {
    var gl = this.gl;
    var shaderProgram = this.shaderProgram;
    $88ed1296090d26cd$var$disableAttributes(gl, shaderProgram);
};
$88ed1296090d26cd$var$WebGlBaseRenderer.prototype.renderTile = function(tile, texture, layer, layerZ) {
    var gl = this.gl;
    var shaderProgram = this.shaderProgram;
    var constantBuffers = this.constantBuffers;
    var projMatrix = this.projMatrix;
    var translateVector = this.translateVector;
    var scaleVector = this.scaleVector;
    translateVector[0] = tile.centerX();
    translateVector[1] = tile.centerY();
    translateVector[2] = -0.5;
    scaleVector[0] = tile.scaleX();
    scaleVector[1] = tile.scaleY();
    scaleVector[2] = 1.0;
    $88ed1296090d26cd$require$mat4.copy(projMatrix, layer.view().projection());
    $88ed1296090d26cd$require$mat4.rotateX(projMatrix, projMatrix, tile.rotX());
    $88ed1296090d26cd$require$mat4.rotateY(projMatrix, projMatrix, tile.rotY());
    $88ed1296090d26cd$require$mat4.translate(projMatrix, projMatrix, translateVector);
    $88ed1296090d26cd$require$mat4.scale(projMatrix, projMatrix, scaleVector);
    gl.uniformMatrix4fv(shaderProgram.uProjMatrix, false, projMatrix);
    $88ed1296090d26cd$var$setDepth(gl, shaderProgram, layerZ, tile.z);
    $88ed1296090d26cd$var$setTexture(gl, shaderProgram, texture);
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, constantBuffers.vertexIndices);
    gl.drawElements(gl.TRIANGLES, $88ed1296090d26cd$var$vertexIndices.length, gl.UNSIGNED_SHORT, 0);
};
module.exports = $88ed1296090d26cd$var$WebGlBaseRenderer;

});
parcelRegister("c3mW8", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $8c678e942362b0b9$export$185802fd694ee1f5; });
$parcel$export(module.exports, "clone", function () { return $8c678e942362b0b9$export$9cd59f9826255e47; });
$parcel$export(module.exports, "copy", function () { return $8c678e942362b0b9$export$784d13d8ee351f07; });
$parcel$export(module.exports, "fromValues", function () { return $8c678e942362b0b9$export$a82be99ed2a44a7d; });
$parcel$export(module.exports, "set", function () { return $8c678e942362b0b9$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "identity", function () { return $8c678e942362b0b9$export$f0954fd7d5368655; });
$parcel$export(module.exports, "transpose", function () { return $8c678e942362b0b9$export$9cb09a71b7d66923; });
$parcel$export(module.exports, "invert", function () { return $8c678e942362b0b9$export$6897c284b6f9f4dc; });
$parcel$export(module.exports, "adjoint", function () { return $8c678e942362b0b9$export$33f3c024b4ae00a1; });
$parcel$export(module.exports, "determinant", function () { return $8c678e942362b0b9$export$a04698f914c55ed9; });
$parcel$export(module.exports, "multiply", function () { return $8c678e942362b0b9$export$2060d2db72cce88f; });
$parcel$export(module.exports, "translate", function () { return $8c678e942362b0b9$export$d73ee8ef04f5226a; });
$parcel$export(module.exports, "scale", function () { return $8c678e942362b0b9$export$dcdf75081b88279d; });
$parcel$export(module.exports, "rotate", function () { return $8c678e942362b0b9$export$bb628a54ab399bc9; });
$parcel$export(module.exports, "rotateX", function () { return $8c678e942362b0b9$export$a59c8716592e09af; });
$parcel$export(module.exports, "rotateY", function () { return $8c678e942362b0b9$export$cf71e4d4ca4d1cfd; });
$parcel$export(module.exports, "rotateZ", function () { return $8c678e942362b0b9$export$ea6eae3365de5b9c; });
$parcel$export(module.exports, "fromTranslation", function () { return $8c678e942362b0b9$export$bc9e79e74e9fddf6; });
$parcel$export(module.exports, "fromScaling", function () { return $8c678e942362b0b9$export$832ca188ffb1955d; });
$parcel$export(module.exports, "fromRotation", function () { return $8c678e942362b0b9$export$926fc125ff3c666c; });
$parcel$export(module.exports, "fromXRotation", function () { return $8c678e942362b0b9$export$dd47cc2f828c32ef; });
$parcel$export(module.exports, "fromYRotation", function () { return $8c678e942362b0b9$export$7dc997d67d2b7f33; });
$parcel$export(module.exports, "fromZRotation", function () { return $8c678e942362b0b9$export$ad5ddaedc8f405df; });
$parcel$export(module.exports, "fromRotationTranslation", function () { return $8c678e942362b0b9$export$9545ac307f2a256b; });
$parcel$export(module.exports, "fromQuat2", function () { return $8c678e942362b0b9$export$ff497f2be31cc6a; });
$parcel$export(module.exports, "getTranslation", function () { return $8c678e942362b0b9$export$202e99f82f7f0395; });
$parcel$export(module.exports, "getScaling", function () { return $8c678e942362b0b9$export$71dc54d92bd04b57; });
$parcel$export(module.exports, "getRotation", function () { return $8c678e942362b0b9$export$df3937d3b537df0a; });
$parcel$export(module.exports, "fromRotationTranslationScale", function () { return $8c678e942362b0b9$export$ddf9c55c9f2be172; });
$parcel$export(module.exports, "fromRotationTranslationScaleOrigin", function () { return $8c678e942362b0b9$export$1def1f860edc4b1f; });
$parcel$export(module.exports, "fromQuat", function () { return $8c678e942362b0b9$export$2ff2bbe382249af7; });
$parcel$export(module.exports, "frustum", function () { return $8c678e942362b0b9$export$89b5708c387cac6c; });
$parcel$export(module.exports, "perspective", function () { return $8c678e942362b0b9$export$541149539f3a4684; });
$parcel$export(module.exports, "perspectiveFromFieldOfView", function () { return $8c678e942362b0b9$export$58ae211c788e338f; });
$parcel$export(module.exports, "ortho", function () { return $8c678e942362b0b9$export$4f2167e613cfc87b; });
$parcel$export(module.exports, "lookAt", function () { return $8c678e942362b0b9$export$d924e14fd6d9aa66; });
$parcel$export(module.exports, "targetTo", function () { return $8c678e942362b0b9$export$aa67782f4dc9e52c; });
$parcel$export(module.exports, "str", function () { return $8c678e942362b0b9$export$42d51816ce590c93; });
$parcel$export(module.exports, "frob", function () { return $8c678e942362b0b9$export$326827e8268e9cdb; });
$parcel$export(module.exports, "add", function () { return $8c678e942362b0b9$export$e16d8520af44a096; });
$parcel$export(module.exports, "subtract", function () { return $8c678e942362b0b9$export$4e2d2ead65e5f7e3; });
$parcel$export(module.exports, "multiplyScalar", function () { return $8c678e942362b0b9$export$c697bed75648cdb7; });
$parcel$export(module.exports, "multiplyScalarAndAdd", function () { return $8c678e942362b0b9$export$553579f63bdd7137; });
$parcel$export(module.exports, "exactEquals", function () { return $8c678e942362b0b9$export$f2599a5cf1109d8; });
$parcel$export(module.exports, "equals", function () { return $8c678e942362b0b9$export$e9bab7fafb253603; });
$parcel$export(module.exports, "mul", function () { return $8c678e942362b0b9$export$6e3a27864ab166fe; });
$parcel$export(module.exports, "sub", function () { return $8c678e942362b0b9$export$f93b5905241a7cca; });

var $rqjzO = parcelRequire("rqjzO");
function $8c678e942362b0b9$export$185802fd694ee1f5() {
    var out = new $rqjzO.ARRAY_TYPE(16);
    if ($rqjzO.ARRAY_TYPE != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[4] = 0;
        out[6] = 0;
        out[7] = 0;
        out[8] = 0;
        out[9] = 0;
        out[11] = 0;
        out[12] = 0;
        out[13] = 0;
        out[14] = 0;
    }
    out[0] = 1;
    out[5] = 1;
    out[10] = 1;
    out[15] = 1;
    return out;
}
function $8c678e942362b0b9$export$9cd59f9826255e47(a) {
    var out = new $rqjzO.ARRAY_TYPE(16);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $8c678e942362b0b9$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $8c678e942362b0b9$export$a82be99ed2a44a7d(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    var out = new $rqjzO.ARRAY_TYPE(16);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $8c678e942362b0b9$export$adaa4cf7ef1b65be(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $8c678e942362b0b9$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $8c678e942362b0b9$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a03 = a[3];
        var a12 = a[6], a13 = a[7];
        var a23 = a[11];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a01;
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a02;
        out[9] = a12;
        out[11] = a[14];
        out[12] = a03;
        out[13] = a13;
        out[14] = a23;
    } else {
        out[0] = a[0];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a[1];
        out[5] = a[5];
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a[2];
        out[9] = a[6];
        out[10] = a[10];
        out[11] = a[14];
        out[12] = a[3];
        out[13] = a[7];
        out[14] = a[11];
        out[15] = a[15];
    }
    return out;
}
function $8c678e942362b0b9$export$6897c284b6f9f4dc(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
    return out;
}
function $8c678e942362b0b9$export$33f3c024b4ae00a1(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    out[0] = a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22);
    out[1] = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
    out[2] = a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12);
    out[3] = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
    out[4] = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
    out[5] = a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22);
    out[6] = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
    out[7] = a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12);
    out[8] = a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21);
    out[9] = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
    out[10] = a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11);
    out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
    out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
    out[13] = a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21);
    out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
    out[15] = a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11);
    return out;
}
function $8c678e942362b0b9$export$a04698f914c55ed9(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
}
function $8c678e942362b0b9$export$2060d2db72cce88f(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15]; // Cache only the current line of the second matrix
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[4];
    b1 = b[5];
    b2 = b[6];
    b3 = b[7];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[8];
    b1 = b[9];
    b2 = b[10];
    b3 = b[11];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[12];
    b1 = b[13];
    b2 = b[14];
    b3 = b[15];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    return out;
}
function $8c678e942362b0b9$export$d73ee8ef04f5226a(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
        a00 = a[0];
        a01 = a[1];
        a02 = a[2];
        a03 = a[3];
        a10 = a[4];
        a11 = a[5];
        a12 = a[6];
        a13 = a[7];
        a20 = a[8];
        a21 = a[9];
        a22 = a[10];
        a23 = a[11];
        out[0] = a00;
        out[1] = a01;
        out[2] = a02;
        out[3] = a03;
        out[4] = a10;
        out[5] = a11;
        out[6] = a12;
        out[7] = a13;
        out[8] = a20;
        out[9] = a21;
        out[10] = a22;
        out[11] = a23;
        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }
    return out;
}
function $8c678e942362b0b9$export$dcdf75081b88279d(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $8c678e942362b0b9$export$bb628a54ab399bc9(out, a, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.hypot(x, y, z);
    var s, c, t;
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    var b00, b01, b02;
    var b10, b11, b12;
    var b20, b21, b22;
    if (len < $rqjzO.EPSILON) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11]; // Construct the elements of the rotation matrix
    b00 = x * x * t + c;
    b01 = y * x * t + z * s;
    b02 = z * x * t - y * s;
    b10 = x * y * t - z * s;
    b11 = y * y * t + c;
    b12 = z * y * t + x * s;
    b20 = x * z * t + y * s;
    b21 = y * z * t - x * s;
    b22 = z * z * t + c; // Perform rotation-specific matrix multiplication
    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
    out[11] = a03 * b20 + a13 * b21 + a23 * b22;
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    return out;
}
function $8c678e942362b0b9$export$a59c8716592e09af(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[4] = a10 * c + a20 * s;
    out[5] = a11 * c + a21 * s;
    out[6] = a12 * c + a22 * s;
    out[7] = a13 * c + a23 * s;
    out[8] = a20 * c - a10 * s;
    out[9] = a21 * c - a11 * s;
    out[10] = a22 * c - a12 * s;
    out[11] = a23 * c - a13 * s;
    return out;
}
function $8c678e942362b0b9$export$cf71e4d4ca4d1cfd(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[4] = a[4];
        out[5] = a[5];
        out[6] = a[6];
        out[7] = a[7];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[0] = a00 * c - a20 * s;
    out[1] = a01 * c - a21 * s;
    out[2] = a02 * c - a22 * s;
    out[3] = a03 * c - a23 * s;
    out[8] = a00 * s + a20 * c;
    out[9] = a01 * s + a21 * c;
    out[10] = a02 * s + a22 * c;
    out[11] = a03 * s + a23 * c;
    return out;
}
function $8c678e942362b0b9$export$ea6eae3365de5b9c(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[8] = a[8];
        out[9] = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    } // Perform axis-specific matrix multiplication
    out[0] = a00 * c + a10 * s;
    out[1] = a01 * c + a11 * s;
    out[2] = a02 * c + a12 * s;
    out[3] = a03 * c + a13 * s;
    out[4] = a10 * c - a00 * s;
    out[5] = a11 * c - a01 * s;
    out[6] = a12 * c - a02 * s;
    out[7] = a13 * c - a03 * s;
    return out;
}
function $8c678e942362b0b9$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $8c678e942362b0b9$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = v[1];
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = v[2];
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $8c678e942362b0b9$export$926fc125ff3c666c(out, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.hypot(x, y, z);
    var s, c, t;
    if (len < $rqjzO.EPSILON) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c; // Perform rotation-specific matrix multiplication
    out[0] = x * x * t + c;
    out[1] = y * x * t + z * s;
    out[2] = z * x * t - y * s;
    out[3] = 0;
    out[4] = x * y * t - z * s;
    out[5] = y * y * t + c;
    out[6] = z * y * t + x * s;
    out[7] = 0;
    out[8] = x * z * t + y * s;
    out[9] = y * z * t - x * s;
    out[10] = z * z * t + c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $8c678e942362b0b9$export$dd47cc2f828c32ef(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = c;
    out[6] = s;
    out[7] = 0;
    out[8] = 0;
    out[9] = -s;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $8c678e942362b0b9$export$7dc997d67d2b7f33(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = 0;
    out[2] = -s;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = s;
    out[9] = 0;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $8c678e942362b0b9$export$ad5ddaedc8f405df(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad); // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = 0;
    out[4] = -s;
    out[5] = c;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $8c678e942362b0b9$export$9545ac307f2a256b(out, q, v) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - (yy + zz);
    out[1] = xy + wz;
    out[2] = xz - wy;
    out[3] = 0;
    out[4] = xy - wz;
    out[5] = 1 - (xx + zz);
    out[6] = yz + wx;
    out[7] = 0;
    out[8] = xz + wy;
    out[9] = yz - wx;
    out[10] = 1 - (xx + yy);
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $8c678e942362b0b9$export$ff497f2be31cc6a(out, a) {
    var translation = new $rqjzO.ARRAY_TYPE(3);
    var bx = -a[0], by = -a[1], bz = -a[2], bw = a[3], ax = a[4], ay = a[5], az = a[6], aw = a[7];
    var magnitude = bx * bx + by * by + bz * bz + bw * bw; //Only scale if it makes sense
    if (magnitude > 0) {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2 / magnitude;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2 / magnitude;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2 / magnitude;
    } else {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
    }
    $8c678e942362b0b9$export$9545ac307f2a256b(out, a, translation);
    return out;
}
function $8c678e942362b0b9$export$202e99f82f7f0395(out, mat) {
    out[0] = mat[12];
    out[1] = mat[13];
    out[2] = mat[14];
    return out;
}
function $8c678e942362b0b9$export$71dc54d92bd04b57(out, mat) {
    var m11 = mat[0];
    var m12 = mat[1];
    var m13 = mat[2];
    var m21 = mat[4];
    var m22 = mat[5];
    var m23 = mat[6];
    var m31 = mat[8];
    var m32 = mat[9];
    var m33 = mat[10];
    out[0] = Math.hypot(m11, m12, m13);
    out[1] = Math.hypot(m21, m22, m23);
    out[2] = Math.hypot(m31, m32, m33);
    return out;
}
function $8c678e942362b0b9$export$df3937d3b537df0a(out, mat) {
    var scaling = new $rqjzO.ARRAY_TYPE(3);
    $8c678e942362b0b9$export$71dc54d92bd04b57(scaling, mat);
    var is1 = 1 / scaling[0];
    var is2 = 1 / scaling[1];
    var is3 = 1 / scaling[2];
    var sm11 = mat[0] * is1;
    var sm12 = mat[1] * is2;
    var sm13 = mat[2] * is3;
    var sm21 = mat[4] * is1;
    var sm22 = mat[5] * is2;
    var sm23 = mat[6] * is3;
    var sm31 = mat[8] * is1;
    var sm32 = mat[9] * is2;
    var sm33 = mat[10] * is3;
    var trace = sm11 + sm22 + sm33;
    var S = 0;
    if (trace > 0) {
        S = Math.sqrt(trace + 1.0) * 2;
        out[3] = 0.25 * S;
        out[0] = (sm23 - sm32) / S;
        out[1] = (sm31 - sm13) / S;
        out[2] = (sm12 - sm21) / S;
    } else if (sm11 > sm22 && sm11 > sm33) {
        S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
        out[3] = (sm23 - sm32) / S;
        out[0] = 0.25 * S;
        out[1] = (sm12 + sm21) / S;
        out[2] = (sm31 + sm13) / S;
    } else if (sm22 > sm33) {
        S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
        out[3] = (sm31 - sm13) / S;
        out[0] = (sm12 + sm21) / S;
        out[1] = 0.25 * S;
        out[2] = (sm23 + sm32) / S;
    } else {
        S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
        out[3] = (sm12 - sm21) / S;
        out[0] = (sm31 + sm13) / S;
        out[1] = (sm23 + sm32) / S;
        out[2] = 0.25 * S;
    }
    return out;
}
function $8c678e942362b0b9$export$ddf9c55c9f2be172(out, q, v, s) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    out[0] = (1 - (yy + zz)) * sx;
    out[1] = (xy + wz) * sx;
    out[2] = (xz - wy) * sx;
    out[3] = 0;
    out[4] = (xy - wz) * sy;
    out[5] = (1 - (xx + zz)) * sy;
    out[6] = (yz + wx) * sy;
    out[7] = 0;
    out[8] = (xz + wy) * sz;
    out[9] = (yz - wx) * sz;
    out[10] = (1 - (xx + yy)) * sz;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $8c678e942362b0b9$export$1def1f860edc4b1f(out, q, v, s, o) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    var ox = o[0];
    var oy = o[1];
    var oz = o[2];
    var out0 = (1 - (yy + zz)) * sx;
    var out1 = (xy + wz) * sx;
    var out2 = (xz - wy) * sx;
    var out4 = (xy - wz) * sy;
    var out5 = (1 - (xx + zz)) * sy;
    var out6 = (yz + wx) * sy;
    var out8 = (xz + wy) * sz;
    var out9 = (yz - wx) * sz;
    var out10 = (1 - (xx + yy)) * sz;
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = 0;
    out[4] = out4;
    out[5] = out5;
    out[6] = out6;
    out[7] = 0;
    out[8] = out8;
    out[9] = out9;
    out[10] = out10;
    out[11] = 0;
    out[12] = v[0] + ox - (out0 * ox + out4 * oy + out8 * oz);
    out[13] = v[1] + oy - (out1 * ox + out5 * oy + out9 * oz);
    out[14] = v[2] + oz - (out2 * ox + out6 * oy + out10 * oz);
    out[15] = 1;
    return out;
}
function $8c678e942362b0b9$export$2ff2bbe382249af7(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var yx = y * x2;
    var yy = y * y2;
    var zx = z * x2;
    var zy = z * y2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - yy - zz;
    out[1] = yx + wz;
    out[2] = zx - wy;
    out[3] = 0;
    out[4] = yx - wz;
    out[5] = 1 - xx - zz;
    out[6] = zy + wx;
    out[7] = 0;
    out[8] = zx + wy;
    out[9] = zy - wx;
    out[10] = 1 - xx - yy;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $8c678e942362b0b9$export$89b5708c387cac6c(out, left, right, bottom, top, near, far) {
    var rl = 1 / (right - left);
    var tb = 1 / (top - bottom);
    var nf = 1 / (near - far);
    out[0] = near * 2 * rl;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = near * 2 * tb;
    out[6] = 0;
    out[7] = 0;
    out[8] = (right + left) * rl;
    out[9] = (top + bottom) * tb;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = far * near * 2 * nf;
    out[15] = 0;
    return out;
}
function $8c678e942362b0b9$export$541149539f3a4684(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2), nf;
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        nf = 1 / (near - far);
        out[10] = (far + near) * nf;
        out[14] = 2 * far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -2 * near;
    }
    return out;
}
function $8c678e942362b0b9$export$58ae211c788e338f(out, fov, near, far) {
    var upTan = Math.tan(fov.upDegrees * Math.PI / 180.0);
    var downTan = Math.tan(fov.downDegrees * Math.PI / 180.0);
    var leftTan = Math.tan(fov.leftDegrees * Math.PI / 180.0);
    var rightTan = Math.tan(fov.rightDegrees * Math.PI / 180.0);
    var xScale = 2.0 / (leftTan + rightTan);
    var yScale = 2.0 / (upTan + downTan);
    out[0] = xScale;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    out[4] = 0.0;
    out[5] = yScale;
    out[6] = 0.0;
    out[7] = 0.0;
    out[8] = -((leftTan - rightTan) * xScale * 0.5);
    out[9] = (upTan - downTan) * yScale * 0.5;
    out[10] = far / (near - far);
    out[11] = -1;
    out[12] = 0.0;
    out[13] = 0.0;
    out[14] = far * near / (near - far);
    out[15] = 0.0;
    return out;
}
function $8c678e942362b0b9$export$4f2167e613cfc87b(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 2 * nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = (far + near) * nf;
    out[15] = 1;
    return out;
}
function $8c678e942362b0b9$export$d924e14fd6d9aa66(out, eye, center, up) {
    var x0, x1, x2, y0, y1, y2, z0, z1, z2, len;
    var eyex = eye[0];
    var eyey = eye[1];
    var eyez = eye[2];
    var upx = up[0];
    var upy = up[1];
    var upz = up[2];
    var centerx = center[0];
    var centery = center[1];
    var centerz = center[2];
    if (Math.abs(eyex - centerx) < $rqjzO.EPSILON && Math.abs(eyey - centery) < $rqjzO.EPSILON && Math.abs(eyez - centerz) < $rqjzO.EPSILON) return $8c678e942362b0b9$export$f0954fd7d5368655(out);
    z0 = eyex - centerx;
    z1 = eyey - centery;
    z2 = eyez - centerz;
    len = 1 / Math.hypot(z0, z1, z2);
    z0 *= len;
    z1 *= len;
    z2 *= len;
    x0 = upy * z2 - upz * z1;
    x1 = upz * z0 - upx * z2;
    x2 = upx * z1 - upy * z0;
    len = Math.hypot(x0, x1, x2);
    if (!len) {
        x0 = 0;
        x1 = 0;
        x2 = 0;
    } else {
        len = 1 / len;
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    y0 = z1 * x2 - z2 * x1;
    y1 = z2 * x0 - z0 * x2;
    y2 = z0 * x1 - z1 * x0;
    len = Math.hypot(y0, y1, y2);
    if (!len) {
        y0 = 0;
        y1 = 0;
        y2 = 0;
    } else {
        len = 1 / len;
        y0 *= len;
        y1 *= len;
        y2 *= len;
    }
    out[0] = x0;
    out[1] = y0;
    out[2] = z0;
    out[3] = 0;
    out[4] = x1;
    out[5] = y1;
    out[6] = z1;
    out[7] = 0;
    out[8] = x2;
    out[9] = y2;
    out[10] = z2;
    out[11] = 0;
    out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
    out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
    out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
    out[15] = 1;
    return out;
}
function $8c678e942362b0b9$export$aa67782f4dc9e52c(out, eye, target, up) {
    var eyex = eye[0], eyey = eye[1], eyez = eye[2], upx = up[0], upy = up[1], upz = up[2];
    var z0 = eyex - target[0], z1 = eyey - target[1], z2 = eyez - target[2];
    var len = z0 * z0 + z1 * z1 + z2 * z2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        z0 *= len;
        z1 *= len;
        z2 *= len;
    }
    var x0 = upy * z2 - upz * z1, x1 = upz * z0 - upx * z2, x2 = upx * z1 - upy * z0;
    len = x0 * x0 + x1 * x1 + x2 * x2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    out[0] = x0;
    out[1] = x1;
    out[2] = x2;
    out[3] = 0;
    out[4] = z1 * x2 - z2 * x1;
    out[5] = z2 * x0 - z0 * x2;
    out[6] = z0 * x1 - z1 * x0;
    out[7] = 0;
    out[8] = z0;
    out[9] = z1;
    out[10] = z2;
    out[11] = 0;
    out[12] = eyex;
    out[13] = eyey;
    out[14] = eyez;
    out[15] = 1;
    return out;
}
function $8c678e942362b0b9$export$42d51816ce590c93(a) {
    return "mat4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ", " + a[9] + ", " + a[10] + ", " + a[11] + ", " + a[12] + ", " + a[13] + ", " + a[14] + ", " + a[15] + ")";
}
function $8c678e942362b0b9$export$326827e8268e9cdb(a) {
    return Math.hypot(a[0], a[1], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
}
function $8c678e942362b0b9$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    out[9] = a[9] + b[9];
    out[10] = a[10] + b[10];
    out[11] = a[11] + b[11];
    out[12] = a[12] + b[12];
    out[13] = a[13] + b[13];
    out[14] = a[14] + b[14];
    out[15] = a[15] + b[15];
    return out;
}
function $8c678e942362b0b9$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    out[9] = a[9] - b[9];
    out[10] = a[10] - b[10];
    out[11] = a[11] - b[11];
    out[12] = a[12] - b[12];
    out[13] = a[13] - b[13];
    out[14] = a[14] - b[14];
    out[15] = a[15] - b[15];
    return out;
}
function $8c678e942362b0b9$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    out[9] = a[9] * b;
    out[10] = a[10] * b;
    out[11] = a[11] * b;
    out[12] = a[12] * b;
    out[13] = a[13] * b;
    out[14] = a[14] * b;
    out[15] = a[15] * b;
    return out;
}
function $8c678e942362b0b9$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    out[6] = a[6] + b[6] * scale;
    out[7] = a[7] + b[7] * scale;
    out[8] = a[8] + b[8] * scale;
    out[9] = a[9] + b[9] * scale;
    out[10] = a[10] + b[10] * scale;
    out[11] = a[11] + b[11] * scale;
    out[12] = a[12] + b[12] * scale;
    out[13] = a[13] + b[13] * scale;
    out[14] = a[14] + b[14] * scale;
    out[15] = a[15] + b[15] * scale;
    return out;
}
function $8c678e942362b0b9$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] && a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
}
function $8c678e942362b0b9$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7];
    var a8 = a[8], a9 = a[9], a10 = a[10], a11 = a[11];
    var a12 = a[12], a13 = a[13], a14 = a[14], a15 = a[15];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    var b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7];
    var b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11];
    var b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    return Math.abs(a0 - b0) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a8), Math.abs(b8)) && Math.abs(a9 - b9) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a9), Math.abs(b9)) && Math.abs(a10 - b10) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a10), Math.abs(b10)) && Math.abs(a11 - b11) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a11), Math.abs(b11)) && Math.abs(a12 - b12) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a12), Math.abs(b12)) && Math.abs(a13 - b13) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a13), Math.abs(b13)) && Math.abs(a14 - b14) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a14), Math.abs(b14)) && Math.abs(a15 - b15) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a15), Math.abs(b15));
}
var $8c678e942362b0b9$export$6e3a27864ab166fe = $8c678e942362b0b9$export$2060d2db72cce88f;
var $8c678e942362b0b9$export$f93b5905241a7cca = $8c678e942362b0b9$export$4e2d2ead65e5f7e3;

});
parcelRegister("rqjzO", function(module, exports) {

$parcel$export(module.exports, "EPSILON", function () { return $0526ef4aedbd7991$export$fd293b15f47e270; });
$parcel$export(module.exports, "ARRAY_TYPE", function () { return $0526ef4aedbd7991$export$b67359430d3b1b2; });
$parcel$export(module.exports, "RANDOM", function () { return $0526ef4aedbd7991$export$5ada478c8a628231; });
$parcel$export(module.exports, "setMatrixArrayType", function () { return $0526ef4aedbd7991$export$cb2c0eb57f5e532c; });
$parcel$export(module.exports, "toRadian", function () { return $0526ef4aedbd7991$export$408b8ee5959eefd5; });
$parcel$export(module.exports, "equals", function () { return $0526ef4aedbd7991$export$e9bab7fafb253603; });
/**
 * Common utilities
 * @module glMatrix
 */ // Configuration Constants
var $0526ef4aedbd7991$export$fd293b15f47e270 = 0.000001;
var $0526ef4aedbd7991$export$b67359430d3b1b2 = typeof Float32Array !== "undefined" ? Float32Array : Array;
var $0526ef4aedbd7991$export$5ada478c8a628231 = Math.random;
function $0526ef4aedbd7991$export$cb2c0eb57f5e532c(type) {
    $0526ef4aedbd7991$export$b67359430d3b1b2 = type;
}
var $0526ef4aedbd7991$var$degree = Math.PI / 180;
function $0526ef4aedbd7991$export$408b8ee5959eefd5(a) {
    return a * $0526ef4aedbd7991$var$degree;
}
function $0526ef4aedbd7991$export$e9bab7fafb253603(a, b) {
    return Math.abs(a - b) <= $0526ef4aedbd7991$export$fd293b15f47e270 * Math.max(1.0, Math.abs(a), Math.abs(b));
}
if (!Math.hypot) Math.hypot = function() {
    var y = 0, i = arguments.length;
    while(i--)y += arguments[i] * arguments[i];
    return Math.sqrt(y);
};

});


parcelRegister("fwwPx", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $b4d34f945b36eb1f$export$185802fd694ee1f5; });
$parcel$export(module.exports, "clone", function () { return $b4d34f945b36eb1f$export$9cd59f9826255e47; });
$parcel$export(module.exports, "length", function () { return $b4d34f945b36eb1f$export$f24224f1c91d8156; });
$parcel$export(module.exports, "fromValues", function () { return $b4d34f945b36eb1f$export$a82be99ed2a44a7d; });
$parcel$export(module.exports, "copy", function () { return $b4d34f945b36eb1f$export$784d13d8ee351f07; });
$parcel$export(module.exports, "set", function () { return $b4d34f945b36eb1f$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "add", function () { return $b4d34f945b36eb1f$export$e16d8520af44a096; });
$parcel$export(module.exports, "subtract", function () { return $b4d34f945b36eb1f$export$4e2d2ead65e5f7e3; });
$parcel$export(module.exports, "multiply", function () { return $b4d34f945b36eb1f$export$2060d2db72cce88f; });
$parcel$export(module.exports, "divide", function () { return $b4d34f945b36eb1f$export$cd007d971a5a2143; });
$parcel$export(module.exports, "ceil", function () { return $b4d34f945b36eb1f$export$803ce6b71a0a94b2; });
$parcel$export(module.exports, "floor", function () { return $b4d34f945b36eb1f$export$a3fe094919f356fd; });
$parcel$export(module.exports, "min", function () { return $b4d34f945b36eb1f$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $b4d34f945b36eb1f$export$8960430cfd85939f; });
$parcel$export(module.exports, "round", function () { return $b4d34f945b36eb1f$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "scale", function () { return $b4d34f945b36eb1f$export$dcdf75081b88279d; });
$parcel$export(module.exports, "scaleAndAdd", function () { return $b4d34f945b36eb1f$export$19cedf1da84ba854; });
$parcel$export(module.exports, "distance", function () { return $b4d34f945b36eb1f$export$9f17032d917177de; });
$parcel$export(module.exports, "squaredDistance", function () { return $b4d34f945b36eb1f$export$88e6ebb4fe54f538; });
$parcel$export(module.exports, "squaredLength", function () { return $b4d34f945b36eb1f$export$ab44e1323ffc8376; });
$parcel$export(module.exports, "negate", function () { return $b4d34f945b36eb1f$export$aef51622e549b8b0; });
$parcel$export(module.exports, "inverse", function () { return $b4d34f945b36eb1f$export$70ae2c07e401031b; });
$parcel$export(module.exports, "normalize", function () { return $b4d34f945b36eb1f$export$a3295358bff77e; });
$parcel$export(module.exports, "dot", function () { return $b4d34f945b36eb1f$export$94132a0e348806d4; });
$parcel$export(module.exports, "cross", function () { return $b4d34f945b36eb1f$export$bb646b20bb93d339; });
$parcel$export(module.exports, "lerp", function () { return $b4d34f945b36eb1f$export$3a89f8d6f6bf6c9f; });
$parcel$export(module.exports, "hermite", function () { return $b4d34f945b36eb1f$export$ae8865616f30561c; });
$parcel$export(module.exports, "bezier", function () { return $b4d34f945b36eb1f$export$b9c5f84610baddaf; });
$parcel$export(module.exports, "random", function () { return $b4d34f945b36eb1f$export$4385e60b38654f68; });
$parcel$export(module.exports, "transformMat4", function () { return $b4d34f945b36eb1f$export$5ffbd13800309d59; });
$parcel$export(module.exports, "transformMat3", function () { return $b4d34f945b36eb1f$export$f0bfa0a0024626ee; });
$parcel$export(module.exports, "transformQuat", function () { return $b4d34f945b36eb1f$export$c32adef9e939ce85; });
$parcel$export(module.exports, "rotateX", function () { return $b4d34f945b36eb1f$export$a59c8716592e09af; });
$parcel$export(module.exports, "rotateY", function () { return $b4d34f945b36eb1f$export$cf71e4d4ca4d1cfd; });
$parcel$export(module.exports, "rotateZ", function () { return $b4d34f945b36eb1f$export$ea6eae3365de5b9c; });
$parcel$export(module.exports, "angle", function () { return $b4d34f945b36eb1f$export$944b09d2ad10b378; });
$parcel$export(module.exports, "zero", function () { return $b4d34f945b36eb1f$export$7f9972325ebfd559; });
$parcel$export(module.exports, "str", function () { return $b4d34f945b36eb1f$export$42d51816ce590c93; });
$parcel$export(module.exports, "exactEquals", function () { return $b4d34f945b36eb1f$export$f2599a5cf1109d8; });
$parcel$export(module.exports, "equals", function () { return $b4d34f945b36eb1f$export$e9bab7fafb253603; });
$parcel$export(module.exports, "sub", function () { return $b4d34f945b36eb1f$export$f93b5905241a7cca; });
$parcel$export(module.exports, "mul", function () { return $b4d34f945b36eb1f$export$6e3a27864ab166fe; });
$parcel$export(module.exports, "div", function () { return $b4d34f945b36eb1f$export$159d9494db57879b; });
$parcel$export(module.exports, "dist", function () { return $b4d34f945b36eb1f$export$6c4a311cc157c764; });
$parcel$export(module.exports, "sqrDist", function () { return $b4d34f945b36eb1f$export$2422cd6c492a8b3a; });
$parcel$export(module.exports, "len", function () { return $b4d34f945b36eb1f$export$fc1400facf92c78; });
$parcel$export(module.exports, "sqrLen", function () { return $b4d34f945b36eb1f$export$99d8dd3f32a3435; });
$parcel$export(module.exports, "forEach", function () { return $b4d34f945b36eb1f$export$4b80e395e36b5a56; });

var $rqjzO = parcelRequire("rqjzO");
function $b4d34f945b36eb1f$export$185802fd694ee1f5() {
    var out = new $rqjzO.ARRAY_TYPE(3);
    if ($rqjzO.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    return out;
}
function $b4d34f945b36eb1f$export$9cd59f9826255e47(a) {
    var out = new $rqjzO.ARRAY_TYPE(3);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $b4d34f945b36eb1f$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return Math.hypot(x, y, z);
}
function $b4d34f945b36eb1f$export$a82be99ed2a44a7d(x, y, z) {
    var out = new $rqjzO.ARRAY_TYPE(3);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $b4d34f945b36eb1f$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $b4d34f945b36eb1f$export$adaa4cf7ef1b65be(out, x, y, z) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $b4d34f945b36eb1f$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
}
function $b4d34f945b36eb1f$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
}
function $b4d34f945b36eb1f$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    return out;
}
function $b4d34f945b36eb1f$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    return out;
}
function $b4d34f945b36eb1f$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    return out;
}
function $b4d34f945b36eb1f$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    return out;
}
function $b4d34f945b36eb1f$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    return out;
}
function $b4d34f945b36eb1f$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    return out;
}
function $b4d34f945b36eb1f$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    return out;
}
function $b4d34f945b36eb1f$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
}
function $b4d34f945b36eb1f$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    return out;
}
function $b4d34f945b36eb1f$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return Math.hypot(x, y, z);
}
function $b4d34f945b36eb1f$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return x * x + y * y + z * z;
}
function $b4d34f945b36eb1f$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return x * x + y * y + z * z;
}
function $b4d34f945b36eb1f$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    return out;
}
function $b4d34f945b36eb1f$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    return out;
}
function $b4d34f945b36eb1f$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var len = x * x + y * y + z * z;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    out[2] = a[2] * len;
    return out;
}
function $b4d34f945b36eb1f$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $b4d34f945b36eb1f$export$bb646b20bb93d339(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2];
    var bx = b[0], by = b[1], bz = b[2];
    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
}
function $b4d34f945b36eb1f$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    return out;
}
function $b4d34f945b36eb1f$export$ae8865616f30561c(out, a, b, c, d, t) {
    var factorTimes2 = t * t;
    var factor1 = factorTimes2 * (2 * t - 3) + 1;
    var factor2 = factorTimes2 * (t - 2) + t;
    var factor3 = factorTimes2 * (t - 1);
    var factor4 = factorTimes2 * (3 - 2 * t);
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $b4d34f945b36eb1f$export$b9c5f84610baddaf(out, a, b, c, d, t) {
    var inverseFactor = 1 - t;
    var inverseFactorTimesTwo = inverseFactor * inverseFactor;
    var factorTimes2 = t * t;
    var factor1 = inverseFactorTimesTwo * inverseFactor;
    var factor2 = 3 * t * inverseFactorTimesTwo;
    var factor3 = 3 * factorTimes2 * inverseFactor;
    var factor4 = factorTimes2 * t;
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $b4d34f945b36eb1f$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    var r = $rqjzO.RANDOM() * 2.0 * Math.PI;
    var z = $rqjzO.RANDOM() * 2.0 - 1.0;
    var zScale = Math.sqrt(1.0 - z * z) * scale;
    out[0] = Math.cos(r) * zScale;
    out[1] = Math.sin(r) * zScale;
    out[2] = z * scale;
    return out;
}
function $b4d34f945b36eb1f$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    var w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
    return out;
}
function $b4d34f945b36eb1f$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x * m[0] + y * m[3] + z * m[6];
    out[1] = x * m[1] + y * m[4] + z * m[7];
    out[2] = x * m[2] + y * m[5] + z * m[8];
    return out;
}
function $b4d34f945b36eb1f$export$c32adef9e939ce85(out, a, q) {
    // benchmarks: https://jsperf.com/quaternion-transform-vec3-implementations-fixed
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3];
    var x = a[0], y = a[1], z = a[2]; // var qvec = [qx, qy, qz];
    // var uv = vec3.cross([], qvec, a);
    var uvx = qy * z - qz * y, uvy = qz * x - qx * z, uvz = qx * y - qy * x; // var uuv = vec3.cross([], qvec, uv);
    var uuvx = qy * uvz - qz * uvy, uuvy = qz * uvx - qx * uvz, uuvz = qx * uvy - qy * uvx; // vec3.scale(uv, uv, 2 * w);
    var w2 = qw * 2;
    uvx *= w2;
    uvy *= w2;
    uvz *= w2; // vec3.scale(uuv, uuv, 2);
    uuvx *= 2;
    uuvy *= 2;
    uuvz *= 2; // return vec3.add(out, a, vec3.add(out, uv, uuv));
    out[0] = x + uvx + uuvx;
    out[1] = y + uvy + uuvy;
    out[2] = z + uvz + uuvz;
    return out;
}
function $b4d34f945b36eb1f$export$a59c8716592e09af(out, a, b, c) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[0];
    r[1] = p[1] * Math.cos(c) - p[2] * Math.sin(c);
    r[2] = p[1] * Math.sin(c) + p[2] * Math.cos(c); //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $b4d34f945b36eb1f$export$cf71e4d4ca4d1cfd(out, a, b, c) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[2] * Math.sin(c) + p[0] * Math.cos(c);
    r[1] = p[1];
    r[2] = p[2] * Math.cos(c) - p[0] * Math.sin(c); //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $b4d34f945b36eb1f$export$ea6eae3365de5b9c(out, a, b, c) {
    var p = [], r = []; //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2]; //perform rotation
    r[0] = p[0] * Math.cos(c) - p[1] * Math.sin(c);
    r[1] = p[0] * Math.sin(c) + p[1] * Math.cos(c);
    r[2] = p[2]; //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $b4d34f945b36eb1f$export$944b09d2ad10b378(a, b) {
    var tempA = $b4d34f945b36eb1f$export$a82be99ed2a44a7d(a[0], a[1], a[2]);
    var tempB = $b4d34f945b36eb1f$export$a82be99ed2a44a7d(b[0], b[1], b[2]);
    $b4d34f945b36eb1f$export$a3295358bff77e(tempA, tempA);
    $b4d34f945b36eb1f$export$a3295358bff77e(tempB, tempB);
    var cosine = $b4d34f945b36eb1f$export$94132a0e348806d4(tempA, tempB);
    if (cosine > 1.0) return 0;
    else if (cosine < -1) return Math.PI;
    else return Math.acos(cosine);
}
function $b4d34f945b36eb1f$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    return out;
}
function $b4d34f945b36eb1f$export$42d51816ce590c93(a) {
    return "vec3(" + a[0] + ", " + a[1] + ", " + a[2] + ")";
}
function $b4d34f945b36eb1f$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
function $b4d34f945b36eb1f$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2];
    var b0 = b[0], b1 = b[1], b2 = b[2];
    return Math.abs(a0 - b0) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2));
}
var $b4d34f945b36eb1f$export$f93b5905241a7cca = $b4d34f945b36eb1f$export$4e2d2ead65e5f7e3;
var $b4d34f945b36eb1f$export$6e3a27864ab166fe = $b4d34f945b36eb1f$export$2060d2db72cce88f;
var $b4d34f945b36eb1f$export$159d9494db57879b = $b4d34f945b36eb1f$export$cd007d971a5a2143;
var $b4d34f945b36eb1f$export$6c4a311cc157c764 = $b4d34f945b36eb1f$export$9f17032d917177de;
var $b4d34f945b36eb1f$export$2422cd6c492a8b3a = $b4d34f945b36eb1f$export$88e6ebb4fe54f538;
var $b4d34f945b36eb1f$export$fc1400facf92c78 = $b4d34f945b36eb1f$export$f24224f1c91d8156;
var $b4d34f945b36eb1f$export$99d8dd3f32a3435 = $b4d34f945b36eb1f$export$ab44e1323ffc8376;
var $b4d34f945b36eb1f$export$4b80e395e36b5a56 = function() {
    var vec = $b4d34f945b36eb1f$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 3;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
        }
        return a;
    };
}();

});

parcelRegister("3KYUN", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
// These are used to set the WebGl depth for a tile.
var $2bc4eb70f599d6df$var$MAX_LAYERS = 256; // Max number of layers per stage.
var $2bc4eb70f599d6df$var$MAX_LEVELS = 256; // Max number of levels per layer.

var $eCQUD = parcelRequire("eCQUD");

var $c3mW8 = parcelRequire("c3mW8");
var $fwwPx = parcelRequire("fwwPx");
var $8QvoZ = parcelRequire("8QvoZ");
var $2bc4eb70f599d6df$require$vec4 = $8QvoZ;

var $c3mW8 = parcelRequire("c3mW8");
var $fwwPx = parcelRequire("fwwPx");
var $8QvoZ = parcelRequire("8QvoZ");
var $2bc4eb70f599d6df$require$vec3 = $fwwPx;

var $c3mW8 = parcelRequire("c3mW8");
var $fwwPx = parcelRequire("fwwPx");
var $8QvoZ = parcelRequire("8QvoZ");
var $2bc4eb70f599d6df$require$mat4 = $c3mW8;
function $2bc4eb70f599d6df$var$createShader(gl, type, src) {
    var shader = gl.createShader(type);
    gl.shaderSource(shader, src);
    gl.compileShader(shader);
    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) throw gl.getShaderInfoLog(shader);
    return shader;
}
function $2bc4eb70f599d6df$var$createShaderProgram(gl, vertexSrc, fragmentSrc, attribList, uniformList) {
    var vertexShader = $2bc4eb70f599d6df$var$createShader(gl, gl.VERTEX_SHADER, vertexSrc);
    var fragmentShader = $2bc4eb70f599d6df$var$createShader(gl, gl.FRAGMENT_SHADER, fragmentSrc);
    var shaderProgram = gl.createProgram();
    gl.attachShader(shaderProgram, vertexShader);
    gl.attachShader(shaderProgram, fragmentShader);
    gl.linkProgram(shaderProgram);
    if (!gl.getProgramParameter(shaderProgram, gl.LINK_STATUS)) throw gl.getProgramInfoLog(shaderProgram);
    for(var i = 0; i < attribList.length; i++){
        var attrib = attribList[i];
        shaderProgram[attrib] = gl.getAttribLocation(shaderProgram, attrib);
        if (shaderProgram[attrib] === -1) throw new Error("Shader program has no " + attrib + " attribute");
    }
    for(var j = 0; j < uniformList.length; j++){
        var uniform = uniformList[j];
        shaderProgram[uniform] = gl.getUniformLocation(shaderProgram, uniform);
        if (shaderProgram[uniform] === -1) throw new Error("Shader program has no " + uniform + " uniform");
    }
    return shaderProgram;
}
function $2bc4eb70f599d6df$var$destroyShaderProgram(gl, shaderProgram) {
    var shaderList = gl.getAttachedShaders(shaderProgram);
    for(var i = 0; i < shaderList.length; i++){
        var shader = shaderList[i];
        gl.detachShader(shaderProgram, shader);
        gl.deleteShader(shader);
    }
    gl.deleteProgram(shaderProgram);
}
function $2bc4eb70f599d6df$var$createConstantBuffer(gl, target, usage, value) {
    var buffer = gl.createBuffer();
    gl.bindBuffer(target, buffer);
    gl.bufferData(target, value, usage);
    return buffer;
}
function $2bc4eb70f599d6df$var$createConstantBuffers(gl, vertexIndices, vertexPositions, textureCoords) {
    return {
        vertexIndices: $2bc4eb70f599d6df$var$createConstantBuffer(gl, gl.ELEMENT_ARRAY_BUFFER, gl.STATIC_DRAW, new Uint16Array(vertexIndices)),
        vertexPositions: $2bc4eb70f599d6df$var$createConstantBuffer(gl, gl.ARRAY_BUFFER, gl.STATIC_DRAW, new Float32Array(vertexPositions)),
        textureCoords: $2bc4eb70f599d6df$var$createConstantBuffer(gl, gl.ARRAY_BUFFER, gl.STATIC_DRAW, new Float32Array(textureCoords))
    };
}
function $2bc4eb70f599d6df$var$destroyConstantBuffers(gl, constantBuffers) {
    gl.deleteBuffer(constantBuffers.vertexIndices);
    gl.deleteBuffer(constantBuffers.vertexPositions);
    gl.deleteBuffer(constantBuffers.textureCoords);
}
function $2bc4eb70f599d6df$var$enableAttributes(gl, shaderProgram) {
    var numAttrs = gl.getProgramParameter(shaderProgram, gl.ACTIVE_ATTRIBUTES);
    for(var i = 0; i < numAttrs; i++)gl.enableVertexAttribArray(i);
}
function $2bc4eb70f599d6df$var$disableAttributes(gl, shaderProgram) {
    var numAttrs = gl.getProgramParameter(shaderProgram, gl.ACTIVE_ATTRIBUTES);
    for(var i = 0; i < numAttrs; i++)gl.disableVertexAttribArray(i);
}
function $2bc4eb70f599d6df$var$setTexture(gl, shaderProgram, texture) {
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, texture._texture);
    gl.uniform1i(shaderProgram.uSampler, 0);
}
function $2bc4eb70f599d6df$var$setDepth(gl, shaderProgram, layerZ, tileZ) {
    var depth = ((layerZ + 1) * $2bc4eb70f599d6df$var$MAX_LEVELS - tileZ) / ($2bc4eb70f599d6df$var$MAX_LEVELS * $2bc4eb70f599d6df$var$MAX_LAYERS);
    gl.uniform1f(shaderProgram.uDepth, depth);
}
var $2bc4eb70f599d6df$var$defaultOpacity = 1.0;
var $2bc4eb70f599d6df$var$defaultColorOffset = $2bc4eb70f599d6df$require$vec4.create();
var $2bc4eb70f599d6df$var$defaultColorMatrix = $2bc4eb70f599d6df$require$mat4.create();
$2bc4eb70f599d6df$require$mat4.identity($2bc4eb70f599d6df$var$defaultColorMatrix);
function $2bc4eb70f599d6df$var$setupPixelEffectUniforms(gl, effects, uniforms) {
    var opacity = $2bc4eb70f599d6df$var$defaultOpacity;
    if (effects && effects.opacity != null) opacity = effects.opacity;
    gl.uniform1f(uniforms.opacity, opacity);
    var colorOffset = $2bc4eb70f599d6df$var$defaultColorOffset;
    if (effects && effects.colorOffset) colorOffset = effects.colorOffset;
    gl.uniform4fv(uniforms.colorOffset, colorOffset);
    var colorMatrix = $2bc4eb70f599d6df$var$defaultColorMatrix;
    if (effects && effects.colorMatrix) colorMatrix = effects.colorMatrix;
    gl.uniformMatrix4fv(uniforms.colorMatrix, false, colorMatrix);
}
// Temporary vectors for setViewport.
var $2bc4eb70f599d6df$var$translateVector = $2bc4eb70f599d6df$require$vec3.create();
var $2bc4eb70f599d6df$var$scaleVector = $2bc4eb70f599d6df$require$vec3.create();
// Sets the WebGL viewport and returns a viewport clamping compensation matrix.
//
// Negative viewport origin coordinates cause rendering issues. Letting the
// viewport dimensions extend beyond the visible area do not seem to cause
// rendering issues, but they may still have an impact on performance.
// Therefore, when the scene's rect is not fully contained in the rendering
// area, we clamp the viewport to the rendering area, and return a compensation
// matrix to scale and translate vertices accordingly.
function $2bc4eb70f599d6df$var$setViewport(gl, layer, rect, viewportMatrix) {
    if (rect.x === 0 && rect.width === 1 && rect.y === 0 && rect.height === 1) {
        // Fast path for full rect.
        gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
        $2bc4eb70f599d6df$require$mat4.identity(viewportMatrix);
        return;
    }
    var offsetX = rect.x;
    var clampedOffsetX = $eCQUD(offsetX, 0, 1);
    var leftExcess = clampedOffsetX - offsetX;
    var maxClampedWidth = 1 - clampedOffsetX;
    var clampedWidth = $eCQUD(rect.width - leftExcess, 0, maxClampedWidth);
    var rightExcess = rect.width - clampedWidth;
    var offsetY = 1 - rect.height - rect.y;
    var clampedOffsetY = $eCQUD(offsetY, 0, 1);
    var bottomExcess = clampedOffsetY - offsetY;
    var maxClampedHeight = 1 - clampedOffsetY;
    var clampedHeight = $eCQUD(rect.height - bottomExcess, 0, maxClampedHeight);
    var topExcess = rect.height - clampedHeight;
    $2bc4eb70f599d6df$require$vec3.set($2bc4eb70f599d6df$var$scaleVector, rect.width / clampedWidth, rect.height / clampedHeight, 1);
    $2bc4eb70f599d6df$require$vec3.set($2bc4eb70f599d6df$var$translateVector, (rightExcess - leftExcess) / clampedWidth, (topExcess - bottomExcess) / clampedHeight, 0);
    $2bc4eb70f599d6df$require$mat4.identity(viewportMatrix);
    $2bc4eb70f599d6df$require$mat4.translate(viewportMatrix, viewportMatrix, $2bc4eb70f599d6df$var$translateVector);
    $2bc4eb70f599d6df$require$mat4.scale(viewportMatrix, viewportMatrix, $2bc4eb70f599d6df$var$scaleVector);
    gl.viewport(gl.drawingBufferWidth * clampedOffsetX, gl.drawingBufferHeight * clampedOffsetY, gl.drawingBufferWidth * clampedWidth, gl.drawingBufferHeight * clampedHeight);
}
module.exports = {
    createShaderProgram: $2bc4eb70f599d6df$var$createShaderProgram,
    destroyShaderProgram: $2bc4eb70f599d6df$var$destroyShaderProgram,
    createConstantBuffers: $2bc4eb70f599d6df$var$createConstantBuffers,
    destroyConstantBuffers: $2bc4eb70f599d6df$var$destroyConstantBuffers,
    enableAttributes: $2bc4eb70f599d6df$var$enableAttributes,
    disableAttributes: $2bc4eb70f599d6df$var$disableAttributes,
    setTexture: $2bc4eb70f599d6df$var$setTexture,
    setDepth: $2bc4eb70f599d6df$var$setDepth,
    setViewport: $2bc4eb70f599d6df$var$setViewport,
    setupPixelEffectUniforms: $2bc4eb70f599d6df$var$setupPixelEffectUniforms
};

});
parcelRegister("eCQUD", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
function $aa5da89748021ec3$var$clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
module.exports = $aa5da89748021ec3$var$clamp;

});

parcelRegister("8QvoZ", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $670b89df6ca628ce$export$185802fd694ee1f5; });
$parcel$export(module.exports, "clone", function () { return $670b89df6ca628ce$export$9cd59f9826255e47; });
$parcel$export(module.exports, "fromValues", function () { return $670b89df6ca628ce$export$a82be99ed2a44a7d; });
$parcel$export(module.exports, "copy", function () { return $670b89df6ca628ce$export$784d13d8ee351f07; });
$parcel$export(module.exports, "set", function () { return $670b89df6ca628ce$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "add", function () { return $670b89df6ca628ce$export$e16d8520af44a096; });
$parcel$export(module.exports, "subtract", function () { return $670b89df6ca628ce$export$4e2d2ead65e5f7e3; });
$parcel$export(module.exports, "multiply", function () { return $670b89df6ca628ce$export$2060d2db72cce88f; });
$parcel$export(module.exports, "divide", function () { return $670b89df6ca628ce$export$cd007d971a5a2143; });
$parcel$export(module.exports, "ceil", function () { return $670b89df6ca628ce$export$803ce6b71a0a94b2; });
$parcel$export(module.exports, "floor", function () { return $670b89df6ca628ce$export$a3fe094919f356fd; });
$parcel$export(module.exports, "min", function () { return $670b89df6ca628ce$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $670b89df6ca628ce$export$8960430cfd85939f; });
$parcel$export(module.exports, "round", function () { return $670b89df6ca628ce$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "scale", function () { return $670b89df6ca628ce$export$dcdf75081b88279d; });
$parcel$export(module.exports, "scaleAndAdd", function () { return $670b89df6ca628ce$export$19cedf1da84ba854; });
$parcel$export(module.exports, "distance", function () { return $670b89df6ca628ce$export$9f17032d917177de; });
$parcel$export(module.exports, "squaredDistance", function () { return $670b89df6ca628ce$export$88e6ebb4fe54f538; });
$parcel$export(module.exports, "length", function () { return $670b89df6ca628ce$export$f24224f1c91d8156; });
$parcel$export(module.exports, "squaredLength", function () { return $670b89df6ca628ce$export$ab44e1323ffc8376; });
$parcel$export(module.exports, "negate", function () { return $670b89df6ca628ce$export$aef51622e549b8b0; });
$parcel$export(module.exports, "inverse", function () { return $670b89df6ca628ce$export$70ae2c07e401031b; });
$parcel$export(module.exports, "normalize", function () { return $670b89df6ca628ce$export$a3295358bff77e; });
$parcel$export(module.exports, "dot", function () { return $670b89df6ca628ce$export$94132a0e348806d4; });
$parcel$export(module.exports, "cross", function () { return $670b89df6ca628ce$export$bb646b20bb93d339; });
$parcel$export(module.exports, "lerp", function () { return $670b89df6ca628ce$export$3a89f8d6f6bf6c9f; });
$parcel$export(module.exports, "random", function () { return $670b89df6ca628ce$export$4385e60b38654f68; });
$parcel$export(module.exports, "transformMat4", function () { return $670b89df6ca628ce$export$5ffbd13800309d59; });
$parcel$export(module.exports, "transformQuat", function () { return $670b89df6ca628ce$export$c32adef9e939ce85; });
$parcel$export(module.exports, "zero", function () { return $670b89df6ca628ce$export$7f9972325ebfd559; });
$parcel$export(module.exports, "str", function () { return $670b89df6ca628ce$export$42d51816ce590c93; });
$parcel$export(module.exports, "exactEquals", function () { return $670b89df6ca628ce$export$f2599a5cf1109d8; });
$parcel$export(module.exports, "equals", function () { return $670b89df6ca628ce$export$e9bab7fafb253603; });
$parcel$export(module.exports, "sub", function () { return $670b89df6ca628ce$export$f93b5905241a7cca; });
$parcel$export(module.exports, "mul", function () { return $670b89df6ca628ce$export$6e3a27864ab166fe; });
$parcel$export(module.exports, "div", function () { return $670b89df6ca628ce$export$159d9494db57879b; });
$parcel$export(module.exports, "dist", function () { return $670b89df6ca628ce$export$6c4a311cc157c764; });
$parcel$export(module.exports, "sqrDist", function () { return $670b89df6ca628ce$export$2422cd6c492a8b3a; });
$parcel$export(module.exports, "len", function () { return $670b89df6ca628ce$export$fc1400facf92c78; });
$parcel$export(module.exports, "sqrLen", function () { return $670b89df6ca628ce$export$99d8dd3f32a3435; });
$parcel$export(module.exports, "forEach", function () { return $670b89df6ca628ce$export$4b80e395e36b5a56; });

var $rqjzO = parcelRequire("rqjzO");
function $670b89df6ca628ce$export$185802fd694ee1f5() {
    var out = new $rqjzO.ARRAY_TYPE(4);
    if ($rqjzO.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
    }
    return out;
}
function $670b89df6ca628ce$export$9cd59f9826255e47(a) {
    var out = new $rqjzO.ARRAY_TYPE(4);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $670b89df6ca628ce$export$a82be99ed2a44a7d(x, y, z, w) {
    var out = new $rqjzO.ARRAY_TYPE(4);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $670b89df6ca628ce$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $670b89df6ca628ce$export$adaa4cf7ef1b65be(out, x, y, z, w) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $670b89df6ca628ce$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    return out;
}
function $670b89df6ca628ce$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    return out;
}
function $670b89df6ca628ce$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    out[3] = a[3] * b[3];
    return out;
}
function $670b89df6ca628ce$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    out[3] = a[3] / b[3];
    return out;
}
function $670b89df6ca628ce$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    out[3] = Math.ceil(a[3]);
    return out;
}
function $670b89df6ca628ce$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    out[3] = Math.floor(a[3]);
    return out;
}
function $670b89df6ca628ce$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    out[3] = Math.min(a[3], b[3]);
    return out;
}
function $670b89df6ca628ce$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    out[3] = Math.max(a[3], b[3]);
    return out;
}
function $670b89df6ca628ce$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    out[3] = Math.round(a[3]);
    return out;
}
function $670b89df6ca628ce$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    return out;
}
function $670b89df6ca628ce$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    return out;
}
function $670b89df6ca628ce$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    var w = b[3] - a[3];
    return Math.hypot(x, y, z, w);
}
function $670b89df6ca628ce$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    var w = b[3] - a[3];
    return x * x + y * y + z * z + w * w;
}
function $670b89df6ca628ce$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    return Math.hypot(x, y, z, w);
}
function $670b89df6ca628ce$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    return x * x + y * y + z * z + w * w;
}
function $670b89df6ca628ce$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = -a[3];
    return out;
}
function $670b89df6ca628ce$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    out[3] = 1.0 / a[3];
    return out;
}
function $670b89df6ca628ce$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    var len = x * x + y * y + z * z + w * w;
    if (len > 0) len = 1 / Math.sqrt(len);
    out[0] = x * len;
    out[1] = y * len;
    out[2] = z * len;
    out[3] = w * len;
    return out;
}
function $670b89df6ca628ce$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
}
function $670b89df6ca628ce$export$bb646b20bb93d339(out, u, v, w) {
    var A = v[0] * w[1] - v[1] * w[0], B = v[0] * w[2] - v[2] * w[0], C = v[0] * w[3] - v[3] * w[0], D = v[1] * w[2] - v[2] * w[1], E = v[1] * w[3] - v[3] * w[1], F = v[2] * w[3] - v[3] * w[2];
    var G = u[0];
    var H = u[1];
    var I = u[2];
    var J = u[3];
    out[0] = H * F - I * E + J * D;
    out[1] = -(G * F) + I * C - J * B;
    out[2] = G * E - H * C + J * A;
    out[3] = -(G * D) + H * B - I * A;
    return out;
}
function $670b89df6ca628ce$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    var aw = a[3];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    out[3] = aw + t * (b[3] - aw);
    return out;
}
function $670b89df6ca628ce$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0; // Marsaglia, George. Choosing a Point from the Surface of a
    // Sphere. Ann. Math. Statist. 43 (1972), no. 2, 645--646.
    // http://projecteuclid.org/euclid.aoms/1177692644;
    var v1, v2, v3, v4;
    var s1, s2;
    do {
        v1 = $rqjzO.RANDOM() * 2 - 1;
        v2 = $rqjzO.RANDOM() * 2 - 1;
        s1 = v1 * v1 + v2 * v2;
    }while (s1 >= 1);
    do {
        v3 = $rqjzO.RANDOM() * 2 - 1;
        v4 = $rqjzO.RANDOM() * 2 - 1;
        s2 = v3 * v3 + v4 * v4;
    }while (s2 >= 1);
    var d = Math.sqrt((1 - s1) / s2);
    out[0] = scale * v1;
    out[1] = scale * v2;
    out[2] = scale * v3 * d;
    out[3] = scale * v4 * d;
    return out;
}
function $670b89df6ca628ce$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
    out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
    out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
    out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
    return out;
}
function $670b89df6ca628ce$export$c32adef9e939ce85(out, a, q) {
    var x = a[0], y = a[1], z = a[2];
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3]; // calculate quat * vec
    var ix = qw * x + qy * z - qz * y;
    var iy = qw * y + qz * x - qx * z;
    var iz = qw * z + qx * y - qy * x;
    var iw = -qx * x - qy * y - qz * z; // calculate result * inverse quat
    out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
    out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
    out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
    out[3] = a[3];
    return out;
}
function $670b89df6ca628ce$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    return out;
}
function $670b89df6ca628ce$export$42d51816ce590c93(a) {
    return "vec4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
function $670b89df6ca628ce$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
}
function $670b89df6ca628ce$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    return Math.abs(a0 - b0) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3));
}
var $670b89df6ca628ce$export$f93b5905241a7cca = $670b89df6ca628ce$export$4e2d2ead65e5f7e3;
var $670b89df6ca628ce$export$6e3a27864ab166fe = $670b89df6ca628ce$export$2060d2db72cce88f;
var $670b89df6ca628ce$export$159d9494db57879b = $670b89df6ca628ce$export$cd007d971a5a2143;
var $670b89df6ca628ce$export$6c4a311cc157c764 = $670b89df6ca628ce$export$9f17032d917177de;
var $670b89df6ca628ce$export$2422cd6c492a8b3a = $670b89df6ca628ce$export$88e6ebb4fe54f538;
var $670b89df6ca628ce$export$fc1400facf92c78 = $670b89df6ca628ce$export$f24224f1c91d8156;
var $670b89df6ca628ce$export$99d8dd3f32a3435 = $670b89df6ca628ce$export$ab44e1323ffc8376;
var $670b89df6ca628ce$export$4b80e395e36b5a56 = function() {
    var vec = $670b89df6ca628ce$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 4;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            vec[3] = a[i + 3];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
            a[i + 3] = vec[3];
        }
        return a;
    };
}();

});


parcelRegister("o1WjV", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
module.exports = [
    "attribute vec3 aVertexPosition;",
    "attribute vec2 aTextureCoord;",
    "uniform float uDepth;",
    "uniform mat4 uViewportMatrix;",
    "uniform mat4 uProjMatrix;",
    "varying vec2 vTextureCoord;",
    "void main(void) {",
    "  gl_Position = uViewportMatrix * uProjMatrix * vec4(aVertexPosition.xy, 0.0, 1.0);",
    "  gl_Position.z = uDepth * gl_Position.w;",
    "  vTextureCoord = aTextureCoord;",
    "}"
].join("\n");

});

parcelRegister("7d8BE", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
module.exports = [
    "#ifdef GL_FRAGMENT_PRECISION_HIGH",
    "precision highp float;",
    "#else",
    "precision mediump float;",
    "#endif",
    "uniform sampler2D uSampler;",
    "uniform float uOpacity;",
    "uniform vec4 uColorOffset;",
    "uniform mat4 uColorMatrix;",
    "varying vec2 vTextureCoord;",
    "void main(void) {",
    "  vec4 color = texture2D(uSampler, vTextureCoord) * uColorMatrix + uColorOffset;",
    "  gl_FragColor = vec4(color.rgba * uOpacity);",
    "}"
].join("\n");

});



parcelRegister("6yDfP", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $bKQXE = parcelRequire("bKQXE");

var $Yar88 = parcelRequire("Yar88");
/**
 * @class WebGlFlatRenderer
 * @implements Renderer
 * @classdesc
 *
 * A renderer for {@link FlatGeometry} and {@link FlatView}, appropriate for a
 * {@link WebGlStage}.
 *
 * Most users do not need to instantiate this class. Renderers are created and
 * destroyed by {@link Stage} as necessary.
 */ function $4c645e1e9e1de633$var$WebGlFlatRenderer() {
    this.constructor.super_.apply(this, arguments);
}
$Yar88($4c645e1e9e1de633$var$WebGlFlatRenderer, $bKQXE);
module.exports = $4c645e1e9e1de633$var$WebGlFlatRenderer;

});

parcelRegister("iIThc", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $c3mW8 = parcelRequire("c3mW8");
var $da1736cd2fd385ef$require$mat4 = $c3mW8;

var $2Xxut = parcelRequire("2Xxut");

var $3KYUN = parcelRequire("3KYUN");
var $da1736cd2fd385ef$var$createConstantBuffers = $3KYUN.createConstantBuffers;
var $da1736cd2fd385ef$var$destroyConstantBuffers = $3KYUN.destroyConstantBuffers;
var $da1736cd2fd385ef$var$createShaderProgram = $3KYUN.createShaderProgram;
var $da1736cd2fd385ef$var$destroyShaderProgram = $3KYUN.destroyShaderProgram;
var $da1736cd2fd385ef$var$enableAttributes = $3KYUN.enableAttributes;
var $da1736cd2fd385ef$var$disableAttributes = $3KYUN.disableAttributes;
var $da1736cd2fd385ef$var$setViewport = $3KYUN.setViewport;
var $da1736cd2fd385ef$var$setupPixelEffectUniforms = $3KYUN.setupPixelEffectUniforms;
var $da1736cd2fd385ef$var$setDepth = $3KYUN.setDepth;
var $da1736cd2fd385ef$var$setTexture = $3KYUN.setTexture;

var $aVswm = parcelRequire("aVswm");

var $3C2IP = parcelRequire("3C2IP");
var $da1736cd2fd385ef$var$vertexIndices = [
    0,
    1,
    2,
    0,
    2,
    3
];
var $da1736cd2fd385ef$var$vertexPositions = [
    -1,
    -1,
    0.0,
    1.0,
    -1,
    0.0,
    1.0,
    1.0,
    0.0,
    -1,
    1.0,
    0.0
];
var $da1736cd2fd385ef$var$textureCoords = [
    0.0,
    0.0,
    1.0,
    0.0,
    1.0,
    1.0,
    0.0,
    1.0
];
var $da1736cd2fd385ef$var$attribList = [
    "aVertexPosition"
];
var $da1736cd2fd385ef$var$uniformList = [
    "uDepth",
    "uOpacity",
    "uSampler",
    "uInvProjMatrix",
    "uViewportMatrix",
    "uColorOffset",
    "uColorMatrix",
    "uTextureX",
    "uTextureY",
    "uTextureWidth",
    "uTextureHeight"
];
/**
 * @class WebGlEquirectRenderer
 * @implements Renderer
 * @classdesc
 *
 * A renderer for {@link EquirectGeometry} and {@link RectilinearView},
 * appropriate for {@link WebGlStage}.
 *
 * Most users do not need to instantiate this class. Renderers are created and
 * destroyed by {@link Stage} as necessary.
 */ function $da1736cd2fd385ef$var$WebGlEquirectRenderer(gl) {
    this.gl = gl;
    // The inverse projection matrix.
    this.invProjMatrix = $da1736cd2fd385ef$require$mat4.create();
    // The viewport matrix responsible for viewport clamping.
    // See setViewport() for an explanation of how it works.
    this.viewportMatrix = $da1736cd2fd385ef$require$mat4.create();
    this.constantBuffers = $da1736cd2fd385ef$var$createConstantBuffers(gl, $da1736cd2fd385ef$var$vertexIndices, $da1736cd2fd385ef$var$vertexPositions, $da1736cd2fd385ef$var$textureCoords);
    this.shaderProgram = $da1736cd2fd385ef$var$createShaderProgram(gl, $aVswm, $3C2IP, $da1736cd2fd385ef$var$attribList, $da1736cd2fd385ef$var$uniformList);
}
$da1736cd2fd385ef$var$WebGlEquirectRenderer.prototype.destroy = function() {
    $da1736cd2fd385ef$var$destroyConstantBuffers(this.gl, this.constantBuffers);
    $da1736cd2fd385ef$var$destroyShaderProgram(this.gl, this.shaderProgram);
    $2Xxut(this);
};
$da1736cd2fd385ef$var$WebGlEquirectRenderer.prototype.startLayer = function(layer, rect) {
    var gl = this.gl;
    var shaderProgram = this.shaderProgram;
    var constantBuffers = this.constantBuffers;
    var invProjMatrix = this.invProjMatrix;
    var viewportMatrix = this.viewportMatrix;
    gl.useProgram(shaderProgram);
    $da1736cd2fd385ef$var$enableAttributes(gl, shaderProgram);
    $da1736cd2fd385ef$var$setViewport(gl, layer, rect, viewportMatrix);
    gl.uniformMatrix4fv(shaderProgram.uViewportMatrix, false, viewportMatrix);
    gl.bindBuffer(gl.ARRAY_BUFFER, constantBuffers.vertexPositions);
    gl.vertexAttribPointer(shaderProgram.aVertexPosition, 3, gl.FLOAT, gl.FALSE, 0, 0);
    gl.bindBuffer(gl.ARRAY_BUFFER, constantBuffers.textureCoords);
    // Compute and set the inverse projection matrix.
    $da1736cd2fd385ef$require$mat4.copy(invProjMatrix, layer.view().projection());
    $da1736cd2fd385ef$require$mat4.invert(invProjMatrix, invProjMatrix);
    gl.uniformMatrix4fv(shaderProgram.uInvProjMatrix, false, invProjMatrix);
    // Compute and set the texture scale and crop offsets.
    var textureCrop = layer.effects().textureCrop || {};
    var textureX = textureCrop.x != null ? textureCrop.x : 0;
    var textureY = textureCrop.y != null ? textureCrop.y : 0;
    var textureWidth = textureCrop.width != null ? textureCrop.width : 1;
    var textureHeight = textureCrop.height != null ? textureCrop.height : 1;
    gl.uniform1f(shaderProgram.uTextureX, textureX);
    gl.uniform1f(shaderProgram.uTextureY, textureY);
    gl.uniform1f(shaderProgram.uTextureWidth, textureWidth);
    gl.uniform1f(shaderProgram.uTextureHeight, textureHeight);
    $da1736cd2fd385ef$var$setupPixelEffectUniforms(gl, layer.effects(), {
        opacity: shaderProgram.uOpacity,
        colorOffset: shaderProgram.uColorOffset,
        colorMatrix: shaderProgram.uColorMatrix
    });
};
$da1736cd2fd385ef$var$WebGlEquirectRenderer.prototype.endLayer = function(layer, rect) {
    var gl = this.gl;
    var shaderProgram = this.shaderProgram;
    $da1736cd2fd385ef$var$disableAttributes(gl, shaderProgram);
};
$da1736cd2fd385ef$var$WebGlEquirectRenderer.prototype.renderTile = function(tile, texture, layer, layerZ) {
    var gl = this.gl;
    var shaderProgram = this.shaderProgram;
    var constantBuffers = this.constantBuffers;
    $da1736cd2fd385ef$var$setDepth(gl, shaderProgram, layerZ, tile.z);
    $da1736cd2fd385ef$var$setTexture(gl, shaderProgram, texture);
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, constantBuffers.vertexIndices);
    gl.drawElements(gl.TRIANGLES, $da1736cd2fd385ef$var$vertexIndices.length, gl.UNSIGNED_SHORT, 0);
};
module.exports = $da1736cd2fd385ef$var$WebGlEquirectRenderer;

});
parcelRegister("aVswm", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
module.exports = [
    "attribute vec3 aVertexPosition;",
    "uniform float uDepth;",
    "uniform mat4 uViewportMatrix;",
    "uniform mat4 uInvProjMatrix;",
    "varying vec4 vRay;",
    "void main(void) {",
    "  vRay = uInvProjMatrix * vec4(aVertexPosition.xy, 1.0, 1.0);",
    "  gl_Position = uViewportMatrix * vec4(aVertexPosition.xy, uDepth, 1.0);",
    "}"
].join("\n");

});

parcelRegister("3C2IP", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
module.exports = [
    "#ifdef GL_FRAGMENT_PRECISION_HIGH",
    "precision highp float;",
    "#else",
    "precision mediump float",
    "#endif",
    "uniform sampler2D uSampler;",
    "uniform float uOpacity;",
    "uniform float uTextureX;",
    "uniform float uTextureY;",
    "uniform float uTextureWidth;",
    "uniform float uTextureHeight;",
    "uniform vec4 uColorOffset;",
    "uniform mat4 uColorMatrix;",
    "varying vec4 vRay;",
    "const float PI = 3.14159265358979323846264;",
    "void main(void) {",
    "  float r = inversesqrt(vRay.x * vRay.x + vRay.y * vRay.y + vRay.z * vRay.z);",
    "  float phi  = acos(vRay.y * r);",
    "  float theta = atan(vRay.x, -1.0*vRay.z);",
    "  float s = 0.5 + 0.5 * theta / PI;",
    "  float t = 1.0 - phi / PI;",
    "  s = s * uTextureWidth + uTextureX;",
    "  t = t * uTextureHeight + uTextureY;",
    "  vec4 color = texture2D(uSampler, vec2(s, t)) * uColorMatrix + uColorOffset;",
    "  gl_FragColor = vec4(color.rgba * uOpacity);",
    "}"
].join("\n");

});


parcelRegister("48tXO", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $4QGnk = parcelRequire("4QGnk");
var $302f26ecbc1518d9$require$CubeTile = $4QGnk.Tile;

var $iv3ES = parcelRequire("iv3ES");

var $asoyN = parcelRequire("asoyN");

var $Yar88 = parcelRequire("Yar88");
/**
 * @class CssCubeRenderer
 * @implements Renderer
 * @classdesc
 *
 * A renderer for {@link CubeGeometry} and {@link RectilinearView}, appropriate
 * for a {@link CssStage}.
 *
 * Most users do not need to instantiate this class. Renderers are created and
 * destroyed by {@link Stage} as necessary.
 */ function $302f26ecbc1518d9$var$CssCubeRenderer(root, quirks) {
    this.constructor.super_.call(this, root, quirks, $302f26ecbc1518d9$require$CubeTile);
}
$Yar88($302f26ecbc1518d9$var$CssCubeRenderer, $iv3ES);
$302f26ecbc1518d9$var$CssCubeRenderer.prototype.calculateTransform = function(tile, texture, view) {
    var padSize = this._browserQuirks.padSize;
    var reverseLevelDepth = this._browserQuirks.reverseLevelDepth;
    var perspectiveNudge = this._browserQuirks.perspectiveNudge;
    var transform = "";
    // Calculate the cube size for this level.
    var cubeSize = reverseLevelDepth ? 256 - tile.z : tile.levelWidth();
    // Place top left corner of tile at viewport center to serve as the center
    // of rotation.
    // We do not rotate about the center of the tile because, for some mysterious
    // reason, this seems to occasionally crash Chrome.
    var size = view.size();
    var viewportWidth = size.width;
    var viewportHeight = size.height;
    transform += "translate3d(" + $asoyN(viewportWidth / 2) + "px, " + $asoyN(viewportHeight / 2) + "px, 0px) ";
    // Set the perspective depth.
    var perspective = 0.5 * viewportHeight / Math.tan(view.fov() / 2);
    var distance = perspective + perspectiveNudge;
    transform += "perspective(" + $asoyN(perspective) + "px) translateZ(" + $asoyN(distance) + "px) ";
    // Set the camera rotation.
    var viewRotZ = -view.roll();
    var viewRotX = -view.pitch();
    var viewRotY = view.yaw();
    transform += "rotateZ(" + $asoyN(viewRotZ) + "rad) rotateX(" + $asoyN(viewRotX) + "rad) rotateY(" + $asoyN(viewRotY) + "rad) ";
    // Set the cube face orientation.
    var tileRotX = -tile.rotX();
    var tileRotY = tile.rotY();
    transform += "rotateX(" + $asoyN(tileRotX) + "rad) rotateY(" + $asoyN(tileRotY) + "rad) ";
    // Move tile into its position within the cube face.
    var cornerX = tile.centerX() - tile.scaleX() / 2;
    var cornerY = -(tile.centerY() + tile.scaleY() / 2);
    var translX = cornerX * cubeSize;
    var translY = cornerY * cubeSize;
    var translZ = -cubeSize / 2;
    transform += "translate3d(" + $asoyN(translX) + "px, " + $asoyN(translY) + "px, " + $asoyN(translZ) + "px) ";
    // Scale tile into correct size.
    if (reverseLevelDepth) {
        var scaleX = cubeSize * tile.scaleX() / tile.width();
        var scaleY = cubeSize * tile.scaleY() / tile.height();
        transform += "scale(" + $asoyN(scaleX) + ", " + $asoyN(scaleY) + ") ";
    }
    // Compensate for padding around the tile.
    var padLeft = tile.padLeft() ? padSize : 0;
    var padTop = tile.padTop() ? padSize : 0;
    if (padLeft !== 0 || padTop !== 0) transform += "translate3d(" + $asoyN(-padLeft) + "px, " + $asoyN(-padTop) + "px, 0) ";
    return transform;
};
module.exports = $302f26ecbc1518d9$var$CssCubeRenderer;

});
parcelRegister("4QGnk", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $Yar88 = parcelRequire("Yar88");

var $4j7qz = parcelRequire("4j7qz");

var $1tXVZ = parcelRequire("1tXVZ");

var $dW5wO = parcelRequire("dW5wO");

var $4tCa7 = parcelRequire("4tCa7");

var $4rFjs = parcelRequire("4rFjs");
var $387ce39a02ed0988$require$makeLevelList = $4rFjs.makeLevelList;

var $4rFjs = parcelRequire("4rFjs");
var $387ce39a02ed0988$require$makeSelectableLevelList = $4rFjs.makeSelectableLevelList;

var $eCQUD = parcelRequire("eCQUD");

var $3nhrd = parcelRequire("3nhrd");

var $fXp6t = parcelRequire("fXp6t");

var $fwwPx = parcelRequire("fwwPx");
var $8QvoZ = parcelRequire("8QvoZ");
var $387ce39a02ed0988$require$vec3 = $fwwPx;

var $fwwPx = parcelRequire("fwwPx");
var $8QvoZ = parcelRequire("8QvoZ");
var $387ce39a02ed0988$require$vec4 = $8QvoZ;
var $387ce39a02ed0988$var$neighborsCacheSize = 64;
// Some renderer implementations require tiles to be padded around with
// repeated pixels to prevent the appearance of visible seams between tiles.
//
// In order to prevent the padding from being visible, the tiles must be
// padded and stacked such that the padding on one of the sides, when present,
// stacks below the neighboring tile on that side.
//
// The padding rules are as follows:
// * Define a tile to be X-marginal if it contacts the X-edge of its cube face.
// * Pad top if the tile is top-marginal and the face is F or U.
// * Pad bottom unless the tile is bottom-marginal or the face is F or D.
// * Pad left if the tile is left-marginal and the face is F, L, U or D.
// * Pad right unless the tile is right-marginal or the face is F, R, U or D.
//
// The stacking rules are as follows:
// * Within an image, stack smaller zoom levels below larger zoom levels.
// * Within a level, stack tiles bottom to top in FUDLRB face order.
// * Within a face, stack tiles bottom to top in ascending Y coordinate order.
// * Within a row, stack tiles bottom to top in ascending X coordinate order.
//
// Crucially, these rules affect the implementation of the tile cmp() method,
// which determines the stacking order, and of the pad*() tile methods, which
// determine the amount of padding on each of the four sides of a tile.
// Initials for cube faces in stacking order.
var $387ce39a02ed0988$var$faceList = "fudlrb";
// Rotation of each face, relative to the front face.
var $387ce39a02ed0988$var$faceRotation = {
    f: {
        x: 0,
        y: 0
    },
    b: {
        x: 0,
        y: Math.PI
    },
    l: {
        x: 0,
        y: Math.PI / 2
    },
    r: {
        x: 0,
        y: -Math.PI / 2
    },
    u: {
        x: Math.PI / 2,
        y: 0
    },
    d: {
        x: -Math.PI / 2,
        y: 0
    }
};
// Zero vector.
var $387ce39a02ed0988$var$origin = $387ce39a02ed0988$require$vec3.create();
// Rotate a vector in ZXY order.
function $387ce39a02ed0988$var$rotateVector(vec, z, x, y) {
    if (z) $387ce39a02ed0988$require$vec3.rotateZ(vec, vec, $387ce39a02ed0988$var$origin, z);
    if (x) $387ce39a02ed0988$require$vec3.rotateX(vec, vec, $387ce39a02ed0988$var$origin, x);
    if (y) $387ce39a02ed0988$require$vec3.rotateY(vec, vec, $387ce39a02ed0988$var$origin, y);
}
// Normalized vectors pointing to the center of each face.
var $387ce39a02ed0988$var$faceVectors = {};
for(var $387ce39a02ed0988$var$i = 0; $387ce39a02ed0988$var$i < $387ce39a02ed0988$var$faceList.length; $387ce39a02ed0988$var$i++){
    var $387ce39a02ed0988$var$face = $387ce39a02ed0988$var$faceList[$387ce39a02ed0988$var$i];
    var $387ce39a02ed0988$var$rotation = $387ce39a02ed0988$var$faceRotation[$387ce39a02ed0988$var$face];
    var $387ce39a02ed0988$var$v = $387ce39a02ed0988$require$vec3.fromValues(0, 0, -1);
    $387ce39a02ed0988$var$rotateVector($387ce39a02ed0988$var$v, 0, $387ce39a02ed0988$var$rotation.x, $387ce39a02ed0988$var$rotation.y);
    $387ce39a02ed0988$var$faceVectors[$387ce39a02ed0988$var$face] = $387ce39a02ed0988$var$v;
}
// Map each face to its adjacent faces.
// The order is as suggested by the front face.
var $387ce39a02ed0988$var$adjacentFace = {
    f: [
        "l",
        "r",
        "u",
        "d"
    ],
    b: [
        "r",
        "l",
        "u",
        "d"
    ],
    l: [
        "b",
        "f",
        "u",
        "d"
    ],
    r: [
        "f",
        "b",
        "u",
        "d"
    ],
    u: [
        "l",
        "r",
        "b",
        "f"
    ],
    d: [
        "l",
        "r",
        "f",
        "b"
    ]
};
// Offsets to apply to the (x,y) coordinates of a tile to get its neighbors.
var $387ce39a02ed0988$var$neighborOffsets = [
    [
        0,
        1
    ],
    [
        1,
        0
    ],
    [
        0,
        -1
    ],
    [
        -1,
        0
    ] // left
];
/**
 * @class CubeTile
 * @implements Tile
 * @classdesc
 *
 * A tile in a @{CubeGeometry}.
 */ function $387ce39a02ed0988$var$CubeTile(face, x, y, z, geometry) {
    this.face = face;
    this.x = x;
    this.y = y;
    this.z = z;
    this._geometry = geometry;
    this._level = geometry.levelList[z];
}
$387ce39a02ed0988$var$CubeTile.prototype.rotX = function() {
    return $387ce39a02ed0988$var$faceRotation[this.face].x;
};
$387ce39a02ed0988$var$CubeTile.prototype.rotY = function() {
    return $387ce39a02ed0988$var$faceRotation[this.face].y;
};
$387ce39a02ed0988$var$CubeTile.prototype.centerX = function() {
    return (this.x + 0.5) / this._level.numHorizontalTiles() - 0.5;
};
$387ce39a02ed0988$var$CubeTile.prototype.centerY = function() {
    return 0.5 - (this.y + 0.5) / this._level.numVerticalTiles();
};
$387ce39a02ed0988$var$CubeTile.prototype.scaleX = function() {
    return 1 / this._level.numHorizontalTiles();
};
$387ce39a02ed0988$var$CubeTile.prototype.scaleY = function() {
    return 1 / this._level.numVerticalTiles();
};
$387ce39a02ed0988$var$CubeTile.prototype.width = function() {
    return this._level.tileWidth();
};
$387ce39a02ed0988$var$CubeTile.prototype.height = function() {
    return this._level.tileHeight();
};
$387ce39a02ed0988$var$CubeTile.prototype.levelWidth = function() {
    return this._level.width();
};
$387ce39a02ed0988$var$CubeTile.prototype.levelHeight = function() {
    return this._level.height();
};
$387ce39a02ed0988$var$CubeTile.prototype.atTopLevel = function() {
    return this.z === 0;
};
$387ce39a02ed0988$var$CubeTile.prototype.atBottomLevel = function() {
    return this.z === this._geometry.levelList.length - 1;
};
$387ce39a02ed0988$var$CubeTile.prototype.atTopEdge = function() {
    return this.y === 0;
};
$387ce39a02ed0988$var$CubeTile.prototype.atBottomEdge = function() {
    return this.y === this._level.numVerticalTiles() - 1;
};
$387ce39a02ed0988$var$CubeTile.prototype.atLeftEdge = function() {
    return this.x === 0;
};
$387ce39a02ed0988$var$CubeTile.prototype.atRightEdge = function() {
    return this.x === this._level.numHorizontalTiles() - 1;
};
$387ce39a02ed0988$var$CubeTile.prototype.padTop = function() {
    return this.atTopEdge() && /[fu]/.test(this.face);
};
$387ce39a02ed0988$var$CubeTile.prototype.padBottom = function() {
    return !this.atBottomEdge() || /[fd]/.test(this.face);
};
$387ce39a02ed0988$var$CubeTile.prototype.padLeft = function() {
    return this.atLeftEdge() && /[flud]/.test(this.face);
};
$387ce39a02ed0988$var$CubeTile.prototype.padRight = function() {
    return !this.atRightEdge() || /[frud]/.test(this.face);
};
$387ce39a02ed0988$var$CubeTile.prototype.vertices = function(result) {
    if (!result) result = [
        $387ce39a02ed0988$require$vec3.create(),
        $387ce39a02ed0988$require$vec3.create(),
        $387ce39a02ed0988$require$vec3.create(),
        $387ce39a02ed0988$require$vec3.create()
    ];
    var rot = $387ce39a02ed0988$var$faceRotation[this.face];
    function makeVertex(vec, x, y) {
        $387ce39a02ed0988$require$vec3.set(vec, x, y, -0.5);
        $387ce39a02ed0988$var$rotateVector(vec, 0, rot.x, rot.y);
    }
    var left = this.centerX() - this.scaleX() / 2;
    var right = this.centerX() + this.scaleX() / 2;
    var bottom = this.centerY() - this.scaleY() / 2;
    var top = this.centerY() + this.scaleY() / 2;
    makeVertex(result[0], left, top);
    makeVertex(result[1], right, top);
    makeVertex(result[2], right, bottom);
    makeVertex(result[3], left, bottom);
    return result;
};
$387ce39a02ed0988$var$CubeTile.prototype.parent = function() {
    if (this.atTopLevel()) return null;
    var face = this.face;
    var z = this.z;
    var x = this.x;
    var y = this.y;
    var geometry = this._geometry;
    var level = geometry.levelList[z];
    var parentLevel = geometry.levelList[z - 1];
    var tileX = Math.floor(x / level.numHorizontalTiles() * parentLevel.numHorizontalTiles());
    var tileY = Math.floor(y / level.numVerticalTiles() * parentLevel.numVerticalTiles());
    var tileZ = z - 1;
    return new $387ce39a02ed0988$var$CubeTile(face, tileX, tileY, tileZ, geometry);
};
$387ce39a02ed0988$var$CubeTile.prototype.children = function(result) {
    if (this.atBottomLevel()) return null;
    var face = this.face;
    var z = this.z;
    var x = this.x;
    var y = this.y;
    var geometry = this._geometry;
    var level = geometry.levelList[z];
    var childLevel = geometry.levelList[z + 1];
    var nHoriz = childLevel.numHorizontalTiles() / level.numHorizontalTiles();
    var nVert = childLevel.numVerticalTiles() / level.numVerticalTiles();
    result = result || [];
    for(var h = 0; h < nHoriz; h++)for(var v = 0; v < nVert; v++){
        var tileX = nHoriz * x + h;
        var tileY = nVert * y + v;
        var tileZ = z + 1;
        result.push(new $387ce39a02ed0988$var$CubeTile(face, tileX, tileY, tileZ, geometry));
    }
    return result;
};
$387ce39a02ed0988$var$CubeTile.prototype.neighbors = function() {
    var geometry = this._geometry;
    var cache = geometry._neighborsCache;
    // Satisfy from cache when available.
    var cachedResult = cache.get(this);
    if (cachedResult) return cachedResult;
    var vec = geometry._vec;
    var face = this.face;
    var x = this.x;
    var y = this.y;
    var z = this.z;
    var level = this._level;
    var numX = level.numHorizontalTiles();
    var numY = level.numVerticalTiles();
    var result = [];
    for(var i = 0; i < $387ce39a02ed0988$var$neighborOffsets.length; i++){
        var xOffset = $387ce39a02ed0988$var$neighborOffsets[i][0];
        var yOffset = $387ce39a02ed0988$var$neighborOffsets[i][1];
        var newX = x + xOffset;
        var newY = y + yOffset;
        var newZ = z;
        var newFace = face;
        if (newX < 0 || newX >= numX || newY < 0 || newY >= numY) {
            // If the neighboring tile belongs to a different face, calculate a
            // vector pointing to the edge between the two faces at the point the
            // tile and its neighbor meet, and convert it into tile coordinates for
            // the neighboring face.
            var xCoord = this.centerX();
            var yCoord = this.centerY();
            // First, calculate the vector as if the initial tile belongs to the
            // front face, so that the tile x,y coordinates map directly into the
            // x,y axes.
            if (newX < 0) {
                $387ce39a02ed0988$require$vec3.set(vec, -0.5, yCoord, -0.5);
                newFace = $387ce39a02ed0988$var$adjacentFace[face][0];
            } else if (newX >= numX) {
                $387ce39a02ed0988$require$vec3.set(vec, 0.5, yCoord, -0.5);
                newFace = $387ce39a02ed0988$var$adjacentFace[face][1];
            } else if (newY < 0) {
                $387ce39a02ed0988$require$vec3.set(vec, xCoord, 0.5, -0.5);
                newFace = $387ce39a02ed0988$var$adjacentFace[face][2];
            } else if (newY >= numY) {
                $387ce39a02ed0988$require$vec3.set(vec, xCoord, -0.5, -0.5);
                newFace = $387ce39a02ed0988$var$adjacentFace[face][3];
            }
            var rot;
            // Then, rotate the vector into the actual face the initial tile
            // belongs to.
            rot = $387ce39a02ed0988$var$faceRotation[face];
            $387ce39a02ed0988$var$rotateVector(vec, 0, rot.x, rot.y);
            // Finally, rotate the vector from the neighboring face into the front
            // face. Again, this is so that the neighboring tile x,y coordinates
            // map directly into the x,y axes.
            rot = $387ce39a02ed0988$var$faceRotation[newFace];
            $387ce39a02ed0988$var$rotateVector(vec, 0, -rot.x, -rot.y);
            // Calculate the neighboring tile coordinates.
            newX = $eCQUD(Math.floor((0.5 + vec[0]) * numX), 0, numX - 1);
            newY = $eCQUD(Math.floor((0.5 - vec[1]) * numY), 0, numY - 1);
        }
        result.push(new $387ce39a02ed0988$var$CubeTile(newFace, newX, newY, newZ, geometry));
    }
    // Store into cache to satisfy future requests.
    cache.set(this, result);
    return result;
};
$387ce39a02ed0988$var$CubeTile.prototype.hash = function() {
    return $4j7qz($387ce39a02ed0988$var$faceList.indexOf(this.face), this.z, this.y, this.x);
};
$387ce39a02ed0988$var$CubeTile.prototype.equals = function(that) {
    return this.geometry === that.geometry && this.face === that.face && this.z === that.z && this.y === that.y && this.x === that.x;
};
$387ce39a02ed0988$var$CubeTile.prototype.cmp = function(that) {
    return $3nhrd(this.z, that.z) || $3nhrd($387ce39a02ed0988$var$faceList.indexOf(this.face), $387ce39a02ed0988$var$faceList.indexOf(that.face)) || $3nhrd(this.y, that.y) || $3nhrd(this.x, that.x);
};
$387ce39a02ed0988$var$CubeTile.prototype.str = function() {
    return "CubeTile(" + tile.face + ", " + tile.x + ", " + tile.y + ", " + tile.z + ")";
};
function $387ce39a02ed0988$var$CubeLevel(levelProperties) {
    this.constructor.super_.call(this, levelProperties);
    this._size = levelProperties.size;
    this._tileSize = levelProperties.tileSize;
    if (this._size % this._tileSize !== 0) throw new Error("Level size is not multiple of tile size: " + this._size + " " + this._tileSize);
}
$Yar88($387ce39a02ed0988$var$CubeLevel, $4tCa7);
$387ce39a02ed0988$var$CubeLevel.prototype.width = function() {
    return this._size;
};
$387ce39a02ed0988$var$CubeLevel.prototype.height = function() {
    return this._size;
};
$387ce39a02ed0988$var$CubeLevel.prototype.tileWidth = function() {
    return this._tileSize;
};
$387ce39a02ed0988$var$CubeLevel.prototype.tileHeight = function() {
    return this._tileSize;
};
$387ce39a02ed0988$var$CubeLevel.prototype._validateWithParentLevel = function(parentLevel) {
    var width = this.width();
    var height = this.height();
    var tileWidth = this.tileWidth();
    var tileHeight = this.tileHeight();
    var numHorizontal = this.numHorizontalTiles();
    var numVertical = this.numVerticalTiles();
    var parentWidth = parentLevel.width();
    var parentHeight = parentLevel.height();
    var parentTileWidth = parentLevel.tileWidth();
    var parentTileHeight = parentLevel.tileHeight();
    var parentNumHorizontal = parentLevel.numHorizontalTiles();
    var parentNumVertical = parentLevel.numVerticalTiles();
    if (width % parentWidth !== 0) throw new Error("Level width must be multiple of parent level: " + width + " vs. " + parentWidth);
    if (height % parentHeight !== 0) throw new Error("Level height must be multiple of parent level: " + height + " vs. " + parentHeight);
    if (numHorizontal % parentNumHorizontal !== 0) throw new Error("Number of horizontal tiles must be multiple of parent level: " + numHorizontal + " (" + width + "/" + tileWidth + ")" + " vs. " + parentNumHorizontal + " (" + parentWidth + "/" + parentTileWidth + ")");
    if (numVertical % parentNumVertical !== 0) throw new Error("Number of vertical tiles must be multiple of parent level: " + numVertical + " (" + height + "/" + tileHeight + ")" + " vs. " + parentNumVertical + " (" + parentHeight + "/" + parentTileHeight + ")");
};
/**
 * @class CubeGeometry
 * @implements Geometry
 * @classdesc
 *
 * A {@link Geometry} implementation suitable for tiled cube images with
 * multiple resolution levels.
 *
 * The following restrictions apply:
 *   - All tiles in a level must be square and form a rectangular grid;
 *   - The size of a level must be a multiple of the tile size;
 *   - The size of a level must be a multiple of the parent level size;
 *   - The number of tiles in a level must be a multiple of the number of tiles
 *     in the parent level.
 *
 * @param {Object[]} levelPropertiesList Level description
 * @param {number} levelPropertiesList[].size Cube face size in pixels
 * @param {number} levelPropertiesList[].tileSize Tile size in pixels
 */ function $387ce39a02ed0988$var$CubeGeometry(levelPropertiesList) {
    if ($fXp6t(levelPropertiesList) !== "array") throw new Error("Level list must be an array");
    this.levelList = $387ce39a02ed0988$require$makeLevelList(levelPropertiesList, $387ce39a02ed0988$var$CubeLevel);
    this.selectableLevelList = $387ce39a02ed0988$require$makeSelectableLevelList(this.levelList);
    for(var i = 1; i < this.levelList.length; i++)this.levelList[i]._validateWithParentLevel(this.levelList[i - 1]);
    this._tileSearcher = new $1tXVZ(this);
    this._neighborsCache = new $dW5wO($387ce39a02ed0988$var$neighborsCacheSize);
    this._vec = $387ce39a02ed0988$require$vec4.create();
    this._viewSize = {};
}
$387ce39a02ed0988$var$CubeGeometry.prototype.maxTileSize = function() {
    var maxTileSize = 0;
    for(var i = 0; i < this.levelList.length; i++){
        var level = this.levelList[i];
        maxTileSize = Math.max(maxTileSize, level.tileWidth, level.tileHeight);
    }
    return maxTileSize;
};
$387ce39a02ed0988$var$CubeGeometry.prototype.levelTiles = function(level, result) {
    var levelIndex = this.levelList.indexOf(level);
    var maxX = level.numHorizontalTiles() - 1;
    var maxY = level.numVerticalTiles() - 1;
    result = result || [];
    for(var f = 0; f < $387ce39a02ed0988$var$faceList.length; f++){
        var face = $387ce39a02ed0988$var$faceList[f];
        for(var x = 0; x <= maxX; x++)for(var y = 0; y <= maxY; y++)result.push(new $387ce39a02ed0988$var$CubeTile(face, x, y, levelIndex, this));
    }
    return result;
};
$387ce39a02ed0988$var$CubeGeometry.prototype._closestTile = function(view, level) {
    var ray = this._vec;
    // Compute a view ray into the central screen point.
    $387ce39a02ed0988$require$vec4.set(ray, 0, 0, 1, 1);
    $387ce39a02ed0988$require$vec4.transformMat4(ray, ray, view.inverseProjection());
    var minAngle = Infinity;
    var closestFace = null;
    // Find the face whose vector makes a minimal angle with the view ray.
    // This is the face into which the view ray points.
    for(var face in $387ce39a02ed0988$var$faceVectors){
        var vector = $387ce39a02ed0988$var$faceVectors[face];
        // For a small angle between two normalized vectors, angle ~ 1-cos(angle).
        var angle = 1 - $387ce39a02ed0988$require$vec3.dot(vector, ray);
        if (angle < minAngle) {
            minAngle = angle;
            closestFace = face;
        }
    }
    // Project view ray onto cube, i.e., normalize the coordinate with
    // largest absolute value to ±0.5.
    var max = Math.max(Math.abs(ray[0]), Math.abs(ray[1]), Math.abs(ray[2])) / 0.5;
    for(var i = 0; i < 3; i++)ray[i] = ray[i] / max;
    // Rotate view ray into front face.
    var rot = $387ce39a02ed0988$var$faceRotation[closestFace];
    $387ce39a02ed0988$var$rotateVector(ray, 0, -rot.x, -rot.y);
    // Get the desired zoom level.
    var tileZ = this.levelList.indexOf(level);
    var numX = level.numHorizontalTiles();
    var numY = level.numVerticalTiles();
    // Find the coordinates of the tile that the view ray points into.
    var tileX = $eCQUD(Math.floor((0.5 + ray[0]) * numX), 0, numX - 1);
    var tileY = $eCQUD(Math.floor((0.5 - ray[1]) * numY), 0, numY - 1);
    return new $387ce39a02ed0988$var$CubeTile(closestFace, tileX, tileY, tileZ, this);
};
$387ce39a02ed0988$var$CubeGeometry.prototype.visibleTiles = function(view, level, result) {
    var viewSize = this._viewSize;
    var tileSearcher = this._tileSearcher;
    result = result || [];
    view.size(viewSize);
    if (viewSize.width === 0 || viewSize.height === 0) // No tiles are visible if the viewport is empty.
    return result;
    var startingTile = this._closestTile(view, level);
    var count = tileSearcher.search(view, startingTile, result);
    if (!count) throw new Error("Starting tile is not visible");
    return result;
};
$387ce39a02ed0988$var$CubeGeometry.Tile = $387ce39a02ed0988$var$CubeGeometry.prototype.Tile = $387ce39a02ed0988$var$CubeTile;
$387ce39a02ed0988$var$CubeGeometry.type = $387ce39a02ed0988$var$CubeGeometry.prototype.type = "cube";
$387ce39a02ed0988$var$CubeTile.type = $387ce39a02ed0988$var$CubeTile.prototype.type = "cube";
module.exports = $387ce39a02ed0988$var$CubeGeometry;

});
parcelRegister("4j7qz", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
// Jenkins one-at-a-time hash
// http://www.burtleburtle.net/bob/hash/doobs.html
// Input: an array of integers
// Output: an integer
function $322eb2c0f4220044$var$hash() {
    var h = 0;
    for(var i = 0; i < arguments.length; i++){
        var k = arguments[i];
        h += k;
        h += k << 10;
        h ^= k >> 6;
    }
    h += h << 3;
    h ^= h >> 11;
    h += h << 15;
    return h >= 0 ? h : -h;
}
module.exports = $322eb2c0f4220044$var$hash;

});

parcelRegister("1tXVZ", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $fio2g = parcelRequire("fio2g");
/**
 * @class TileSearcher
 * @classdesc
 *
 * A TileSearcher performs searches for visible tiles.
 */ function $1146fd93dd0182e7$var$TileSearcher() {
    // Stack of tiles to be explored.
    this._stack = [];
    // Set of already explored tiles.
    this._visited = new $fio2g();
    // Tile vertices. Allocated by Tile#vertices on first use.
    this._vertices = null;
}
/**
 * Performs a search for visible tiles by starting at a given tile and
 * recursively exploring neighbors until no more visible tiles are found.
 *
 * @param {View} view The view used to deem whether a tile is visible.
 * @param {Tile} tile The starting tile.
 * @param {Tile[]} result An array to append the visible tiles to, including the
 *     starting tile when visible. Existing array members are preserved.
 * @return {number} The number of visible tiles found.
 */ $1146fd93dd0182e7$var$TileSearcher.prototype.search = function(view, startingTile, result) {
    var stack = this._stack;
    var visited = this._visited;
    var vertices = this._vertices;
    var count = 0;
    // Clear internal state.
    this._clear();
    stack.push(startingTile);
    while(stack.length > 0){
        var tile = stack.pop();
        if (visited.has(tile)) continue;
        if (!view.intersects(tile.vertices(vertices))) continue;
        // Mark tile as visited.
        visited.add(tile);
        // Add neighbors to the stack of tiles to explore.
        var neighbors = tile.neighbors();
        for(var i = 0; i < neighbors.length; i++)stack.push(neighbors[i]);
        // Add to result.
        result.push(tile);
        count++;
    }
    // Reuse the vertices array in future searches.
    this._vertices = vertices;
    // Clear internal state.
    this._clear();
    return count;
};
$1146fd93dd0182e7$var$TileSearcher.prototype._clear = function() {
    this._stack.length = 0;
    this._visited.clear();
};
module.exports = $1146fd93dd0182e7$var$TileSearcher;

});
parcelRegister("fio2g", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $iZgBB = parcelRequire("iZgBB");
var $b22b2e6b2a6620cd$var$defaultCapacity = 64;
// A set data structure for elements implementing hash() and equals().
// The capacity, if given, is just a hint; the set is allowed to exceed it, but
// performance may suffer.
function $b22b2e6b2a6620cd$var$Set(capacity) {
    if (capacity != null && (!isFinite(capacity) || Math.floor(capacity) !== capacity || capacity < 1)) throw new Error("Set: invalid capacity");
    this._capacity = this._capacity || $b22b2e6b2a6620cd$var$defaultCapacity;
    this._buckets = [];
    for(var i = 0; i < this._capacity; i++)this._buckets.push([]);
    this._size = 0;
}
// Adds an element, replacing an existing element.
// Returns the replaced element, or null if no element was replaced.
$b22b2e6b2a6620cd$var$Set.prototype.add = function(element) {
    var h = $iZgBB(element.hash(), this._capacity);
    var bucket = this._buckets[h];
    for(var i = 0; i < bucket.length; i++){
        var existingElement = bucket[i];
        if (element.equals(existingElement)) {
            bucket[i] = element;
            return existingElement;
        }
    }
    bucket.push(element);
    this._size++;
    return null;
};
// Removes an element.
// Returns the removed element, or null if the element was not found.
$b22b2e6b2a6620cd$var$Set.prototype.remove = function(element) {
    var h = $iZgBB(element.hash(), this._capacity);
    var bucket = this._buckets[h];
    for(var i = 0; i < bucket.length; i++){
        var existingElement = bucket[i];
        if (element.equals(existingElement)) {
            // Splice manually to avoid Array#splice return value allocation.
            for(var j = i; j < bucket.length - 1; j++)bucket[j] = bucket[j + 1];
            bucket.length = bucket.length - 1;
            this._size--;
            return existingElement;
        }
    }
    return null;
};
// Returns whether an element is in the set.
$b22b2e6b2a6620cd$var$Set.prototype.has = function(element) {
    var h = $iZgBB(element.hash(), this._capacity);
    var bucket = this._buckets[h];
    for(var i = 0; i < bucket.length; i++){
        var existingElement = bucket[i];
        if (element.equals(existingElement)) return true;
    }
    return false;
};
// Returns the number of elements in the set.
$b22b2e6b2a6620cd$var$Set.prototype.size = function() {
    return this._size;
};
// Removes all elements from the set.
$b22b2e6b2a6620cd$var$Set.prototype.clear = function() {
    for(var i = 0; i < this._capacity; i++)this._buckets[i].length = 0;
    this._size = 0;
};
// Calls fn(element) for each element in the set, in an unspecified order.
// Returns the number of times fn was called.
// The result is unspecified if the set is mutated during iteration.
$b22b2e6b2a6620cd$var$Set.prototype.forEach = function(fn) {
    var count = 0;
    for(var i = 0; i < this._capacity; i++){
        var bucket = this._buckets[i];
        for(var j = 0; j < bucket.length; j++){
            fn(bucket[j]);
            count += 1;
        }
    }
    return count;
};
module.exports = $b22b2e6b2a6620cd$var$Set;

});
parcelRegister("iZgBB", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
/**
 * Modulo operation
 *
 * @memberof util
 * @param {Number} dividend
 * @param {Number} divisor
 * @returns {Number} Value in range `[0,divisor[`
 */ function $dd2ace05bbe02279$var$mod(a, b) {
    return (+a % (b = +b) + b) % b;
}
module.exports = $dd2ace05bbe02279$var$mod;

});



parcelRegister("dW5wO", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $iZgBB = parcelRequire("iZgBB");
// An LruMap holds up to a maximum number of key-value pairs, ordered by their
// time of insertion. When the addition of a key-value pair would cause the
// capacity to be exceeded, the oldest key-value pair in the set is evicted.
// As a special case, an LruMap with zero capacity always rejects the insertion
// of a key-value pair.
//
// Keys must implement hash() and equals(). Note that the implementation doesn't
// currently use hash(), but a future version might.
function $a254faf283c27d31$var$LruMap(capacity) {
    if (!isFinite(capacity) || Math.floor(capacity) !== capacity || capacity < 0) throw new Error("LruMap: invalid capacity");
    this._capacity = capacity;
    // Keys and values are stored in circular arrays ordered by decreasing age.
    // Start is the index of the oldest key/value and size is the number of valid
    // key/values; the region containing valid keys/values may wrap around.
    this._keys = new Array(this._capacity);
    this._values = new Array(this._capacity);
    this._start = 0;
    this._size = 0;
}
$a254faf283c27d31$var$LruMap.prototype._index = function(i) {
    return $iZgBB(this._start + i, this._capacity);
};
// Returns the value associated to the specified key, or null if not found.
$a254faf283c27d31$var$LruMap.prototype.get = function(key) {
    for(var i = 0; i < this._size; i++){
        var existingKey = this._keys[this._index(i)];
        if (key.equals(existingKey)) return this._values[this._index(i)];
    }
    return null;
};
// Associates the specified value with the specified key, possibly replacing the
// currently associated value. The key-value pair becomes the newest. If the map
// is at capacity, the oldest key-value pair is removed. Returns the removed
// key, or null otherwise. If the capacity is zero, does nothing and returns
// the key.
$a254faf283c27d31$var$LruMap.prototype.set = function(key, value) {
    if (this._capacity === 0) return key;
    this.del(key);
    var evictedKey = this._size === this._capacity ? this._keys[this._index(0)] : null;
    this._keys[this._index(this._size)] = key;
    this._values[this._index(this._size)] = value;
    if (this._size < this._capacity) this._size++;
    else this._start = this._index(1);
    return evictedKey;
};
// Removes the key-value pair associated with the specified key.
// Returns the removed value, or null if not found.
$a254faf283c27d31$var$LruMap.prototype.del = function(key) {
    for(var i = 0; i < this._size; i++)if (key.equals(this._keys[this._index(i)])) {
        var existingValue = this._values[this._index(i)];
        for(var j = i; j < this._size - 1; j++){
            this._keys[this._index(j)] = this._keys[this._index(j + 1)];
            this._values[this._index(j)] = this._values[this._index(j + 1)];
        }
        this._size--;
        return existingValue;
    }
    return null;
};
// Returns whether there is a value associated with the specified key.
$a254faf283c27d31$var$LruMap.prototype.has = function(key) {
    for(var i = 0; i < this._size; i++){
        if (key.equals(this._keys[this._index(i)])) return true;
    }
    return false;
};
// Returns the number of key-value pairs in the map.
$a254faf283c27d31$var$LruMap.prototype.size = function() {
    return this._size;
};
// Removes all key-value pairs from the map.
$a254faf283c27d31$var$LruMap.prototype.clear = function() {
    this._keys.length = 0;
    this._values.length = 0;
    this._start = 0;
    this._size = 0;
};
// Calls fn(key, value) for each item in the map, in an unspecified order.
// Returns the number of times fn was called.
// The result is unspecified if the map is mutated during iteration.
$a254faf283c27d31$var$LruMap.prototype.forEach = function(fn) {
    var count = 0;
    for(var i = 0; i < this._size; i++){
        fn(this._keys[this._index(i)], this._values[this._index(i)]);
        count += 1;
    }
    return count;
};
module.exports = $a254faf283c27d31$var$LruMap;

});

parcelRegister("4tCa7", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
function $3427791892b79f43$var$Level(levelProperties) {
    this._fallbackOnly = !!levelProperties.fallbackOnly;
}
$3427791892b79f43$var$Level.prototype.numHorizontalTiles = function() {
    return Math.ceil(this.width() / this.tileWidth());
};
$3427791892b79f43$var$Level.prototype.numVerticalTiles = function() {
    return Math.ceil(this.height() / this.tileHeight());
};
$3427791892b79f43$var$Level.prototype.fallbackOnly = function() {
    return this._fallbackOnly;
};
module.exports = $3427791892b79f43$var$Level;

});

parcelRegister("4rFjs", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $3nhrd = parcelRequire("3nhrd");
function $33c9baebe74e4420$var$makeLevelList(levelPropertiesList, LevelClass) {
    var list = [];
    for(var i = 0; i < levelPropertiesList.length; i++)list.push(new LevelClass(levelPropertiesList[i]));
    list.sort(function(level1, level2) {
        return $3nhrd(level1.width(), level2.width());
    });
    return list;
}
function $33c9baebe74e4420$var$makeSelectableLevelList(levelList) {
    var list = [];
    for(var i = 0; i < levelList.length; i++)if (!levelList[i]._fallbackOnly) list.push(levelList[i]);
    if (!list.length) throw new Error("No selectable levels in list");
    return list;
}
module.exports = {
    makeLevelList: $33c9baebe74e4420$var$makeLevelList,
    makeSelectableLevelList: $33c9baebe74e4420$var$makeSelectableLevelList
};

});
parcelRegister("3nhrd", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
function $27510be60f338f4c$var$cmp(x, y) {
    if (x < y) return -1;
    if (x > y) return 1;
    return 0;
}
module.exports = $27510be60f338f4c$var$cmp;

});


parcelRegister("fXp6t", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
function $b9dfd6b301a50546$var$type(x) {
    var typ = typeof x;
    if (typ === "object") {
        if (x === null) return "null";
        if (Object.prototype.toString.call(x) === "[object Array]") return "array";
        if (Object.prototype.toString.call(x) === "[object RegExp]") return "regexp";
    }
    return typ;
}
module.exports = $b9dfd6b301a50546$var$type;

});


parcelRegister("iv3ES", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $jOYf3 = parcelRequire("jOYf3");

var $asoyN = parcelRequire("asoyN");

var $dBMHD = parcelRequire("dBMHD");
var $d77df5b8fa140bee$require$setOverflowHidden = $dBMHD.setOverflowHidden;

var $dBMHD = parcelRequire("dBMHD");
var $d77df5b8fa140bee$require$setNoPointerEvents = $dBMHD.setNoPointerEvents;

var $dBMHD = parcelRequire("dBMHD");
var $d77df5b8fa140bee$require$setNullTransform = $dBMHD.setNullTransform;

var $dBMHD = parcelRequire("dBMHD");
var $d77df5b8fa140bee$require$setTransform = $dBMHD.setTransform;

var $2Xxut = parcelRequire("2Xxut");
var $d77df5b8fa140bee$var$debug = typeof MARZIPANODEBUG !== "undefined" && MARZIPANODEBUG.css;
function $d77df5b8fa140bee$var$tileCmp(a, b) {
    return a.cmp(b);
}
function $d77df5b8fa140bee$var$CssBaseRenderer(root, quirks, tileClass) {
    this._root = root;
    this._browserQuirks = quirks;
    // Create a container for this renderer's tiles, so we can style them
    // as a whole separately from other renderers in the same stage.
    var domElement = document.createElement("div");
    root.appendChild(domElement);
    domElement.style.position = "absolute";
    // For some weird reason, this prevents flickering on Safari Desktop.
    $d77df5b8fa140bee$require$setOverflowHidden(domElement);
    // Prevent touch events on tiles from messing up pinching gestures on iOS.
    $d77df5b8fa140bee$require$setNoPointerEvents(domElement);
    if (this._browserQuirks.useNullTransform) $d77df5b8fa140bee$require$setNullTransform(domElement);
    this.domElement = domElement;
    this._oldTileList = [];
    this._newTileList = [];
    this._textureMap = new $jOYf3();
}
$d77df5b8fa140bee$var$CssBaseRenderer.prototype.destroy = function() {
    this._root.removeChild(this.domElement);
    $2Xxut(this);
};
$d77df5b8fa140bee$var$CssBaseRenderer.prototype.startLayer = function(layer, rect) {
    var domElement = this.domElement;
    // Set viewport effect.
    var stageWidth = this._root.clientWidth;
    var stageHeight = this._root.clientHeight;
    domElement.style.left = $asoyN(stageWidth * rect.left) + "px";
    domElement.style.top = $asoyN(stageHeight * rect.top) + "px";
    domElement.style.width = $asoyN(stageWidth * rect.width) + "px";
    domElement.style.height = $asoyN(stageHeight * rect.height) + "px";
    // Set opacity effect.
    var opacity = 1.0;
    var effects = layer.effects();
    if (effects && effects.opacity != null) opacity = effects.opacity;
    domElement.style.opacity = opacity;
    // Clear temporary variables.
    this._newTileList.length = 0;
    this._textureMap.clear();
};
$d77df5b8fa140bee$var$CssBaseRenderer.prototype.renderTile = function(tile, texture) {
    this._newTileList.push(tile);
    this._textureMap.set(tile, texture);
};
$d77df5b8fa140bee$var$CssBaseRenderer.prototype.endLayer = function(layer, rect) {
    var domElement = this.domElement;
    var oldTileList = this._oldTileList;
    var newTileList = this._newTileList;
    var textureMap = this._textureMap;
    var oldIndex, newIndex, oldTile, newTile;
    var texture, canvas;
    var currentNode, nextNode;
    var view = layer.view();
    // Iterate the old and new tile lists in a consistent order and perform
    // insertions and removals as we go. This minimizes the number of DOM
    // operations performed.
    // Neither the tile list nor the texture list may contain duplicates,
    // otherwise this logic will fail.
    // Consistency check.
    if (domElement.children.length !== oldTileList.length) throw new Error("DOM not in sync with tile list");
    newTileList.sort($d77df5b8fa140bee$var$tileCmp);
    oldIndex = 0;
    oldTile = oldTileList[oldIndex];
    currentNode = domElement.firstChild;
    for(newIndex = 0; newIndex < newTileList.length; newIndex++){
        newTile = newTileList[newIndex];
        // Iterate old list until it catches up with the new list.
        while(oldIndex < oldTileList.length){
            if (oldTile.cmp(newTile) >= 0) break;
            // Tile is no longer visible.
            // Remove it from the DOM.
            nextNode = currentNode.nextSibling;
            domElement.removeChild(currentNode);
            currentNode = nextNode;
            oldTile = oldTileList[++oldIndex];
        }
        // Get the texture for the current tile.
        texture = textureMap.get(newTile);
        canvas = texture ? texture._canvas : null;
        // Consistency check.
        if (!canvas) throw new Error("Rendering tile with missing texture");
        if (oldTile && oldTile.cmp(newTile) === 0) {
            // The old and new tile are the same.
            // Consistency check.
            if (canvas != currentNode) throw new Error("DOM not in sync with tile list");
            currentNode = currentNode.nextSibling;
            oldTile = oldTileList[++oldIndex];
        } else // The new tile comes before the old tile.
        // Insert it into the DOM.
        domElement.insertBefore(canvas, currentNode);
        // Set the CSS transform on the current tile.
        $d77df5b8fa140bee$require$setTransform(canvas, this.calculateTransform(newTile, texture, view));
        if ($d77df5b8fa140bee$var$debug) canvas.setAttribute("data-tile", newTile.str());
    }
    // Remove trailing tiles that are no longer visible from the DOM.
    while(currentNode){
        nextNode = currentNode.nextSibling;
        domElement.removeChild(currentNode);
        currentNode = nextNode;
    }
    // Consistenty check.
    if (domElement.children.length !== newTileList.length) throw new Error("DOM not in sync with tile list");
    // The old and new tile lists swap roles between iterations.
    var tmp = this._oldTileList;
    this._oldTileList = this._newTileList;
    this._newTileList = tmp;
};
module.exports = $d77df5b8fa140bee$var$CssBaseRenderer;

});
parcelRegister("jOYf3", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $iZgBB = parcelRequire("iZgBB");
var $e6e16a93a5a6d2ce$var$defaultCapacity = 64;
// A map data structure for keys implementing hash() and equals() and arbitrary
// values. The capacity, if given, is just a hint; the map is allowed to exceed
// it, but performance may suffer.
function $e6e16a93a5a6d2ce$var$Map(capacity) {
    if (capacity != null && (!isFinite(capacity) || Math.floor(capacity) !== capacity || capacity < 1)) throw new Error("Map: invalid capacity");
    this._capacity = capacity || $e6e16a93a5a6d2ce$var$defaultCapacity;
    this._keyBuckets = [];
    this._valBuckets = [];
    for(var i = 0; i < this._capacity; i++){
        this._keyBuckets.push([]);
        this._valBuckets.push([]);
    }
    this._size = 0;
}
// Returns the value associated with the specified key, or null if not found.
$e6e16a93a5a6d2ce$var$Map.prototype.get = function(key) {
    var h = $iZgBB(key.hash(), this._capacity);
    var keyBucket = this._keyBuckets[h];
    for(var i = 0; i < keyBucket.length; i++){
        var existingKey = keyBucket[i];
        if (key.equals(existingKey)) {
            var valBucket = this._valBuckets[h];
            var existingValue = valBucket[i];
            return existingValue;
        }
    }
    return null;
};
// Associates the specified value with the specified key, possibly replacing the
// currently associated value.
// Returns the replaced value, or null if no value was replaced.
$e6e16a93a5a6d2ce$var$Map.prototype.set = function(key, val) {
    var h = $iZgBB(key.hash(), this._capacity);
    var keyBucket = this._keyBuckets[h];
    var valBucket = this._valBuckets[h];
    for(var i = 0; i < keyBucket.length; i++){
        var existingKey = keyBucket[i];
        if (key.equals(existingKey)) {
            var existingValue = valBucket[i];
            keyBucket[i] = key;
            valBucket[i] = val;
            return existingValue;
        }
    }
    keyBucket.push(key);
    valBucket.push(val);
    this._size++;
    return null;
};
// Removes the key-value pair associated with the specified key.
// Returns the removed value, or null if not found.
$e6e16a93a5a6d2ce$var$Map.prototype.del = function(key) {
    var h = $iZgBB(key.hash(), this._capacity);
    var keyBucket = this._keyBuckets[h];
    var valBucket = this._valBuckets[h];
    for(var i = 0; i < keyBucket.length; i++){
        var existingKey = keyBucket[i];
        if (key.equals(existingKey)) {
            var existingValue = valBucket[i];
            // Splice manually to avoid Array#splice return value allocation.
            for(var j = i; j < keyBucket.length - 1; j++){
                keyBucket[j] = keyBucket[j + 1];
                valBucket[j] = valBucket[j + 1];
            }
            keyBucket.length = keyBucket.length - 1;
            valBucket.length = valBucket.length - 1;
            this._size--;
            return existingValue;
        }
    }
    return null;
};
// Returns whether there is a value associated with the specified key.
$e6e16a93a5a6d2ce$var$Map.prototype.has = function(key) {
    var h = $iZgBB(key.hash(), this._capacity);
    var keyBucket = this._keyBuckets[h];
    for(var i = 0; i < keyBucket.length; i++){
        var existingKey = keyBucket[i];
        if (key.equals(existingKey)) return true;
    }
    return false;
};
// Returns the number of key-value pairs in the map.
$e6e16a93a5a6d2ce$var$Map.prototype.size = function() {
    return this._size;
};
// Removes all key-value pairs from the map.
$e6e16a93a5a6d2ce$var$Map.prototype.clear = function() {
    for(var i = 0; i < this._capacity; i++){
        this._keyBuckets[i].length = 0;
        this._valBuckets[i].length = 0;
    }
    this._size = 0;
};
// Calls fn(key, value) for each key-value pair in the map, in an unspecified
// order. Returns the number of times fn was called.
// The result is unspecified if the map is mutated during iteration.
$e6e16a93a5a6d2ce$var$Map.prototype.forEach = function(fn) {
    var count = 0;
    for(var i = 0; i < this._capacity; i++){
        var keyBucket = this._keyBuckets[i];
        var valBucket = this._valBuckets[i];
        for(var j = 0; j < keyBucket.length; j++){
            fn(keyBucket[j], valBucket[j]);
            count += 1;
        }
    }
    return count;
};
module.exports = $e6e16a93a5a6d2ce$var$Map;

});

parcelRegister("asoyN", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
// Convert a number to a string in decimal notation.
function $79cf9210aca8fb7b$var$decimal(x) {
    // Double-precision floats have 15 significant decimal digits.
    return x.toPrecision(15);
}
module.exports = $79cf9210aca8fb7b$var$decimal;

});



parcelRegister("aYyo6", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $l1BkT = parcelRequire("l1BkT");
var $7fda2eaa0ce1864f$require$FlatTile = $l1BkT.Tile;

var $iv3ES = parcelRequire("iv3ES");

var $asoyN = parcelRequire("asoyN");

var $Yar88 = parcelRequire("Yar88");
/**
 * @class CssFlatRenderer
 * @implements Renderer
 * @classdesc
 *
 * A renderer for {@link FlatGeometry} and {@link FlatView}, appropriate for a
 * {@link CssStage}.
 *
 * Most users do not need to instantiate this class. Renderers are created and
 * destroyed by {@link Stage} as necessary.
 */ function $7fda2eaa0ce1864f$var$CssFlatRenderer(root, quirks) {
    this.constructor.super_.call(this, root, quirks, $7fda2eaa0ce1864f$require$FlatTile);
}
$Yar88($7fda2eaa0ce1864f$var$CssFlatRenderer, $iv3ES);
$7fda2eaa0ce1864f$var$CssFlatRenderer.prototype.calculateTransform = function(tile, texture, view) {
    var padSize = this._browserQuirks.padSize;
    var transform = "";
    // Place top left corner of tile at the center of the viewport.
    var viewportWidth = view.width();
    var viewportHeight = view.height();
    transform += "translateX(" + $asoyN(viewportWidth / 2) + "px) translateY(" + $asoyN(viewportHeight / 2) + "px) ";
    // Determine the zoom factor.
    var zoomX = viewportWidth / view._zoomX();
    var zoomY = viewportHeight / view._zoomY();
    // Move tile into its position within the image.
    var cornerX = tile.centerX() - tile.scaleX() / 2 + 0.5;
    var cornerY = 0.5 - tile.centerY() - tile.scaleY() / 2;
    var translX = cornerX * zoomX;
    var translY = cornerY * zoomY;
    transform += "translateX(" + $asoyN(translX) + "px) translateY(" + $asoyN(translY) + "px) ";
    // Apply view offsets.
    var offX = -view.x() * zoomX;
    var offY = -view.y() * zoomY;
    transform += "translateX(" + $asoyN(offX) + "px) translateY(" + $asoyN(offY) + "px) ";
    // Compensate for padding around the tile.
    var padLeft = tile.padLeft() ? padSize : 0;
    var padTop = tile.padTop() ? padSize : 0;
    if (padLeft !== 0 || padTop !== 0) transform += "translateX(" + $asoyN(-padLeft) + "px) translateY(" + $asoyN(-padTop) + "px) ";
    // Scale tile into correct size.
    var scaleX = zoomX / tile.levelWidth();
    var scaleY = zoomY / tile.levelHeight();
    transform += "scale(" + $asoyN(scaleX) + ", " + $asoyN(scaleY) + ") ";
    return transform;
};
module.exports = $7fda2eaa0ce1864f$var$CssFlatRenderer;

});
parcelRegister("l1BkT", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $Yar88 = parcelRequire("Yar88");

var $4j7qz = parcelRequire("4j7qz");

var $1tXVZ = parcelRequire("1tXVZ");

var $dW5wO = parcelRequire("dW5wO");

var $4tCa7 = parcelRequire("4tCa7");

var $4rFjs = parcelRequire("4rFjs");
var $f4e6a71b0e40022d$require$makeLevelList = $4rFjs.makeLevelList;

var $4rFjs = parcelRequire("4rFjs");
var $f4e6a71b0e40022d$require$makeSelectableLevelList = $4rFjs.makeSelectableLevelList;

var $eCQUD = parcelRequire("eCQUD");

var $iZgBB = parcelRequire("iZgBB");

var $3nhrd = parcelRequire("3nhrd");

var $fXp6t = parcelRequire("fXp6t");

var $5VJvE = parcelRequire("5VJvE");
var $8QvoZ = parcelRequire("8QvoZ");
var $f4e6a71b0e40022d$require$vec2 = $5VJvE;

var $5VJvE = parcelRequire("5VJvE");
var $8QvoZ = parcelRequire("8QvoZ");
var $f4e6a71b0e40022d$require$vec4 = $8QvoZ;
var $f4e6a71b0e40022d$var$neighborsCacheSize = 64;
// Some renderer implementations require tiles to be padded around with
// repeated pixels to prevent the appearance of visible seams between tiles.
//
// In order to prevent the padding from being visible, the tiles must be
// padded and stacked such that the padding on one of the sides, when present,
// stacks below the neighboring tile on that side.
//
// Padding rules:
// * Pad tiles on the right and on the bottom.
//
// Stacking rules:
// * Within an image, stack smaller zoom levels below larger zoom levels.
// * Within a level, stack tiles bottom to top in ascending Y coordinate order.
// * Within a row, stack tiles bottom to top in ascending X coordinate order.
// Offsets to apply to the (x,y) coordinates of a tile to get its neighbors.
var $f4e6a71b0e40022d$var$neighborOffsets = [
    [
        0,
        1
    ],
    [
        1,
        0
    ],
    [
        0,
        -1
    ],
    [
        -1,
        0
    ] // left
];
/**
 * @class FlatTile
 * @implements Tile
 * @classdesc
 *
 * A tile in a {@link FlatGeometry}.
 */ function $f4e6a71b0e40022d$var$FlatTile(x, y, z, geometry) {
    this.x = x;
    this.y = y;
    this.z = z;
    this._geometry = geometry;
    this._level = geometry.levelList[z];
}
$f4e6a71b0e40022d$var$FlatTile.prototype.rotX = function() {
    return 0;
};
$f4e6a71b0e40022d$var$FlatTile.prototype.rotY = function() {
    return 0;
};
$f4e6a71b0e40022d$var$FlatTile.prototype.centerX = function() {
    var levelWidth = this._level.width();
    var tileWidth = this._level.tileWidth();
    return (this.x * tileWidth + 0.5 * this.width()) / levelWidth - 0.5;
};
$f4e6a71b0e40022d$var$FlatTile.prototype.centerY = function() {
    var levelHeight = this._level.height();
    var tileHeight = this._level.tileHeight();
    return 0.5 - (this.y * tileHeight + 0.5 * this.height()) / levelHeight;
};
$f4e6a71b0e40022d$var$FlatTile.prototype.scaleX = function() {
    var levelWidth = this._level.width();
    return this.width() / levelWidth;
};
$f4e6a71b0e40022d$var$FlatTile.prototype.scaleY = function() {
    var levelHeight = this._level.height();
    return this.height() / levelHeight;
};
$f4e6a71b0e40022d$var$FlatTile.prototype.width = function() {
    var levelWidth = this._level.width();
    var tileWidth = this._level.tileWidth();
    if (this.atRightEdge()) {
        var widthRemainder = $iZgBB(levelWidth, tileWidth);
        return widthRemainder || tileWidth;
    } else return tileWidth;
};
$f4e6a71b0e40022d$var$FlatTile.prototype.height = function() {
    var levelHeight = this._level.height();
    var tileHeight = this._level.tileHeight();
    if (this.atBottomEdge()) {
        var heightRemainder = $iZgBB(levelHeight, tileHeight);
        return heightRemainder || tileHeight;
    } else return tileHeight;
};
$f4e6a71b0e40022d$var$FlatTile.prototype.levelWidth = function() {
    return this._level.width();
};
$f4e6a71b0e40022d$var$FlatTile.prototype.levelHeight = function() {
    return this._level.height();
};
$f4e6a71b0e40022d$var$FlatTile.prototype.atTopLevel = function() {
    return this.z === 0;
};
$f4e6a71b0e40022d$var$FlatTile.prototype.atBottomLevel = function() {
    return this.z === this._geometry.levelList.length - 1;
};
$f4e6a71b0e40022d$var$FlatTile.prototype.atTopEdge = function() {
    return this.y === 0;
};
$f4e6a71b0e40022d$var$FlatTile.prototype.atBottomEdge = function() {
    return this.y === this._level.numVerticalTiles() - 1;
};
$f4e6a71b0e40022d$var$FlatTile.prototype.atLeftEdge = function() {
    return this.x === 0;
};
$f4e6a71b0e40022d$var$FlatTile.prototype.atRightEdge = function() {
    return this.x === this._level.numHorizontalTiles() - 1;
};
$f4e6a71b0e40022d$var$FlatTile.prototype.padTop = function() {
    return false;
};
$f4e6a71b0e40022d$var$FlatTile.prototype.padBottom = function() {
    return !this.atBottomEdge();
};
$f4e6a71b0e40022d$var$FlatTile.prototype.padLeft = function() {
    return false;
};
$f4e6a71b0e40022d$var$FlatTile.prototype.padRight = function() {
    return !this.atRightEdge();
};
$f4e6a71b0e40022d$var$FlatTile.prototype.vertices = function(result) {
    if (!result) result = [
        $f4e6a71b0e40022d$require$vec2.create(),
        $f4e6a71b0e40022d$require$vec2.create(),
        $f4e6a71b0e40022d$require$vec2.create(),
        $f4e6a71b0e40022d$require$vec2.create()
    ];
    var left = this.centerX() - this.scaleX() / 2;
    var right = this.centerX() + this.scaleX() / 2;
    var bottom = this.centerY() - this.scaleY() / 2;
    var top = this.centerY() + this.scaleY() / 2;
    $f4e6a71b0e40022d$require$vec2.set(result[0], left, top);
    $f4e6a71b0e40022d$require$vec2.set(result[1], right, top);
    $f4e6a71b0e40022d$require$vec2.set(result[2], right, bottom);
    $f4e6a71b0e40022d$require$vec2.set(result[3], left, bottom);
    return result;
};
$f4e6a71b0e40022d$var$FlatTile.prototype.parent = function() {
    if (this.atTopLevel()) return null;
    var geometry = this._geometry;
    var z = this.z - 1;
    // TODO: Currently assuming each level is double the size of previous one.
    // Fix to support other multiples.
    var x = Math.floor(this.x / 2);
    var y = Math.floor(this.y / 2);
    return new $f4e6a71b0e40022d$var$FlatTile(x, y, z, geometry);
};
$f4e6a71b0e40022d$var$FlatTile.prototype.children = function(result) {
    if (this.atBottomLevel()) return null;
    var geometry = this._geometry;
    var z = this.z + 1;
    result = result || [];
    // TODO: Currently assuming each level is double the size of previous one.
    // Fix to support other multiples.
    result.push(new $f4e6a71b0e40022d$var$FlatTile(2 * this.x, 2 * this.y, z, geometry));
    result.push(new $f4e6a71b0e40022d$var$FlatTile(2 * this.x, 2 * this.y + 1, z, geometry));
    result.push(new $f4e6a71b0e40022d$var$FlatTile(2 * this.x + 1, 2 * this.y, z, geometry));
    result.push(new $f4e6a71b0e40022d$var$FlatTile(2 * this.x + 1, 2 * this.y + 1, z, geometry));
    return result;
};
$f4e6a71b0e40022d$var$FlatTile.prototype.neighbors = function() {
    var geometry = this._geometry;
    var cache = geometry._neighborsCache;
    // Satisfy from cache when available.
    var cachedResult = cache.get(this);
    if (cachedResult) return cachedResult;
    var x = this.x;
    var y = this.y;
    var z = this.z;
    var level = this._level;
    var numX = level.numHorizontalTiles() - 1;
    var numY = level.numVerticalTiles() - 1;
    var result = [];
    for(var i = 0; i < $f4e6a71b0e40022d$var$neighborOffsets.length; i++){
        var xOffset = $f4e6a71b0e40022d$var$neighborOffsets[i][0];
        var yOffset = $f4e6a71b0e40022d$var$neighborOffsets[i][1];
        var newX = x + xOffset;
        var newY = y + yOffset;
        var newZ = z;
        if (0 <= newX && newX <= numX && 0 <= newY && newY <= numY) result.push(new $f4e6a71b0e40022d$var$FlatTile(newX, newY, newZ, geometry));
    }
    // Store into cache to satisfy future requests.
    cache.set(this, result);
    return result;
};
$f4e6a71b0e40022d$var$FlatTile.prototype.hash = function() {
    return $4j7qz(this.z, this.y, this.x);
};
$f4e6a71b0e40022d$var$FlatTile.prototype.equals = function(that) {
    return this.geometry === that.geometry && this.z === that.z && this.y === that.y && this.x === that.x;
};
$f4e6a71b0e40022d$var$FlatTile.prototype.cmp = function(that) {
    return $3nhrd(this.z, that.z) || $3nhrd(this.y, that.y) || $3nhrd(this.x, that.x);
};
$f4e6a71b0e40022d$var$FlatTile.prototype.str = function() {
    return "FlatTile(" + tile.x + ", " + tile.y + ", " + tile.z + ")";
};
function $f4e6a71b0e40022d$var$FlatLevel(levelProperties) {
    this.constructor.super_.call(this, levelProperties);
    this._width = levelProperties.width;
    this._height = levelProperties.height;
    this._tileWidth = levelProperties.tileWidth;
    this._tileHeight = levelProperties.tileHeight;
}
$Yar88($f4e6a71b0e40022d$var$FlatLevel, $4tCa7);
$f4e6a71b0e40022d$var$FlatLevel.prototype.width = function() {
    return this._width;
};
$f4e6a71b0e40022d$var$FlatLevel.prototype.height = function() {
    return this._height;
};
$f4e6a71b0e40022d$var$FlatLevel.prototype.tileWidth = function() {
    return this._tileWidth;
};
$f4e6a71b0e40022d$var$FlatLevel.prototype.tileHeight = function() {
    return this._tileHeight;
};
$f4e6a71b0e40022d$var$FlatLevel.prototype._validateWithParentLevel = function(parentLevel) {
    var width = this.width();
    var height = this.height();
    var tileWidth = this.tileWidth();
    var tileHeight = this.tileHeight();
    var parentWidth = parentLevel.width();
    var parentHeight = parentLevel.height();
    var parentTileWidth = parentLevel.tileWidth();
    var parentTileHeight = parentLevel.tileHeight();
    if (width % parentWidth !== 0) return new Error("Level width must be multiple of parent level: " + width + " vs. " + parentWidth);
    if (height % parentHeight !== 0) return new Error("Level height must be multiple of parent level: " + height + " vs. " + parentHeight);
    if (tileWidth % parentTileWidth !== 0) return new Error("Level tile width must be multiple of parent level: " + tileWidth + " vs. " + parentTileWidth);
    if (tileHeight % parentTileHeight !== 0) return new Error("Level tile height must be multiple of parent level: " + tileHeight + " vs. " + parentTileHeight);
};
/**
 * @class FlatGeometry
 * @implements Geometry
 * @classdesc
 *
 * A {@link Geometry} implementation suitable for tiled flat images with
 * multiple resolution levels.
 *
 * The following restrictions apply:
 *   - All tiles must be square, except when in the last row or column position,
 *     and must form a rectangular grid;
 *   - The width and height of a level must be multiples of the parent level
 *     width and height.
 *
 * @param {Object[]} levelPropertiesList Level description
 * @param {number} levelPropertiesList[].width Level width in pixels
 * @param {number} levelPropertiesList[].tileWidth Tile width in pixels for
 *                 square tiles
 * @param {number} levelPropertiesList[].height Level height in pixels
 * @param {number} levelPropertiesList[].tileHeight Tile height in pixels for
 *                 square tiles
 */ function $f4e6a71b0e40022d$var$FlatGeometry(levelPropertiesList) {
    if ($fXp6t(levelPropertiesList) !== "array") throw new Error("Level list must be an array");
    this.levelList = $f4e6a71b0e40022d$require$makeLevelList(levelPropertiesList, $f4e6a71b0e40022d$var$FlatLevel);
    this.selectableLevelList = $f4e6a71b0e40022d$require$makeSelectableLevelList(this.levelList);
    for(var i = 1; i < this.levelList.length; i++)this.levelList[i]._validateWithParentLevel(this.levelList[i - 1]);
    this._tileSearcher = new $1tXVZ(this);
    this._neighborsCache = new $dW5wO($f4e6a71b0e40022d$var$neighborsCacheSize);
    this._vec = $f4e6a71b0e40022d$require$vec4.create();
    this._viewSize = {};
}
$f4e6a71b0e40022d$var$FlatGeometry.prototype.maxTileSize = function() {
    var maxTileSize = 0;
    for(var i = 0; i < this.levelList.length; i++){
        var level = this.levelList[i];
        maxTileSize = Math.max(maxTileSize, level.tileWidth, level.tileHeight);
    }
    return maxTileSize;
};
$f4e6a71b0e40022d$var$FlatGeometry.prototype.levelTiles = function(level, result) {
    var levelIndex = this.levelList.indexOf(level);
    var maxX = level.numHorizontalTiles() - 1;
    var maxY = level.numVerticalTiles() - 1;
    if (!result) result = [];
    for(var x = 0; x <= maxX; x++)for(var y = 0; y <= maxY; y++)result.push(new $f4e6a71b0e40022d$var$FlatTile(x, y, levelIndex, this));
    return result;
};
$f4e6a71b0e40022d$var$FlatGeometry.prototype._closestTile = function(view, level) {
    var ray = this._vec;
    // Compute a view ray into the central screen point.
    $f4e6a71b0e40022d$require$vec4.set(ray, 0, 0, 1, 1);
    $f4e6a71b0e40022d$require$vec4.transformMat4(ray, ray, view.inverseProjection());
    // Compute the image coordinates that the view ray points into.
    var x = 0.5 + ray[0];
    var y = 0.5 - ray[1];
    // Get the desired zoom level.
    var tileZ = this.levelList.indexOf(level);
    var levelWidth = level.width();
    var levelHeight = level.height();
    var tileWidth = level.tileWidth();
    var tileHeight = level.tileHeight();
    var numX = level.numHorizontalTiles();
    var numY = level.numVerticalTiles();
    // Find the coordinates of the tile that the view ray points into.
    var tileX = $eCQUD(Math.floor(x * levelWidth / tileWidth), 0, numX - 1);
    var tileY = $eCQUD(Math.floor(y * levelHeight / tileHeight), 0, numY - 1);
    return new $f4e6a71b0e40022d$var$FlatTile(tileX, tileY, tileZ, this);
};
$f4e6a71b0e40022d$var$FlatGeometry.prototype.visibleTiles = function(view, level, result) {
    var viewSize = this._viewSize;
    var tileSearcher = this._tileSearcher;
    result = result || [];
    view.size(viewSize);
    if (viewSize.width === 0 || viewSize.height === 0) // No tiles are visible if the viewport is empty.
    return result;
    var startingTile = this._closestTile(view, level);
    var count = tileSearcher.search(view, startingTile, result);
    if (!count) throw new Error("Starting tile is not visible");
    return result;
};
$f4e6a71b0e40022d$var$FlatGeometry.Tile = $f4e6a71b0e40022d$var$FlatGeometry.prototype.Tile = $f4e6a71b0e40022d$var$FlatTile;
$f4e6a71b0e40022d$var$FlatGeometry.type = $f4e6a71b0e40022d$var$FlatGeometry.prototype.type = "flat";
$f4e6a71b0e40022d$var$FlatTile.type = $f4e6a71b0e40022d$var$FlatTile.prototype.type = "flat";
module.exports = $f4e6a71b0e40022d$var$FlatGeometry;

});
parcelRegister("5VJvE", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $451593d984d40c98$export$185802fd694ee1f5; });
$parcel$export(module.exports, "clone", function () { return $451593d984d40c98$export$9cd59f9826255e47; });
$parcel$export(module.exports, "fromValues", function () { return $451593d984d40c98$export$a82be99ed2a44a7d; });
$parcel$export(module.exports, "copy", function () { return $451593d984d40c98$export$784d13d8ee351f07; });
$parcel$export(module.exports, "set", function () { return $451593d984d40c98$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "add", function () { return $451593d984d40c98$export$e16d8520af44a096; });
$parcel$export(module.exports, "subtract", function () { return $451593d984d40c98$export$4e2d2ead65e5f7e3; });
$parcel$export(module.exports, "multiply", function () { return $451593d984d40c98$export$2060d2db72cce88f; });
$parcel$export(module.exports, "divide", function () { return $451593d984d40c98$export$cd007d971a5a2143; });
$parcel$export(module.exports, "ceil", function () { return $451593d984d40c98$export$803ce6b71a0a94b2; });
$parcel$export(module.exports, "floor", function () { return $451593d984d40c98$export$a3fe094919f356fd; });
$parcel$export(module.exports, "min", function () { return $451593d984d40c98$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "max", function () { return $451593d984d40c98$export$8960430cfd85939f; });
$parcel$export(module.exports, "round", function () { return $451593d984d40c98$export$2077e0241d6afd3c; });
$parcel$export(module.exports, "scale", function () { return $451593d984d40c98$export$dcdf75081b88279d; });
$parcel$export(module.exports, "scaleAndAdd", function () { return $451593d984d40c98$export$19cedf1da84ba854; });
$parcel$export(module.exports, "distance", function () { return $451593d984d40c98$export$9f17032d917177de; });
$parcel$export(module.exports, "squaredDistance", function () { return $451593d984d40c98$export$88e6ebb4fe54f538; });
$parcel$export(module.exports, "length", function () { return $451593d984d40c98$export$f24224f1c91d8156; });
$parcel$export(module.exports, "squaredLength", function () { return $451593d984d40c98$export$ab44e1323ffc8376; });
$parcel$export(module.exports, "negate", function () { return $451593d984d40c98$export$aef51622e549b8b0; });
$parcel$export(module.exports, "inverse", function () { return $451593d984d40c98$export$70ae2c07e401031b; });
$parcel$export(module.exports, "normalize", function () { return $451593d984d40c98$export$a3295358bff77e; });
$parcel$export(module.exports, "dot", function () { return $451593d984d40c98$export$94132a0e348806d4; });
$parcel$export(module.exports, "cross", function () { return $451593d984d40c98$export$bb646b20bb93d339; });
$parcel$export(module.exports, "lerp", function () { return $451593d984d40c98$export$3a89f8d6f6bf6c9f; });
$parcel$export(module.exports, "random", function () { return $451593d984d40c98$export$4385e60b38654f68; });
$parcel$export(module.exports, "transformMat2", function () { return $451593d984d40c98$export$b732428d73874bfc; });
$parcel$export(module.exports, "transformMat2d", function () { return $451593d984d40c98$export$3e55bc4b3707dfd3; });
$parcel$export(module.exports, "transformMat3", function () { return $451593d984d40c98$export$f0bfa0a0024626ee; });
$parcel$export(module.exports, "transformMat4", function () { return $451593d984d40c98$export$5ffbd13800309d59; });
$parcel$export(module.exports, "rotate", function () { return $451593d984d40c98$export$bb628a54ab399bc9; });
$parcel$export(module.exports, "angle", function () { return $451593d984d40c98$export$944b09d2ad10b378; });
$parcel$export(module.exports, "zero", function () { return $451593d984d40c98$export$7f9972325ebfd559; });
$parcel$export(module.exports, "str", function () { return $451593d984d40c98$export$42d51816ce590c93; });
$parcel$export(module.exports, "exactEquals", function () { return $451593d984d40c98$export$f2599a5cf1109d8; });
$parcel$export(module.exports, "equals", function () { return $451593d984d40c98$export$e9bab7fafb253603; });
$parcel$export(module.exports, "len", function () { return $451593d984d40c98$export$fc1400facf92c78; });
$parcel$export(module.exports, "sub", function () { return $451593d984d40c98$export$f93b5905241a7cca; });
$parcel$export(module.exports, "mul", function () { return $451593d984d40c98$export$6e3a27864ab166fe; });
$parcel$export(module.exports, "div", function () { return $451593d984d40c98$export$159d9494db57879b; });
$parcel$export(module.exports, "dist", function () { return $451593d984d40c98$export$6c4a311cc157c764; });
$parcel$export(module.exports, "sqrDist", function () { return $451593d984d40c98$export$2422cd6c492a8b3a; });
$parcel$export(module.exports, "sqrLen", function () { return $451593d984d40c98$export$99d8dd3f32a3435; });
$parcel$export(module.exports, "forEach", function () { return $451593d984d40c98$export$4b80e395e36b5a56; });

var $rqjzO = parcelRequire("rqjzO");
function $451593d984d40c98$export$185802fd694ee1f5() {
    var out = new $rqjzO.ARRAY_TYPE(2);
    if ($rqjzO.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
    }
    return out;
}
function $451593d984d40c98$export$9cd59f9826255e47(a) {
    var out = new $rqjzO.ARRAY_TYPE(2);
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $451593d984d40c98$export$a82be99ed2a44a7d(x, y) {
    var out = new $rqjzO.ARRAY_TYPE(2);
    out[0] = x;
    out[1] = y;
    return out;
}
function $451593d984d40c98$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $451593d984d40c98$export$adaa4cf7ef1b65be(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
}
function $451593d984d40c98$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    return out;
}
function $451593d984d40c98$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    return out;
}
function $451593d984d40c98$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    return out;
}
function $451593d984d40c98$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    return out;
}
function $451593d984d40c98$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    return out;
}
function $451593d984d40c98$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    return out;
}
function $451593d984d40c98$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    return out;
}
function $451593d984d40c98$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    return out;
}
function $451593d984d40c98$export$2077e0241d6afd3c(out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    return out;
}
function $451593d984d40c98$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    return out;
}
function $451593d984d40c98$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    return out;
}
function $451593d984d40c98$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return Math.hypot(x, y);
}
function $451593d984d40c98$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return x * x + y * y;
}
function $451593d984d40c98$export$f24224f1c91d8156(a) {
    var x = a[0], y = a[1];
    return Math.hypot(x, y);
}
function $451593d984d40c98$export$ab44e1323ffc8376(a) {
    var x = a[0], y = a[1];
    return x * x + y * y;
}
function $451593d984d40c98$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    return out;
}
function $451593d984d40c98$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    return out;
}
function $451593d984d40c98$export$a3295358bff77e(out, a) {
    var x = a[0], y = a[1];
    var len = x * x + y * y;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    return out;
}
function $451593d984d40c98$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1];
}
function $451593d984d40c98$export$bb646b20bb93d339(out, a, b) {
    var z = a[0] * b[1] - a[1] * b[0];
    out[0] = out[1] = 0;
    out[2] = z;
    return out;
}
function $451593d984d40c98$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0], ay = a[1];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    return out;
}
function $451593d984d40c98$export$4385e60b38654f68(out, scale) {
    scale = scale || 1.0;
    var r = $rqjzO.RANDOM() * 2.0 * Math.PI;
    out[0] = Math.cos(r) * scale;
    out[1] = Math.sin(r) * scale;
    return out;
}
function $451593d984d40c98$export$b732428d73874bfc(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    return out;
}
function $451593d984d40c98$export$3e55bc4b3707dfd3(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $451593d984d40c98$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[3] * y + m[6];
    out[1] = m[1] * x + m[4] * y + m[7];
    return out;
}
function $451593d984d40c98$export$5ffbd13800309d59(out, a, m) {
    var x = a[0];
    var y = a[1];
    out[0] = m[0] * x + m[4] * y + m[12];
    out[1] = m[1] * x + m[5] * y + m[13];
    return out;
}
function $451593d984d40c98$export$bb628a54ab399bc9(out, a, b, c) {
    //Translate point to the origin
    var p0 = a[0] - b[0], p1 = a[1] - b[1], sinC = Math.sin(c), cosC = Math.cos(c); //perform rotation and translate to correct position
    out[0] = p0 * cosC - p1 * sinC + b[0];
    out[1] = p0 * sinC + p1 * cosC + b[1];
    return out;
}
function $451593d984d40c98$export$944b09d2ad10b378(a, b) {
    var x1 = a[0], y1 = a[1], x2 = b[0], y2 = b[1];
    var len1 = x1 * x1 + y1 * y1;
    if (len1 > 0) //TODO: evaluate use of glm_invsqrt here?
    len1 = 1 / Math.sqrt(len1);
    var len2 = x2 * x2 + y2 * y2;
    if (len2 > 0) //TODO: evaluate use of glm_invsqrt here?
    len2 = 1 / Math.sqrt(len2);
    var cosine = (x1 * x2 + y1 * y2) * len1 * len2;
    if (cosine > 1.0) return 0;
    else if (cosine < -1) return Math.PI;
    else return Math.acos(cosine);
}
function $451593d984d40c98$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    return out;
}
function $451593d984d40c98$export$42d51816ce590c93(a) {
    return "vec2(" + a[0] + ", " + a[1] + ")";
}
function $451593d984d40c98$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1];
}
function $451593d984d40c98$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1];
    var b0 = b[0], b1 = b[1];
    return Math.abs(a0 - b0) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1));
}
var $451593d984d40c98$export$fc1400facf92c78 = $451593d984d40c98$export$f24224f1c91d8156;
var $451593d984d40c98$export$f93b5905241a7cca = $451593d984d40c98$export$4e2d2ead65e5f7e3;
var $451593d984d40c98$export$6e3a27864ab166fe = $451593d984d40c98$export$2060d2db72cce88f;
var $451593d984d40c98$export$159d9494db57879b = $451593d984d40c98$export$cd007d971a5a2143;
var $451593d984d40c98$export$6c4a311cc157c764 = $451593d984d40c98$export$9f17032d917177de;
var $451593d984d40c98$export$2422cd6c492a8b3a = $451593d984d40c98$export$88e6ebb4fe54f538;
var $451593d984d40c98$export$99d8dd3f32a3435 = $451593d984d40c98$export$ab44e1323ffc8376;
var $451593d984d40c98$export$4b80e395e36b5a56 = function() {
    var vec = $451593d984d40c98$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 2;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
        }
        return a;
    };
}();

});



parcelRegister("aK6y2", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $de14n = parcelRequire("de14n");

var $4QGnk = parcelRequire("4QGnk");
var $7d23478d77fbbf43$require$CubeTile = $4QGnk.Tile;

var $Yar88 = parcelRequire("Yar88");

var $jSacE = parcelRequire("jSacE");
/**
 * @class FlashCubeRenderer
 * @implements Renderer
 * @classdesc
 *
 * A renderer for {@link CubeGeometry} and {@link RectilinearView}, appropriate
 * for a {@link FlashStage}.
 *
 * Most users do not need to instantiate this class. Renderers are created and
 * destroyed by {@link Stage} as necessary.
 */ function $7d23478d77fbbf43$var$FlashCubeRenderer(flashElement, layerId, quirks) {
    this.constructor.super_.call(this, flashElement, layerId, quirks, $7d23478d77fbbf43$require$CubeTile);
    this._flashTileList = [];
}
$Yar88($7d23478d77fbbf43$var$FlashCubeRenderer, $de14n);
$7d23478d77fbbf43$var$FlashCubeRenderer.prototype._renderOnFlash = function(layer, rect) {
    var flashElement = this._flashElement;
    var layerId = this._layerId;
    var padSize = this._quirks.padSize;
    var tileList = this._tileList;
    var textureMap = this._textureMap;
    var flashTileList = this._flashTileList;
    flashTileList.length = 0;
    for(var i = 0; i < tileList.length; i++){
        var tile = tileList[i];
        var texture = textureMap.get(tile);
        if (!texture) throw new Error("Rendering tile with missing texture");
        // Get padding sizes.
        var padTop = tile.padTop() ? padSize : 0;
        var padBottom = tile.padBottom() ? padSize : 0;
        var padLeft = tile.padLeft() ? padSize : 0;
        var padRight = tile.padRight() ? padSize : 0;
        flashTileList.push({
            textureId: texture._textureId,
            face: tile.face,
            width: tile.width(),
            height: tile.height(),
            centerX: tile.centerX(),
            centerY: tile.centerY(),
            rotX: $jSacE(tile.rotX()),
            rotY: $jSacE(tile.rotY()),
            levelSize: tile.levelWidth(),
            padTop: padTop,
            padBottom: padBottom,
            padLeft: padLeft,
            padRight: padRight
        });
    }
    // Get viewport position and size.
    var stageWidth = this._flashElement.clientWidth;
    var stageHeight = this._flashElement.clientHeight;
    var viewportX = stageWidth * rect.x;
    var viewportY = stageHeight * rect.y;
    var viewportWidth = stageWidth * rect.width;
    var viewportHeight = stageHeight * rect.height;
    // Get opacity value.
    var opacity = 1.0;
    var effects = layer.effects();
    if (effects && effects.opacity != null) opacity = effects.opacity;
    // Get view parameters.
    var view = layer.view();
    var yaw = view.yaw();
    var pitch = view.pitch();
    var roll = view.roll();
    var fov = view.fov();
    flashElement.drawCubeTiles(layerId, viewportWidth, viewportHeight, viewportX, viewportY, opacity, yaw, pitch, roll, fov, flashTileList);
};
module.exports = $7d23478d77fbbf43$var$FlashCubeRenderer;

});
parcelRegister("de14n", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $jOYf3 = parcelRequire("jOYf3");

var $2Xxut = parcelRequire("2Xxut");
function $9a0d699020b8474a$var$tileCmp(a, b) {
    return a.cmp(b);
}
function $9a0d699020b8474a$var$FlashBaseRenderer(flashElement, layerId, quirks, tileClass) {
    this._flashElement = flashElement;
    this._layerId = layerId;
    this._quirks = quirks;
    this._tileList = [];
    this._textureMap = new $jOYf3();
    // Whether the Flash layer for this renderer has already been created
    // by calling flashElement.createLayer(). Note that we cannot do this
    // right here because Flash may not be initialized yet.
    this._layerCreated = false;
}
$9a0d699020b8474a$var$FlashBaseRenderer.prototype.destroy = function() {
    if (this._layerCreated) this._flashElement.destroyLayer(this._layerId);
    $2Xxut(this);
};
$9a0d699020b8474a$var$FlashBaseRenderer.prototype.startLayer = function(layer, rect) {
    if (!this._flashElement.isReady || !this._flashElement.isReady()) return;
    if (!this._layerCreated) {
        this._flashElement.createLayer(this._layerId);
        this._layerCreated = true;
    }
    this._tileList.length = 0;
    this._textureMap.clear();
};
$9a0d699020b8474a$var$FlashBaseRenderer.prototype.renderTile = function(tile, texture) {
    this._tileList.push(tile);
    this._textureMap.set(tile, texture);
};
$9a0d699020b8474a$var$FlashBaseRenderer.prototype.endLayer = function(layer, rect) {
    if (!this._flashElement.isReady || !this._flashElement.isReady()) return;
    // Sort tiles so they are rendered in an order coherent with their padding.
    var tileList = this._tileList;
    tileList.sort($9a0d699020b8474a$var$tileCmp);
    this._renderOnFlash(layer, rect);
};
module.exports = $9a0d699020b8474a$var$FlashBaseRenderer;

});

parcelRegister("jSacE", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
/**
 * @memberof util
 * @param {number} rad
 * @return {number}
 */ function $e77af99022ab2a34$var$radToDeg(rad) {
    return rad * 180 / Math.PI;
}
module.exports = $e77af99022ab2a34$var$radToDeg;

});


parcelRegister("51qT1", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $de14n = parcelRequire("de14n");

var $l1BkT = parcelRequire("l1BkT");
var $3a81e6d75d4723be$require$FlatTile = $l1BkT.Tile;

var $Yar88 = parcelRequire("Yar88");
/**
 * @class FlashFlatRenderer
 * @implements Renderer
 * @classdesc
 *
 * A renderer for {@link FlatGeometry} and {@link FlatView}, appropriate for a
 * {@link FlashStage}.
 *
 * Most users do not need to instantiate this class. Renderers are created and
 * destroyed by {@link Stage} as necessary.
 */ function $3a81e6d75d4723be$var$FlashFlatRenderer(flashElement, layerId, quirks) {
    this.constructor.super_.call(this, flashElement, layerId, quirks, $3a81e6d75d4723be$require$FlatTile);
    this._flashTileList = [];
}
$Yar88($3a81e6d75d4723be$var$FlashFlatRenderer, $de14n);
$3a81e6d75d4723be$var$FlashFlatRenderer.prototype._renderOnFlash = function(layer, rect) {
    var flashElement = this._flashElement;
    var layerId = this._layerId;
    var padSize = this._quirks.padSize;
    var tileList = this._tileList;
    var textureMap = this._textureMap;
    var flashTileList = this._flashTileList;
    flashTileList.length = 0;
    for(var i = 0; i < tileList.length; i++){
        var tile = tileList[i];
        var texture = textureMap.get(tile);
        if (!texture) throw new Error("Rendering tile with missing texture");
        // Get padding sizes.
        var padTop = tile.padTop() ? padSize : 0;
        var padBottom = tile.padBottom() ? padSize : 0;
        var padLeft = tile.padLeft() ? padSize : 0;
        var padRight = tile.padRight() ? padSize : 0;
        flashTileList.push({
            textureId: texture._textureId,
            width: tile.width(),
            height: tile.height(),
            centerX: tile.centerX(),
            centerY: tile.centerY(),
            scaleX: tile.scaleX(),
            scaleY: tile.scaleY(),
            levelWidth: tile.levelWidth(),
            levelHeight: tile.levelHeight(),
            padTop: padTop,
            padBottom: padBottom,
            padLeft: padLeft,
            padRight: padRight
        });
    }
    // Get viewport position and size.
    var stageWidth = this._flashElement.clientWidth;
    var stageHeight = this._flashElement.clientHeight;
    var viewportX = stageWidth * rect.x;
    var viewportY = stageHeight * rect.y;
    var viewportWidth = stageWidth * rect.width;
    var viewportHeight = stageHeight * rect.height;
    // Get opacity value.
    var opacity = 1.0;
    var effects = layer.effects();
    if (effects && effects.opacity != null) opacity = effects.opacity;
    // Get view parameters.
    var view = layer.view();
    var x = view.x();
    var y = view.y();
    var zoomX = view._zoomX();
    var zoomY = view._zoomY();
    flashElement.drawFlatTiles(layerId, viewportWidth, viewportHeight, viewportX, viewportY, opacity, x, y, zoomX, zoomY, flashTileList);
};
module.exports = $3a81e6d75d4723be$var$FlashFlatRenderer;

});

parcelRegister("kjZKr", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $b7h3a = parcelRequire("b7h3a");

var $6yDfP = parcelRequire("6yDfP");

var $iIThc = parcelRequire("iIThc");

var $48tXO = parcelRequire("48tXO");

var $aYyo6 = parcelRequire("aYyo6");

var $aK6y2 = parcelRequire("aK6y2");

var $51qT1 = parcelRequire("51qT1");
/**
 * Registers all known renderers for the given stage type into that stage.
 * Most users will not need to register renderers, as {@link Viewer} does it for
 * them.
 *
 * @param {Stage} stage The stage where the renderers are to be registered.
 * @throws An error if the stage type is unknown.
 */ function $ecb57adc64cae261$var$registerDefaultRenderers(stage) {
    switch(stage.type){
        case "webgl":
            stage.registerRenderer("flat", "flat", $6yDfP);
            stage.registerRenderer("cube", "rectilinear", $b7h3a);
            stage.registerRenderer("equirect", "rectilinear", $iIThc);
            break;
        case "css":
            stage.registerRenderer("flat", "flat", $aYyo6);
            stage.registerRenderer("cube", "rectilinear", $48tXO);
            break;
        case "flash":
            stage.registerRenderer("flat", "flat", $51qT1);
            stage.registerRenderer("cube", "rectilinear", $aK6y2);
            break;
        default:
            throw new Error("Unknown stage type: " + stage.type);
    }
}
module.exports = $ecb57adc64cae261$var$registerDefaultRenderers;

});

parcelRegister("bI46y", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $Yar88 = parcelRequire("Yar88");

var $4j7qz = parcelRequire("4j7qz");

var $3nhrd = parcelRequire("3nhrd");

var $4rFjs = parcelRequire("4rFjs");

var $4tCa7 = parcelRequire("4tCa7");

var $fXp6t = parcelRequire("fXp6t");
/**
 * @class EquirectTile
 * @implements Tile
 * @classdesc
 *
 * A tile in an @{EquirectGeometry}.
 */ function $8866fcddc892b476$var$EquirectTile(z, geometry) {
    this.z = z;
    this._geometry = geometry;
    this._level = geometry.levelList[z];
}
$8866fcddc892b476$var$EquirectTile.prototype.rotX = function() {
    return 0;
};
$8866fcddc892b476$var$EquirectTile.prototype.rotY = function() {
    return 0;
};
$8866fcddc892b476$var$EquirectTile.prototype.centerX = function() {
    return 0.5;
};
$8866fcddc892b476$var$EquirectTile.prototype.centerY = function() {
    return 0.5;
};
$8866fcddc892b476$var$EquirectTile.prototype.scaleX = function() {
    return 1;
};
$8866fcddc892b476$var$EquirectTile.prototype.scaleY = function() {
    return 1;
};
$8866fcddc892b476$var$EquirectTile.prototype.width = function() {
    return this._level.tileWidth();
};
$8866fcddc892b476$var$EquirectTile.prototype.height = function() {
    return this._level.tileHeight();
};
$8866fcddc892b476$var$EquirectTile.prototype.levelWidth = function() {
    return this._level.width();
};
$8866fcddc892b476$var$EquirectTile.prototype.levelHeight = function() {
    return this._level.height();
};
$8866fcddc892b476$var$EquirectTile.prototype.atTopLevel = function() {
    return this.z === 0;
};
$8866fcddc892b476$var$EquirectTile.prototype.atBottomLevel = function() {
    return this.z === this._geometry.levelList.length - 1;
};
$8866fcddc892b476$var$EquirectTile.prototype.atTopEdge = function() {
    return true;
};
$8866fcddc892b476$var$EquirectTile.prototype.atBottomEdge = function() {
    return true;
};
$8866fcddc892b476$var$EquirectTile.prototype.atLeftEdge = function() {
    return true;
};
$8866fcddc892b476$var$EquirectTile.prototype.atRightEdge = function() {
    return true;
};
$8866fcddc892b476$var$EquirectTile.prototype.padTop = function() {
    return false;
};
$8866fcddc892b476$var$EquirectTile.prototype.padBottom = function() {
    return false;
};
$8866fcddc892b476$var$EquirectTile.prototype.padLeft = function() {
    return false;
};
$8866fcddc892b476$var$EquirectTile.prototype.padRight = function() {
    return false;
};
$8866fcddc892b476$var$EquirectTile.prototype.parent = function() {
    if (this.atTopLevel()) return null;
    return new $8866fcddc892b476$var$EquirectTile(this.z - 1, this._geometry);
};
$8866fcddc892b476$var$EquirectTile.prototype.children = function(result) {
    if (this.atBottomLevel()) return null;
    result = result || [];
    result.push(new $8866fcddc892b476$var$EquirectTile(this.z + 1, this._geometry));
    return result;
};
$8866fcddc892b476$var$EquirectTile.prototype.neighbors = function() {
    return [];
};
$8866fcddc892b476$var$EquirectTile.prototype.hash = function() {
    return $4j7qz(this.z);
};
$8866fcddc892b476$var$EquirectTile.prototype.equals = function(that) {
    return this.geometry === that.geometry && this.z === that.z;
};
$8866fcddc892b476$var$EquirectTile.prototype.cmp = function(that) {
    return $3nhrd(this.z, that.z);
};
$8866fcddc892b476$var$EquirectTile.prototype.str = function() {
    return "EquirectTile(" + tile.z + ")";
};
function $8866fcddc892b476$var$EquirectLevel(levelProperties) {
    this.constructor.super_.call(this, levelProperties);
    this._width = levelProperties.width;
}
$Yar88($8866fcddc892b476$var$EquirectLevel, $4tCa7);
$8866fcddc892b476$var$EquirectLevel.prototype.width = function() {
    return this._width;
};
$8866fcddc892b476$var$EquirectLevel.prototype.height = function() {
    return this._width / 2;
};
$8866fcddc892b476$var$EquirectLevel.prototype.tileWidth = function() {
    return this._width;
};
$8866fcddc892b476$var$EquirectLevel.prototype.tileHeight = function() {
    return this._width / 2;
};
/**
 * @class EquirectGeometry
 * @implements Geometry
 * @classdesc
 *
 * A {@link Geometry} implementation suitable for equirectangular images with a
 * 2:1 aspect ratio.
 *
 * @param {Object[]} levelPropertiesList Level description
 * @param {number} levelPropertiesList[].width Level width in pixels
*/ function $8866fcddc892b476$var$EquirectGeometry(levelPropertiesList) {
    if ($fXp6t(levelPropertiesList) !== "array") throw new Error("Level list must be an array");
    this.levelList = $4rFjs.makeLevelList(levelPropertiesList, $8866fcddc892b476$var$EquirectLevel);
    this.selectableLevelList = $4rFjs.makeSelectableLevelList(this.levelList);
}
$8866fcddc892b476$var$EquirectGeometry.prototype.maxTileSize = function() {
    var maxTileSize = 0;
    for(var i = 0; i < this.levelList.length; i++){
        var level = this.levelList[i];
        maxTileSize = Math.max(maxTileSize, level.tileWidth, level.tileHeight);
    }
    return maxTileSize;
};
$8866fcddc892b476$var$EquirectGeometry.prototype.levelTiles = function(level, result) {
    var levelIndex = this.levelList.indexOf(level);
    result = result || [];
    result.push(new $8866fcddc892b476$var$EquirectTile(levelIndex, this));
    return result;
};
$8866fcddc892b476$var$EquirectGeometry.prototype.visibleTiles = function(view, level, result) {
    var tile1 = new $8866fcddc892b476$var$EquirectTile(this.levelList.indexOf(level), this);
    result = result || [];
    result.length = 0;
    result.push(tile1);
};
$8866fcddc892b476$var$EquirectGeometry.Tile = $8866fcddc892b476$var$EquirectGeometry.prototype.Tile = $8866fcddc892b476$var$EquirectTile;
$8866fcddc892b476$var$EquirectGeometry.type = $8866fcddc892b476$var$EquirectGeometry.prototype.type = "equirect";
$8866fcddc892b476$var$EquirectTile.type = $8866fcddc892b476$var$EquirectTile.prototype.type = "equirect";
module.exports = $8866fcddc892b476$var$EquirectGeometry;

});

parcelRegister("63xsq", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $6mia6 = parcelRequire("6mia6");

var $c3mW8 = parcelRequire("c3mW8");
var $8QvoZ = parcelRequire("8QvoZ");
var $468cf9d9bfd41e18$require$mat4 = $c3mW8;

var $c3mW8 = parcelRequire("c3mW8");
var $8QvoZ = parcelRequire("8QvoZ");
var $468cf9d9bfd41e18$require$vec4 = $8QvoZ;

var $lNra6 = parcelRequire("lNra6");

var $hmySL = parcelRequire("hmySL");

var $iZgBB = parcelRequire("iZgBB");

var $0OTzd = parcelRequire("0OTzd");

var $eCQUD = parcelRequire("eCQUD");

var $asoyN = parcelRequire("asoyN");

var $arsG2 = parcelRequire("arsG2");

var $2Xxut = parcelRequire("2Xxut");
// Default viewport dimensions.
// Start with zero to ensure that those values are handled correctly.
var $468cf9d9bfd41e18$var$defaultWidth = 0;
var $468cf9d9bfd41e18$var$defaultHeight = 0;
// Default view parameters.
var $468cf9d9bfd41e18$var$defaultYaw = 0;
var $468cf9d9bfd41e18$var$defaultPitch = 0;
var $468cf9d9bfd41e18$var$defaultRoll = 0;
var $468cf9d9bfd41e18$var$defaultFov = Math.PI / 4;
var $468cf9d9bfd41e18$var$defaultProjectionCenterX = 0;
var $468cf9d9bfd41e18$var$defaultProjectionCenterY = 0;
// A fov of exactly 0 or π breaks some computations, so we constrain it to the
// [fovLimitEpsilon, π - fovLimitEpsilon] interval. We use 6 decimal places for
// the epsilon value to avoid broken rendering due to loss of precision in
// floating point computations.
var $468cf9d9bfd41e18$var$fovLimitEpsilon = 0.000001;
/**
 * @interface RectilinearViewParams
 *
 * A camera configuration for a {@link RectilinearView}.
 *
 * @property {number} yaw The yaw angle, in the [-π, π] range.
 *     When `yaw < 0`, the view rotates to the left.
 *     When `yaw > 0`, the view rotates to the right.
 *
 * @property {number} pitch The pitch angle, in the [-π, π] range.
 *     When `pitch < 0`, the view rotates downwards.
 *     When `pitch > 0`, the view rotates upwards.
 *
 * @property {number} roll The roll angle, in the [-π, π] range.
 *     When `roll < 0`, the view rotates clockwise.
 *     When `roll > 0`, the view rotates counter-clockwise.
 *
 * @property {fov} fov The vertical field of view, in the [0, π] range.
 */ /**
 * @interface RectilinearViewCoords
 *
 * The position of a point in a 360° image.
 *
 * @property {number} yaw The yaw angle, in the [-π, π] range.
 * @property {number} pitch The pitch angle, in the [-π, π] range.
 */ /**
 * @typedef {function} RectilinearViewLimiter
 *
 * View limiter for a {@link RectilinearView}.
 *
 * A view limiter is a function that receives a {@link RectilinearViewParams}
 * object, optionally modifies it in place, and returns it. It can be used to
 * enforce constraints on the view parameters.
 *
 * See {@link RectilinearView.limit} for commonly used limiters. They may be
 * composed together or with user-defined limiters with {@link util.compose}.
 *
 * @param {RectilinearViewParams} params
 * @return {RectilinearViewParams}
 */ /**
 * @class RectilinearView
 * @implements View
 * @classdesc
 *
 * A {@link View} implementing a rectilinear projection for 360° images.
 *
 * @param {RectilinearViewParams=} params The initial view parameters. If
 *     unspecified, defaults to `{yaw: 0, pitch: 0, roll: 0, fov: Math.PI/4 }`.
 * @param {RectilinearViewLimiter=} limiter The view limiter. If unspecified,
 *     no view limiting is applied. See {@link RectilinearView.limit} for
 *     commonly used limiters.
 */ function $468cf9d9bfd41e18$var$RectilinearView(params, limiter) {
    // The initial values for the view parameters.
    this._yaw = params && params.yaw != null ? params.yaw : $468cf9d9bfd41e18$var$defaultYaw;
    this._pitch = params && params.pitch != null ? params.pitch : $468cf9d9bfd41e18$var$defaultPitch;
    this._roll = params && params.roll != null ? params.roll : $468cf9d9bfd41e18$var$defaultRoll;
    this._fov = params && params.fov != null ? params.fov : $468cf9d9bfd41e18$var$defaultFov;
    this._width = params && params.width != null ? params.width : $468cf9d9bfd41e18$var$defaultWidth;
    this._height = params && params.height != null ? params.height : $468cf9d9bfd41e18$var$defaultHeight;
    this._projectionCenterX = params && params.projectionCenterX != null ? params.projectionCenterX : $468cf9d9bfd41e18$var$defaultProjectionCenterX;
    this._projectionCenterY = params && params.projectionCenterY != null ? params.projectionCenterY : $468cf9d9bfd41e18$var$defaultProjectionCenterY;
    // The initial value for the view limiter.
    this._limiter = limiter || null;
    // The last calculated projection matrix and its inverse.
    this._projMatrix = $468cf9d9bfd41e18$require$mat4.create();
    this._invProjMatrix = $468cf9d9bfd41e18$require$mat4.create();
    // The last calculated view frustum.
    this._frustum = [
        $468cf9d9bfd41e18$require$vec4.create(),
        $468cf9d9bfd41e18$require$vec4.create(),
        $468cf9d9bfd41e18$require$vec4.create(),
        $468cf9d9bfd41e18$require$vec4.create(),
        $468cf9d9bfd41e18$require$vec4.create() // camera
    ];
    // Whether the projection matrices and the view frustum need to be updated.
    this._projectionChanged = true;
    // Temporary variables used for calculations.
    this._params = {};
    this._fovs = {};
    this._tmpVec = $468cf9d9bfd41e18$require$vec4.create();
    // Force view limiting on initial parameters.
    this._update();
}
$6mia6($468cf9d9bfd41e18$var$RectilinearView);
/**
 * Destructor.
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.destroy = function() {
    $2Xxut(this);
};
/**
 * Get the yaw angle.
 * @return {number}
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.yaw = function() {
    return this._yaw;
};
/**
 * Get the pitch angle.
 * @return {number}
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.pitch = function() {
    return this._pitch;
};
/**
 * Get the roll angle.
 * @return {number}
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.roll = function() {
    return this._roll;
};
$468cf9d9bfd41e18$var$RectilinearView.prototype.projectionCenterX = function() {
    return this._projectionCenterX;
};
$468cf9d9bfd41e18$var$RectilinearView.prototype.projectionCenterY = function() {
    return this._projectionCenterY;
};
/**
 * Get the fov value.
 * @return {number}
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.fov = function() {
    return this._fov;
};
/**
 * Get the viewport width.
 * @return {number}
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.width = function() {
    return this._width;
};
/**
 * Get the viewport height.
 * @return {number}
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.height = function() {
    return this._height;
};
/**
 * Get the viewport dimensions. If an argument is supplied, it is filled in with
 * the result and returned. Otherwise, a fresh object is filled in and returned.
 * @param {Size=} size
 * @return {Size}
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.size = function(size) {
    size = size || {};
    size.width = this._width;
    size.height = this._height;
    return size;
};
/**
 * Get the view parameters. If an argument is supplied, it is filled in with the
 * result and returned. Otherwise, a fresh object is filled in and returned.
 * @param {RectilinearViewParams=} obj
 * @return {RectilinearViewParams}
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.parameters = function(params) {
    params = params || {};
    params.yaw = this._yaw;
    params.pitch = this._pitch;
    params.roll = this._roll;
    params.fov = this._fov;
    return params;
};
/**
 * Get the view limiter, or null if unset.
 * @return {?RectilinearViewLimiter}
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.limiter = function() {
    return this._limiter;
};
/**
 * Set the yaw angle.
 * @param {number} yaw
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.setYaw = function(yaw) {
    this._resetParams();
    this._params.yaw = yaw;
    this._update(this._params);
};
/**
 * Set the pitch angle.
 * @param {number} pitch
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.setPitch = function(pitch) {
    this._resetParams();
    this._params.pitch = pitch;
    this._update(this._params);
};
/**
 * Set the roll angle.
 * @param {number} roll
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.setRoll = function(roll) {
    this._resetParams();
    this._params.roll = roll;
    this._update(this._params);
};
/**
 * Set the fov value.
 * @param {number} fov
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.setFov = function(fov) {
    this._resetParams();
    this._params.fov = fov;
    this._update(this._params);
};
$468cf9d9bfd41e18$var$RectilinearView.prototype.setProjectionCenterX = function(projectionCenterX) {
    this._resetParams();
    this._params.projectionCenterX = projectionCenterX;
    this._update(this._params);
};
$468cf9d9bfd41e18$var$RectilinearView.prototype.setProjectionCenterY = function(projectionCenterY) {
    this._resetParams();
    this._params.projectionCenterY = projectionCenterY;
    this._update(this._params);
};
/**
 * Add yawOffset to the current yaw value.
 * @param {number} yawOffset
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.offsetYaw = function(yawOffset) {
    this.setYaw(this._yaw + yawOffset);
};
/**
 * Add pitchOffset to the current pitch value.
 * @param {number} pitchOffset
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.offsetPitch = function(pitchOffset) {
    this.setPitch(this._pitch + pitchOffset);
};
/**
 * Add rollOffset to the current roll value.
 * @param {number} rollOffset
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.offsetRoll = function(rollOffset) {
    this.setRoll(this._roll + rollOffset);
};
/**
 * Add fovOffset to the current fov value.
 * @param {number} fovOffset
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.offsetFov = function(fovOffset) {
    this.setFov(this._fov + fovOffset);
};
/**
 * Set the viewport dimensions.
 * @param {Size} size
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.setSize = function(size) {
    this._resetParams();
    this._params.width = size.width;
    this._params.height = size.height;
    this._update(this._params);
};
/**
 * Set the view parameters. Unspecified parameters are left unchanged.
 * @param {RectilinearViewParameters} params
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.setParameters = function(params) {
    this._resetParams();
    this._params.yaw = params.yaw;
    this._params.pitch = params.pitch;
    this._params.roll = params.roll;
    this._params.fov = params.fov;
    this._params.projectionCenterX = params.projectionCenterX;
    this._params.projectionCenterY = params.projectionCenterY;
    this._update(this._params);
};
/**
 * Set the view limiter.
 * @param {?RectilinearViewLimiter} limiter The new limiter, or null to unset.
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.setLimiter = function(limiter) {
    this._limiter = limiter || null;
    this._update();
};
$468cf9d9bfd41e18$var$RectilinearView.prototype._resetParams = function() {
    var params = this._params;
    params.yaw = null;
    params.pitch = null;
    params.roll = null;
    params.fov = null;
    params.width = null;
    params.height = null;
};
$468cf9d9bfd41e18$var$RectilinearView.prototype._update = function(params) {
    // Avoid object allocation when no parameters are supplied.
    if (params == null) {
        this._resetParams();
        params = this._params;
    }
    // Save old parameters for later comparison.
    var oldYaw = this._yaw;
    var oldPitch = this._pitch;
    var oldRoll = this._roll;
    var oldFov = this._fov;
    var oldProjectionCenterX = this._projectionCenterX;
    var oldProjectionCenterY = this._projectionCenterY;
    var oldWidth = this._width;
    var oldHeight = this._height;
    // Fill in object with the new set of parameters to pass into the limiter.
    params.yaw = params.yaw != null ? params.yaw : oldYaw;
    params.pitch = params.pitch != null ? params.pitch : oldPitch;
    params.roll = params.roll != null ? params.roll : oldRoll;
    params.fov = params.fov != null ? params.fov : oldFov;
    params.width = params.width != null ? params.width : oldWidth;
    params.height = params.height != null ? params.height : oldHeight;
    params.projectionCenterX = params.projectionCenterX != null ? params.projectionCenterX : oldProjectionCenterX;
    params.projectionCenterY = params.projectionCenterY != null ? params.projectionCenterY : oldProjectionCenterY;
    // Apply view limiting when defined.
    if (this._limiter) {
        params = this._limiter(params);
        if (!params) throw new Error("Bad view limiter");
    }
    // Normalize parameters.
    params = this._normalize(params);
    // Grab the limited parameters.
    var newYaw = params.yaw;
    var newPitch = params.pitch;
    var newRoll = params.roll;
    var newFov = params.fov;
    var newWidth = params.width;
    var newHeight = params.height;
    var newProjectionCenterX = params.projectionCenterX;
    var newProjectionCenterY = params.projectionCenterY;
    // Consistency check.
    if (!$0OTzd(newYaw) || !$0OTzd(newPitch) || !$0OTzd(newRoll) || !$0OTzd(newFov) || !$0OTzd(newWidth) || !$0OTzd(newHeight) || !$0OTzd(newProjectionCenterX) || !$0OTzd(newProjectionCenterY)) throw new Error("Bad view - suspect a broken limiter");
    // Update parameters.
    this._yaw = newYaw;
    this._pitch = newPitch;
    this._roll = newRoll;
    this._fov = newFov;
    this._width = newWidth;
    this._height = newHeight;
    this._projectionCenterX = newProjectionCenterX;
    this._projectionCenterY = newProjectionCenterY;
    // Check whether the parameters changed and emit the corresponding events.
    if (newYaw !== oldYaw || newPitch !== oldPitch || newRoll !== oldRoll || newFov !== oldFov || newWidth !== oldWidth || newHeight !== oldHeight || newProjectionCenterX !== oldProjectionCenterX || newProjectionCenterY !== oldProjectionCenterY) {
        this._projectionChanged = true;
        this.emit("change");
    }
    if (newWidth !== oldWidth || newHeight !== oldHeight) this.emit("resize");
};
$468cf9d9bfd41e18$var$RectilinearView.prototype._normalize = function(params) {
    this._normalizeCoordinates(params);
    // Make sure that neither the horizontal nor the vertical fields of view
    // exceed π - fovLimitEpsilon.
    var hfovPi = $hmySL.htov(Math.PI, params.width, params.height);
    var maxFov = isNaN(hfovPi) ? Math.PI : Math.min(Math.PI, hfovPi);
    params.fov = $eCQUD(params.fov, $468cf9d9bfd41e18$var$fovLimitEpsilon, maxFov - $468cf9d9bfd41e18$var$fovLimitEpsilon);
    return params;
};
$468cf9d9bfd41e18$var$RectilinearView.prototype._normalizeCoordinates = function(params) {
    // Constrain yaw, pitch and roll to the [-π, π] interval.
    if ("yaw" in params) params.yaw = $iZgBB(params.yaw - Math.PI, -2 * Math.PI) + Math.PI;
    if ("pitch" in params) params.pitch = $iZgBB(params.pitch - Math.PI, -2 * Math.PI) + Math.PI;
    if ("roll" in params) params.roll = $iZgBB(params.roll - Math.PI, -2 * Math.PI) + Math.PI;
    return params;
};
/**
 * Normalize view coordinates so that they are the closest to the current view.
 * Useful for tweening the view through the shortest path. If a result argument
 * is supplied, it is filled in with the result and returned. Otherwise, a fresh
 * object is filled in and returned.
 *
 * @param {RectilinearViewCoords} coords The view coordinates.
 * @param {RectilinearViewCoords} result The result argument for the normalized
 *     view coordinates.
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.normalizeToClosest = function(coords, result) {
    var viewYaw = this._yaw;
    var viewPitch = this._pitch;
    var coordYaw = coords.yaw;
    var coordPitch = coords.pitch;
    // Check if the yaw is closer after subtracting or adding a full circle.
    var prevYaw = coordYaw - 2 * Math.PI;
    var nextYaw = coordYaw + 2 * Math.PI;
    if (Math.abs(prevYaw - viewYaw) < Math.abs(coordYaw - viewYaw)) coordYaw = prevYaw;
    else if (Math.abs(nextYaw - viewYaw) < Math.abs(coordYaw - viewYaw)) coordYaw = nextYaw;
    // Check if the pitch is closer after subtracting or adding a full circle.
    var prevPitch = coordPitch - 2 * Math.PI;
    var nextPitch = coordPitch + 2 * Math.PI;
    if (Math.abs(prevPitch - viewPitch) < Math.abs(coordPitch - viewPitch)) coordPitch = prevPitch;
    else if (Math.abs(prevPitch - viewPitch) < Math.abs(coordPitch - viewPitch)) coordPitch = nextPitch;
    result = result || {};
    result.yaw = coordYaw;
    result.pitch = coordPitch;
    return result;
};
$468cf9d9bfd41e18$var$RectilinearView.prototype.updateWithControlParameters = function(parameters) {
    // axisScaledX and axisScaledY are scaled according to their own axis
    // x and y are scaled by the same value
    // If the viewport dimensions are zero, assume a square viewport
    // when converting from hfov to vfov.
    var vfov = this._fov;
    var hfov = $hmySL.vtoh(vfov, this._width, this._height);
    if (isNaN(hfov)) hfov = vfov;
    // TODO: revisit this after we rethink the control parameters.
    this.offsetYaw(parameters.axisScaledX * hfov + parameters.x * 2 * hfov + parameters.yaw);
    this.offsetPitch(parameters.axisScaledY * vfov + parameters.y * 2 * hfov + parameters.pitch);
    this.offsetRoll(-parameters.roll);
    this.offsetFov(parameters.zoom * vfov);
};
$468cf9d9bfd41e18$var$RectilinearView.prototype._updateProjection = function() {
    var projMatrix = this._projMatrix;
    var invProjMatrix = this._invProjMatrix;
    var frustum = this._frustum;
    if (this._projectionChanged) {
        var width = this._width;
        var height = this._height;
        var vfov = this._fov;
        var hfov = $hmySL.vtoh(vfov, width, height);
        var aspect = width / height;
        var projectionCenterX = this._projectionCenterX;
        var projectionCenterY = this._projectionCenterY;
        if (projectionCenterX !== 0 || projectionCenterY !== 0) {
            var offsetAngleX = Math.atan(projectionCenterX * 2 * Math.tan(hfov / 2));
            var offsetAngleY = Math.atan(projectionCenterY * 2 * Math.tan(vfov / 2));
            var fovs = this._fovs;
            fovs.leftDegrees = (hfov / 2 + offsetAngleX) * 180 / Math.PI;
            fovs.rightDegrees = (hfov / 2 - offsetAngleX) * 180 / Math.PI;
            fovs.upDegrees = (vfov / 2 + offsetAngleY) * 180 / Math.PI;
            fovs.downDegrees = (vfov / 2 - offsetAngleY) * 180 / Math.PI;
            $468cf9d9bfd41e18$require$mat4.perspectiveFromFieldOfView(projMatrix, fovs, -1, 1);
        } else $468cf9d9bfd41e18$require$mat4.perspective(projMatrix, vfov, aspect, -1, 1);
        $468cf9d9bfd41e18$require$mat4.rotateZ(projMatrix, projMatrix, this._roll);
        $468cf9d9bfd41e18$require$mat4.rotateX(projMatrix, projMatrix, this._pitch);
        $468cf9d9bfd41e18$require$mat4.rotateY(projMatrix, projMatrix, this._yaw);
        $468cf9d9bfd41e18$require$mat4.invert(invProjMatrix, projMatrix);
        this._matrixToFrustum(projMatrix, frustum);
        this._projectionChanged = false;
    }
};
$468cf9d9bfd41e18$var$RectilinearView.prototype._matrixToFrustum = function(p, f) {
    // Extract frustum planes from projection matrix.
    // http://www8.cs.umu.se/kurser/5DV051/HT12/lab/plane_extraction.pdf
    $468cf9d9bfd41e18$require$vec4.set(f[0], p[3] + p[0], p[7] + p[4], p[11] + p[8], 0); // left
    $468cf9d9bfd41e18$require$vec4.set(f[1], p[3] - p[0], p[7] - p[4], p[11] - p[8], 0); // right
    $468cf9d9bfd41e18$require$vec4.set(f[2], p[3] + p[1], p[7] + p[5], p[11] + p[9], 0); // top
    $468cf9d9bfd41e18$require$vec4.set(f[3], p[3] - p[1], p[7] - p[5], p[11] - p[9], 0); // bottom
    $468cf9d9bfd41e18$require$vec4.set(f[4], p[3] + p[2], p[7] + p[6], p[11] + p[10], 0); // camera
};
/**
 * Returns the projection matrix for the current view.
 * @returns {mat4}
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.projection = function() {
    this._updateProjection();
    return this._projMatrix;
};
/**
 * Returns the inverse projection matrix for the current view.
 * @returns {mat4}
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.inverseProjection = function() {
    this._updateProjection();
    return this._invProjMatrix;
};
/**
 * Return whether the view frustum intersects the given rectangle.
 *
 * This function may return false positives, but never false negatives.
 * It is used for frustum culling, i.e., excluding invisible tiles from the
 * rendering process.
 *
 * @param {vec2[]} rectangle The vertices of the rectangle.
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.intersects = function(rectangle) {
    this._updateProjection();
    var frustum = this._frustum;
    var vertex = this._tmpVec;
    // Check whether the rectangle is on the outer side of any of the frustum
    // planes. This is a sufficient condition, though not necessary, for the
    // rectangle to be completely outside the frustum.
    for(var i = 0; i < frustum.length; i++){
        var plane = frustum[i];
        var inside = false;
        for(var j = 0; j < rectangle.length; j++){
            var corner = rectangle[j];
            $468cf9d9bfd41e18$require$vec4.set(vertex, corner[0], corner[1], corner[2], 0);
            if ($468cf9d9bfd41e18$require$vec4.dot(plane, vertex) >= 0) inside = true;
        }
        if (!inside) return false;
    }
    return true;
};
/**
 * Select the level that should be used to render the view.
 * @param {Level[]} levelList the list of levels from which to select.
 * @return {Level} the selected level.
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.selectLevel = function(levelList) {
    // Multiply the viewport width by the device pixel ratio to get the required
    // horizontal resolution in pixels.
    //
    // Calculate the fraction of a cube face that would be visible given the
    // current vertical field of view. Then, for each level, multiply by the
    // level height to get the height in pixels of the portion that would be
    // visible.
    //
    // Search for the smallest level that satifies the the required height,
    // falling back on the largest level if none do.
    var requiredPixels = $lNra6() * this._height;
    var coverFactor = Math.tan(0.5 * this._fov);
    for(var i = 0; i < levelList.length; i++){
        var level = levelList[i];
        if (coverFactor * level.height() >= requiredPixels) return level;
    }
    return levelList[levelList.length - 1];
};
/**
 * Convert view parameters into screen position. If a result argument is
 * provided, it is filled in and returned. Otherwise, a fresh object is filled
 * in and returned.
 *
 * @param {RectilinearViewCoords} coords The view coordinates.
 * @param {Coords=} result The result argument for the screen coordinates.
 * @return {Coords}
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.coordinatesToScreen = function(coords, result) {
    var ray = this._tmpVec;
    if (!result) result = {};
    var width = this._width;
    var height = this._height;
    // Undefined on a null viewport.
    if (width <= 0 || height <= 0) {
        result.x = null;
        result.y = null;
        return null;
    }
    // Compute view ray pointing into the (yaw, pitch) direction.
    var yaw = coords.yaw;
    var pitch = coords.pitch;
    var x = Math.sin(yaw) * Math.cos(pitch);
    var y = -Math.sin(coords.pitch);
    var z = -Math.cos(yaw) * Math.cos(pitch);
    $468cf9d9bfd41e18$require$vec4.set(ray, x, y, z, 1);
    // Project view ray onto clip space.
    $468cf9d9bfd41e18$require$vec4.transformMat4(ray, ray, this.projection());
    // w in clip space equals -z in camera space.
    if (ray[3] >= 0) {
        // Point is in front of camera.
        // Convert to viewport coordinates.
        result.x = width * (ray[0] / ray[3] + 1) / 2;
        result.y = height * (1 - ray[1] / ray[3]) / 2;
    } else {
        // Point is behind camera.
        result.x = null;
        result.y = null;
        return null;
    }
    return result;
};
/**
 * Convert screen coordinates into view coordinates. If a result argument is
 * provided, it is filled in with the result and returned. Otherwise, a fresh
 * object is filled in and returned.
 *
 * @param {Coords} coords The screen coordinates.
 * @param {RectilinearViewCoords=} result The view coordinates.
 * @return {RectilinearViewCoords}
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.screenToCoordinates = function(coords, result) {
    var ray = this._tmpVec;
    if (!result) result = {};
    var width = this._width;
    var height = this._height;
    // Convert viewport coordinates to clip space.
    var vecx = 2 * coords.x / width - 1;
    var vecy = 1 - 2 * coords.y / height;
    $468cf9d9bfd41e18$require$vec4.set(ray, vecx, vecy, 1, 1);
    // Project back to world space.
    $468cf9d9bfd41e18$require$vec4.transformMat4(ray, ray, this.inverseProjection());
    // Convert to spherical coordinates.
    var r = Math.sqrt(ray[0] * ray[0] + ray[1] * ray[1] + ray[2] * ray[2]);
    result.yaw = Math.atan2(ray[0], -ray[2]);
    result.pitch = Math.acos(ray[1] / r) - Math.PI / 2;
    this._normalizeCoordinates(result);
    return result;
};
/**
 * Calculate the perspective transform required to position an element with
 * perspective.
 *
 * @param {RectilinearViewCoords} coords The view coordinates.
 * @param {number} radius Radius of the sphere embedding the element.
 * @param {string} extraTransforms Extra transformations to be applied after
 *     the element is positioned. This may be used to rotate the element.
 * @return {string} The CSS 3D transform to be applied to the element.
 */ $468cf9d9bfd41e18$var$RectilinearView.prototype.coordinatesToPerspectiveTransform = function(coords, radius, extraTransforms) {
    extraTransforms = extraTransforms || "";
    var height = this._height;
    var width = this._width;
    var fov = this._fov;
    var perspective = 0.5 * height / Math.tan(fov / 2);
    var transform = "";
    // Center hotspot in screen.
    transform += "translateX(" + $asoyN(width / 2) + "px) ";
    transform += "translateY(" + $asoyN(height / 2) + "px) ";
    transform += "translateX(-50%) translateY(-50%) ";
    // Set the perspective depth.
    transform += "perspective(" + $asoyN(perspective) + "px) ";
    transform += "translateZ(" + $asoyN(perspective) + "px) ";
    // Set the camera rotation.
    transform += "rotateZ(" + $asoyN(-this._roll) + "rad) ";
    transform += "rotateX(" + $asoyN(-this._pitch) + "rad) ";
    transform += "rotateY(" + $asoyN(this._yaw) + "rad) ";
    // Set the hotspot rotation.
    transform += "rotateY(" + $asoyN(-coords.yaw) + "rad) ";
    transform += "rotateX(" + $asoyN(coords.pitch) + "rad) ";
    // Move back to sphere.
    transform += "translateZ(" + $asoyN(-radius) + "px) ";
    // Apply the extra transformations
    transform += extraTransforms + " ";
    return transform;
};
/**
 * Factory functions for view limiters. See {@link RectilinearViewLimiter}.
 * @namespace
 */ $468cf9d9bfd41e18$var$RectilinearView.limit = {
    /**
   * Returns a view limiter that constrains the yaw angle.
   * @param {number} min The minimum yaw value.
   * @param {number} max The maximum yaw value.
   * @return {RectilinearViewLimiter}
   */ yaw: function(min, max) {
        return function limitYaw(params) {
            params.yaw = $eCQUD(params.yaw, min, max);
            return params;
        };
    },
    /**
   * Returns a view limiter that constrains the pitch angle.
   * @param {number} min The minimum pitch value.
   * @param {number} max The maximum pitch value.
   * @return {RectilinearViewLimiter}
   */ pitch: function(min, max) {
        return function limitPitch(params) {
            params.pitch = $eCQUD(params.pitch, min, max);
            return params;
        };
    },
    /**
   * Returns a view limiter that constrains the roll angle.
   * @param {number} min The minimum roll value.
   * @param {number} max The maximum roll value.
   * @return {RectilinearViewLimiter}
   */ roll: function(min, max) {
        return function limitRoll(params) {
            params.roll = $eCQUD(params.roll, min, max);
            return params;
        };
    },
    /**
   * Returns a view limiter that constrains the horizontal field of view.
   * @param {number} min The minimum horizontal field of view.
   * @param {number} max The maximum horizontal field of view.
   * @return {RectilinearViewLimiter}
   */ hfov: function(min, max) {
        return function limitHfov(params) {
            var width = params.width;
            var height = params.height;
            if (width > 0 && height > 0) {
                var vmin = $hmySL.htov(min, width, height);
                var vmax = $hmySL.htov(max, width, height);
                params.fov = $eCQUD(params.fov, vmin, vmax);
            }
            return params;
        };
    },
    /**
   * Returns a view limiter that constrains the vertical field of view.
   * @param {number} min The minimum vertical field of view.
   * @param {number} max The maximum vertical field of view.
   * @return {RectilinearViewLimiter}
   */ vfov: function(min, max) {
        return function limitVfov(params) {
            params.fov = $eCQUD(params.fov, min, max);
            return params;
        };
    },
    /**
   * Returns a view limiter that prevents zooming in beyond the given
   * resolution.
   * @param {number} size The cube face width in pixels or, equivalently, one
   *     fourth of the equirectangular width in pixels.
   * @return {RectilinearViewLimiter}
   */ resolution: function(size) {
        return function limitResolution(params) {
            var height = params.height;
            if (height) {
                var requiredPixels = $lNra6() * height;
                var minFov = 2 * Math.atan(requiredPixels / size);
                params.fov = $eCQUD(params.fov, minFov, Infinity);
            }
            return params;
        };
    },
    /**
   * Returns a view limiter that limits the horizontal and vertical field of
   * view, prevents zooming in past the image resolution, and limits the pitch
   * range to prevent the camera wrapping around at the poles. These are the
   * most common view constraints for a 360° panorama.
   * @param {number} maxResolution The cube face width in pixels or,
   *     equivalently, one fourth of the equirectangular width in pixels.
   * @param {number} maxVFov The maximum vertical field of view.
   * @param {number} [maxHFov=maxVFov] The maximum horizontal field of view.
   * @return {RectilinearViewLimiter}
   */ traditional: function(maxResolution, maxVFov, maxHFov) {
        maxHFov = maxHFov != null ? maxHFov : maxVFov;
        return $arsG2($468cf9d9bfd41e18$var$RectilinearView.limit.resolution(maxResolution), $468cf9d9bfd41e18$var$RectilinearView.limit.vfov(0, maxVFov), $468cf9d9bfd41e18$var$RectilinearView.limit.hfov(0, maxHFov), $468cf9d9bfd41e18$var$RectilinearView.limit.pitch(-Math.PI / 2, Math.PI / 2));
    }
};
$468cf9d9bfd41e18$var$RectilinearView.type = $468cf9d9bfd41e18$var$RectilinearView.prototype.type = "rectilinear";
module.exports = $468cf9d9bfd41e18$var$RectilinearView;

});
parcelRegister("hmySL", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
/**
 * Convert fov
 *
 * For example, to convert from hfov to vfov one would call 
 * `convert(hfov, width, height)`
 *
 * @param {number} fov
 * @param {number} fromDimension
 * @param {number} toDimension
 * @return {number}
 * @memberof util.convertFov
 */ function $ca3f8ca1d42e4409$var$convert(fov, fromDimension, toDimension) {
    return 2 * Math.atan(toDimension * Math.tan(fov / 2) / fromDimension);
}
/**
 * @param {number} fov
 * @param {number} fromDimension
 * @param {number} toDimension
 * @return {number}
 * @memberof util.convertFov
 */ function $ca3f8ca1d42e4409$var$htov(fov, width, height) {
    return $ca3f8ca1d42e4409$var$convert(fov, width, height);
}
/**
 * @param {number} fov
 * @param {number} fromDimension
 * @param {number} toDimension
 * @return {number}
 * @memberof util.convertFov
 */ function $ca3f8ca1d42e4409$var$htod(fov, width, height) {
    return $ca3f8ca1d42e4409$var$convert(fov, width, Math.sqrt(width * width + height * height));
}
/**
 * @param {number} fov
 * @param {number} fromDimension
 * @param {number} toDimension
 * @return {number}
 * @memberof util.convertFov
 */ function $ca3f8ca1d42e4409$var$vtoh(fov, width, height) {
    return $ca3f8ca1d42e4409$var$convert(fov, height, width);
}
/**
 * @param {number} fov
 * @param {number} fromDimension
 * @param {number} toDimension
 * @return {number}
 * @memberof util.convertFov
 */ function $ca3f8ca1d42e4409$var$vtod(fov, width, height) {
    return $ca3f8ca1d42e4409$var$convert(fov, height, Math.sqrt(width * width + height * height));
}
/**
 * @param {number} fov
 * @param {number} fromDimension
 * @param {number} toDimension
 * @return {number}
 * @memberof util.convertFov
 */ function $ca3f8ca1d42e4409$var$dtoh(fov, width, height) {
    return $ca3f8ca1d42e4409$var$convert(fov, Math.sqrt(width * width + height * height), width);
}
/**
 * @param {number} fov
 * @param {number} fromDimension
 * @param {number} toDimension
 * @return {number}
 * @memberof util.convertFov
 */ function $ca3f8ca1d42e4409$var$dtov(fov, width, height) {
    return $ca3f8ca1d42e4409$var$convert(fov, Math.sqrt(width * width + height * height), height);
}
/**
 * @namespace util.convertFov
 */ module.exports = {
    convert: $ca3f8ca1d42e4409$var$convert,
    htov: $ca3f8ca1d42e4409$var$htov,
    htod: $ca3f8ca1d42e4409$var$htod,
    vtoh: $ca3f8ca1d42e4409$var$vtoh,
    vtod: $ca3f8ca1d42e4409$var$vtod,
    dtoh: $ca3f8ca1d42e4409$var$dtoh,
    dtov: $ca3f8ca1d42e4409$var$dtov
};

});

parcelRegister("0OTzd", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
function $00277aefd4c26732$var$real(x) {
    return typeof x === "number" && isFinite(x);
}
module.exports = $00277aefd4c26732$var$real;

});

parcelRegister("arsG2", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
/**
  * Compose multiple functions
  *
  * `compose(f, g)` returns `function(x) { return f(g(x)); }`
  *
  * @memberof util
  * @param {Function[]} functions The functions to compose
  * @return {Function}
  */ function $79a2aba5a3e184cb$var$compose() {
    var fnList = arguments;
    return function composed(initialArg) {
        var ret = initialArg;
        for(var i = 0; i < fnList.length; i++){
            var fn = fnList[i];
            ret = fn.call(null, ret);
        }
        return ret;
    };
}
module.exports = $79a2aba5a3e184cb$var$compose;

});


parcelRegister("9iOfn", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $6mia6 = parcelRequire("6mia6");

var $c3mW8 = parcelRequire("c3mW8");
var $8QvoZ = parcelRequire("8QvoZ");
var $6c5cc58465138606$require$mat4 = $c3mW8;

var $c3mW8 = parcelRequire("c3mW8");
var $8QvoZ = parcelRequire("8QvoZ");
var $6c5cc58465138606$require$vec4 = $8QvoZ;

var $lNra6 = parcelRequire("lNra6");

var $0OTzd = parcelRequire("0OTzd");

var $eCQUD = parcelRequire("eCQUD");

var $2Xxut = parcelRequire("2Xxut");
// Default viewport dimensions.
// Start with zero to ensure that those values are handled correctly.
var $6c5cc58465138606$var$defaultWidth = 0;
var $6c5cc58465138606$var$defaultHeight = 0;
// Default view parameters.
var $6c5cc58465138606$var$defaultX = 0.5;
var $6c5cc58465138606$var$defaultY = 0.5;
var $6c5cc58465138606$var$defaultZoom = 1;
// Constant values used to simplify the frustum culling logic.
// planeAxes[i] indicates the coordinate value that defines a frustum plane.
// planeCmp[i] indicates how point and plane coordinates should be compared
// to determine whether the point is on the outer side of the plane.
var $6c5cc58465138606$var$planeAxes = [
    1,
    0,
    1,
    0 // left
];
var $6c5cc58465138606$var$planeCmp = [
    -1,
    -1,
    1,
    1 // left
];
// A zoom of exactly 0 breaks some computations, so we force a minimum positive
// value. We use 6 decimal places for the epsilon value to avoid broken
// rendering due to loss of precision in floating point computations.
var $6c5cc58465138606$var$zoomLimitEpsilon = 0.000001;
/**
 * @interface FlatViewParams
 *
 * A camera configuration for a {@link FlatView}.
 *
 * @property {number} x The horizontal coordinate of the image point displayed
 *     at the viewport center, in the [0, 1] range.
 *     When `x === 0.5`, the image is centered horizontally.
 *     When `x === 0`, the left edge of the image is at the viewport center.
 *     When `x === 1`, the right edge of the image is at the viewport center.
 * @property {number} y The vertical coordinate of the image point displayed at
 *     the viewport center, in the [0, 1] range.
 *     When `y === 0.5`, the image is centered vertically.
 *     When `y === 0`, the top edge of the image is at the viewport center.
 *     When `y === 1`, the bottom edge of the image is at the viewport center.
 * @property {number} zoom The horizontal zoom, in the [0, ∞) range.
 *     When `zoom === 1`, the viewport is as wide as the image.
 *     When `zoom < 1`, the image is zoomed in.
 *     When `zoom > 1`, the image is zoomed out.
 * @property {number} mediaAspectRatio The image aspect ratio.
 *     When `mediaAspectRatio === 1`, the image width equals its height.
 *     When `mediaAspectRatio < 1`, the image width is less than its height.
 *     When `mediaAspectRatio > 1`, the image height is less than its width.
 */ /**
 * @interface FlatViewCoords
 *
 * The position of a point in a flat image.
 *
 * @property {number} x The horizontal coordinate, in the [0, 1] range.
 * @property {number} y The vertical coordinate, in the [0, 1] range.
 */ /**
 * @typedef {function} FlatViewLimiter
 *
 * View limiter for a {@link FlatView}.
 *
 * A view limiter is a function that receives a {@link FlatViewParams} object,
 * optionally modifies it in place, and returns it. It can be used to enforce
 * constraints on the view parameters.
 *
 * See {@link FlatView.limit} for commonly used limiters. They may be composed
 * together or with user-defined limiters with {@link util.compose}.
 *
 * @param {FlatViewParams} params
 * @return {FlatViewParams}
 */ /**
 * @class FlatView
 * @implements View
 * @classdesc
 *
 * A {@link View} implementing an orthogonal projection for flat images.
 *
 * @param {FlatViewParams} params The initial view parameters. The
 *     `mediaAspectRatio` parameter must always be set. The other parameters
 *     default to `{x: 0.5, y: 0.5, z: 1 }` if unspecified.
 * @param {FlatViewLimiter=} limiter The view limiter. If unspecified, no view
 *     limiting is applied. See {@link FlatView.limit} for commonly used
 *     limiters.
 */ function $6c5cc58465138606$var$FlatView(params, limiter) {
    // Require an aspect ratio to be specified.
    if (!(params && params.mediaAspectRatio != null)) throw new Error("mediaAspectRatio must be defined");
    // The initial values for the view parameters.
    this._x = params && params.x != null ? params.x : $6c5cc58465138606$var$defaultX;
    this._y = params && params.y != null ? params.y : $6c5cc58465138606$var$defaultY;
    this._zoom = params && params.zoom != null ? params.zoom : $6c5cc58465138606$var$defaultZoom;
    this._mediaAspectRatio = params.mediaAspectRatio;
    this._width = params && params.width != null ? params.width : $6c5cc58465138606$var$defaultWidth;
    this._height = params && params.height != null ? params.height : $6c5cc58465138606$var$defaultHeight;
    // The initial value for the view limiter.
    this._limiter = limiter || null;
    // The last calculated projection matrix and its inverse.
    this._projMatrix = $6c5cc58465138606$require$mat4.create();
    this._invProjMatrix = $6c5cc58465138606$require$mat4.create();
    // The last calculated view frustum.
    this._frustum = [
        0,
        0,
        0,
        0 // left
    ];
    // Whether the projection matrices and view frustum need to be updated.
    this._projectionChanged = true;
    // Temporary variables used for calculations.
    this._params = {};
    this._vec = $6c5cc58465138606$require$vec4.create();
    // Force view limiting on initial parameters.
    this._update();
}
$6mia6($6c5cc58465138606$var$FlatView);
/**
 * Destructor.
 */ $6c5cc58465138606$var$FlatView.prototype.destroy = function() {
    $2Xxut(this);
};
/**
 * Get the x parameter.
 * @return {number}
 */ $6c5cc58465138606$var$FlatView.prototype.x = function() {
    return this._x;
};
/**
 * Get the y parameter.
 * @return {number}
 */ $6c5cc58465138606$var$FlatView.prototype.y = function() {
    return this._y;
};
/**
 * Get the zoom value.
 * @return {number}
 */ $6c5cc58465138606$var$FlatView.prototype.zoom = function() {
    return this._zoom;
};
/**
 * Get the media aspect ratio.
 * @return {number}
 */ $6c5cc58465138606$var$FlatView.prototype.mediaAspectRatio = function() {
    return this._mediaAspectRatio;
};
/**
 * Get the viewport width.
 * @return {number}
 */ $6c5cc58465138606$var$FlatView.prototype.width = function() {
    return this._width;
};
/**
 * Get the viewport height.
 * @return {number}
 */ $6c5cc58465138606$var$FlatView.prototype.height = function() {
    return this._height;
};
/**
 * Get the viewport dimensions. If an argument is supplied, it is filled in with
 * the result and returned. Otherwise, a fresh object is filled in and returned.
 * @param {Size=} size
 * @return {Size}
 */ $6c5cc58465138606$var$FlatView.prototype.size = function(size) {
    size = size || {};
    size.width = this._width;
    size.height = this._height;
    return size;
};
/**
 * Get the view parameters. If an argument is supplied, it is filled in with the
 * result and returned. Otherwise, a fresh object is filled in and returned.
 * @param {FlatViewParams=} params
 * @return {FlatViewParams}
 */ $6c5cc58465138606$var$FlatView.prototype.parameters = function(params) {
    params = params || {};
    params.x = this._x;
    params.y = this._y;
    params.zoom = this._zoom;
    params.mediaAspectRatio = this._mediaAspectRatio;
    return params;
};
/**
 * Get the view limiter, or null if unset.
 * @return {?FlatViewLimiter}
 */ $6c5cc58465138606$var$FlatView.prototype.limiter = function() {
    return this._limiter;
};
/**
 * Set the x parameter.
 * @param {number} x
 */ $6c5cc58465138606$var$FlatView.prototype.setX = function(x) {
    this._resetParams();
    this._params.x = x;
    this._update(this._params);
};
/**
 * Set the y parameter.
 * @param {number} y
 */ $6c5cc58465138606$var$FlatView.prototype.setY = function(y) {
    this._resetParams();
    this._params.y = y;
    this._update(this._params);
};
/**
 * Set the zoom value.
 * @param {number} zoom
 */ $6c5cc58465138606$var$FlatView.prototype.setZoom = function(zoom) {
    this._resetParams();
    this._params.zoom = zoom;
    this._update(this._params);
};
/**
 * Add xOffset to the x parameter.
 * @param {number} xOffset
 */ $6c5cc58465138606$var$FlatView.prototype.offsetX = function(xOffset) {
    this.setX(this._x + xOffset);
};
/**
 * Add yOffset to the y parameter.
 * @param {number} yOffset
 */ $6c5cc58465138606$var$FlatView.prototype.offsetY = function(yOffset) {
    this.setY(this._y + yOffset);
};
/**
 * Add zoomOffset to the zoom value.
 * @param {number} zoomOffset
 */ $6c5cc58465138606$var$FlatView.prototype.offsetZoom = function(zoomOffset) {
    this.setZoom(this._zoom + zoomOffset);
};
/**
 * Set the media aspect ratio.
 * @param {number} mediaAspectRatio
 */ $6c5cc58465138606$var$FlatView.prototype.setMediaAspectRatio = function(mediaAspectRatio) {
    this._resetParams();
    this._params.mediaAspectRatio = mediaAspectRatio;
    this._update(this._params);
};
/**
 * Set the viewport dimensions.
 * @param {Size} size
 */ $6c5cc58465138606$var$FlatView.prototype.setSize = function(size) {
    this._resetParams();
    this._params.width = size.width;
    this._params.height = size.height;
    this._update(this._params);
};
/**
 * Set the view parameters. Unspecified parameters are left unchanged.
 * @param {FlatViewParameters} params
 */ $6c5cc58465138606$var$FlatView.prototype.setParameters = function(params) {
    this._resetParams();
    this._params.x = params.x;
    this._params.y = params.y;
    this._params.zoom = params.zoom;
    this._params.mediaAspectRatio = params.mediaAspectRatio;
    this._update(this._params);
};
/**
 * Set the view limiter.
 * @param {?FlatViewLimiter} limiter The new limiter, or null to unset.
 */ $6c5cc58465138606$var$FlatView.prototype.setLimiter = function(limiter) {
    this._limiter = limiter || null;
    this._update();
};
$6c5cc58465138606$var$FlatView.prototype._resetParams = function() {
    var params = this._params;
    params.x = null;
    params.y = null;
    params.zoom = null;
    params.mediaAspectRatio = null;
    params.width = null;
    params.height = null;
};
$6c5cc58465138606$var$FlatView.prototype._update = function(params) {
    // Avoid object allocation when no parameters are supplied.
    if (params == null) {
        this._resetParams();
        params = this._params;
    }
    // Save old parameters for later comparison.
    var oldX = this._x;
    var oldY = this._y;
    var oldZoom = this._zoom;
    var oldMediaAspectRatio = this._mediaAspectRatio;
    var oldWidth = this._width;
    var oldHeight = this._height;
    // Fill in object with the new set of parameters to pass into the limiter.
    params.x = params.x != null ? params.x : oldX;
    params.y = params.y != null ? params.y : oldY;
    params.zoom = params.zoom != null ? params.zoom : oldZoom;
    params.mediaAspectRatio = params.mediaAspectRatio != null ? params.mediaAspectRatio : oldMediaAspectRatio;
    params.width = params.width != null ? params.width : oldWidth;
    params.height = params.height != null ? params.height : oldHeight;
    // Apply view limiting when defined.
    if (this._limiter) {
        params = this._limiter(params);
        if (!params) throw new Error("Bad view limiter");
    }
    // Grab the limited parameters.
    var newX = params.x;
    var newY = params.y;
    var newZoom = params.zoom;
    var newMediaAspectRatio = params.mediaAspectRatio;
    var newWidth = params.width;
    var newHeight = params.height;
    // Consistency check.
    if (!$0OTzd(newX) || !$0OTzd(newY) || !$0OTzd(newZoom) || !$0OTzd(newMediaAspectRatio) || !$0OTzd(newWidth) || !$0OTzd(newHeight)) throw new Error("Bad view - suspect a broken limiter");
    // Constrain zoom.
    newZoom = $eCQUD(newZoom, $6c5cc58465138606$var$zoomLimitEpsilon, Infinity);
    // Update parameters.
    this._x = newX;
    this._y = newY;
    this._zoom = newZoom;
    this._mediaAspectRatio = newMediaAspectRatio;
    this._width = newWidth;
    this._height = newHeight;
    // Check whether the parameters changed and emit the corresponding events.
    if (newX !== oldX || newY !== oldY || newZoom !== oldZoom || newMediaAspectRatio !== oldMediaAspectRatio || newWidth !== oldWidth || newHeight !== oldHeight) {
        this._projectionChanged = true;
        this.emit("change");
    }
    if (newWidth !== oldWidth || newHeight !== oldHeight) this.emit("resize");
};
$6c5cc58465138606$var$FlatView.prototype._zoomX = function() {
    return this._zoom;
};
$6c5cc58465138606$var$FlatView.prototype._zoomY = function() {
    var mediaAspectRatio = this._mediaAspectRatio;
    var aspect = this._width / this._height;
    var zoomX = this._zoom;
    var zoomY = zoomX * mediaAspectRatio / aspect;
    if (isNaN(zoomY)) zoomY = zoomX;
    return zoomY;
};
$6c5cc58465138606$var$FlatView.prototype.updateWithControlParameters = function(parameters) {
    var scale = this.zoom();
    var zoomX = this._zoomX();
    var zoomY = this._zoomY();
    // TODO: should the scale be the same for both axes?
    this.offsetX(parameters.axisScaledX * zoomX + parameters.x * scale);
    this.offsetY(parameters.axisScaledY * zoomY + parameters.y * scale);
    this.offsetZoom(parameters.zoom * scale);
};
$6c5cc58465138606$var$FlatView.prototype._updateProjection = function() {
    var projMatrix = this._projMatrix;
    var invProjMatrix = this._invProjMatrix;
    var frustum = this._frustum;
    // Recalculate projection matrix when required.
    if (this._projectionChanged) {
        var x = this._x;
        var y = this._y;
        var zoomX = this._zoomX();
        var zoomY = this._zoomY();
        // Recalculate view frustum.
        var top = frustum[0] = 0.5 - y + 0.5 * zoomY;
        var right = frustum[1] = x - 0.5 + 0.5 * zoomX;
        var bottom = frustum[2] = 0.5 - y - 0.5 * zoomY;
        var left = frustum[3] = x - 0.5 - 0.5 * zoomX;
        // Recalculate projection matrix and its inverse.
        $6c5cc58465138606$require$mat4.ortho(projMatrix, left, right, bottom, top, -1, 1);
        $6c5cc58465138606$require$mat4.invert(invProjMatrix, projMatrix);
        this._projectionChanged = false;
    }
};
/**
 * Returns the projection matrix for the current view.
 * @returns {mat4}
 */ $6c5cc58465138606$var$FlatView.prototype.projection = function() {
    this._updateProjection();
    return this._projMatrix;
};
/**
 * Returns the inverse projection matrix for the current view.
 * @returns {mat4}
 */ $6c5cc58465138606$var$FlatView.prototype.inverseProjection = function() {
    this._updateProjection();
    return this._invProjMatrix;
};
/**
 * Return whether the view frustum intersects the given rectangle.
 *
 * This function may return false positives, but never false negatives.
 * It is used for frustum culling, i.e., excluding invisible tiles from the
 * rendering process.
 *
 * @param {vec3[]} rectangle The vertices of the rectangle.
 */ $6c5cc58465138606$var$FlatView.prototype.intersects = function(rectangle) {
    this._updateProjection();
    var frustum = this._frustum;
    // Check whether the rectangle is on the outer side of any of the frustum
    // planes. This is a sufficient condition, though not necessary, for the
    // rectangle to be completely outside the fruouter
    for(var i = 0; i < frustum.length; i++){
        var limit = frustum[i];
        var axis = $6c5cc58465138606$var$planeAxes[i];
        var cmp = $6c5cc58465138606$var$planeCmp[i];
        var inside = false;
        for(var j = 0; j < rectangle.length; j++){
            var vertex = rectangle[j];
            if (cmp < 0 && vertex[axis] < limit || cmp > 0 && vertex[axis] > limit) {
                inside = true;
                break;
            }
        }
        if (!inside) return false;
    }
    return true;
};
/**
 * Select the level that should be used to render the view.
 * @param {Level[]} levelList the list of levels from which to select.
 * @return {Level} the selected level.
 */ $6c5cc58465138606$var$FlatView.prototype.selectLevel = function(levels) {
    // Multiply the viewport width by the device pixel ratio to get the required
    // horizontal resolution in pixels.
    //
    // Calculate the fraction of the image that would be visible at the current
    // zoom value. Then, for each level, multiply by the level width to get the
    // width in pixels of the portion that would be visible.
    //
    // Search for the smallest level that satifies the the required width,
    // falling back on the largest level if none do.
    var requiredPixels = $lNra6() * this.width();
    var zoomFactor = this._zoom;
    for(var i = 0; i < levels.length; i++){
        var level = levels[i];
        if (zoomFactor * level.width() >= requiredPixels) return level;
    }
    return levels[levels.length - 1];
};
/**
 * Convert view coordinates into screen coordinates. If a result argument is
 * provided, it is filled in and returned. Otherwise, a fresh object is filled
 * in and returned.
 *
 * @param {FlatViewCoords} coords The view coordinates.
 * @param {Coords=} result The result argument for the screen coordinates.
 * @return {Coords}
 */ $6c5cc58465138606$var$FlatView.prototype.coordinatesToScreen = function(coords, result) {
    var ray = this._vec;
    if (!result) result = {};
    var width = this._width;
    var height = this._height;
    // Undefined on a null viewport.
    if (width <= 0 || height <= 0) {
        result.x = null;
        result.y = null;
        return null;
    }
    // Extract coordinates from argument, filling in default values.
    var x = coords && coords.x != null ? coords.x : $6c5cc58465138606$var$defaultX;
    var y = coords && coords.y != null ? coords.y : $6c5cc58465138606$var$defaultY;
    // Project view ray onto clip space.
    $6c5cc58465138606$require$vec4.set(ray, x - 0.5, 0.5 - y, -1, 1);
    $6c5cc58465138606$require$vec4.transformMat4(ray, ray, this.projection());
    // Calculate perspective divide.
    for(var i = 0; i < 3; i++)ray[i] /= ray[3];
    // Convert to viewport coordinates and return.
    result.x = width * (ray[0] + 1) / 2;
    result.y = height * (1 - ray[1]) / 2;
    return result;
};
/**
 * Convert screen coordinates into view coordinates. If a result argument is
 * provided, it is filled in with the result and returned. Otherwise, a fresh
 * object is filled in and returned.
 *
 * @param {Coords} coords The screen coordinates.
 * @param {FlatViewCoords=} result The result argument for the view coordinates.
 * @return {FlatViewCoords}
 */ $6c5cc58465138606$var$FlatView.prototype.screenToCoordinates = function(coords, result) {
    var ray = this._vec;
    if (!result) result = {};
    var width = this._width;
    var height = this._height;
    // Convert viewport coordinates to clip space.
    var vecx = 2 * coords.x / width - 1;
    var vecy = 1 - 2 * coords.y / height;
    $6c5cc58465138606$require$vec4.set(ray, vecx, vecy, 1, 1);
    // Project back to world space.
    $6c5cc58465138606$require$vec4.transformMat4(ray, ray, this.inverseProjection());
    // Convert to flat coordinates.
    result.x = 0.5 + ray[0];
    result.y = 0.5 - ray[1];
    return result;
};
/**
 * Factory functions for view limiters. See {@link FlatViewLimiter}.
 * @namespace
 */ $6c5cc58465138606$var$FlatView.limit = {
    /**
   * Returns a view limiter that constrains the x parameter.
   * @param {number} min The minimum x value.
   * @param {number} max The maximum y value.
   * @return {FlatViewLimiter}
   */ x: function(min, max) {
        return function limitX(params) {
            params.x = $eCQUD(params.x, min, max);
            return params;
        };
    },
    /**
   * Return a view limiter that constrains the y parameter.
   * @param {number} min The minimum y value.
   * @param {number} max The maximum y value.
   * @return {FlatViewLimiter}
   */ y: function(min, max) {
        return function limitY(params) {
            params.y = $eCQUD(params.y, min, max);
            return params;
        };
    },
    /**
   * Returns a view limiter than constrains the zoom parameter.
   * @param {number} min The minimum zoom value.
   * @param {number} max The maximum zoom value.
   * @return {FlatViewLimiter}
   */ zoom: function(min, max) {
        return function limitZoom(params) {
            params.zoom = $eCQUD(params.zoom, min, max);
            return params;
        };
    },
    /**
   * Returns a view limiter that prevents zooming in beyond the given
   * resolution.
   * @param {number} size The image width in pixels.
   * @return {FlatViewLimiter}
   */ resolution: function(size) {
        return function limitResolution(params) {
            if (params.width <= 0 || params.height <= 0) return params;
            var width = params.width;
            var minZoom = $lNra6() * width / size;
            params.zoom = $eCQUD(params.zoom, minZoom, Infinity);
            return params;
        };
    },
    /**
   * Returns a view limiter that constrains the values of the x parameter that
   * are inside the viewport.
   * @param {number} min The minimum x value.
   * @param {number} max The maximum x value.
   * @return {FlatViewLimiter}
   */ visibleX: function(min, max) {
        return function limitVisibleX(params) {
            // Calculate the zoom value that makes the specified range fully visible.
            var maxZoom = max - min;
            // Clamp zoom to the maximum value.
            if (params.zoom > maxZoom) params.zoom = maxZoom;
            // Bound X such that the image is visible up to the range edges.
            var minX = min + 0.5 * params.zoom;
            var maxX = max - 0.5 * params.zoom;
            params.x = $eCQUD(params.x, minX, maxX);
            return params;
        };
    },
    /**
   * Returns a view limiter that constrains the values of the y parameter that
   * are inside the viewport.
   * @param {number} min The minimum y value.
   * @param {number} max The maximum y value.
   * @return {FlatViewLimiter}
   */ visibleY: function(min, max) {
        return function limitVisibleY(params) {
            // Do nothing for a null viewport.
            if (params.width <= 0 || params.height <= 0) return params;
            // Calculate the X to Y conversion factor.
            var viewportAspectRatio = params.width / params.height;
            var factor = viewportAspectRatio / params.mediaAspectRatio;
            // Calculate the zoom value that makes the specified range fully visible.
            var maxZoom = (max - min) * factor;
            // Clamp zoom to the maximum value.
            if (params.zoom > maxZoom) params.zoom = maxZoom;
            // Bound Y such that the image is visible up to the range edges.
            var minY = min + 0.5 * params.zoom / factor;
            var maxY = max - 0.5 * params.zoom / factor;
            params.y = $eCQUD(params.y, minY, maxY);
            return params;
        };
    },
    /**
   * Returns a view limiter that constrains the zoom parameter such that
   * zooming out is prevented beyond the point at which the image is fully
   * visible. Unless the image and the viewport have the same aspect ratio,
   * this will cause bands to appear around the image.
   * @return {FlatViewLimiter}
   */ letterbox: function() {
        return function limitLetterbox(params) {
            if (params.width <= 0 || params.height <= 0) return params;
            var viewportAspectRatio = params.width / params.height;
            var fullWidthZoom = 1.0;
            var fullHeightZoom = viewportAspectRatio / params.mediaAspectRatio;
            // If the image is wider than the viewport, limit the horizontal zoom to
            // the image width.
            if (params.mediaAspectRatio >= viewportAspectRatio) params.zoom = Math.min(params.zoom, fullWidthZoom);
            // If the image is narrower than the viewport, limit the vertical zoom to
            // the image height.
            if (params.mediaAspectRatio <= viewportAspectRatio) params.zoom = Math.min(params.zoom, fullHeightZoom);
            // If the full image width is visible, limit x to the central point.
            // Else, bound x such that image is visible up to the horizontal edges.
            var minX, maxX;
            if (params.zoom > fullWidthZoom) minX = maxX = 0.5;
            else {
                minX = 0.0 + 0.5 * params.zoom / fullWidthZoom;
                maxX = 1.0 - 0.5 * params.zoom / fullWidthZoom;
            }
            // If the full image height is visible, limit y to the central point.
            // Else, bound y such that image is visible up to the vertical edges.
            var minY, maxY;
            if (params.zoom > fullHeightZoom) minY = maxY = 0.5;
            else {
                minY = 0.0 + 0.5 * params.zoom / fullHeightZoom;
                maxY = 1.0 - 0.5 * params.zoom / fullHeightZoom;
            }
            // Clamp x and y into the calculated bounds.
            params.x = $eCQUD(params.x, minX, maxX);
            params.y = $eCQUD(params.y, minY, maxY);
            return params;
        };
    }
};
$6c5cc58465138606$var$FlatView.type = $6c5cc58465138606$var$FlatView.prototype.type = "flat";
module.exports = $6c5cc58465138606$var$FlatView;

});

parcelRegister("3vK5M", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $6mia6 = parcelRequire("6mia6");

var $1Cfry = parcelRequire("1Cfry");

var $aPjjN = parcelRequire("aPjjN");

var $61A4i = parcelRequire("61A4i");

var $7OILR = parcelRequire("7OILR");

var $azWbw = parcelRequire("azWbw");
// Map template properties to their corresponding tile properties.
var $28e805513a7c304b$var$templateProperties = {
    x: "x",
    y: "y",
    z: "z",
    f: "face"
};
// Default face order for cube maps.
var $28e805513a7c304b$var$defaultCubeMapFaceOrder = "bdflru";
// Default maximum number of concurrent requests.
var $28e805513a7c304b$var$defaultConcurrency = 4;
// Default milliseconds to wait before retrying failed requests.
var $28e805513a7c304b$var$defaultRetryDelay = 10000;
/**
 * @class ImageUrlSource
 * @implements Source
 * @classdesc
 *
 * A {@link Source} that loads {@link Asset assets} from images given a URL and
 * a crop rectangle.
 *
 * @param {Function} sourceFromTile Function that receives a tile and returns
 * a `{ url, rect }` object, where `url` is an image URL and `rect`, when
 * present, is an `{ x, y, width, height }` object in normalized coordinates
 * denoting the portion of the image to use.
 * @param {Object} opts
 * @param {number} [opts.concurrency=4] Maximum number of tiles to request at
 *     the same time. The limit is per {@link ImageSourceUrl} instance.
 * @param {number} [opts.retryDelay=10000] Time in milliseconds to wait before
 *     retrying a failed request.
 */ function $28e805513a7c304b$var$ImageUrlSource(sourceFromTile, opts) {
    opts = opts ? opts : {};
    this._loadPool = new $aPjjN({
        concurrency: opts.concurrency || $28e805513a7c304b$var$defaultConcurrency
    });
    this._retryDelay = opts.retryDelay || $28e805513a7c304b$var$defaultRetryDelay;
    this._retryMap = {};
    this._sourceFromTile = sourceFromTile;
}
$6mia6($28e805513a7c304b$var$ImageUrlSource);
$28e805513a7c304b$var$ImageUrlSource.prototype.loadAsset = function(stage, tile, done) {
    var self = this;
    var retryDelay = this._retryDelay;
    var retryMap = this._retryMap;
    var tileSource = this._sourceFromTile(tile);
    var url = tileSource.url;
    var rect = tileSource.rect;
    var loadImage = stage.loadImage.bind(stage, url, rect);
    var loadFn = function(done) {
        // TODO: Deduplicate load requests for the same URL. Although the browser
        // might be smart enough to avoid duplicate requests, they are still unduly
        // impacted by the concurrency parameter.
        return self._loadPool.push(loadImage, function(err, asset) {
            if (err) {
                if (err instanceof $1Cfry) {
                    // If a network error occurred, wait before retrying.
                    retryMap[url] = $azWbw();
                    self.emit("networkError", asset, err);
                }
                done(err, tile);
            } else {
                // On a successful fetch, forget the previous timeout.
                delete retryMap[url];
                done(null, tile, asset);
            }
        });
    };
    // Check whether we are retrying a failed request.
    var delayAmount;
    var lastTime = retryMap[url];
    if (lastTime != null) {
        var currentTime = $azWbw();
        var elapsed = currentTime - lastTime;
        if (elapsed < retryDelay) // Wait before retrying.
        delayAmount = retryDelay - elapsed;
        else {
            // Retry timeout expired; perform the request at once.
            delayAmount = 0;
            delete retryMap[url];
        }
    }
    var delayFn = $7OILR.bind(null, delayAmount);
    return $61A4i(delayFn, loadFn)(done);
};
/**
 * Creates an ImageUrlSource from a string template.
 *
 * @param {String} url Tile URL template, which may contain the following
 *    placeholders:
 *    - `{f}` : tile face (one of `b`, `d`, `f`, `l`, `r`, `u`)
 *    - `{z}` : tile level index (0 is the smallest level)
 *    - `{x}` : tile horizontal index
 *    - `{y}` : tile vertical index
 * @param {Object} opts In addition to the options already supported by the
 *     {@link ImageUrlSource} constructor.
 * @param {String} opts.cubeMapPreviewUrl URL to use as the preview level.
 *     This must be a single image containing six cube faces laid out
 *     vertically according to the face order parameter.
 * @param {String} [opts.cubeMapPreviewFaceOrder='bdflru'] Face order within
 *     the preview image.
 */ $28e805513a7c304b$var$ImageUrlSource.fromString = function(url, opts) {
    opts = opts || {};
    var faceOrder = opts && opts.cubeMapPreviewFaceOrder || $28e805513a7c304b$var$defaultCubeMapFaceOrder;
    var urlFn = opts.cubeMapPreviewUrl ? withPreview : withoutPreview;
    return new $28e805513a7c304b$var$ImageUrlSource(urlFn, opts);
    function withoutPreview(tile) {
        var tileUrl = url;
        for(var property in $28e805513a7c304b$var$templateProperties){
            var templateProperty = $28e805513a7c304b$var$templateProperties[property];
            var regExp = $28e805513a7c304b$var$propertyRegExp(property);
            var valueFromTile = tile.hasOwnProperty(templateProperty) ? tile[templateProperty] : "";
            tileUrl = tileUrl.replace(regExp, valueFromTile);
        }
        return {
            url: tileUrl
        };
    }
    function withPreview(tile) {
        if (tile.z === 0) return cubeMapUrl(tile);
        else return withoutPreview(tile);
    }
    function cubeMapUrl(tile) {
        var y = faceOrder.indexOf(tile.face) / 6;
        return {
            url: opts.cubeMapPreviewUrl,
            rect: {
                x: 0,
                y: y,
                width: 1,
                height: 1 / 6
            }
        };
    }
};
function $28e805513a7c304b$var$propertyRegExp(property) {
    var regExpStr = "\\{(" + property + ")\\}";
    return new RegExp(regExpStr, "g");
}
module.exports = $28e805513a7c304b$var$ImageUrlSource;

});
parcelRegister("aPjjN", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $hluEj = parcelRequire("hluEj");

var $iZgBB = parcelRequire("iZgBB");
function $7e1da70263e469ef$var$WorkPool(opts) {
    this._concurrency = opts && opts.concurrency || 1;
    this._paused = opts && !!opts.paused || false;
    this._pool = [];
    for(var i = 0; i < this._concurrency; i++)this._pool.push(new $hluEj(opts));
    this._next = 0;
}
$7e1da70263e469ef$var$WorkPool.prototype.length = function() {
    var len = 0;
    for(var i = 0; i < this._pool.length; i++)len += this._pool[i].length();
    return len;
};
$7e1da70263e469ef$var$WorkPool.prototype.push = function(fn, cb) {
    var i = this._next;
    var cancel = this._pool[i].push(fn, cb);
    this._next = $iZgBB(this._next + 1, this._concurrency);
    return cancel;
};
$7e1da70263e469ef$var$WorkPool.prototype.pause = function() {
    if (!this._paused) {
        this._paused = true;
        for(var i = 0; i < this._concurrency; i++)this._pool[i].pause();
    }
};
$7e1da70263e469ef$var$WorkPool.prototype.resume = function() {
    if (this._paused) {
        this._paused = false;
        for(var i = 0; i < this._concurrency; i++)this._pool[i].resume();
    }
};
module.exports = $7e1da70263e469ef$var$WorkPool;

});

parcelRegister("61A4i", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $exIfG = parcelRequire("exIfG");
// Return a function that executes its arguments (which should be cancelables)
// in sequence, so that each of them passes its return values to the next.
// Execution is aborted if one of the functions returns an error; in that case
// the last function in the sequence is called with the error.
// See util/cancelize.js for an explanation of what cancelables are.
function $462ed0808f68dc36$var$chain() {
    // The list of functions to chain together.
    var argList = Array.prototype.slice.call(arguments, 0);
    return function chained() {
        // List of remaining functions to be executed.
        // Make a copy of the original list so we can mutate the former while
        // preserving the latter intact for future invocations of the chain.
        var fnList = argList.slice(0);
        // Currently executing function.
        var fn = null;
        // Cancel method for the currently executing function.
        var cfn = null;
        // Arguments for the first function.
        var args = arguments.length ? Array.prototype.slice.call(arguments, 0, arguments.length - 1) : [];
        // Callback for the chain.
        var done = arguments.length ? arguments[arguments.length - 1] : $exIfG;
        // Execute the next function in the chain.
        // Receives the error and return values from the previous function.
        function exec() {
            // Extract error from arguments.
            var err = arguments[0];
            // Abort chain on error.
            if (err) {
                fn = cfn = null;
                done.apply(null, arguments);
                return;
            }
            // Terminate if there are no functions left in the chain.
            if (!fnList.length) {
                fn = cfn = null;
                done.apply(null, arguments);
                return;
            }
            // Advance to the next function in the chain.
            fn = fnList.shift();
            var _fn = fn;
            // Extract arguments to pass into the next function.
            var ret = Array.prototype.slice.call(arguments, 1);
            // Call next function with previous return value and call back exec.
            ret.push(exec);
            var _cfn = fn.apply(null, ret); // fn(null, ret..., exec)
            // Detect when fn has completed synchronously and do not clobber the
            // internal state in that case. You're not expected to understand this.
            if (_fn !== fn) return;
            // Remember the cancel method for the currently executing function.
            // Detect chaining on non-cancellable function.
            if (typeof _cfn !== "function") throw new Error("chain: chaining on non-cancellable function");
            else cfn = _cfn;
        }
        // Cancel chain execution.
        function cancel() {
            if (cfn) cfn.apply(null, arguments);
        }
        // Start chain execution.
        // We call exec as if linking from a previous function in the chain,
        // except that the error is always null. As a consequence, chaining on an
        // empty list yields the identity function.
        args.unshift(null);
        exec.apply(null, args); // exec(null, args...)
        return cancel;
    };
}
module.exports = $462ed0808f68dc36$var$chain;

});
parcelRegister("exIfG", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
function $a9667944b3fbadf4$var$noop() {}
module.exports = $a9667944b3fbadf4$var$noop;

});


parcelRegister("7OILR", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
// Perform a cancelable delay.
// See util/cancelize.js for an explanation of what cancelables are.
function $5b0fee843f2ef954$var$delay(ms, done) {
    // Work around IE8 bug whereby a setTimeout callback may still be called
    // after the corresponding clearTimeout is invoked.
    var timer = null;
    function finish() {
        if (timer != null) {
            timer = null;
            done(null);
        }
    }
    function cancel() {
        if (timer != null) {
            clearTimeout(timer);
            timer = null;
            done.apply(null, arguments);
        }
    }
    timer = setTimeout(finish, ms);
    return cancel;
}
module.exports = $5b0fee843f2ef954$var$delay;

});


parcelRegister("lEiVO", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
/**
 * @class SingleAssetSource
 * @implements Source
 * @classdesc
 *
 * A {@link Source} that always provides the same {@link Asset}.
 *
 * @param {Asset} asset The asset.
*/ function $041139e224bfcfad$var$SingleAssetSource(asset) {
    this._asset = asset;
}
$041139e224bfcfad$var$SingleAssetSource.prototype.asset = function() {
    return this._asset;
};
$041139e224bfcfad$var$SingleAssetSource.prototype.loadAsset = function(stage, tile, done) {
    var self = this;
    var timeout = setTimeout(function() {
        done(null, tile, self._asset);
    }, 0);
    function cancel() {
        clearTimeout(timeout);
        done.apply(null, arguments);
    }
    return cancel;
};
module.exports = $041139e224bfcfad$var$SingleAssetSource;

});

parcelRegister("iB2Tl", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $4Qk7S = parcelRequire("4Qk7S");

var $Yar88 = parcelRequire("Yar88");

var $6mia6 = parcelRequire("6mia6");

var $2Xxut = parcelRequire("2Xxut");
/**
 * @class DynamicAsset
 * @implements Asset
 * @extends StaticAsset
 * @classdesc
 *
 * A mutable {@link Asset} compatible with {@link WebGlStage} and
 * {@link CssStage}.
 *
 * @param {HTMLImageElement|HTMLCanvasElement|ImageBitmap} element The
 *     underlying pixel source.
 * @throws If the pixel source is unsupported.
 */ function $d89decebabfcc15e$var$DynamicAsset(element) {
    this.constructor.super_.call(this, element);
    this._timestamp = 0;
}
$Yar88($d89decebabfcc15e$var$DynamicAsset, $4Qk7S);
$6mia6($d89decebabfcc15e$var$DynamicAsset);
/**
 * Destructor.
 */ $d89decebabfcc15e$var$DynamicAsset.prototype.destroy = function() {
    $2Xxut(this);
};
$d89decebabfcc15e$var$DynamicAsset.prototype.timestamp = function() {
    return this._timestamp;
};
$d89decebabfcc15e$var$DynamicAsset.prototype.isDynamic = function() {
    return true;
};
/**
 * Marks the asset dirty, signaling that the contents of the underlying pixel
 * source have changed.
 *
 * @throws If the asset is not dynamic.
 */ $d89decebabfcc15e$var$DynamicAsset.prototype.markDirty = function() {
    this._timestamp++;
    this.emit("change");
};
module.exports = $d89decebabfcc15e$var$DynamicAsset;

});

parcelRegister("8U6hQ", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $jOYf3 = parcelRequire("jOYf3");

var $fio2g = parcelRequire("fio2g");

var $eyQFW = parcelRequire("eyQFW");

var $6mia6 = parcelRequire("6mia6");

var $9eJDl = parcelRequire("9eJDl");

var $2uuGq = parcelRequire("2uuGq");

var $61A4i = parcelRequire("61A4i");

var $Yar88 = parcelRequire("Yar88");

var $2Xxut = parcelRequire("2Xxut");
var $67b86e256734db6e$var$debug = typeof MARZIPANODEBUG !== "undefined" && MARZIPANODEBUG.textureStore;
// A Stage informs the TextureStore about the set of visible tiles during a
// frame by calling startFrame, markTile and endFrame. In a particular frame,
// TextureStore expects one or more calls to startFrame, followed by zero or
// more calls to markTile, followed by one or more calls to endFrame. The
// number of calls to startFrame and endFrame must match. Calls to other
// TextureStore methods may be freely interleaved with this sequence.
//
// At any given time, TextureStore is in one of four states. The START state
// corresponds to the interval between the first startFrame and the first
// markTile of a frame. The MARK state corresponds to the interval between the
// first markTile and the first endFrame. The END state corresponds to the
// interval between the first and the last endFrame. At any other time, the
// TextureStore is in the IDLE state.
var $67b86e256734db6e$var$State = {
    IDLE: 0,
    START: 1,
    MARK: 2,
    END: 3
};
var $67b86e256734db6e$var$defaultOptions = {
    // Maximum number of cached textures for previously visible tiles.
    previouslyVisibleCacheSize: 512
};
// Assign an id to each operation so we can track its state.
// We actually only need this in debug mode, but the code is less convoluted
// if we track unconditionally, and the performance hit is minimal anyway.
var $67b86e256734db6e$var$nextId = 0;
// Distinguishes a cancellation from other kinds of errors.
function $67b86e256734db6e$var$CancelError() {}
$Yar88($67b86e256734db6e$var$CancelError, Error);
/**
 * @class TextureStoreItem
 * @classdesc
 *
 * An item saved in a {@link TextureStore}.
 *
 * Clients do not need to instantiate this. It is automatically instantiated by
 * a {@link TextureStore} to manage the lifetime of a stored item: loading,
 * refreshing, unloading and emitting associated events.
 *
 * @param {TextureStore} store The underlying {@link TextureStore}.
 * @param {Tile} tile The underlying tile.
 */ function $67b86e256734db6e$var$TextureStoreItem(store, tile) {
    var self = this;
    var id = $67b86e256734db6e$var$nextId++;
    self._id = id;
    self._store = store;
    self._tile = tile;
    self._asset = null;
    self._texture = null;
    self._changeHandler = function() {
        store.emit("textureInvalid", tile);
    };
    var source = store.source();
    var stage = store.stage();
    var loadAsset = source.loadAsset.bind(source);
    var createTexture = stage.createTexture.bind(stage);
    // Retry loading the asset until it succeeds, then create the texture from it.
    // This process may be canceled at any point by calling the destroy() method.
    var fn = $61A4i($2uuGq(loadAsset), createTexture);
    store.emit("textureStartLoad", tile);
    if ($67b86e256734db6e$var$debug) console.log("loading", id, tile);
    self._cancel = fn(stage, tile, function(err, _tile, asset, texture) {
        // Make sure we do not call cancel after the operation is complete.
        self._cancel = null;
        if (err) {
            // The loading process was interrupted by an error.
            // This could either be because the texture creation failed, or because
            // the operation was canceled before the loading was complete.
            // Destroy the asset and texture, if they exist.
            if (asset) asset.destroy();
            if (texture) texture.destroy();
            // Emit events.
            if (err instanceof $67b86e256734db6e$var$CancelError) {
                store.emit("textureCancel", tile);
                if ($67b86e256734db6e$var$debug) console.log("cancel", id, tile);
            } else {
                store.emit("textureError", tile, err);
                if ($67b86e256734db6e$var$debug) console.log("error", id, tile);
            }
            return;
        }
        // Save a local reference to the texture.
        self._texture = texture;
        // If the asset is dynamic, save a local reference to it and set up a
        // handler to be called whenever it changes. Otherwise, destroy the asset
        // as we won't be needing it any longer.
        if (asset.isDynamic()) {
            self._asset = asset;
            asset.addEventListener("change", self._changeHandler);
        } else asset.destroy();
        // Emit event.
        store.emit("textureLoad", tile);
        if ($67b86e256734db6e$var$debug) console.log("load", id, tile);
    });
}
$67b86e256734db6e$var$TextureStoreItem.prototype.asset = function() {
    return this._asset;
};
$67b86e256734db6e$var$TextureStoreItem.prototype.texture = function() {
    return this._texture;
};
$67b86e256734db6e$var$TextureStoreItem.prototype.destroy = function() {
    var id = this._id;
    var store = this._store;
    var tile = this._tile;
    var asset = this._asset;
    var texture = this._texture;
    var cancel = this._cancel;
    if (cancel) {
        // The texture is still loading, so cancel it.
        cancel(new $67b86e256734db6e$var$CancelError("Texture load cancelled"));
        return;
    }
    // Destroy asset.
    if (asset) {
        asset.removeEventListener("change", this._changeHandler);
        asset.destroy();
    }
    // Destroy texture.
    if (texture) texture.destroy();
    // Emit event.
    store.emit("textureUnload", tile);
    if ($67b86e256734db6e$var$debug) console.log("unload", id, tile);
    $2Xxut(this);
};
$6mia6($67b86e256734db6e$var$TextureStoreItem);
/**
 * Signals that a texture has started to load.
 *
 * This event is followed by either {@link TextureStore#textureLoad},
 * {@link TextureStore#textureError} or {@link TextureStore#textureCancel}.
 *
 * @event TextureStore#textureStartLoad
 * @param {Tile} tile The tile for which the texture has started to load.
 */ /**
 * Signals that a texture has been loaded.
 *
 * @event TextureStore#textureLoad
 * @param {Tile} tile The tile for which the texture was loaded.
 */ /**
 * Signals that a texture has been unloaded.
 *
 * @event TextureStore#textureUnload
 * @param {Tile} tile The tile for which the texture was unloaded.
 */ /**
 * Signals that a texture has been invalidated.
 *
 * This event may be raised for a texture with an underlying dynamic asset. It
 * may only occur while the texture is loaded, i.e., in between
 * {@link TextureStore#textureLoad} and {@link TextureStore#textureUnload}.
 *
 * @event TextureStore#textureInvalid
 * @param {Tile} tile The tile for which the texture was invalidated.
 */ /**
 * Signals that loading a texture has been cancelled.
 *
 * This event may follow {@link TextureStore#textureStartLoad} if the texture
 * becomes unnecessary before it finishes loading.
 *
 * @event TextureStore#textureCancel
 * @param {Tile} tile The tile for which the texture loading was cancelled.
 */ /**
 * Signals that loading a texture has failed.
 *
 * This event may follow {@link TextureStore#textureStartLoad} if the texture
 * fails to load.
 *
 * @event TextureStore#textureError
 * @param {Tile} tile The tile for which the texture loading has failed.
 */ /**
 * @class TextureStore
 * @classdesc
 *
 * A TextureStore maintains a cache of textures used to render a {@link Layer}.
 *
 * A {@link Stage} communicates with the TextureStore through the startFrame(),
 * markTile() and endFrame() methods, which indicate the tiles that are visible
 * in the current frame. Textures for visible tiles are loaded and retained
 * as long as the tiles remain visible. A limited amount of textures whose
 * tiles were previously visible are cached according to an LRU policy. Tiles
 * may be pinned to keep their respective textures cached even when they are
 * invisible; these textures do not count towards the previously visible limit.
 *
 * Multiple layers belonging to the same underlying {@link WebGlStage} may
 * share the same TextureStore. Layers belonging to distinct {@link WebGlStage}
 * instances, or belonging to a {@link CssStage} or a {@link FlashStage},
 * may not do so due to restrictions on the use of textures across stages.
 *
 * @param {Source} source The underlying source.
 * @param {Stage} stage The underlying stage.
 * @param {Object} opts Options.
 * @param {Number} [opts.previouslyVisibleCacheSize=32] The maximum number of
 *     previously visible textures to cache according to an LRU policy.
 */ function $67b86e256734db6e$var$TextureStore(source, stage, opts) {
    opts = $9eJDl(opts || {}, $67b86e256734db6e$var$defaultOptions);
    this._source = source;
    this._stage = stage;
    // The current state.
    this._state = $67b86e256734db6e$var$State.IDLE;
    // The number of startFrame calls yet to be matched by endFrame calls during
    // the current frame.
    this._delimCount = 0;
    // The cache proper: map cached tiles to their respective textures/assets.
    this._itemMap = new $jOYf3();
    // The subset of cached tiles that are currently visible.
    this._visible = new $fio2g();
    // The subset of cached tiles that were visible recently, but are not
    // visible right now. Newly inserted tiles replace older ones.
    this._previouslyVisible = new $eyQFW(opts.previouslyVisibleCacheSize);
    // The subset of cached tiles that should never be evicted from the cache.
    // A tile may be pinned more than once; map each tile into a reference count.
    this._pinMap = new $jOYf3();
    // Temporary variables.
    this._newVisible = new $fio2g();
    this._noLongerVisible = [];
    this._visibleAgain = [];
    this._evicted = [];
}
$6mia6($67b86e256734db6e$var$TextureStore);
/**
 * Destructor.
 */ $67b86e256734db6e$var$TextureStore.prototype.destroy = function() {
    this.clear();
    $2Xxut(this);
};
/**
 * Return the underlying {@link Stage}.
 * @return {Stage}
 */ $67b86e256734db6e$var$TextureStore.prototype.stage = function() {
    return this._stage;
};
/**
 * Return the underlying {@link Source}.
 * @return {Source}
 */ $67b86e256734db6e$var$TextureStore.prototype.source = function() {
    return this._source;
};
/**
 * Remove all textures from the TextureStore, including pinned textures.
 */ $67b86e256734db6e$var$TextureStore.prototype.clear = function() {
    var self = this;
    // Collect list of tiles to be evicted.
    self._evicted.length = 0;
    self._itemMap.forEach(function(tile) {
        self._evicted.push(tile);
    });
    // Evict tiles.
    self._evicted.forEach(function(tile) {
        self._unloadTile(tile);
    });
    // Clear all internal state.
    self._itemMap.clear();
    self._visible.clear();
    self._previouslyVisible.clear();
    self._pinMap.clear();
    self._newVisible.clear();
    self._noLongerVisible.length = 0;
    self._visibleAgain.length = 0;
    self._evicted.length = 0;
};
/**
 * Remove all textures in the TextureStore, excluding unpinned textures.
 */ $67b86e256734db6e$var$TextureStore.prototype.clearNotPinned = function() {
    var self = this;
    // Collect list of tiles to be evicted.
    self._evicted.length = 0;
    self._itemMap.forEach(function(tile) {
        if (!self._pinMap.has(tile)) self._evicted.push(tile);
    });
    // Evict tiles.
    self._evicted.forEach(function(tile) {
        self._unloadTile(tile);
    });
    // Clear all caches except the pinned set.
    self._visible.clear();
    self._previouslyVisible.clear();
    // Clear temporary variables.
    self._evicted.length = 0;
};
/**
 * Signal the beginning of a frame. Called from {@link Stage}.
 */ $67b86e256734db6e$var$TextureStore.prototype.startFrame = function() {
    // Check that we are in an appropriate state.
    if (this._state !== $67b86e256734db6e$var$State.IDLE && this._state !== $67b86e256734db6e$var$State.START) throw new Error("TextureStore: startFrame called out of sequence");
    // Enter the START state, if not already there.
    this._state = $67b86e256734db6e$var$State.START;
    // Expect one more endFrame call.
    this._delimCount++;
};
/**
 * Mark a tile as visible within the current frame. Called from {@link Stage}.
 * @param {Tile} tile The tile to mark.
 */ $67b86e256734db6e$var$TextureStore.prototype.markTile = function(tile) {
    // Check that we are in an appropriate state.
    if (this._state !== $67b86e256734db6e$var$State.START && this._state !== $67b86e256734db6e$var$State.MARK) throw new Error("TextureStore: markTile called out of sequence");
    // Enter the MARK state, if not already there.
    this._state = $67b86e256734db6e$var$State.MARK;
    // Refresh texture for dynamic assets.
    var item = this._itemMap.get(tile);
    var texture = item && item.texture();
    var asset = item && item.asset();
    if (texture && asset) texture.refresh(tile, asset);
    // Add tile to the visible set.
    this._newVisible.add(tile);
};
/**
 * Signal the end of a frame. Called from {@link Stage}.
 */ $67b86e256734db6e$var$TextureStore.prototype.endFrame = function() {
    // Check that we are in an appropriate state.
    if (this._state !== $67b86e256734db6e$var$State.START && this._state !== $67b86e256734db6e$var$State.MARK && this._state !== $67b86e256734db6e$var$State.END) throw new Error("TextureStore: endFrame called out of sequence");
    // Enter the END state, if not already there.
    this._state = $67b86e256734db6e$var$State.END;
    // Expect one less call to endFrame.
    this._delimCount--;
    // If no further calls are expected, process frame and enter the IDLE state.
    if (!this._delimCount) {
        this._update();
        this._state = $67b86e256734db6e$var$State.IDLE;
    }
};
$67b86e256734db6e$var$TextureStore.prototype._update = function() {
    var self = this;
    // Calculate the set of tiles that used to be visible but no longer are.
    self._noLongerVisible.length = 0;
    self._visible.forEach(function(tile) {
        if (!self._newVisible.has(tile)) self._noLongerVisible.push(tile);
    });
    // Calculate the set of tiles that were visible recently and have become
    // visible again.
    self._visibleAgain.length = 0;
    self._newVisible.forEach(function(tile) {
        if (self._previouslyVisible.has(tile)) self._visibleAgain.push(tile);
    });
    // Remove tiles that have become visible again from the list of previously
    // visible tiles.
    self._visibleAgain.forEach(function(tile) {
        self._previouslyVisible.remove(tile);
    });
    // Cancel loading of tiles that are no longer visible.
    // Move no longer visible tiles with a loaded texture into the previously
    // visible set, and collect the tiles evicted from the latter.
    self._evicted.length = 0;
    self._noLongerVisible.forEach(function(tile) {
        var item = self._itemMap.get(tile);
        var texture = item && item.texture();
        if (texture) {
            var otherTile = self._previouslyVisible.add(tile);
            if (otherTile != null) self._evicted.push(otherTile);
        } else if (item) self._unloadTile(tile);
    });
    // Unload evicted tiles, unless they are pinned.
    self._evicted.forEach(function(tile) {
        if (!self._pinMap.has(tile)) self._unloadTile(tile);
    });
    // Load visible tiles that are not already in the store.
    // Refresh texture on visible tiles for dynamic assets.
    self._newVisible.forEach(function(tile) {
        var item = self._itemMap.get(tile);
        if (!item) self._loadTile(tile);
    });
    // Swap the old visible set with the new one.
    var tmp = self._visible;
    self._visible = self._newVisible;
    self._newVisible = tmp;
    // Clear the new visible set.
    self._newVisible.clear();
    // Clear temporary variables.
    self._noLongerVisible.length = 0;
    self._visibleAgain.length = 0;
    self._evicted.length = 0;
};
$67b86e256734db6e$var$TextureStore.prototype._loadTile = function(tile) {
    if (this._itemMap.has(tile)) throw new Error("TextureStore: loading texture already in cache");
    var item = new $67b86e256734db6e$var$TextureStoreItem(this, tile);
    this._itemMap.set(tile, item);
};
$67b86e256734db6e$var$TextureStore.prototype._unloadTile = function(tile) {
    var item = this._itemMap.del(tile);
    if (!item) throw new Error("TextureStore: unloading texture not in cache");
    item.destroy();
};
$67b86e256734db6e$var$TextureStore.prototype.asset = function(tile) {
    var item = this._itemMap.get(tile);
    if (item) return item.asset();
    return null;
};
$67b86e256734db6e$var$TextureStore.prototype.texture = function(tile) {
    var item = this._itemMap.get(tile);
    if (item) return item.texture();
    return null;
};
/**
 * Pin a tile. Textures for pinned tiles are never evicted from the store.
 * Upon pinning, the texture is created if not already present. Pins are
 * reference-counted; a tile may be pinned multiple times and must be unpinned
 * the corresponding number of times. Pinning is useful e.g. to ensure that
 * the lowest-resolution level of an image is always available to fall back
 * onto.
 * @param {Tile} tile the tile to pin
 * @returns {number} the pin reference count.
 */ $67b86e256734db6e$var$TextureStore.prototype.pin = function(tile) {
    // Increment reference count.
    var count = (this._pinMap.get(tile) || 0) + 1;
    this._pinMap.set(tile, count);
    // If the texture for the tile is not present, load it now.
    if (!this._itemMap.has(tile)) this._loadTile(tile);
    return count;
};
/**
 * Unpin a tile. Pins are reference-counted; a tile may be pinned multiple
 * times and must be unpinned the corresponding number of times.
 * @param {Tile} tile the tile to unpin
 * @returns {number} the pin reference count.
 */ $67b86e256734db6e$var$TextureStore.prototype.unpin = function(tile) {
    var count = this._pinMap.get(tile);
    // Consistency check.
    if (!count) throw new Error("TextureStore: unpin when not pinned");
    else {
        // Decrement reference count.
        count--;
        if (count > 0) this._pinMap.set(tile, count);
        else {
            this._pinMap.del(tile);
            // If the tile does not belong to either the visible or previously
            // visible sets, evict it from the cache.
            if (!this._visible.has(tile) && !this._previouslyVisible.has(tile)) this._unloadTile(tile);
        }
    }
    return count;
};
/**
 * Return type for {@link TextureStore#query}.
 * @typedef {Object} TileState
 * @property {boolean} visible Whether the tile is in the visible set.
 * @property {boolean} previouslyVisible Whether the tile is in the previously
 *     visible set.
 * @property {boolean} hasAsset Whether the asset for the tile is present.
 * @property {boolean} hasTexture Whether the texture for the tile is present.
 * @property {boolean} pinned Whether the tile is in the pinned set.
 * @property {number} pinCount The pin reference count for the tile.
 */ /**
 * Return the state of a tile.
 * @param {Tile} tile The tile to query.
 * @return {TileState}
 */ $67b86e256734db6e$var$TextureStore.prototype.query = function(tile) {
    var item = this._itemMap.get(tile);
    var pinCount = this._pinMap.get(tile) || 0;
    return {
        visible: this._visible.has(tile),
        previouslyVisible: this._previouslyVisible.has(tile),
        hasAsset: item != null && item.asset() != null,
        hasTexture: item != null && item.texture() != null,
        pinned: pinCount !== 0,
        pinCount: pinCount
    };
};
module.exports = $67b86e256734db6e$var$TextureStore;

});
parcelRegister("eyQFW", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $iZgBB = parcelRequire("iZgBB");
// An LruSet holds up to a maximum number of elements, ordered by their time of
// insertion. When the addition of an element would cause the capacity to be
// exceeded, the oldest element in the set is evicted. As a special case, an
// LruSet with zero capacity always rejects the insertion of an element.
//
// Elements must implement hash() and equals(). Note that the implementation
// doesn't currently use hash(), but a future version might.
function $a99d19ed639f6ebc$var$LruSet(capacity) {
    if (!isFinite(capacity) || Math.floor(capacity) !== capacity || capacity < 0) throw new Error("LruSet: invalid capacity");
    this._capacity = capacity;
    // Elements are stored in a circular array ordered by decreasing age.
    // Start is the index of the oldest element and size is the number of valid
    // elements; the region containing valid elements may wrap around.
    this._elements = new Array(this._capacity);
    this._start = 0;
    this._size = 0;
}
$a99d19ed639f6ebc$var$LruSet.prototype._index = function(i) {
    return $iZgBB(this._start + i, this._capacity);
};
// Adds an element into the set, possibly replacing an equal element already in
// the set. The element becomes the newest. If the set is at capacity, the
// oldest element is removed. Returns the removed element if it does not equal
// the inserted element, or null otherwise. If the capacity is zero, does
// nothing and returns the element.
$a99d19ed639f6ebc$var$LruSet.prototype.add = function(element) {
    if (this._capacity === 0) return element;
    this.remove(element);
    var evictedElement = this._size === this._capacity ? this._elements[this._index(0)] : null;
    this._elements[this._index(this._size)] = element;
    if (this._size < this._capacity) this._size++;
    else this._start = this._index(1);
    return evictedElement;
};
// Removes an element from the set.
// Returns the removed element, or null if the element was not found.
$a99d19ed639f6ebc$var$LruSet.prototype.remove = function(element) {
    for(var i = 0; i < this._size; i++){
        var existingElement = this._elements[this._index(i)];
        if (element.equals(existingElement)) {
            for(var j = i; j < this._size - 1; j++)this._elements[this._index(j)] = this._elements[this._index(j + 1)];
            this._size--;
            return existingElement;
        }
    }
    return null;
};
// Returns whether an element is in the set.
$a99d19ed639f6ebc$var$LruSet.prototype.has = function(element) {
    for(var i = 0; i < this._size; i++){
        if (element.equals(this._elements[this._index(i)])) return true;
    }
    return false;
};
// Returns the number of elements in the set.
$a99d19ed639f6ebc$var$LruSet.prototype.size = function() {
    return this._size;
};
// Removes all elements from the set.
$a99d19ed639f6ebc$var$LruSet.prototype.clear = function() {
    this._elements.length = 0;
    this._start = 0;
    this._size = 0;
};
// Calls fn(element) for each element in the set, in an unspecified order.
// Returns the number of times fn was called.
// The result is unspecified if the set is mutated during iteration.
$a99d19ed639f6ebc$var$LruSet.prototype.forEach = function(fn) {
    var count = 0;
    for(var i = 0; i < this._size; i++){
        fn(this._elements[this._index(i)]);
        count += 1;
    }
    return count;
};
module.exports = $a99d19ed639f6ebc$var$LruSet;

});

parcelRegister("9eJDl", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
function $6b98d1c1215cc19d$var$defaults(obj, defaultsObj) {
    for(var key in defaultsObj)if (!(key in obj)) obj[key] = defaultsObj[key];
    return obj;
}
module.exports = $6b98d1c1215cc19d$var$defaults;

});

parcelRegister("2uuGq", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $exIfG = parcelRequire("exIfG");
// Return a cancelable function that executes fn in a loop until it returns
// successfully.
function $1d062f298142bf4e$var$retry(fn) {
    return function retried() {
        var args = arguments.length ? Array.prototype.slice.call(arguments, 0, arguments.length - 1) : [];
        var done = arguments.length ? arguments[arguments.length - 1] : $exIfG;
        var cfn = null;
        var canceled = false;
        function exec() {
            var err = arguments[0];
            if (!err || canceled) done.apply(null, arguments);
            else cfn = fn.apply(null, args);
        }
        args.push(exec);
        exec(true);
        return function cancel() {
            canceled = true;
            cfn.apply(null, arguments);
        };
    };
}
module.exports = $1d062f298142bf4e$var$retry;

});


parcelRegister("gouN9", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $6mia6 = parcelRequire("6mia6");

var $iozi5 = parcelRequire("iozi5");

var $2Xxut = parcelRequire("2Xxut");
/**
 * Signals that the layer has been rendered.
 *
 * @param {boolean} stable Whether all tiles were successfully rendered without
 *     missing textures or resorting to fallbacks.
 * @event Layer#renderComplete
 */ /**
 * @class Layer
 * @classdesc
 *
 * A Layer is a combination of {@link Source}, {@link Geometry}, {@link View}
 * and {@link TextureStore} that may be added into a {@link Stage} and rendered
 * with {@link Effects}.
 *
 * @param {Source} source
 * @param {Geometry} geometry
 * @param {View} view
 * @param {TextureStore} textureStore
 * @param {Object} opts
 * @param {Effects} opts.effects
*/ function $bef6c5d7db09d718$var$Layer(source, geometry, view, textureStore, opts) {
    opts = opts || {};
    var self = this;
    this._source = source;
    this._geometry = geometry;
    this._view = view;
    this._textureStore = textureStore;
    this._effects = opts.effects || {};
    this._fixedLevelIndex = null;
    this._viewChangeHandler = function() {
        self.emit("viewChange", self.view());
    };
    this._view.addEventListener("change", this._viewChangeHandler);
    this._textureStoreChangeHandler = function() {
        self.emit("textureStoreChange", self.textureStore());
    };
    this._textureStore.addEventListener("textureLoad", this._textureStoreChangeHandler);
    this._textureStore.addEventListener("textureError", this._textureStoreChangeHandler);
    this._textureStore.addEventListener("textureInvalid", this._textureStoreChangeHandler);
}
$6mia6($bef6c5d7db09d718$var$Layer);
/**
 * Destructor.
 */ $bef6c5d7db09d718$var$Layer.prototype.destroy = function() {
    this._view.removeEventListener("change", this._viewChangeHandler);
    this._textureStore.removeEventListener("textureLoad", this._textureStoreChangeHandler);
    this._textureStore.removeEventListener("textureError", this._textureStoreChangeHandler);
    this._textureStore.removeEventListener("textureInvalid", this._textureStoreChangeHandler);
    $2Xxut(this);
};
/**
 * Returns the underlying {@link Source source}.
 * @return {Source}
 */ $bef6c5d7db09d718$var$Layer.prototype.source = function() {
    return this._source;
};
/**
 * Returns the underlying {@link Geometry geometry}.
 * @return {Geometry}
 */ $bef6c5d7db09d718$var$Layer.prototype.geometry = function() {
    return this._geometry;
};
/**
 * Returns the underlying {@link View view}.
 * @return {View}
 */ $bef6c5d7db09d718$var$Layer.prototype.view = function() {
    return this._view;
};
/**
 * Returns the underlying {@link TextureStore texture store}.
 * @return {TextureStore}
 */ $bef6c5d7db09d718$var$Layer.prototype.textureStore = function() {
    return this._textureStore;
};
/**
 * Returns the currently set {@link Effects effects}.
 * @return {Effects}
 */ $bef6c5d7db09d718$var$Layer.prototype.effects = function() {
    return this._effects;
};
/**
 * Sets the {@link Effects effects}.
 * @param {Effects} effects
 */ $bef6c5d7db09d718$var$Layer.prototype.setEffects = function(effects) {
    this._effects = effects;
    this.emit("effectsChange", this._effects);
};
/**
 * Merges effects into the currently set ones. The merge is non-recursive; for
 * instance, if current effects are `{ rect: { relativeWidth: 0.5 } }`,
 * calling this method with `{ rect: { relativeX: 0.5 }}` will reset
 * `rect.relativeWidth`.
 *
 * @param {Effects} effects
 */ $bef6c5d7db09d718$var$Layer.prototype.mergeEffects = function(effects) {
    $iozi5(this._effects, effects);
    this.emit("effectsChange", this._effects);
};
/**
 * Returns the fixed level index.
 * @return {(number|null)}
 */ $bef6c5d7db09d718$var$Layer.prototype.fixedLevel = function() {
    return this._fixedLevelIndex;
};
/**
 * Sets the fixed level index. When set, the corresponding level will be
 * used regardless of the view parameters. Unset with a null argument.
 *
 * @param {(number|null)} levelIndex
 * @throws An error if the level index is out of range.
 */ $bef6c5d7db09d718$var$Layer.prototype.setFixedLevel = function(levelIndex) {
    if (levelIndex !== this._fixedLevelIndex) {
        if (levelIndex != null && (levelIndex >= this._geometry.levelList.length || levelIndex < 0)) throw new Error("Level index out of range: " + levelIndex);
        this._fixedLevelIndex = levelIndex;
        this.emit("fixedLevelChange", this._fixedLevelIndex);
    }
};
$bef6c5d7db09d718$var$Layer.prototype._selectLevel = function() {
    var level;
    if (this._fixedLevelIndex != null) level = this._geometry.levelList[this._fixedLevelIndex];
    else level = this._view.selectLevel(this._geometry.selectableLevelList);
    return level;
};
$bef6c5d7db09d718$var$Layer.prototype.visibleTiles = function(result) {
    var level = this._selectLevel();
    return this._geometry.visibleTiles(this._view, level, result);
};
/**
 * Pin a whole level into the texture store.
 * @param {Number} levelIndex
 */ $bef6c5d7db09d718$var$Layer.prototype.pinLevel = function(levelIndex) {
    var level = this._geometry.levelList[levelIndex];
    var tiles = this._geometry.levelTiles(level);
    for(var i = 0; i < tiles.length; i++)this._textureStore.pin(tiles[i]);
};
/**
 * Unpin a whole level from the texture store.
 * @param {Number} levelIndex
 */ $bef6c5d7db09d718$var$Layer.prototype.unpinLevel = function(levelIndex) {
    var level = this._geometry.levelList[levelIndex];
    var tiles = this._geometry.levelTiles(level);
    for(var i = 0; i < tiles.length; i++)this._textureStore.unpin(tiles[i]);
};
/**
 * Pin the first level. Equivalent to `pinLevel(0)`.
 */ $bef6c5d7db09d718$var$Layer.prototype.pinFirstLevel = function() {
    return this.pinLevel(0);
};
/**
 * Unpin the first level. Equivalent to `unpinLevel(0)`.
 */ $bef6c5d7db09d718$var$Layer.prototype.unpinFirstLevel = function() {
    return this.unpinLevel(0);
};
module.exports = $bef6c5d7db09d718$var$Layer;

});
parcelRegister("iozi5", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
function $d645d7e268a03d13$var$extend(obj, sourceObj) {
    for(var key in sourceObj)obj[key] = sourceObj[key];
    return obj;
}
module.exports = $d645d7e268a03d13$var$extend;

});


parcelRegister("h0UOQ", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $6mia6 = parcelRequire("6mia6");

var $2Xxut = parcelRequire("2Xxut");
/**
 * Signals that {@link Stage#render} is about to be called.
 * @event RenderLoop#beforeRender
 */ /**
 * Signals that {@link Stage#render} has just been called.
 * @event RenderLoop#afterRender
 */ /**
 * @class RenderLoop
 * @classdesc
 *
 * A RenderLoop wraps a {@link Stage} and calls {@link Stage#render} on the next
 * frame whenever it fires {@link Stage#renderInvalid}. It may be started and
 * stopped, and is initially in the stopped state, in which no call to
 * {@link Stage#render} occurs.
 *
 * @listens Stage#renderInvalid
 *
 * @param {Stage} stage
 */ function $c62e82d490c40b15$var$RenderLoop(stage) {
    var self = this;
    // The stage wrapped by the loop.
    this._stage = stage;
    // Whether the loop is running.
    this._running = false;
    // Whether the loop is currently rendering.
    this._rendering = false;
    // The current requestAnimationFrame handle.
    this._requestHandle = null;
    // The callback passed into requestAnimationFrame.
    this._boundLoop = this._loop.bind(this);
    // Handler for renderInvalid events emitted by the stage.
    this._renderInvalidHandler = function() {
        // If we are already rendering, there's no need to schedule a new render
        // on the next frame.
        if (!self._rendering) self.renderOnNextFrame();
    };
    // Handle renderInvalid events emitted by the stage.
    this._stage.addEventListener("renderInvalid", this._renderInvalidHandler);
}
$6mia6($c62e82d490c40b15$var$RenderLoop);
/**
 * Destructor.
 */ $c62e82d490c40b15$var$RenderLoop.prototype.destroy = function() {
    this.stop();
    this._stage.removeEventListener("renderInvalid", this._renderInvalidHandler);
    $2Xxut(this);
};
/**
 * Returns the underlying stage.
 * @return {Stage}
 */ $c62e82d490c40b15$var$RenderLoop.prototype.stage = function() {
    return this._stage;
};
/**
 * Starts the render loop.
 */ $c62e82d490c40b15$var$RenderLoop.prototype.start = function() {
    this._running = true;
    this.renderOnNextFrame();
};
/**
 * Stops the render loop.
 */ $c62e82d490c40b15$var$RenderLoop.prototype.stop = function() {
    if (this._requestHandle) {
        window.cancelAnimationFrame(this._requestHandle);
        this._requestHandle = null;
    }
    this._running = false;
};
/**
 * Forces the stage to render on the next frame, even if its contents remain
 * valid. Does nothing if the loop is stopped.
 */ $c62e82d490c40b15$var$RenderLoop.prototype.renderOnNextFrame = function() {
    if (this._running && !this._requestHandle) this._requestHandle = window.requestAnimationFrame(this._boundLoop);
};
$c62e82d490c40b15$var$RenderLoop.prototype._loop = function() {
    if (!this._running) throw new Error("Render loop running while in stopped state");
    this._requestHandle = null;
    this._rendering = true;
    this.emit("beforeRender");
    this._rendering = false;
    this._stage.render();
    this.emit("afterRender");
};
module.exports = $c62e82d490c40b15$var$RenderLoop;

});

parcelRegister("kniT1", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $6mia6 = parcelRequire("6mia6");

var $bqWZD = parcelRequire("bqWZD");

var $2Xxut = parcelRequire("2Xxut");
/**
 * @class KeyControlMethod
 * @implements ControlMethod
 * @classdesc
 *
 * Sets the velocity and friction of a single parameter by pressing and
 * unpressing a key.
 *
 * @param {number} keyCode Key which activates the method when pressed
 * @param {string} parameter The parameter to be controlled (e.g. `x`, `y` or `zoom`)
 * @param {number} velocity Velocity at which the parameter changes. Use a
 * negative number for opposite direction
 * @param {number} friction Friction at which the parameter stops
 * @param {Element} [element=document] DOM element where the key events are listened to
 */ function $ed549b163b1d230d$var$KeyControlMethod(keyCode, parameter, velocity, friction, element) {
    if (!keyCode) throw new Error("KeyControlMethod: keyCode must be defined");
    if (!parameter) throw new Error("KeyControlMethod: parameter must be defined");
    if (!velocity) throw new Error("KeyControlMethod: velocity must be defined");
    if (!friction) throw new Error("KeyControlMethod: friction must be defined");
    element = element || document;
    this._keyCode = keyCode;
    this._parameter = parameter;
    this._velocity = velocity;
    this._friction = friction;
    this._element = element;
    this._keydownHandler = this._handlePress.bind(this);
    this._keyupHandler = this._handleRelease.bind(this);
    this._blurHandler = this._handleBlur.bind(this);
    this._element.addEventListener("keydown", this._keydownHandler);
    this._element.addEventListener("keyup", this._keyupHandler);
    window.addEventListener("blur", this._blurHandler);
    this._dynamics = new $bqWZD();
    this._pressing = false;
}
$6mia6($ed549b163b1d230d$var$KeyControlMethod);
/**
 * Destructor.
 */ $ed549b163b1d230d$var$KeyControlMethod.prototype.destroy = function() {
    this._element.removeEventListener("keydown", this._keydownHandler);
    this._element.removeEventListener("keyup", this._keyupHandler);
    window.removeEventListener("blur", this._blurHandler);
    $2Xxut(this);
};
$ed549b163b1d230d$var$KeyControlMethod.prototype._handlePress = function(e) {
    if (e.keyCode !== this._keyCode) return;
    this._pressing = true;
    this._dynamics.velocity = this._velocity;
    this._dynamics.friction = 0;
    this.emit("parameterDynamics", this._parameter, this._dynamics);
    this.emit("active");
};
$ed549b163b1d230d$var$KeyControlMethod.prototype._handleRelease = function(e) {
    if (e.keyCode !== this._keyCode) return;
    if (this._pressing) {
        this._dynamics.friction = this._friction;
        this.emit("parameterDynamics", this._parameter, this._dynamics);
        this.emit("inactive");
    }
    this._pressing = false;
};
$ed549b163b1d230d$var$KeyControlMethod.prototype._handleBlur = function() {
    this._dynamics.velocity = 0;
    this.emit("parameterDynamics", this._parameter, this._dynamics);
    this.emit("inactive");
    this._pressing = false;
};
module.exports = $ed549b163b1d230d$var$KeyControlMethod;

});
parcelRegister("bqWZD", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
/**
 * @class Dynamics
 * @classdesc
 *
 * Represents how a control parameter changes. Used in the events emitted by
 * {@link ControlMethod}.
 *
 * @property {number} offset Parameter changed by a fixed value
 * @property {number} velocity Parameter is changing at this velocity
 * @property {number} friction The velocity will decrease at this rate
 */ function $852fe23eeece1a4d$var$Dynamics() {
    this.velocity = null;
    this.friction = null;
    this.offset = null;
}
$852fe23eeece1a4d$var$Dynamics.equals = function(d1, d2) {
    return d1.velocity === d2.velocity && d1.friction === d2.friction && d1.offset === d2.offset;
};
$852fe23eeece1a4d$var$Dynamics.prototype.equals = function(other) {
    return $852fe23eeece1a4d$var$Dynamics.equals(this, other);
};
$852fe23eeece1a4d$var$Dynamics.prototype.update = function(other, elapsed) {
    if (other.offset) {
        // If other has an offset, make this.offset a number instead of null
        this.offset = this.offset || 0;
        this.offset += other.offset;
    }
    var offsetFromVelocity = this.offsetFromVelocity(elapsed);
    if (offsetFromVelocity) {
        // If there is an offset to add from the velocity, make this offset a number instead of null
        this.offset = this.offset || 0;
        this.offset += offsetFromVelocity;
    }
    this.velocity = other.velocity;
    this.friction = other.friction;
};
$852fe23eeece1a4d$var$Dynamics.prototype.reset = function() {
    this.velocity = null;
    this.friction = null;
    this.offset = null;
};
$852fe23eeece1a4d$var$Dynamics.prototype.velocityAfter = function(elapsed) {
    if (!this.velocity) return null;
    if (this.friction) return $852fe23eeece1a4d$var$decreaseAbs(this.velocity, this.friction * elapsed);
    return this.velocity;
};
$852fe23eeece1a4d$var$Dynamics.prototype.offsetFromVelocity = function(elapsed) {
    elapsed = Math.min(elapsed, this.nullVelocityTime());
    var velocityEnd = this.velocityAfter(elapsed);
    var averageVelocity = (this.velocity + velocityEnd) / 2;
    return averageVelocity * elapsed;
};
$852fe23eeece1a4d$var$Dynamics.prototype.nullVelocityTime = function() {
    if (this.velocity == null) return 0;
    if (this.velocity && !this.friction) return Infinity;
    return Math.abs(this.velocity / this.friction);
};
function $852fe23eeece1a4d$var$decreaseAbs(num, dec) {
    if (num < 0) return Math.min(0, num + dec);
    if (num > 0) return Math.max(0, num - dec);
    return 0;
}
module.exports = $852fe23eeece1a4d$var$Dynamics;

});


parcelRegister("efdW7", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $6mia6 = parcelRequire("6mia6");

var $bqWZD = parcelRequire("bqWZD");

var $8BNHT = parcelRequire("8BNHT");

var $9eJDl = parcelRequire("9eJDl");

var $nc4qC = parcelRequire("nc4qC");
var $a5ed46dfd02f4481$require$maxFriction = $nc4qC.maxFriction;

var $2Xxut = parcelRequire("2Xxut");
var $a5ed46dfd02f4481$var$defaultOptions = {
    friction: 6,
    maxFrictionTime: 0.3
};
var $a5ed46dfd02f4481$var$debug = typeof MARZIPANODEBUG !== "undefined" && MARZIPANODEBUG.controls;
/**
 * @class DragControlMethod
 * @implements ControlMethod
 * @classdesc
 *
 * Controls the view by clicking/tapping and dragging.
 *
 * @param {Element} element Element to listen for events.
 * @param {string} pointerType Which Hammer.js pointer type to use (e.g.
 * `mouse` or `touch`).
 * @param {Object} opts
 * @param {number} opts.friction
 * @param {number} opts.maxFrictionTime
 */ function $a5ed46dfd02f4481$var$DragControlMethod(element, pointerType, opts) {
    this._element = element;
    this._opts = $9eJDl(opts || {}, $a5ed46dfd02f4481$var$defaultOptions);
    this._startEvent = null;
    this._lastEvent = null;
    this._active = false;
    this._dynamics = {
        x: new $bqWZD(),
        y: new $bqWZD()
    };
    this._hammer = $8BNHT.get(element, pointerType);
    this._hammer.on("hammer.input", this._handleHammerEvent.bind(this));
    this._hammer.on("panstart", this._handleStart.bind(this));
    this._hammer.on("panmove", this._handleMove.bind(this));
    this._hammer.on("panend", this._handleEnd.bind(this));
    this._hammer.on("pancancel", this._handleEnd.bind(this));
}
$6mia6($a5ed46dfd02f4481$var$DragControlMethod);
/**
 * Destructor.
 */ $a5ed46dfd02f4481$var$DragControlMethod.prototype.destroy = function() {
    this._hammer.release();
    $2Xxut(this);
};
$a5ed46dfd02f4481$var$DragControlMethod.prototype._handleHammerEvent = function(e) {
    if (e.isFirst) {
        if ($a5ed46dfd02f4481$var$debug && this._active) throw new Error("DragControlMethod active detected when already active");
        this._active = true;
        this.emit("active");
    }
    if (e.isFinal) {
        if ($a5ed46dfd02f4481$var$debug && !this._active) throw new Error("DragControlMethod inactive detected when already inactive");
        this._active = false;
        this.emit("inactive");
    }
};
$a5ed46dfd02f4481$var$DragControlMethod.prototype._handleStart = function(e) {
    // Prevent this event from dragging other DOM elements, causing
    // unexpected behavior on Chrome.
    e.preventDefault();
    this._startEvent = e;
};
$a5ed46dfd02f4481$var$DragControlMethod.prototype._handleMove = function(e) {
    // Prevent this event from dragging other DOM elements, causing
    // unexpected behavior on Chrome.
    e.preventDefault();
    if (this._startEvent) {
        this._updateDynamicsMove(e);
        this.emit("parameterDynamics", "axisScaledX", this._dynamics.x);
        this.emit("parameterDynamics", "axisScaledY", this._dynamics.y);
    }
};
$a5ed46dfd02f4481$var$DragControlMethod.prototype._handleEnd = function(e) {
    // Prevent this event from dragging other DOM elements, causing
    // unexpected behavior on Chrome.
    e.preventDefault();
    if (this._startEvent) {
        this._updateDynamicsRelease(e);
        this.emit("parameterDynamics", "axisScaledX", this._dynamics.x);
        this.emit("parameterDynamics", "axisScaledY", this._dynamics.y);
    }
    this._startEvent = false;
    this._lastEvent = false;
};
$a5ed46dfd02f4481$var$DragControlMethod.prototype._updateDynamicsMove = function(e) {
    var x = e.deltaX;
    var y = e.deltaY;
    // When a second finger touches the screen, panstart sometimes has a large
    // offset at start; subtract that offset to prevent a sudden jump.
    var eventToSubtract = this._lastEvent || this._startEvent;
    if (eventToSubtract) {
        x -= eventToSubtract.deltaX;
        y -= eventToSubtract.deltaY;
    }
    var elementRect = this._element.getBoundingClientRect();
    var width = elementRect.right - elementRect.left;
    var height = elementRect.bottom - elementRect.top;
    x /= width;
    y /= height;
    this._dynamics.x.reset();
    this._dynamics.y.reset();
    this._dynamics.x.offset = -x;
    this._dynamics.y.offset = -y;
    this._lastEvent = e;
};
var $a5ed46dfd02f4481$var$tmpReleaseFriction = [
    null,
    null
];
$a5ed46dfd02f4481$var$DragControlMethod.prototype._updateDynamicsRelease = function(e) {
    var elementRect = this._element.getBoundingClientRect();
    var width = elementRect.right - elementRect.left;
    var height = elementRect.bottom - elementRect.top;
    var x = 1000 * e.velocityX / width;
    var y = 1000 * e.velocityY / height;
    this._dynamics.x.reset();
    this._dynamics.y.reset();
    this._dynamics.x.velocity = x;
    this._dynamics.y.velocity = y;
    $a5ed46dfd02f4481$require$maxFriction(this._opts.friction, this._dynamics.x.velocity, this._dynamics.y.velocity, this._opts.maxFrictionTime, $a5ed46dfd02f4481$var$tmpReleaseFriction);
    this._dynamics.x.friction = $a5ed46dfd02f4481$var$tmpReleaseFriction[0];
    this._dynamics.y.friction = $a5ed46dfd02f4481$var$tmpReleaseFriction[1];
};
module.exports = $a5ed46dfd02f4481$var$DragControlMethod;

});
parcelRegister("8BNHT", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $bTkIC = parcelRequire("bTkIC");

var $W9Vbx = parcelRequire("W9Vbx");
var $6448562f3462d0fe$var$nextId = 1;
var $6448562f3462d0fe$var$idProperty = "MarzipanoHammerElementId";
function $6448562f3462d0fe$var$getKeyForElementAndType(element, type) {
    if (!element[$6448562f3462d0fe$var$idProperty]) element[$6448562f3462d0fe$var$idProperty] = $6448562f3462d0fe$var$nextId++;
    return type + element[$6448562f3462d0fe$var$idProperty];
}
/**
 * @class HammerGestures
 * @classdesc
 *
 * Manages Hammer.js instances. One instance is created for each combination of
 * DOM element and pointer type.
 */ function $6448562f3462d0fe$var$HammerGestures() {
    this._managers = {};
    this._refCount = {};
}
$6448562f3462d0fe$var$HammerGestures.prototype.get = function(element, type) {
    var key = $6448562f3462d0fe$var$getKeyForElementAndType(element, type);
    if (!this._managers[key]) {
        this._managers[key] = this._createManager(element, type);
        this._refCount[key] = 0;
    }
    this._refCount[key]++;
    return new $6448562f3462d0fe$var$HammerGesturesHandle(this, this._managers[key], element, type);
};
$6448562f3462d0fe$var$HammerGestures.prototype._createManager = function(element, type) {
    var manager = new $bTkIC.Manager(element);
    // Managers are created with different parameters for different pointer
    // types.
    if (type === "mouse") manager.add(new $bTkIC.Pan({
        direction: $bTkIC.DIRECTION_ALL,
        threshold: 0
    }));
    else if (type === "touch" || type === "pen" || type === "kinect") {
        // On touch one wants to have both panning and pinching. The panning
        // recognizer needs a threshold to allow the pinch to be recognized.
        manager.add(new $bTkIC.Pan({
            direction: $bTkIC.DIRECTION_ALL,
            threshold: 20,
            pointers: 1
        }));
        if (!($W9Vbx.msie && parseFloat($W9Vbx.version) < 10)) // Do not add pinch to IE8-9 to prevent focus issues which prevent wheel scrolling from
        // working.
        manager.add(new $bTkIC.Pinch());
    }
    return manager;
};
$6448562f3462d0fe$var$HammerGestures.prototype._releaseHandle = function(element, type) {
    var key = $6448562f3462d0fe$var$getKeyForElementAndType(element, type);
    if (this._refCount[key]) {
        this._refCount[key]--;
        if (!this._refCount[key]) {
            this._managers[key].destroy();
            delete this._managers[key];
            delete this._refCount[key];
        }
    }
};
function $6448562f3462d0fe$var$HammerGesturesHandle(hammerGestures, manager, element, type) {
    this._manager = manager;
    this._element = element;
    this._type = type;
    this._hammerGestures = hammerGestures;
    this._eventHandlers = [];
}
$6448562f3462d0fe$var$HammerGesturesHandle.prototype.on = function(events, handler) {
    var type = this._type;
    var handlerFilteredEvents = function(e) {
        if (type === e.pointerType) handler(e);
    };
    this._eventHandlers.push({
        events: events,
        handler: handlerFilteredEvents
    });
    this._manager.on(events, handlerFilteredEvents);
};
$6448562f3462d0fe$var$HammerGesturesHandle.prototype.release = function() {
    for(var i = 0; i < this._eventHandlers.length; i++){
        var eventHandler = this._eventHandlers[i];
        this._manager.off(eventHandler.events, eventHandler.handler);
    }
    this._hammerGestures._releaseHandle(this._element, this._type);
    this._manager = null;
    this._element = null;
    this._type = null;
    this._hammerGestures = null;
};
$6448562f3462d0fe$var$HammerGesturesHandle.prototype.manager = function() {
    return this._manager;
};
module.exports = new $6448562f3462d0fe$var$HammerGestures();

});
parcelRegister("bTkIC", function(module, exports) {
/*! Hammer.JS - v2.0.4 - 2014-09-28
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2014 Jorik Tangelder;
 * Licensed under the MIT license */ (function(window1, document1, exportName, undefined) {
    "use strict";
    var VENDOR_PREFIXES = [
        "",
        "webkit",
        "moz",
        "MS",
        "ms",
        "o"
    ];
    var TEST_ELEMENT = document1.createElement("div");
    var TYPE_FUNCTION = "function";
    var round = Math.round;
    var abs = Math.abs;
    var now = Date.now;
    /**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */ function setTimeoutContext(fn, timeout, context) {
        return setTimeout(bindFn(fn, context), timeout);
    }
    /**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */ function invokeArrayArg(arg, fn, context) {
        if (Array.isArray(arg)) {
            each(arg, context[fn], context);
            return true;
        }
        return false;
    }
    /**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */ function each(obj, iterator, context) {
        var i;
        if (!obj) return;
        if (obj.forEach) obj.forEach(iterator, context);
        else if (obj.length !== undefined) {
            i = 0;
            while(i < obj.length){
                iterator.call(context, obj[i], i, obj);
                i++;
            }
        } else for(i in obj)obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
    }
    /**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge]
 * @returns {Object} dest
 */ function extend(dest, src, merge) {
        var keys = Object.keys(src);
        var i = 0;
        while(i < keys.length){
            if (!merge || merge && dest[keys[i]] === undefined) dest[keys[i]] = src[keys[i]];
            i++;
        }
        return dest;
    }
    /**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */ function merge(dest, src) {
        return extend(dest, src, true);
    }
    /**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */ function inherit(child, base, properties) {
        var baseP = base.prototype, childP;
        childP = child.prototype = Object.create(baseP);
        childP.constructor = child;
        childP._super = baseP;
        if (properties) extend(childP, properties);
    }
    /**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */ function bindFn(fn, context) {
        return function boundFn() {
            return fn.apply(context, arguments);
        };
    }
    /**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */ function boolOrFn(val, args) {
        if (typeof val == TYPE_FUNCTION) return val.apply(args ? args[0] || undefined : undefined, args);
        return val;
    }
    /**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */ function ifUndefined(val1, val2) {
        return val1 === undefined ? val2 : val1;
    }
    /**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function addEventListeners(target, types, handler) {
        each(splitStr(types), function(type) {
            target.addEventListener(type, handler, false);
        });
    }
    /**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function removeEventListeners(target, types, handler) {
        each(splitStr(types), function(type) {
            target.removeEventListener(type, handler, false);
        });
    }
    /**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */ function hasParent(node, parent) {
        while(node){
            if (node == parent) return true;
            node = node.parentNode;
        }
        return false;
    }
    /**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */ function inStr(str, find) {
        return str.indexOf(find) > -1;
    }
    /**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */ function splitStr(str) {
        return str.trim().split(/\s+/g);
    }
    /**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */ function inArray(src, find, findByKey) {
        if (src.indexOf && !findByKey) return src.indexOf(find);
        else {
            var i = 0;
            while(i < src.length){
                if (findByKey && src[i][findByKey] == find || !findByKey && src[i] === find) return i;
                i++;
            }
            return -1;
        }
    }
    /**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */ function toArray(obj) {
        return Array.prototype.slice.call(obj, 0);
    }
    /**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */ function uniqueArray(src, key, sort) {
        var results = [];
        var values = [];
        var i = 0;
        while(i < src.length){
            var val = key ? src[i][key] : src[i];
            if (inArray(values, val) < 0) results.push(src[i]);
            values[i] = val;
            i++;
        }
        if (sort) {
            if (!key) results = results.sort();
            else results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
        return results;
    }
    /**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */ function prefixed(obj, property) {
        var prefix, prop;
        var camelProp = property[0].toUpperCase() + property.slice(1);
        var i = 0;
        while(i < VENDOR_PREFIXES.length){
            prefix = VENDOR_PREFIXES[i];
            prop = prefix ? prefix + camelProp : property;
            if (prop in obj) return prop;
            i++;
        }
        return undefined;
    }
    /**
 * get a unique id
 * @returns {number} uniqueId
 */ var _uniqueId = 1;
    function uniqueId() {
        return _uniqueId++;
    }
    /**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */ function getWindowForElement(element) {
        var doc = element.ownerDocument;
        return doc.defaultView || doc.parentWindow;
    }
    var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
    var SUPPORT_TOUCH = "ontouchstart" in window1;
    var SUPPORT_POINTER_EVENTS = prefixed(window1, "PointerEvent") !== undefined;
    var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
    var INPUT_TYPE_TOUCH = "touch";
    var INPUT_TYPE_PEN = "pen";
    var INPUT_TYPE_MOUSE = "mouse";
    var INPUT_TYPE_KINECT = "kinect";
    var COMPUTE_INTERVAL = 25;
    var INPUT_START = 1;
    var INPUT_MOVE = 2;
    var INPUT_END = 4;
    var INPUT_CANCEL = 8;
    var DIRECTION_NONE = 1;
    var DIRECTION_LEFT = 2;
    var DIRECTION_RIGHT = 4;
    var DIRECTION_UP = 8;
    var DIRECTION_DOWN = 16;
    var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
    var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
    var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
    var PROPS_XY = [
        "x",
        "y"
    ];
    var PROPS_CLIENT_XY = [
        "clientX",
        "clientY"
    ];
    /**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */ function Input(manager, callback) {
        var self = this;
        this.manager = manager;
        this.callback = callback;
        this.element = manager.element;
        this.target = manager.options.inputTarget;
        // smaller wrapper around the handler, for the scope and the enabled state of the manager,
        // so when disabled the input events are completely bypassed.
        this.domHandler = function(ev) {
            if (boolOrFn(manager.options.enable, [
                manager
            ])) self.handler(ev);
        };
        this.init();
    }
    Input.prototype = {
        /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */ handler: function() {},
        /**
     * bind the events
     */ init: function() {
            this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        },
        /**
     * unbind the events
     */ destroy: function() {
            this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        }
    };
    /**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */ function createInputInstance(manager) {
        var Type;
        var inputClass = manager.options.inputClass;
        if (inputClass) Type = inputClass;
        else if (SUPPORT_POINTER_EVENTS) Type = PointerEventInput;
        else if (SUPPORT_ONLY_TOUCH) Type = TouchInput;
        else if (!SUPPORT_TOUCH) Type = MouseInput;
        else Type = TouchMouseInput;
        return new Type(manager, inputHandler);
    }
    /**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */ function inputHandler(manager, eventType, input) {
        var pointersLen = input.pointers.length;
        var changedPointersLen = input.changedPointers.length;
        var isFirst = eventType & INPUT_START && pointersLen - changedPointersLen === 0;
        var isFinal = eventType & (INPUT_END | INPUT_CANCEL) && pointersLen - changedPointersLen === 0;
        input.isFirst = !!isFirst;
        input.isFinal = !!isFinal;
        if (isFirst) manager.session = {};
        // source event is the normalized value of the domEvents
        // like 'touchstart, mouseup, pointerdown'
        input.eventType = eventType;
        // compute scale, rotation etc
        computeInputData(manager, input);
        // emit secret event
        manager.emit("hammer.input", input);
        manager.recognize(input);
        manager.session.prevInput = input;
    }
    /**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */ function computeInputData(manager, input) {
        var session = manager.session;
        var pointers = input.pointers;
        var pointersLength = pointers.length;
        // store the first input to calculate the distance and direction
        if (!session.firstInput) session.firstInput = simpleCloneInputData(input);
        // to compute scale and rotation we need to store the multiple touches
        if (pointersLength > 1 && !session.firstMultiple) session.firstMultiple = simpleCloneInputData(input);
        else if (pointersLength === 1) session.firstMultiple = false;
        var firstInput = session.firstInput;
        var firstMultiple = session.firstMultiple;
        var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
        var center = input.center = getCenter(pointers);
        input.timeStamp = now();
        input.deltaTime = input.timeStamp - firstInput.timeStamp;
        input.angle = getAngle(offsetCenter, center);
        input.distance = getDistance(offsetCenter, center);
        computeDeltaXY(session, input);
        input.offsetDirection = getDirection(input.deltaX, input.deltaY);
        input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
        input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
        computeIntervalInputData(session, input);
        // find the correct target
        var target = manager.element;
        if (hasParent(input.srcEvent.target, target)) target = input.srcEvent.target;
        input.target = target;
    }
    function computeDeltaXY(session, input) {
        var center = input.center;
        var offset = session.offsetDelta || {};
        var prevDelta = session.prevDelta || {};
        var prevInput = session.prevInput || {};
        if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
            prevDelta = session.prevDelta = {
                x: prevInput.deltaX || 0,
                y: prevInput.deltaY || 0
            };
            offset = session.offsetDelta = {
                x: center.x,
                y: center.y
            };
        }
        input.deltaX = prevDelta.x + (center.x - offset.x);
        input.deltaY = prevDelta.y + (center.y - offset.y);
    }
    /**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */ function computeIntervalInputData(session, input) {
        var last = session.lastInterval || input, deltaTime = input.timeStamp - last.timeStamp, velocity, velocityX, velocityY, direction;
        if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
            var deltaX = last.deltaX - input.deltaX;
            var deltaY = last.deltaY - input.deltaY;
            var v = getVelocity(deltaTime, deltaX, deltaY);
            velocityX = v.x;
            velocityY = v.y;
            velocity = abs(v.x) > abs(v.y) ? v.x : v.y;
            direction = getDirection(deltaX, deltaY);
            session.lastInterval = input;
        } else {
            // use latest velocity info if it doesn't overtake a minimum period
            velocity = last.velocity;
            velocityX = last.velocityX;
            velocityY = last.velocityY;
            direction = last.direction;
        }
        input.velocity = velocity;
        input.velocityX = velocityX;
        input.velocityY = velocityY;
        input.direction = direction;
    }
    /**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */ function simpleCloneInputData(input) {
        // make a simple copy of the pointers because we will get a reference if we don't
        // we only need clientXY for the calculations
        var pointers = [];
        var i = 0;
        while(i < input.pointers.length){
            pointers[i] = {
                clientX: round(input.pointers[i].clientX),
                clientY: round(input.pointers[i].clientY)
            };
            i++;
        }
        return {
            timeStamp: now(),
            pointers: pointers,
            center: getCenter(pointers),
            deltaX: input.deltaX,
            deltaY: input.deltaY
        };
    }
    /**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */ function getCenter(pointers) {
        var pointersLength = pointers.length;
        // no need to loop when only one touch
        if (pointersLength === 1) return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
        var x = 0, y = 0, i = 0;
        while(i < pointersLength){
            x += pointers[i].clientX;
            y += pointers[i].clientY;
            i++;
        }
        return {
            x: round(x / pointersLength),
            y: round(y / pointersLength)
        };
    }
    /**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */ function getVelocity(deltaTime, x, y) {
        return {
            x: x / deltaTime || 0,
            y: y / deltaTime || 0
        };
    }
    /**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */ function getDirection(x, y) {
        if (x === y) return DIRECTION_NONE;
        if (abs(x) >= abs(y)) return x > 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
        return y > 0 ? DIRECTION_UP : DIRECTION_DOWN;
    }
    /**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */ function getDistance(p1, p2, props) {
        if (!props) props = PROPS_XY;
        var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
        return Math.sqrt(x * x + y * y);
    }
    /**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */ function getAngle(p1, p2, props) {
        if (!props) props = PROPS_XY;
        var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
        return Math.atan2(y, x) * 180 / Math.PI;
    }
    /**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */ function getRotation(start, end) {
        return getAngle(end[1], end[0], PROPS_CLIENT_XY) - getAngle(start[1], start[0], PROPS_CLIENT_XY);
    }
    /**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */ function getScale(start, end) {
        return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
    }
    var MOUSE_INPUT_MAP = {
        mousedown: INPUT_START,
        mousemove: INPUT_MOVE,
        mouseup: INPUT_END
    };
    var MOUSE_ELEMENT_EVENTS = "mousedown";
    var MOUSE_WINDOW_EVENTS = "mousemove mouseup";
    /**
 * Mouse events input
 * @constructor
 * @extends Input
 */ function MouseInput() {
        this.evEl = MOUSE_ELEMENT_EVENTS;
        this.evWin = MOUSE_WINDOW_EVENTS;
        this.allow = true; // used by Input.TouchMouse to disable mouse events
        this.pressed = false; // mousedown state
        Input.apply(this, arguments);
    }
    inherit(MouseInput, Input, {
        /**
     * handle mouse events
     * @param {Object} ev
     */ handler: function MEhandler(ev) {
            var eventType = MOUSE_INPUT_MAP[ev.type];
            // on start we want to have the left mouse button down
            if (eventType & INPUT_START && ev.button === 0) this.pressed = true;
            if (eventType & INPUT_MOVE && ev.which !== 1) eventType = INPUT_END;
            // mouse must be down, and mouse events are allowed (see the TouchMouse input)
            if (!this.pressed || !this.allow) return;
            if (eventType & INPUT_END) this.pressed = false;
            this.callback(this.manager, eventType, {
                pointers: [
                    ev
                ],
                changedPointers: [
                    ev
                ],
                pointerType: INPUT_TYPE_MOUSE,
                srcEvent: ev
            });
        }
    });
    var POINTER_INPUT_MAP = {
        pointerdown: INPUT_START,
        pointermove: INPUT_MOVE,
        pointerup: INPUT_END,
        pointercancel: INPUT_CANCEL,
        pointerout: INPUT_CANCEL
    };
    // in IE10 the pointer types is defined as an enum
    var IE10_POINTER_TYPE_ENUM = {
        2: INPUT_TYPE_TOUCH,
        3: INPUT_TYPE_PEN,
        4: INPUT_TYPE_MOUSE,
        5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
    };
    var POINTER_ELEMENT_EVENTS = "pointerdown";
    var POINTER_WINDOW_EVENTS = "pointermove pointerup pointercancel";
    // IE10 has prefixed support, and case-sensitive
    if (window1.MSPointerEvent) {
        POINTER_ELEMENT_EVENTS = "MSPointerDown";
        POINTER_WINDOW_EVENTS = "MSPointerMove MSPointerUp MSPointerCancel";
    }
    /**
 * Pointer events input
 * @constructor
 * @extends Input
 */ function PointerEventInput() {
        this.evEl = POINTER_ELEMENT_EVENTS;
        this.evWin = POINTER_WINDOW_EVENTS;
        Input.apply(this, arguments);
        this.store = this.manager.session.pointerEvents = [];
    }
    inherit(PointerEventInput, Input, {
        /**
     * handle mouse events
     * @param {Object} ev
     */ handler: function PEhandler(ev) {
            var store = this.store;
            var removePointer = false;
            var eventTypeNormalized = ev.type.toLowerCase().replace("ms", "");
            var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
            var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
            var isTouch = pointerType == INPUT_TYPE_TOUCH;
            // get index of the event in the store
            var storeIndex = inArray(store, ev.pointerId, "pointerId");
            // start and mouse must be down
            if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
                if (storeIndex < 0) {
                    store.push(ev);
                    storeIndex = store.length - 1;
                }
            } else if (eventType & (INPUT_END | INPUT_CANCEL)) removePointer = true;
            // it not found, so the pointer hasn't been down (so it's probably a hover)
            if (storeIndex < 0) return;
            // update the event in the store
            store[storeIndex] = ev;
            this.callback(this.manager, eventType, {
                pointers: store,
                changedPointers: [
                    ev
                ],
                pointerType: pointerType,
                srcEvent: ev
            });
            if (removePointer) // remove from the store
            store.splice(storeIndex, 1);
        }
    });
    var SINGLE_TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var SINGLE_TOUCH_TARGET_EVENTS = "touchstart";
    var SINGLE_TOUCH_WINDOW_EVENTS = "touchstart touchmove touchend touchcancel";
    /**
 * Touch events input
 * @constructor
 * @extends Input
 */ function SingleTouchInput() {
        this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
        this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
        this.started = false;
        Input.apply(this, arguments);
    }
    inherit(SingleTouchInput, Input, {
        handler: function TEhandler(ev) {
            var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
            // should we handle the touch events?
            if (type === INPUT_START) this.started = true;
            if (!this.started) return;
            var touches = normalizeSingleTouches.call(this, ev, type);
            // when done, reset the started state
            if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) this.started = false;
            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        }
    });
    /**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */ function normalizeSingleTouches(ev, type) {
        var all = toArray(ev.touches);
        var changed = toArray(ev.changedTouches);
        if (type & (INPUT_END | INPUT_CANCEL)) all = uniqueArray(all.concat(changed), "identifier", true);
        return [
            all,
            changed
        ];
    }
    var TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var TOUCH_TARGET_EVENTS = "touchstart touchmove touchend touchcancel";
    /**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */ function TouchInput() {
        this.evTarget = TOUCH_TARGET_EVENTS;
        this.targetIds = {};
        Input.apply(this, arguments);
    }
    inherit(TouchInput, Input, {
        handler: function MTEhandler(ev) {
            var type = TOUCH_INPUT_MAP[ev.type];
            var touches = getTouches.call(this, ev, type);
            if (!touches) return;
            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        }
    });
    /**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */ function getTouches(ev, type) {
        var allTouches = toArray(ev.touches);
        var targetIds = this.targetIds;
        // when there is only one touch, the process can be simplified
        if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
            targetIds[allTouches[0].identifier] = true;
            return [
                allTouches,
                allTouches
            ];
        }
        var i, targetTouches, changedTouches = toArray(ev.changedTouches), changedTargetTouches = [], target = this.target;
        // get target touches from touches
        targetTouches = allTouches.filter(function(touch) {
            return hasParent(touch.target, target);
        });
        // collect touches
        if (type === INPUT_START) {
            i = 0;
            while(i < targetTouches.length){
                targetIds[targetTouches[i].identifier] = true;
                i++;
            }
        }
        // filter changed touches to only contain touches that exist in the collected target ids
        i = 0;
        while(i < changedTouches.length){
            if (targetIds[changedTouches[i].identifier]) changedTargetTouches.push(changedTouches[i]);
            // cleanup removed touches
            if (type & (INPUT_END | INPUT_CANCEL)) delete targetIds[changedTouches[i].identifier];
            i++;
        }
        if (!changedTargetTouches.length) return;
        return [
            // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
            uniqueArray(targetTouches.concat(changedTargetTouches), "identifier", true),
            changedTargetTouches
        ];
    }
    /**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */ function TouchMouseInput() {
        Input.apply(this, arguments);
        var handler = bindFn(this.handler, this);
        this.touch = new TouchInput(this.manager, handler);
        this.mouse = new MouseInput(this.manager, handler);
    }
    inherit(TouchMouseInput, Input, {
        /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */ handler: function TMEhandler(manager, inputEvent, inputData) {
            var isTouch = inputData.pointerType == INPUT_TYPE_TOUCH, isMouse = inputData.pointerType == INPUT_TYPE_MOUSE;
            // when we're in a touch event, so  block all upcoming mouse events
            // most mobile browser also emit mouseevents, right after touchstart
            if (isTouch) this.mouse.allow = false;
            else if (isMouse && !this.mouse.allow) return;
            // reset the allowMouse when we're done
            if (inputEvent & (INPUT_END | INPUT_CANCEL)) this.mouse.allow = true;
            this.callback(manager, inputEvent, inputData);
        },
        /**
     * remove the event listeners
     */ destroy: function destroy() {
            this.touch.destroy();
            this.mouse.destroy();
        }
    });
    var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, "touchAction");
    var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
    // magical touchAction value
    var TOUCH_ACTION_COMPUTE = "compute";
    var TOUCH_ACTION_AUTO = "auto";
    var TOUCH_ACTION_MANIPULATION = "manipulation"; // not implemented
    var TOUCH_ACTION_NONE = "none";
    var TOUCH_ACTION_PAN_X = "pan-x";
    var TOUCH_ACTION_PAN_Y = "pan-y";
    /**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */ function TouchAction(manager, value) {
        this.manager = manager;
        this.set(value);
    }
    TouchAction.prototype = {
        /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */ set: function(value) {
            // find out the touch-action by the event handlers
            if (value == TOUCH_ACTION_COMPUTE) value = this.compute();
            if (NATIVE_TOUCH_ACTION) this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
            this.actions = value.toLowerCase().trim();
        },
        /**
     * just re-set the touchAction value
     */ update: function() {
            this.set(this.manager.options.touchAction);
        },
        /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */ compute: function() {
            var actions = [];
            each(this.manager.recognizers, function(recognizer) {
                if (boolOrFn(recognizer.options.enable, [
                    recognizer
                ])) actions = actions.concat(recognizer.getTouchAction());
            });
            return cleanTouchActions(actions.join(" "));
        },
        /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */ preventDefaults: function(input) {
            // not needed with native support for the touchAction property
            if (NATIVE_TOUCH_ACTION) return;
            var srcEvent = input.srcEvent;
            var direction = input.offsetDirection;
            // if the touch action did prevented once this session
            if (this.manager.session.prevented) {
                srcEvent.preventDefault();
                return;
            }
            var actions = this.actions;
            var hasNone = inStr(actions, TOUCH_ACTION_NONE);
            var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
            var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
            if (hasNone || hasPanY && direction & DIRECTION_HORIZONTAL || hasPanX && direction & DIRECTION_VERTICAL) return this.preventSrc(srcEvent);
        },
        /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */ preventSrc: function(srcEvent) {
            this.manager.session.prevented = true;
            srcEvent.preventDefault();
        }
    };
    /**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */ function cleanTouchActions(actions) {
        // none
        if (inStr(actions, TOUCH_ACTION_NONE)) return TOUCH_ACTION_NONE;
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
        // pan-x and pan-y can be combined
        if (hasPanX && hasPanY) return TOUCH_ACTION_PAN_X + " " + TOUCH_ACTION_PAN_Y;
        // pan-x OR pan-y
        if (hasPanX || hasPanY) return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
        // manipulation
        if (inStr(actions, TOUCH_ACTION_MANIPULATION)) return TOUCH_ACTION_MANIPULATION;
        return TOUCH_ACTION_AUTO;
    }
    /**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */ var STATE_POSSIBLE = 1;
    var STATE_BEGAN = 2;
    var STATE_CHANGED = 4;
    var STATE_ENDED = 8;
    var STATE_RECOGNIZED = STATE_ENDED;
    var STATE_CANCELLED = 16;
    var STATE_FAILED = 32;
    /**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */ function Recognizer(options) {
        this.id = uniqueId();
        this.manager = null;
        this.options = merge(options || {}, this.defaults);
        // default is enable true
        this.options.enable = ifUndefined(this.options.enable, true);
        this.state = STATE_POSSIBLE;
        this.simultaneous = {};
        this.requireFail = [];
    }
    Recognizer.prototype = {
        /**
     * @virtual
     * @type {Object}
     */ defaults: {},
        /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */ set: function(options) {
            extend(this.options, options);
            // also update the touchAction, in case something changed about the directions/enabled state
            this.manager && this.manager.touchAction.update();
            return this;
        },
        /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ recognizeWith: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, "recognizeWith", this)) return this;
            var simultaneous = this.simultaneous;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            if (!simultaneous[otherRecognizer.id]) {
                simultaneous[otherRecognizer.id] = otherRecognizer;
                otherRecognizer.recognizeWith(this);
            }
            return this;
        },
        /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ dropRecognizeWith: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, "dropRecognizeWith", this)) return this;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            delete this.simultaneous[otherRecognizer.id];
            return this;
        },
        /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ requireFailure: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, "requireFailure", this)) return this;
            var requireFail = this.requireFail;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            if (inArray(requireFail, otherRecognizer) === -1) {
                requireFail.push(otherRecognizer);
                otherRecognizer.requireFailure(this);
            }
            return this;
        },
        /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ dropRequireFailure: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, "dropRequireFailure", this)) return this;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            var index = inArray(this.requireFail, otherRecognizer);
            if (index > -1) this.requireFail.splice(index, 1);
            return this;
        },
        /**
     * has require failures boolean
     * @returns {boolean}
     */ hasRequireFailures: function() {
            return this.requireFail.length > 0;
        },
        /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */ canRecognizeWith: function(otherRecognizer) {
            return !!this.simultaneous[otherRecognizer.id];
        },
        /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */ emit: function(input) {
            var self = this;
            var state = this.state;
            function emit(withState) {
                self.manager.emit(self.options.event + (withState ? stateStr(state) : ""), input);
            }
            // 'panstart' and 'panmove'
            if (state < STATE_ENDED) emit(true);
            emit(); // simple 'eventName' events
            // panend and pancancel
            if (state >= STATE_ENDED) emit(true);
        },
        /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */ tryEmit: function(input) {
            if (this.canEmit()) return this.emit(input);
            // it's failing anyway
            this.state = STATE_FAILED;
        },
        /**
     * can we emit?
     * @returns {boolean}
     */ canEmit: function() {
            var i = 0;
            while(i < this.requireFail.length){
                if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) return false;
                i++;
            }
            return true;
        },
        /**
     * update the recognizer
     * @param {Object} inputData
     */ recognize: function(inputData) {
            // make a new copy of the inputData
            // so we can change the inputData without messing up the other recognizers
            var inputDataClone = extend({}, inputData);
            // is is enabled and allow recognizing?
            if (!boolOrFn(this.options.enable, [
                this,
                inputDataClone
            ])) {
                this.reset();
                this.state = STATE_FAILED;
                return;
            }
            // reset when we've reached the end
            if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) this.state = STATE_POSSIBLE;
            this.state = this.process(inputDataClone);
            // the recognizer has recognized a gesture
            // so trigger an event
            if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) this.tryEmit(inputDataClone);
        },
        /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */ process: function(inputData) {},
        /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */ getTouchAction: function() {},
        /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */ reset: function() {}
    };
    /**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */ function stateStr(state) {
        if (state & STATE_CANCELLED) return "cancel";
        else if (state & STATE_ENDED) return "end";
        else if (state & STATE_CHANGED) return "move";
        else if (state & STATE_BEGAN) return "start";
        return "";
    }
    /**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */ function directionStr(direction) {
        if (direction == DIRECTION_DOWN) return "down";
        else if (direction == DIRECTION_UP) return "up";
        else if (direction == DIRECTION_LEFT) return "left";
        else if (direction == DIRECTION_RIGHT) return "right";
        return "";
    }
    /**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */ function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
        var manager = recognizer.manager;
        if (manager) return manager.get(otherRecognizer);
        return otherRecognizer;
    }
    /**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */ function AttrRecognizer() {
        Recognizer.apply(this, arguments);
    }
    inherit(AttrRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof AttrRecognizer
     */ defaults: {
            /**
         * @type {Number}
         * @default 1
         */ pointers: 1
        },
        /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */ attrTest: function(input) {
            var optionPointers = this.options.pointers;
            return optionPointers === 0 || input.pointers.length === optionPointers;
        },
        /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */ process: function(input) {
            var state = this.state;
            var eventType = input.eventType;
            var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
            var isValid = this.attrTest(input);
            // on cancel input and we've recognized before, return STATE_CANCELLED
            if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) return state | STATE_CANCELLED;
            else if (isRecognized || isValid) {
                if (eventType & INPUT_END) return state | STATE_ENDED;
                else if (!(state & STATE_BEGAN)) return STATE_BEGAN;
                return state | STATE_CHANGED;
            }
            return STATE_FAILED;
        }
    });
    /**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ function PanRecognizer() {
        AttrRecognizer.apply(this, arguments);
        this.pX = null;
        this.pY = null;
    }
    inherit(PanRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof PanRecognizer
     */ defaults: {
            event: "pan",
            threshold: 10,
            pointers: 1,
            direction: DIRECTION_ALL
        },
        getTouchAction: function() {
            var direction = this.options.direction;
            var actions = [];
            if (direction & DIRECTION_HORIZONTAL) actions.push(TOUCH_ACTION_PAN_Y);
            if (direction & DIRECTION_VERTICAL) actions.push(TOUCH_ACTION_PAN_X);
            return actions;
        },
        directionTest: function(input) {
            var options = this.options;
            var hasMoved = true;
            var distance = input.distance;
            var direction = input.direction;
            var x = input.deltaX;
            var y = input.deltaY;
            // lock to axis?
            if (!(direction & options.direction)) {
                if (options.direction & DIRECTION_HORIZONTAL) {
                    direction = x === 0 ? DIRECTION_NONE : x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
                    hasMoved = x != this.pX;
                    distance = Math.abs(input.deltaX);
                } else {
                    direction = y === 0 ? DIRECTION_NONE : y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
                    hasMoved = y != this.pY;
                    distance = Math.abs(input.deltaY);
                }
            }
            input.direction = direction;
            return hasMoved && distance > options.threshold && direction & options.direction;
        },
        attrTest: function(input) {
            return AttrRecognizer.prototype.attrTest.call(this, input) && (this.state & STATE_BEGAN || !(this.state & STATE_BEGAN) && this.directionTest(input));
        },
        emit: function(input) {
            this.pX = input.deltaX;
            this.pY = input.deltaY;
            var direction = directionStr(input.direction);
            if (direction) this.manager.emit(this.options.event + direction, input);
            this._super.emit.call(this, input);
        }
    });
    /**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */ function PinchRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(PinchRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof PinchRecognizer
     */ defaults: {
            event: "pinch",
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_NONE
            ];
        },
        attrTest: function(input) {
            return this._super.attrTest.call(this, input) && (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
        },
        emit: function(input) {
            this._super.emit.call(this, input);
            if (input.scale !== 1) {
                var inOut = input.scale < 1 ? "in" : "out";
                this.manager.emit(this.options.event + inOut, input);
            }
        }
    });
    /**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */ function PressRecognizer() {
        Recognizer.apply(this, arguments);
        this._timer = null;
        this._input = null;
    }
    inherit(PressRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof PressRecognizer
     */ defaults: {
            event: "press",
            pointers: 1,
            time: 500,
            threshold: 5 // a minimal movement is ok, but keep it low
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_AUTO
            ];
        },
        process: function(input) {
            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTime = input.deltaTime > options.time;
            this._input = input;
            // we only allow little movement
            // and we've reached an end event, so a tap is possible
            if (!validMovement || !validPointers || input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime) this.reset();
            else if (input.eventType & INPUT_START) {
                this.reset();
                this._timer = setTimeoutContext(function() {
                    this.state = STATE_RECOGNIZED;
                    this.tryEmit();
                }, options.time, this);
            } else if (input.eventType & INPUT_END) return STATE_RECOGNIZED;
            return STATE_FAILED;
        },
        reset: function() {
            clearTimeout(this._timer);
        },
        emit: function(input) {
            if (this.state !== STATE_RECOGNIZED) return;
            if (input && input.eventType & INPUT_END) this.manager.emit(this.options.event + "up", input);
            else {
                this._input.timeStamp = now();
                this.manager.emit(this.options.event, this._input);
            }
        }
    });
    /**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */ function RotateRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(RotateRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof RotateRecognizer
     */ defaults: {
            event: "rotate",
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_NONE
            ];
        },
        attrTest: function(input) {
            return this._super.attrTest.call(this, input) && (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
        }
    });
    /**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ function SwipeRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(SwipeRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof SwipeRecognizer
     */ defaults: {
            event: "swipe",
            threshold: 10,
            velocity: 0.65,
            direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
            pointers: 1
        },
        getTouchAction: function() {
            return PanRecognizer.prototype.getTouchAction.call(this);
        },
        attrTest: function(input) {
            var direction = this.options.direction;
            var velocity;
            if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) velocity = input.velocity;
            else if (direction & DIRECTION_HORIZONTAL) velocity = input.velocityX;
            else if (direction & DIRECTION_VERTICAL) velocity = input.velocityY;
            return this._super.attrTest.call(this, input) && direction & input.direction && input.distance > this.options.threshold && abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
        },
        emit: function(input) {
            var direction = directionStr(input.direction);
            if (direction) this.manager.emit(this.options.event + direction, input);
            this.manager.emit(this.options.event, input);
        }
    });
    /**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */ function TapRecognizer() {
        Recognizer.apply(this, arguments);
        // previous time and center,
        // used for tap counting
        this.pTime = false;
        this.pCenter = false;
        this._timer = null;
        this._input = null;
        this.count = 0;
    }
    inherit(TapRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof PinchRecognizer
     */ defaults: {
            event: "tap",
            pointers: 1,
            taps: 1,
            interval: 300,
            time: 250,
            threshold: 2,
            posThreshold: 10 // a multi-tap can be a bit off the initial position
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_MANIPULATION
            ];
        },
        process: function(input) {
            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTouchTime = input.deltaTime < options.time;
            this.reset();
            if (input.eventType & INPUT_START && this.count === 0) return this.failTimeout();
            // we only allow little movement
            // and we've reached an end event, so a tap is possible
            if (validMovement && validTouchTime && validPointers) {
                if (input.eventType != INPUT_END) return this.failTimeout();
                var validInterval = this.pTime ? input.timeStamp - this.pTime < options.interval : true;
                var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
                this.pTime = input.timeStamp;
                this.pCenter = input.center;
                if (!validMultiTap || !validInterval) this.count = 1;
                else this.count += 1;
                this._input = input;
                // if tap count matches we have recognized it,
                // else it has began recognizing...
                var tapCount = this.count % options.taps;
                if (tapCount === 0) {
                    // no failing requirements, immediately trigger the tap event
                    // or wait as long as the multitap interval to trigger
                    if (!this.hasRequireFailures()) return STATE_RECOGNIZED;
                    else {
                        this._timer = setTimeoutContext(function() {
                            this.state = STATE_RECOGNIZED;
                            this.tryEmit();
                        }, options.interval, this);
                        return STATE_BEGAN;
                    }
                }
            }
            return STATE_FAILED;
        },
        failTimeout: function() {
            this._timer = setTimeoutContext(function() {
                this.state = STATE_FAILED;
            }, this.options.interval, this);
            return STATE_FAILED;
        },
        reset: function() {
            clearTimeout(this._timer);
        },
        emit: function() {
            if (this.state == STATE_RECOGNIZED) {
                this._input.tapCount = this.count;
                this.manager.emit(this.options.event, this._input);
            }
        }
    });
    /**
 * Simple way to create an manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ function Hammer(element, options) {
        options = options || {};
        options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
        return new Manager(element, options);
    }
    /**
 * @const {string}
 */ Hammer.VERSION = "2.0.4";
    /**
 * default settings
 * @namespace
 */ Hammer.defaults = {
        /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */ domEvents: false,
        /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */ touchAction: TOUCH_ACTION_COMPUTE,
        /**
     * @type {Boolean}
     * @default true
     */ enable: true,
        /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */ inputTarget: null,
        /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */ inputClass: null,
        /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */ preset: [
            // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
            [
                RotateRecognizer,
                {
                    enable: false
                }
            ],
            [
                PinchRecognizer,
                {
                    enable: false
                },
                [
                    "rotate"
                ]
            ],
            [
                SwipeRecognizer,
                {
                    direction: DIRECTION_HORIZONTAL
                }
            ],
            [
                PanRecognizer,
                {
                    direction: DIRECTION_HORIZONTAL
                },
                [
                    "swipe"
                ]
            ],
            [
                TapRecognizer
            ],
            [
                TapRecognizer,
                {
                    event: "doubletap",
                    taps: 2
                },
                [
                    "tap"
                ]
            ],
            [
                PressRecognizer
            ]
        ],
        /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */ cssProps: {
            /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */ userSelect: "none",
            /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */ touchSelect: "none",
            /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */ touchCallout: "none",
            /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */ contentZooming: "none",
            /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */ userDrag: "none",
            /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */ tapHighlightColor: "rgba(0,0,0,0)"
        }
    };
    var STOP = 1;
    var FORCED_STOP = 2;
    /**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ function Manager(element, options) {
        options = options || {};
        this.options = merge(options, Hammer.defaults);
        this.options.inputTarget = this.options.inputTarget || element;
        this.handlers = {};
        this.session = {};
        this.recognizers = [];
        this.element = element;
        this.input = createInputInstance(this);
        this.touchAction = new TouchAction(this, this.options.touchAction);
        toggleCssProps(this, true);
        each(options.recognizers, function(item) {
            var recognizer = this.add(new item[0](item[1]));
            item[2] && recognizer.recognizeWith(item[2]);
            item[3] && recognizer.requireFailure(item[3]);
        }, this);
    }
    Manager.prototype = {
        /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */ set: function(options) {
            extend(this.options, options);
            // Options that need a little more setup
            if (options.touchAction) this.touchAction.update();
            if (options.inputTarget) {
                // Clean up existing event listeners and reinitialize
                this.input.destroy();
                this.input.target = options.inputTarget;
                this.input.init();
            }
            return this;
        },
        /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */ stop: function(force) {
            this.session.stopped = force ? FORCED_STOP : STOP;
        },
        /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */ recognize: function(inputData) {
            var session = this.session;
            if (session.stopped) return;
            // run the touch-action polyfill
            this.touchAction.preventDefaults(inputData);
            var recognizer;
            var recognizers = this.recognizers;
            // this holds the recognizer that is being recognized.
            // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
            // if no recognizer is detecting a thing, it is set to `null`
            var curRecognizer = session.curRecognizer;
            // reset when the last recognizer is recognized
            // or when we're in a new session
            if (!curRecognizer || curRecognizer && curRecognizer.state & STATE_RECOGNIZED) curRecognizer = session.curRecognizer = null;
            var i = 0;
            while(i < recognizers.length){
                recognizer = recognizers[i];
                // find out if we are allowed try to recognize the input for this one.
                // 1.   allow if the session is NOT forced stopped (see the .stop() method)
                // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
                //      that is being recognized.
                // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
                //      this can be setup with the `recognizeWith()` method on the recognizer.
                if (session.stopped !== FORCED_STOP && (!curRecognizer || recognizer == curRecognizer || // 2
                recognizer.canRecognizeWith(curRecognizer))) recognizer.recognize(inputData);
                else recognizer.reset();
                // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
                // current active recognizer. but only if we don't already have an active recognizer
                if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) curRecognizer = session.curRecognizer = recognizer;
                i++;
            }
        },
        /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */ get: function(recognizer) {
            if (recognizer instanceof Recognizer) return recognizer;
            var recognizers = this.recognizers;
            for(var i = 0; i < recognizers.length; i++){
                if (recognizers[i].options.event == recognizer) return recognizers[i];
            }
            return null;
        },
        /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */ add: function(recognizer) {
            if (invokeArrayArg(recognizer, "add", this)) return this;
            // remove existing
            var existing = this.get(recognizer.options.event);
            if (existing) this.remove(existing);
            this.recognizers.push(recognizer);
            recognizer.manager = this;
            this.touchAction.update();
            return recognizer;
        },
        /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */ remove: function(recognizer) {
            if (invokeArrayArg(recognizer, "remove", this)) return this;
            var recognizers = this.recognizers;
            recognizer = this.get(recognizer);
            recognizers.splice(inArray(recognizers, recognizer), 1);
            this.touchAction.update();
            return this;
        },
        /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */ on: function(events, handler) {
            var handlers = this.handlers;
            each(splitStr(events), function(event) {
                handlers[event] = handlers[event] || [];
                handlers[event].push(handler);
            });
            return this;
        },
        /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */ off: function(events, handler) {
            var handlers = this.handlers;
            each(splitStr(events), function(event) {
                if (!handler) delete handlers[event];
                else handlers[event].splice(inArray(handlers[event], handler), 1);
            });
            return this;
        },
        /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */ emit: function(event, data) {
            // we also want to trigger dom events
            if (this.options.domEvents) triggerDomEvent(event, data);
            // no handlers, so skip it all
            var handlers = this.handlers[event] && this.handlers[event].slice();
            if (!handlers || !handlers.length) return;
            data.type = event;
            data.preventDefault = function() {
                data.srcEvent.preventDefault();
            };
            var i = 0;
            while(i < handlers.length){
                handlers[i](data);
                i++;
            }
        },
        /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */ destroy: function() {
            this.element && toggleCssProps(this, false);
            this.handlers = {};
            this.session = {};
            this.input.destroy();
            this.element = null;
        }
    };
    /**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */ function toggleCssProps(manager, add) {
        var element = manager.element;
        each(manager.options.cssProps, function(value, name) {
            element.style[prefixed(element.style, name)] = add ? value : "";
        });
    }
    /**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */ function triggerDomEvent(event, data) {
        var gestureEvent = document1.createEvent("Event");
        gestureEvent.initEvent(event, true, true);
        gestureEvent.gesture = data;
        data.target.dispatchEvent(gestureEvent);
    }
    extend(Hammer, {
        INPUT_START: INPUT_START,
        INPUT_MOVE: INPUT_MOVE,
        INPUT_END: INPUT_END,
        INPUT_CANCEL: INPUT_CANCEL,
        STATE_POSSIBLE: STATE_POSSIBLE,
        STATE_BEGAN: STATE_BEGAN,
        STATE_CHANGED: STATE_CHANGED,
        STATE_ENDED: STATE_ENDED,
        STATE_RECOGNIZED: STATE_RECOGNIZED,
        STATE_CANCELLED: STATE_CANCELLED,
        STATE_FAILED: STATE_FAILED,
        DIRECTION_NONE: DIRECTION_NONE,
        DIRECTION_LEFT: DIRECTION_LEFT,
        DIRECTION_RIGHT: DIRECTION_RIGHT,
        DIRECTION_UP: DIRECTION_UP,
        DIRECTION_DOWN: DIRECTION_DOWN,
        DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
        DIRECTION_VERTICAL: DIRECTION_VERTICAL,
        DIRECTION_ALL: DIRECTION_ALL,
        Manager: Manager,
        Input: Input,
        TouchAction: TouchAction,
        TouchInput: TouchInput,
        MouseInput: MouseInput,
        PointerEventInput: PointerEventInput,
        TouchMouseInput: TouchMouseInput,
        SingleTouchInput: SingleTouchInput,
        Recognizer: Recognizer,
        AttrRecognizer: AttrRecognizer,
        Tap: TapRecognizer,
        Pan: PanRecognizer,
        Swipe: SwipeRecognizer,
        Pinch: PinchRecognizer,
        Rotate: RotateRecognizer,
        Press: PressRecognizer,
        on: addEventListeners,
        off: removeEventListeners,
        each: each,
        merge: merge,
        extend: extend,
        inherit: inherit,
        bindFn: bindFn,
        prefixed: prefixed
    });
    if (typeof define == TYPE_FUNCTION && define.amd) define(function() {
        return Hammer;
    });
    else if (0, module.exports) module.exports = Hammer;
    else window1[exportName] = Hammer;
})(window, document, "Hammer");

});


parcelRegister("nc4qC", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
function $045b83082a3bcfd4$var$maxFriction(friction, velocityX, velocityY, maxFrictionTime, result) {
    var velocity = Math.sqrt(Math.pow(velocityX, 2) + Math.pow(velocityY, 2));
    friction = Math.max(friction, velocity / maxFrictionTime);
    $045b83082a3bcfd4$var$changeVectorNorm(velocityX, velocityY, friction, result);
    result[0] = Math.abs(result[0]);
    result[1] = Math.abs(result[1]);
}
function $045b83082a3bcfd4$var$changeVectorNorm(x, y, n, result) {
    var theta = Math.atan(y / x);
    result[0] = n * Math.cos(theta);
    result[1] = n * Math.sin(theta);
}
module.exports = {
    maxFriction: $045b83082a3bcfd4$var$maxFriction,
    changeVectorNorm: $045b83082a3bcfd4$var$changeVectorNorm
};

});


parcelRegister("kjQCu", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $6mia6 = parcelRequire("6mia6");

var $bqWZD = parcelRequire("bqWZD");

var $8BNHT = parcelRequire("8BNHT");

var $9eJDl = parcelRequire("9eJDl");

var $nc4qC = parcelRequire("nc4qC");
var $ecae663044f8fa73$require$maxFriction = $nc4qC.maxFriction;

var $2Xxut = parcelRequire("2Xxut");
var $ecae663044f8fa73$var$defaultOptions = {
    speed: 8,
    friction: 6,
    maxFrictionTime: 0.3
};
/**
 * @class QtvrControlMethod
 * @implements ControlMethod
 * @classdesc
 *
 * Controls the view by holding the mouse button down and moving it.
 * Also known as "QTVR" control mode.
 *
 * @param {Element} element Element to listen for events.
 * @param {string} pointerType Which Hammer.js pointer type to use (e.g.
 * `mouse` or `touch`).
 * @param {Object} opts
 * @param {number} opts.speed
 * @param {number} opts.friction
 * @param {number} opts.maxFrictionTime
 */ // TODO: allow speed not change linearly with distance to click spot.
// Quadratic or other would allow a larger speed range.
function $ecae663044f8fa73$var$QtvrControlMethod(element, pointerType, opts) {
    this._element = element;
    this._opts = $9eJDl(opts || {}, $ecae663044f8fa73$var$defaultOptions);
    this._active = false;
    this._hammer = $8BNHT.get(element, pointerType);
    this._dynamics = {
        x: new $bqWZD(),
        y: new $bqWZD()
    };
    this._hammer.on("panstart", this._handleStart.bind(this));
    this._hammer.on("panmove", this._handleMove.bind(this));
    this._hammer.on("panend", this._handleRelease.bind(this));
    this._hammer.on("pancancel", this._handleRelease.bind(this));
}
$6mia6($ecae663044f8fa73$var$QtvrControlMethod);
/**
 * Destructor.
 */ $ecae663044f8fa73$var$QtvrControlMethod.prototype.destroy = function() {
    this._hammer.release();
    $2Xxut(this);
};
$ecae663044f8fa73$var$QtvrControlMethod.prototype._handleStart = function(e) {
    // Prevent event dragging other DOM elements and causing strange behavior on Chrome
    e.preventDefault();
    if (!this._active) {
        this._active = true;
        this.emit("active");
    }
};
$ecae663044f8fa73$var$QtvrControlMethod.prototype._handleMove = function(e) {
    // Prevent event dragging other DOM elements and causing strange behavior on Chrome
    e.preventDefault();
    this._updateDynamics(e, false);
};
$ecae663044f8fa73$var$QtvrControlMethod.prototype._handleRelease = function(e) {
    // Prevent event dragging other DOM elements and causing strange behavior on Chrome
    e.preventDefault();
    this._updateDynamics(e, true);
    if (this._active) {
        this._active = false;
        this.emit("inactive");
    }
};
var $ecae663044f8fa73$var$tmpReleaseFriction = [
    null,
    null
];
$ecae663044f8fa73$var$QtvrControlMethod.prototype._updateDynamics = function(e, release) {
    var elementRect = this._element.getBoundingClientRect();
    var width = elementRect.right - elementRect.left;
    var height = elementRect.bottom - elementRect.top;
    var maxDim = Math.max(width, height);
    var x = e.deltaX / maxDim * this._opts.speed;
    var y = e.deltaY / maxDim * this._opts.speed;
    this._dynamics.x.reset();
    this._dynamics.y.reset();
    this._dynamics.x.velocity = x;
    this._dynamics.y.velocity = y;
    if (release) {
        $ecae663044f8fa73$require$maxFriction(this._opts.friction, this._dynamics.x.velocity, this._dynamics.y.velocity, this._opts.maxFrictionTime, $ecae663044f8fa73$var$tmpReleaseFriction);
        this._dynamics.x.friction = $ecae663044f8fa73$var$tmpReleaseFriction[0];
        this._dynamics.y.friction = $ecae663044f8fa73$var$tmpReleaseFriction[1];
    }
    this.emit("parameterDynamics", "x", this._dynamics.x);
    this.emit("parameterDynamics", "y", this._dynamics.y);
};
module.exports = $ecae663044f8fa73$var$QtvrControlMethod;

});

parcelRegister("fCy8Y", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $6mia6 = parcelRequire("6mia6");

var $bqWZD = parcelRequire("bqWZD");

var $7ATuC = parcelRequire("7ATuC");

var $9eJDl = parcelRequire("9eJDl");

var $2Xxut = parcelRequire("2Xxut");
var $b5f4e3da61565ba3$var$defaultOptions = {
    frictionTime: 0.2,
    zoomDelta: 0.001
};
/**
 * @class ScrollZoomControlMethod
 * @implements ControlMethod
 * @classdesc
 *
 * Controls the fov/zoom through the mouse wheel.
 *
 * @param {Element} element Element to listen for events.
 * @param {Object} opts
 * @param {number} [opts.frictionTime=0.2]
 * @param {number} [opts.zoomDelta=0.001]
 */ function $b5f4e3da61565ba3$var$ScrollZoomControlMethod(element, opts) {
    this._opts = $9eJDl(opts || {}, $b5f4e3da61565ba3$var$defaultOptions);
    this._dynamics = new $bqWZD();
    this._eventList = [];
    var fn = this._opts.frictionTime ? this.withSmoothing : this.withoutSmoothing;
    this._wheelListener = new $7ATuC(element, fn.bind(this));
}
$6mia6($b5f4e3da61565ba3$var$ScrollZoomControlMethod);
/**
 * Destructor.
 */ $b5f4e3da61565ba3$var$ScrollZoomControlMethod.prototype.destroy = function() {
    this._wheelListener.destroy();
    $2Xxut(this);
};
$b5f4e3da61565ba3$var$ScrollZoomControlMethod.prototype.withoutSmoothing = function(e) {
    this._dynamics.offset = $b5f4e3da61565ba3$var$wheelEventDelta(e) * this._opts.zoomDelta;
    this.emit("parameterDynamics", "zoom", this._dynamics);
    e.preventDefault();
    this.emit("active");
    this.emit("inactive");
};
$b5f4e3da61565ba3$var$ScrollZoomControlMethod.prototype.withSmoothing = function(e) {
    var currentTime = e.timeStamp;
    // Record event.
    this._eventList.push(e);
    // Remove events whose smoothing has already expired.
    while(this._eventList[0].timeStamp < currentTime - this._opts.frictionTime * 1000)this._eventList.shift(0);
    // Get the current velocity from the recorded events.
    // Each wheel movement causes a velocity of change/frictionTime during frictionTime.
    var velocity = 0;
    for(var i = 0; i < this._eventList.length; i++){
        var zoomChangeFromEvent = $b5f4e3da61565ba3$var$wheelEventDelta(this._eventList[i]) * this._opts.zoomDelta;
        velocity += zoomChangeFromEvent / this._opts.frictionTime;
    }
    this._dynamics.velocity = velocity;
    this._dynamics.friction = Math.abs(velocity) / this._opts.frictionTime;
    this.emit("parameterDynamics", "zoom", this._dynamics);
    e.preventDefault();
    this.emit("active");
    this.emit("inactive");
};
function $b5f4e3da61565ba3$var$wheelEventDelta(e) {
    var multiplier = e.deltaMode == 1 ? 20 : 1;
    return e.deltaY * multiplier;
}
module.exports = $b5f4e3da61565ba3$var$ScrollZoomControlMethod;

});
parcelRegister("7ATuC", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $2Xxut = parcelRequire("2Xxut");
// Cross-browser mouse wheel event listener.
// Adapted from: https://developer.mozilla.org/en-US/docs/Web/Events/wheel
// This version requires eventShim.
function $5876f0ebe6370ef5$var$WheelListener(elem, callback, useCapture) {
    var eventName = $5876f0ebe6370ef5$var$getEventName();
    if (eventName === "wheel") {
        this._fun = callback;
        this._elem = elem;
        this._elem.addEventListener("wheel", this._fun, useCapture);
    } else if (eventName === "mousewheel") {
        this._fun = $5876f0ebe6370ef5$var$fallbackHandler(callback);
        this._elem = elem;
        this._elem.addEventListener("mousewheel", this._fun, useCapture);
    } else throw new Error("Browser does not support mouse wheel events");
}
/**
 * Destructor.
 */ $5876f0ebe6370ef5$var$WheelListener.prototype.destroy = function() {
    this._elem.removeEventListener($5876f0ebe6370ef5$var$getEventName(), this._fun);
    $2Xxut(this);
};
function $5876f0ebe6370ef5$var$fallbackHandler(callback) {
    return function handleWheelEvent(originalEvent) {
        if (!originalEvent) originalEvent = window.event;
        // Create a normalized event object.
        var event = {
            originalEvent: originalEvent,
            target: originalEvent.target || originalEvent.srcElement,
            type: "wheel",
            deltaMode: 1,
            deltaX: 0,
            deltaZ: 0,
            timeStamp: originalEvent.timeStamp || Date.now(),
            preventDefault: originalEvent.preventDefault.bind(originalEvent)
        };
        // Calculate deltaY.
        event.deltaY = -0.025 * originalEvent.wheelDelta;
        if (originalEvent.wheelDeltaX) // Calculate deltaX.
        event.deltaX = -0.025 * originalEvent.wheelDeltaX;
        // Fire the callback.
        return callback(event);
    };
}
// Detect the supported wheel event name and cache the result.
var $5876f0ebe6370ef5$var$eventName;
function $5876f0ebe6370ef5$var$getEventName() {
    if ($5876f0ebe6370ef5$var$eventName !== undefined) return $5876f0ebe6370ef5$var$eventName;
    if ("onwheel" in document.createElement("div")) // Modern browsers support 'wheel'.
    return $5876f0ebe6370ef5$var$eventName = "wheel";
    else if (document.onmousewheel !== undefined) // Webkit and IE support at least 'mousewheel'.
    return $5876f0ebe6370ef5$var$eventName = "mousewheel";
    else return $5876f0ebe6370ef5$var$eventName = null;
}
module.exports = $5876f0ebe6370ef5$var$WheelListener;

});


parcelRegister("2cyzb", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $6mia6 = parcelRequire("6mia6");

var $bqWZD = parcelRequire("bqWZD");

var $8BNHT = parcelRequire("8BNHT");

var $2Xxut = parcelRequire("2Xxut");
/**
 * @class PinchZoomControlMethod
 * @implements ControlMethod
 * @classdesc
 *
 * Control the view fov/zoom by pinching with two fingers.
 *
 * @param {Element} element Element to listen for events.
 * @param {string} pointerType Which Hammer.js pointer type to use
 * @param {Object} opts
 */ function $19a783f2820e6203$var$PinchZoomControlMethod(element, pointerType, opts) {
    this._hammer = $8BNHT.get(element, pointerType);
    this._lastEvent = null;
    this._active = false;
    this._dynamics = new $bqWZD();
    this._hammer.on("pinchstart", this._handleStart.bind(this));
    this._hammer.on("pinch", this._handleEvent.bind(this));
    this._hammer.on("pinchend", this._handleEnd.bind(this));
    this._hammer.on("pinchcancel", this._handleEnd.bind(this));
}
$6mia6($19a783f2820e6203$var$PinchZoomControlMethod);
/**
 * Destructor.
 */ $19a783f2820e6203$var$PinchZoomControlMethod.prototype.destroy = function() {
    this._hammer.release();
    $2Xxut(this);
};
$19a783f2820e6203$var$PinchZoomControlMethod.prototype._handleStart = function() {
    if (!this._active) {
        this._active = true;
        this.emit("active");
    }
};
$19a783f2820e6203$var$PinchZoomControlMethod.prototype._handleEnd = function() {
    this._lastEvent = null;
    if (this._active) {
        this._active = false;
        this.emit("inactive");
    }
};
$19a783f2820e6203$var$PinchZoomControlMethod.prototype._handleEvent = function(e) {
    var scale = e.scale;
    if (this._lastEvent) scale /= this._lastEvent.scale;
    this._dynamics.offset = (scale - 1) * -1;
    this.emit("parameterDynamics", "zoom", this._dynamics);
    this._lastEvent = e;
};
module.exports = $19a783f2820e6203$var$PinchZoomControlMethod;

});

parcelRegister("joYne", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $6mia6 = parcelRequire("6mia6");

var $bqWZD = parcelRequire("bqWZD");

var $2Xxut = parcelRequire("2Xxut");
/**
 * @class VelocityControlMethod
 * @implements ControlMethod
 * @classdesc
 *
 * Sets the velocity and friction of a single parameter.
 *
 * The user should emit 'active' and 'inactive' events if required.
 *
 * @param {String} parameter The parameter to be controlled (e.g. `x`, `y` or `zoom`)
*/ function $e1ff1729d3bd9a06$var$VelocityControlMethod(parameter) {
    if (!parameter) throw new Error("VelocityControlMethod: parameter must be defined");
    this._parameter = parameter;
    this._dynamics = new $bqWZD();
}
$6mia6($e1ff1729d3bd9a06$var$VelocityControlMethod);
/**
 * Destructor.
 */ $e1ff1729d3bd9a06$var$VelocityControlMethod.prototype.destroy = function() {
    $2Xxut(this);
};
/**
 * Set the parameter's velocity.
 * @param {Number} velocity
 */ $e1ff1729d3bd9a06$var$VelocityControlMethod.prototype.setVelocity = function(velocity) {
    this._dynamics.velocity = velocity;
    this.emit("parameterDynamics", this._parameter, this._dynamics);
};
/**
 * Set the parameter's friction.
 * @param {Number} friction
 */ $e1ff1729d3bd9a06$var$VelocityControlMethod.prototype.setFriction = function(friction) {
    this._dynamics.friction = friction;
    this.emit("parameterDynamics", this._parameter, this._dynamics);
};
module.exports = $e1ff1729d3bd9a06$var$VelocityControlMethod;

});

parcelRegister("b7OCs", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $6mia6 = parcelRequire("6mia6");

var $bqWZD = parcelRequire("bqWZD");

var $2Xxut = parcelRequire("2Xxut");
/**
 * @class ElementPressControlMethod
 * @implements ControlMethod
 * @classdesc
 *
 * Sets the velocity and friction of a single parameter by pressing and
 * unpressing a DOM element.
 *
 * @param {Element} element Element which activates the method when pressed
 * @param {string} parameter The parameter to be controlled (e.g. `x`, `y` or `zoom`)
 * @param {number} velocity Velocity at which the parameter changes. Use a
 * negative number for opposite direction
 * @param {number} friction Friction at which the parameter stops
*/ function $81979d1588a0081d$var$ElementPressControlMethod(element, parameter, velocity, friction) {
    if (!element) throw new Error("ElementPressControlMethod: element must be defined");
    if (!parameter) throw new Error("ElementPressControlMethod: parameter must be defined");
    if (!velocity) throw new Error("ElementPressControlMethod: velocity must be defined");
    if (!friction) throw new Error("ElementPressControlMethod: friction must be defined");
    this._element = element;
    this._pressHandler = this._handlePress.bind(this);
    this._releaseHandler = this._handleRelease.bind(this);
    element.addEventListener("mousedown", this._pressHandler);
    element.addEventListener("mouseup", this._releaseHandler);
    element.addEventListener("mouseleave", this._releaseHandler);
    element.addEventListener("touchstart", this._pressHandler);
    element.addEventListener("touchmove", this._releaseHandler);
    element.addEventListener("touchend", this._releaseHandler);
    this._parameter = parameter;
    this._velocity = velocity;
    this._friction = friction;
    this._dynamics = new $bqWZD();
    this._pressing = false;
}
$6mia6($81979d1588a0081d$var$ElementPressControlMethod);
/**
 * Destructor.
 */ $81979d1588a0081d$var$ElementPressControlMethod.prototype.destroy = function() {
    this._element.removeEventListener("mousedown", this._pressHandler);
    this._element.removeEventListener("mouseup", this._releaseHandler);
    this._element.removeEventListener("mouseleave", this._releaseHandler);
    this._element.removeEventListener("touchstart", this._pressHandler);
    this._element.removeEventListener("touchmove", this._releaseHandler);
    this._element.removeEventListener("touchend", this._releaseHandler);
    $2Xxut(this);
};
$81979d1588a0081d$var$ElementPressControlMethod.prototype._handlePress = function() {
    this._pressing = true;
    this._dynamics.velocity = this._velocity;
    this._dynamics.friction = 0;
    this.emit("parameterDynamics", this._parameter, this._dynamics);
    this.emit("active");
};
$81979d1588a0081d$var$ElementPressControlMethod.prototype._handleRelease = function() {
    if (this._pressing) {
        this._dynamics.friction = this._friction;
        this.emit("parameterDynamics", this._parameter, this._dynamics);
        this.emit("inactive");
    }
    this._pressing = false;
};
module.exports = $81979d1588a0081d$var$ElementPressControlMethod;

});

parcelRegister("rtmgR", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $6mia6 = parcelRequire("6mia6");

var $gSThV = parcelRequire("gSThV");

var $2Xxut = parcelRequire("2Xxut");
var $05294ba8e72eb558$var$debug = typeof MARZIPANODEBUG !== "undefined" && MARZIPANODEBUG.controls;
/**
 * @class Controls
 * @classdesc
 *
 * Set of controls which affect a view (e.g. keyboard, touch)
 *
 * {@link ControlMethod} instances can be registered on this class. The methods
 * are then combined to calculate the final parameters to change the {@link View}.
 *
 * Controls is attached to a {@link RenderLoop}. Currently it affects the
 * {@link view} of all {@link Layer} on the {@link Stage} of the
 * {@link RenderLoop} it is attached to. A more flexible API may be provided
 * in the future.
 *
 * The ControlMethod instances are registered with an id and may be enabled,
 * disabled and unregistered using that id. The whole Control can also be
 * enabled or disabled.
 *
 */ function $05294ba8e72eb558$var$Controls(opts) {
    opts = opts || {};
    this._methods = {};
    this._methodGroups = {};
    this._composer = new $gSThV();
    // Whether the controls are enabled.
    this._enabled = opts && opts.enabled ? !!opts.enabled : true;
    // How many control methods are enabled and in the active state.
    this._activeCount = 0;
    this.updatedViews_ = [];
    this._attachedRenderLoop = null;
}
$6mia6($05294ba8e72eb558$var$Controls);
/**
 * Destructor.
 */ $05294ba8e72eb558$var$Controls.prototype.destroy = function() {
    this.detach();
    this._composer.destroy();
    $2Xxut(this);
};
/**
 * @return {ControlMethod[]} List of registered @{link ControlMethod instances}
 */ $05294ba8e72eb558$var$Controls.prototype.methods = function() {
    var obj = {};
    for(var id in this._methods)obj[id] = this._methods[id];
    return obj;
};
/**
 * @param {String} id
 * @return {ControlMethod}
 */ $05294ba8e72eb558$var$Controls.prototype.method = function(id) {
    return this._methods[id];
};
/**
 * @param {String} id
 * @param {ControlMethod} instance
 * @param {Boolean} [enable=false]
 */ $05294ba8e72eb558$var$Controls.prototype.registerMethod = function(id, instance, enable) {
    if (this._methods[id]) throw new Error("Control method already registered with id " + id);
    this._methods[id] = {
        instance: instance,
        enabled: false,
        active: false,
        activeHandler: this._handleActive.bind(this, id),
        inactiveHandler: this._handleInactive.bind(this, id)
    };
    if (enable) this.enableMethod(id, instance);
};
/**
 * @param {String} id
 */ $05294ba8e72eb558$var$Controls.prototype.unregisterMethod = function(id) {
    var method = this._methods[id];
    if (!method) throw new Error("No control method registered with id " + id);
    if (method.enabled) this.disableMethod(id);
    delete this._methods[id];
};
/**
 * @param {String} id
 */ $05294ba8e72eb558$var$Controls.prototype.enableMethod = function(id) {
    var method = this._methods[id];
    if (!method) throw new Error("No control method registered with id " + id);
    if (method.enabled) return;
    method.enabled = true;
    if (method.active) this._incrementActiveCount();
    this._listen(id);
    this._updateComposer();
    this.emit("methodEnabled", id);
};
/**
 * @param {String} id
 */ $05294ba8e72eb558$var$Controls.prototype.disableMethod = function(id) {
    var method = this._methods[id];
    if (!method) throw new Error("No control method registered with id " + id);
    if (!method.enabled) return;
    method.enabled = false;
    if (method.active) this._decrementActiveCount();
    this._unlisten(id);
    this._updateComposer();
    this.emit("methodDisabled", id);
};
/**
 * Create a method group, which can be used to more conveniently enable or
 * disable several control methods at once
 * @param {String} groupId
 * @param {String[]} methodIds
 */ $05294ba8e72eb558$var$Controls.prototype.addMethodGroup = function(groupId, methodIds) {
    this._methodGroups[groupId] = methodIds;
};
/**
 * @param {String} groupId
 */ $05294ba8e72eb558$var$Controls.prototype.removeMethodGroup = function(id) {
    delete this._methodGroups[id];
};
/**
 * @return {ControlMethodGroup[]} List of control method groups
 */ $05294ba8e72eb558$var$Controls.prototype.methodGroups = function() {
    var obj = {};
    for(var id in this._methodGroups)obj[id] = this._methodGroups[id];
    return obj;
};
/**
 * Enables all the control methods in the group
 * @param {String} groupId
 */ $05294ba8e72eb558$var$Controls.prototype.enableMethodGroup = function(id) {
    var self = this;
    self._methodGroups[id].forEach(function(methodId) {
        self.enableMethod(methodId);
    });
};
/**
 * Disables all the control methods in the group
 * @param {String} groupId
 */ $05294ba8e72eb558$var$Controls.prototype.disableMethodGroup = function(id) {
    var self = this;
    self._methodGroups[id].forEach(function(methodId) {
        self.disableMethod(methodId);
    });
};
/**
 * @returns {Boolean}
 */ $05294ba8e72eb558$var$Controls.prototype.enabled = function() {
    return this._enabled;
};
/**
 * Enables the controls
 */ $05294ba8e72eb558$var$Controls.prototype.enable = function() {
    if (this._enabled) return;
    this._enabled = true;
    if (this._activeCount > 0) this.emit("active");
    this.emit("enabled");
    this._updateComposer();
};
/**
 * Disables the controls
 */ $05294ba8e72eb558$var$Controls.prototype.disable = function() {
    if (!this._enabled) return;
    this._enabled = false;
    if (this._activeCount > 0) this.emit("inactive");
    this.emit("disabled");
    this._updateComposer();
};
/**
 * Attaches the controls to a {@link RenderLoop}. The RenderLoop will be woken
 * up when the controls are activated
 *
 * @param {RenderLoop}
 */ $05294ba8e72eb558$var$Controls.prototype.attach = function(renderLoop) {
    if (this._attachedRenderLoop) this.detach();
    this._attachedRenderLoop = renderLoop;
    this._beforeRenderHandler = this._updateViewsWithControls.bind(this);
    this._changeHandler = renderLoop.renderOnNextFrame.bind(renderLoop);
    this._attachedRenderLoop.addEventListener("beforeRender", this._beforeRenderHandler);
    this._composer.addEventListener("change", this._changeHandler);
};
/**
 * Detaches the controls
 */ $05294ba8e72eb558$var$Controls.prototype.detach = function() {
    if (!this._attachedRenderLoop) return;
    this._attachedRenderLoop.removeEventListener("beforeRender", this._beforeRenderHandler);
    this._composer.removeEventListener("change", this._changeHandler);
    this._beforeRenderHandler = null;
    this._changeHandler = null;
    this._attachedRenderLoop = null;
};
/**
 * @param {Boolean}
 */ $05294ba8e72eb558$var$Controls.prototype.attached = function() {
    return this._attachedRenderLoop != null;
};
$05294ba8e72eb558$var$Controls.prototype._listen = function(id) {
    var method = this._methods[id];
    if (!method) throw new Error("Bad method id");
    method.instance.addEventListener("active", method.activeHandler);
    method.instance.addEventListener("inactive", method.inactiveHandler);
};
$05294ba8e72eb558$var$Controls.prototype._unlisten = function(id) {
    var method = this._methods[id];
    if (!method) throw new Error("Bad method id");
    method.instance.removeEventListener("active", method.activeHandler);
    method.instance.removeEventListener("inactive", method.inactiveHandler);
};
$05294ba8e72eb558$var$Controls.prototype._handleActive = function(id) {
    var method = this._methods[id];
    if (!method) throw new Error("Bad method id");
    if (!method.enabled) throw new Error("Should not receive event from disabled control method");
    if (!method.active) {
        method.active = true;
        this._incrementActiveCount();
    }
};
$05294ba8e72eb558$var$Controls.prototype._handleInactive = function(id) {
    var method = this._methods[id];
    if (!method) throw new Error("Bad method id");
    if (!method.enabled) throw new Error("Should not receive event from disabled control method");
    if (method.active) {
        method.active = false;
        this._decrementActiveCount();
    }
};
$05294ba8e72eb558$var$Controls.prototype._incrementActiveCount = function() {
    this._activeCount++;
    if ($05294ba8e72eb558$var$debug) this._checkActiveCount();
    if (this._enabled && this._activeCount === 1) this.emit("active");
};
$05294ba8e72eb558$var$Controls.prototype._decrementActiveCount = function() {
    this._activeCount--;
    if ($05294ba8e72eb558$var$debug) this._checkActiveCount();
    if (this._enabled && this._activeCount === 0) this.emit("inactive");
};
$05294ba8e72eb558$var$Controls.prototype._checkActiveCount = function() {
    var count = 0;
    for(var id in this._methods){
        var method = this._methods[id];
        if (method.enabled && method.active) count++;
    }
    if (count != this._activeCount) throw new Error("Bad control state");
};
$05294ba8e72eb558$var$Controls.prototype._updateComposer = function() {
    var composer = this._composer;
    for(var id in this._methods){
        var method = this._methods[id];
        var enabled = this._enabled && method.enabled;
        if (enabled && !composer.has(method.instance)) composer.add(method.instance);
        if (!enabled && composer.has(method.instance)) composer.remove(method.instance);
    }
};
$05294ba8e72eb558$var$Controls.prototype._updateViewsWithControls = function() {
    var controlData = this._composer.offsets();
    if (controlData.changing) this._attachedRenderLoop.renderOnNextFrame();
    // Update each view at most once, even when shared by multiple layers.
    // The number of views is expected to be small, so use an array to keep track.
    this.updatedViews_.length = 0;
    var layers = this._attachedRenderLoop.stage().listLayers();
    for(var i = 0; i < layers.length; i++){
        var view = layers[i].view();
        if (this.updatedViews_.indexOf(view) < 0) {
            layers[i].view().updateWithControlParameters(controlData.offsets);
            this.updatedViews_.push(view);
        }
    }
};
module.exports = $05294ba8e72eb558$var$Controls;

});
parcelRegister("gSThV", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $6mia6 = parcelRequire("6mia6");

var $bqWZD = parcelRequire("bqWZD");

var $azWbw = parcelRequire("azWbw");

var $2Xxut = parcelRequire("2Xxut");
/**
 * @class ControlComposer
 * @classdesc
 *
 * Combines changes in parameters triggered by multiple {@link ControlMethod}
 * instances.
 *
 * @listens ControlMethod#parameterDynamics
 */ function $c4ac938ec0efcd4f$var$ControlComposer(opts) {
    opts = opts || {};
    this._methods = [];
    this._parameters = [
        "x",
        "y",
        "axisScaledX",
        "axisScaledY",
        "zoom",
        "yaw",
        "pitch",
        "roll"
    ];
    this._now = opts.nowForTesting || $azWbw;
    this._composedOffsets = {};
    this._composeReturn = {
        offsets: this._composedOffsets,
        changing: null
    };
}
$6mia6($c4ac938ec0efcd4f$var$ControlComposer);
$c4ac938ec0efcd4f$var$ControlComposer.prototype.add = function(instance) {
    if (this.has(instance)) return;
    var dynamics = {};
    this._parameters.forEach(function(parameter) {
        dynamics[parameter] = {
            dynamics: new $bqWZD(),
            time: null
        };
    });
    var parameterDynamicsHandler = this._updateDynamics.bind(this, dynamics);
    var method = {
        instance: instance,
        dynamics: dynamics,
        parameterDynamicsHandler: parameterDynamicsHandler
    };
    instance.addEventListener("parameterDynamics", parameterDynamicsHandler);
    this._methods.push(method);
};
$c4ac938ec0efcd4f$var$ControlComposer.prototype.remove = function(instance) {
    var index = this._indexOfInstance(instance);
    if (index >= 0) {
        var method = this._methods.splice(index, 1)[0];
        method.instance.removeEventListener("parameterDynamics", method.parameterDynamicsHandler);
    }
};
$c4ac938ec0efcd4f$var$ControlComposer.prototype.has = function(instance) {
    return this._indexOfInstance(instance) >= 0;
};
$c4ac938ec0efcd4f$var$ControlComposer.prototype._indexOfInstance = function(instance) {
    for(var i = 0; i < this._methods.length; i++){
        if (this._methods[i].instance === instance) return i;
    }
    return -1;
};
$c4ac938ec0efcd4f$var$ControlComposer.prototype.list = function() {
    var instances = [];
    for(var i = 0; i < this._methods.length; i++)instances.push(this._methods[i].instance);
    return instances;
};
$c4ac938ec0efcd4f$var$ControlComposer.prototype._updateDynamics = function(storedDynamics, parameter, dynamics) {
    var parameterDynamics = storedDynamics[parameter];
    if (!parameterDynamics) throw new Error("Unknown control parameter " + parameter);
    var newTime = this._now();
    parameterDynamics.dynamics.update(dynamics, (newTime - parameterDynamics.time) / 1000);
    parameterDynamics.time = newTime;
    this.emit("change");
};
$c4ac938ec0efcd4f$var$ControlComposer.prototype._resetComposedOffsets = function() {
    for(var i = 0; i < this._parameters.length; i++)this._composedOffsets[this._parameters[i]] = 0;
};
$c4ac938ec0efcd4f$var$ControlComposer.prototype.offsets = function() {
    var parameter;
    var changing = false;
    var currentTime = this._now();
    this._resetComposedOffsets();
    for(var i = 0; i < this._methods.length; i++){
        var methodDynamics = this._methods[i].dynamics;
        for(var p = 0; p < this._parameters.length; p++){
            parameter = this._parameters[p];
            var parameterDynamics = methodDynamics[parameter];
            var dynamics = parameterDynamics.dynamics;
            // Add offset to composed offset
            if (dynamics.offset != null) {
                this._composedOffsets[parameter] += dynamics.offset;
                // Reset offset
                dynamics.offset = null;
            }
            // Calculate offset from velocity and add it
            var elapsed = (currentTime - parameterDynamics.time) / 1000;
            var offsetFromVelocity = dynamics.offsetFromVelocity(elapsed);
            if (offsetFromVelocity) this._composedOffsets[parameter] += offsetFromVelocity;
            // Update velocity on dynamics
            var currentVelocity = dynamics.velocityAfter(elapsed);
            dynamics.velocity = currentVelocity;
            // If there is still a velocity, set changing
            if (currentVelocity) changing = true;
            parameterDynamics.time = currentTime;
        }
    }
    this._composeReturn.changing = changing;
    return this._composeReturn;
};
$c4ac938ec0efcd4f$var$ControlComposer.prototype.destroy = function() {
    var instances = this.list();
    for(var i = 0; i < instances.length; i++)this.remove(instances[i]);
    $2Xxut(this);
};
module.exports = $c4ac938ec0efcd4f$var$ControlComposer;

});


parcelRegister("kkazn", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $W9Vbx = parcelRequire("W9Vbx");

var $6mia6 = parcelRequire("6mia6");

var $h0UOQ = parcelRequire("h0UOQ");

var $rtmgR = parcelRequire("rtmgR");

var $9kjMi = parcelRequire("9kjMi");

var $460G7 = parcelRequire("460G7");

var $jgcBG = parcelRequire("jgcBG");

var $kgURn = parcelRequire("kgURn");

var $lUg8r = parcelRequire("lUg8r");

var $1dJzJ = parcelRequire("1dJzJ");

var $8BNHT = parcelRequire("8BNHT");

var $9aEkC = parcelRequire("9aEkC");

var $kjZKr = parcelRequire("kjZKr");

var $dBMHD = parcelRequire("dBMHD");
var $ecbddfc8b3d27744$require$setOverflowHidden = $dBMHD.setOverflowHidden;

var $dBMHD = parcelRequire("dBMHD");
var $ecbddfc8b3d27744$require$setAbsolute = $dBMHD.setAbsolute;

var $dBMHD = parcelRequire("dBMHD");
var $ecbddfc8b3d27744$require$setFullSize = $dBMHD.setFullSize;

var $dBMHD = parcelRequire("dBMHD");
var $ecbddfc8b3d27744$require$setBlocking = $dBMHD.setBlocking;

var $28mhx = parcelRequire("28mhx");

var $exIfG = parcelRequire("exIfG");

var $2Xxut = parcelRequire("2Xxut");
var $ecbddfc8b3d27744$var$stageMap = {
    webgl: $jgcBG,
    css: $kgURn,
    flash: $lUg8r
};
var $ecbddfc8b3d27744$var$stagePrefList = [
    $jgcBG,
    $kgURn,
    $lUg8r
];
/**
 * Signals that the current scene has changed.
 * @event Viewer#sceneChange
 */ /**
 * Signals that the view of the current scene has changed. See
 * {@link View#event:change}.
 * @event Viewer#viewChange
 */ /**
 * @class Viewer
 * @classdesc
 *
 * A Viewer is a container for multiple {@link Scene scenes} to be displayed
 * inside a {@link Stage stage} contained in the DOM.
 *
 * Scenes may be created by calling {@link Viewer#createScene}. Except during a
 * scene switch, a single one of them, called the current scene, is visible.
 * Calling {@link Viewer#switchScene} sets the current scene and switches to it.
 *
 * @param {Element} domElement The DOM element to contain the stage.
 * @param {Object} opts Viewer creation options.
 * @param {(null|'webgl'|'css'|'flash')} [opts.stageType=null] The type of stage
 *     to create. The default is to choose the most appropriate type depending
 *     on the browser capabilities.
 * @param {Object} opts.controls Options to be passed to
 *     {@link registerDefaultControls}.
 * @param {Object} opts.stage Options to be passed to the {@link Stage}
 *     constructor.
 * @param {Object} opts.cursors Cursor options.
 * @param {Object} opts.cursors.drag Drag cursor options to be passed to the
 *     {@link ControlCursor} constructor.
 */ function $ecbddfc8b3d27744$var$Viewer(domElement, opts) {
    opts = opts || {};
    this._domElement = domElement;
    // Add `overflow: hidden` to the domElement.
    $ecbddfc8b3d27744$require$setOverflowHidden(domElement);
    // Select the stage type to use.
    var Stage;
    if (opts.stageType) {
        // If a specific stage type was specified, use that one.
        Stage = $ecbddfc8b3d27744$var$stageMap[opts.stageType];
        if (!Stage) throw new Error("Unknown stage type: " + opts.stageType);
    } else {
        // Choose the best supported stage according to the default preference
        // order. Note that this may yield an unsupported stage for some
        // geometry/view combinations. Client code is expected to pass in a
        // specific stage type in those cases.
        for(var i = 0; i < $ecbddfc8b3d27744$var$stagePrefList.length; i++)if ($ecbddfc8b3d27744$var$stagePrefList[i].supported()) {
            Stage = $ecbddfc8b3d27744$var$stagePrefList[i];
            break;
        }
        if (!Stage) throw new Error("None of the stage types are supported");
    }
    // Create stage.
    this._stage = new Stage(opts.stage);
    // Register the default renderers for the selected stage.
    $kjZKr(this._stage);
    // Add the stage element into the DOM.
    this._domElement.appendChild(this._stage.domElement());
    // Create control container.
    // Controls cannot be placed directly on the root DOM element because
    // Hammer.js will prevent click events from reaching the elements beneath.
    // The hotspot containers will be added inside the controls container.
    this._controlContainer = document.createElement("div");
    $ecbddfc8b3d27744$require$setAbsolute(this._controlContainer);
    $ecbddfc8b3d27744$require$setFullSize(this._controlContainer);
    // Prevent bounce scroll effect on iOS.
    // Applied only for iOS, as Android's events must have the default action to allow interaction with hotspots.
    if ($W9Vbx.ios) this._controlContainer.addEventListener("touchmove", function(event) {
        event.preventDefault();
    });
    // Old IE does not detect mouse events on elements without background
    // Add a child element to the controls with full width, a background color
    // and opacity 0
    var controlCapture = document.createElement("div");
    $ecbddfc8b3d27744$require$setAbsolute(controlCapture);
    $ecbddfc8b3d27744$require$setFullSize(controlCapture);
    $ecbddfc8b3d27744$require$setBlocking(controlCapture);
    this._controlContainer.appendChild(controlCapture);
    domElement.appendChild(this._controlContainer);
    // Respond to window size changes.
    this._size = {};
    this.updateSize();
    this._updateSizeListener = this.updateSize.bind(this);
    window.addEventListener("resize", this._updateSizeListener);
    // Create render loop.
    this._renderLoop = new $h0UOQ(this._stage);
    // Create the controls and register them with the render loop.
    this._controls = new $rtmgR();
    this._controlMethods = $9aEkC(this._controls, this._controlContainer, opts.controls);
    this._controls.attach(this._renderLoop);
    // Expose HammerJS.
    this._hammerManagerTouch = $8BNHT.get(this._controlContainer, "touch");
    this._hammerManagerMouse = $8BNHT.get(this._controlContainer, "mouse");
    // Initialize drag cursor.
    this._dragCursor = new $1dJzJ(this._controls, "mouseViewDrag", domElement, opts.cursors && opts.cursors.drag || {});
    // Start the render loop.
    this._renderLoop.start();
    // Scene list.
    this._scenes = [];
    // The currently visible scene.
    // During a scene transition, this is the scene being switched to.
    this._currentScene = null;
    // The scene being switched from during a scene transition.
    // This is necessary to update the layers correctly when they are added or
    // removed during a transition.
    this._replacedScene = null;
    // The current transition.
    this._cancelCurrentTween = null;
    // The event listener fired when the current scene layers change.
    // This is attached to the correct scene whenever the current scene changes.
    this._layerChangeHandler = this._updateSceneLayers.bind(this);
    // The event listener fired when the current scene view changes.
    // This is attached to the correct scene whenever the current scene changes.
    this._viewChangeHandler = this.emit.bind(this, "viewChange");
    // Setup the idle timer.
    // By default, the timer has an infinite duration so it does nothing.
    this._idleTimer = new $460G7();
    this._idleTimer.start();
    // Reset the timer whenever the view changes.
    this._resetIdleTimerHandler = this._resetIdleTimer.bind(this);
    this.addEventListener("viewChange", this._resetIdleTimerHandler);
    // Start the idle movement when the idle timer fires.
    this._triggerIdleTimerHandler = this._triggerIdleTimer.bind(this);
    this._idleTimer.addEventListener("timeout", this._triggerIdleTimerHandler);
    // Stop an ongoing movement when the controls are activated or when the
    // scene changes.
    this._stopMovementHandler = this.stopMovement.bind(this);
    this._controls.addEventListener("active", this._stopMovementHandler);
    this.addEventListener("sceneChange", this._stopMovementHandler);
    // The currently programmed idle movement.
    this._idleMovement = null;
}
$6mia6($ecbddfc8b3d27744$var$Viewer);
/**
 * Destructor.
 */ $ecbddfc8b3d27744$var$Viewer.prototype.destroy = function() {
    window.removeEventListener("resize", this._updateSizeListener);
    if (this._currentScene) this._removeSceneEventListeners(this._currentScene);
    if (this._replacedScene) this._removeSceneEventListeners(this._replacedScene);
    this._dragCursor.destroy();
    for(var methodName in this._controlMethods)this._controlMethods[methodName].destroy();
    while(this._scenes.length)this.destroyScene(this._scenes[0]);
    // The Flash renderer must be torn down before the element is removed from
    // the DOM, so all scenes must have been destroyed before this point.
    this._domElement.removeChild(this._stage.domElement());
    this._stage.destroy();
    this._renderLoop.destroy();
    this._controls.destroy();
    this._controls = null;
    if (this._cancelCurrentTween) this._cancelCurrentTween();
    $2Xxut(this);
};
/**
 * Updates the stage size to fill the containing element.
 *
 * This method is automatically called when the browser window is resized.
 * Most clients won't need to explicitly call it to keep the size up to date.
 */ $ecbddfc8b3d27744$var$Viewer.prototype.updateSize = function() {
    var size = this._size;
    size.width = this._domElement.clientWidth;
    size.height = this._domElement.clientHeight;
    this._stage.setSize(size);
};
/**
 * Returns the underlying {@link Stage stage}.
 * @return {Stage}
 */ $ecbddfc8b3d27744$var$Viewer.prototype.stage = function() {
    return this._stage;
};
/**
 * Returns the underlying {@link RenderLoop render loop}.
 * @return {RenderLoop}
 */ $ecbddfc8b3d27744$var$Viewer.prototype.renderLoop = function() {
    return this._renderLoop;
};
/**
 * Returns the underlying {@link Controls controls}.
 * @return {Controls}
 */ $ecbddfc8b3d27744$var$Viewer.prototype.controls = function() {
    return this._controls;
};
/**
 * Returns the underlying DOM element.
 * @return {Element}
 */ $ecbddfc8b3d27744$var$Viewer.prototype.domElement = function() {
    return this._domElement;
};
/**
 * Creates a new {@link Scene scene} with a single layer and adds it to the
 * viewer.
 *
 * The current scene does not change. To switch to the scene, call
 * {@link Viewer#switchScene}.
 *
 * @param {Object} opts Scene creation options.
 * @param {View} opts.view The scene's underlying {@link View}.
 * @param {Source} opts.source The layer's underlying {@link Source}.
 * @param {Geometry} opts.geometry The layer's underlying {@link Geometry}.
 * @param {boolean} [opts.pinFirstLevel=false] Whether to pin the first level to
 *     provide a fallback of last resort, at the cost of memory consumption.
 * @param {Object} [opts.textureStoreOpts={}] Options to pass to the
 *     {@link TextureStore} constructor.
 * @param {Object} [opts.layerOpts={}] Options to pass to the {@link Layer}
 *     constructor.
 * @return {Scene}
 */ $ecbddfc8b3d27744$var$Viewer.prototype.createScene = function(opts) {
    opts = opts || {};
    var scene = this.createEmptyScene({
        view: opts.view
    });
    scene.createLayer({
        source: opts.source,
        geometry: opts.geometry,
        pinFirstLevel: opts.pinFirstLevel,
        textureStoreOpts: opts.textureStoreOpts,
        layerOpts: opts.layerOpts
    });
    return scene;
};
/**
 * Creates a new {@link Scene scene} with no layers and adds it to the viewer.
 *
 * Layers may be added to the scene by calling {@link Scene#createLayer}.
 * However, if the scene has a single layer, it is simpler to call
 * {@link Viewer#createScene} instead of this method.
 *
 * The current scene does not change. To switch to the scene, call
 * {@link Viewer#switchScene}.
 *
 * @param {Object} opts Scene creation options.
 * @param {View} opts.view The scene's underlying {@link View}.
 * @return {Scene}
 */ $ecbddfc8b3d27744$var$Viewer.prototype.createEmptyScene = function(opts) {
    opts = opts || {};
    var scene = new $9kjMi(this, opts.view);
    this._scenes.push(scene);
    return scene;
};
$ecbddfc8b3d27744$var$Viewer.prototype._updateSceneLayers = function() {
    var i;
    var layer;
    var stage = this._stage;
    var currentScene = this._currentScene;
    var replacedScene = this._replacedScene;
    var oldLayers = stage.listLayers();
    // The stage contains layers from at most two scenes: the current one, on top,
    // and the one currently being switched away from, on the bottom.
    var newLayers = [];
    if (replacedScene) newLayers = newLayers.concat(replacedScene.listLayers());
    if (currentScene) newLayers = newLayers.concat(currentScene.listLayers());
    // A single layer can be added or removed from the scene at a time.
    if (Math.abs(oldLayers.length - newLayers.length) !== 1) throw new Error("Stage and scene out of sync");
    if (newLayers.length < oldLayers.length) // A layer was removed.
    for(i = 0; i < oldLayers.length; i++){
        layer = oldLayers[i];
        if (newLayers.indexOf(layer) < 0) {
            this._removeLayerFromStage(layer);
            break;
        }
    }
    if (newLayers.length > oldLayers.length) // A layer was added.
    for(i = 0; i < newLayers.length; i++){
        layer = newLayers[i];
        if (oldLayers.indexOf(layer) < 0) this._addLayerToStage(layer, i);
    }
// TODO: When in the middle of a scene transition, call the transition update
// function immediately to prevent an added layer from flashing with the wrong
// opacity.
};
$ecbddfc8b3d27744$var$Viewer.prototype._addLayerToStage = function(layer, i) {
    // Pin the first level to ensure a fallback while the layer is visible.
    // Note that this is distinct from the `pinFirstLevel` option passed to
    // createScene(), which pins the layer even when it's not visible.
    layer.pinFirstLevel();
    this._stage.addLayer(layer, i);
};
$ecbddfc8b3d27744$var$Viewer.prototype._removeLayerFromStage = function(layer) {
    this._stage.removeLayer(layer);
    layer.unpinFirstLevel();
    layer.textureStore().clearNotPinned();
};
$ecbddfc8b3d27744$var$Viewer.prototype._addSceneEventListeners = function(scene) {
    scene.addEventListener("layerChange", this._layerChangeHandler);
    scene.addEventListener("viewChange", this._viewChangeHandler);
};
$ecbddfc8b3d27744$var$Viewer.prototype._removeSceneEventListeners = function(scene) {
    scene.removeEventListener("layerChange", this._layerChangeHandler);
    scene.removeEventListener("viewChange", this._viewChangeHandler);
};
/**
 * Destroys a {@link Scene scene} and removes it from the viewer.
 * @param {Scene} scene
 */ $ecbddfc8b3d27744$var$Viewer.prototype.destroyScene = function(scene) {
    var i = this._scenes.indexOf(scene);
    if (i < 0) throw new Error("No such scene in viewer");
    var j;
    var layers;
    if (this._currentScene === scene) {
        // The destroyed scene is the current scene.
        // Remove event listeners, remove layers from stage and cancel transition.
        this._removeSceneEventListeners(scene);
        layers = scene.listLayers();
        for(j = 0; j < layers.length; j++)this._removeLayerFromStage(layers[j]);
        if (this._cancelCurrentTween) {
            this._cancelCurrentTween();
            this._cancelCurrentTween = null;
        }
        this._currentScene = null;
        this.emit("sceneChange");
    }
    if (this._replacedScene === scene) {
        // The destroyed scene is being switched away from.
        // Remove event listeners and remove layers from stage.
        this._removeSceneEventListeners(scene);
        layers = scene.listLayers();
        for(j = 0; j < layers.length; j++)this._removeLayerFromStage(layers[j]);
        this._replacedScene = null;
    }
    this._scenes.splice(i, 1);
    scene.destroy();
};
/**
 * Destroys all {@link Scene scenes} and removes them from the viewer.
 */ $ecbddfc8b3d27744$var$Viewer.prototype.destroyAllScenes = function() {
    while(this._scenes.length > 0)this.destroyScene(this._scenes[0]);
};
/**
 * Returns whether the viewer contains a {@link Scene scene}.
 * @param {Scene} scene
 * @return {boolean}
 */ $ecbddfc8b3d27744$var$Viewer.prototype.hasScene = function(scene) {
    return this._scenes.indexOf(scene) >= 0;
};
/**
 * Returns a list of all {@link Scene scenes}.
 * @return {Scene[]}
 */ $ecbddfc8b3d27744$var$Viewer.prototype.listScenes = function() {
    return [].concat(this._scenes);
};
/**
 * Returns the current {@link Scene scene}, or null if there isn't one.
 *
 * To change the current scene, call {@link Viewer#switchScene}.
 *
 * @return {Scene}
 */ $ecbddfc8b3d27744$var$Viewer.prototype.scene = function() {
    return this._currentScene;
};
/**
 * Returns the {@link View view} for the current {@link Scene scene}, or null
 * if there isn't one.
 * @return {View}
 */ $ecbddfc8b3d27744$var$Viewer.prototype.view = function() {
    var scene = this._currentScene;
    if (scene) return scene.view();
    return null;
};
/**
 * Tweens the {@link View view} for the current {@link Scene scene}.
 *
 * This method is equivalent to calling {@link Scene#lookTo} on the current
 * scene.
 *
 * @param {Object} opts Options to pass into {@link Scene#lookTo}.
 * @param {function} done Function to call when the tween is complete.
 */ $ecbddfc8b3d27744$var$Viewer.prototype.lookTo = function(params, opts, done) {
    // TODO: is it an error to call lookTo when no scene is displayed?
    var scene = this._currentScene;
    if (scene) scene.lookTo(params, opts, done);
};
/**
 * Starts a movement, possibly replacing the current movement.
 *
 * This method is equivalent to calling {@link Scene#startMovement} on the
 * current scene. If there is no current scene, this is a no-op.
 *
 * @param {function} fn The movement function.
 * @param {function} done Function to be called when the movement finishes or is
 *     interrupted.
 */ $ecbddfc8b3d27744$var$Viewer.prototype.startMovement = function(fn, done) {
    var scene = this._currentScene;
    if (!scene) return;
    scene.startMovement(fn, done);
};
/**
 * Stops the current movement.
 *
 * This method is equivalent to calling {@link Scene#stopMovement} on the
 * current scene. If there is no current scene, this is a no-op.
 */ $ecbddfc8b3d27744$var$Viewer.prototype.stopMovement = function() {
    var scene = this._currentScene;
    if (!scene) return;
    scene.stopMovement();
};
/**
 * Returns the current movement.
 *
 * This method is equivalent to calling {@link Scene#movement} on the
 * current scene. If there is no current scene, this is a no-op.
 *
 * @return {function}
 */ $ecbddfc8b3d27744$var$Viewer.prototype.movement = function() {
    var scene = this._currentScene;
    if (!scene) return;
    return scene.movement();
};
/**
 * Schedules an idle movement to be automatically started when the view remains
 * unchanged for the given timeout period.
 *
 * Changing the view while the idle movement is active stops the movement and
 * schedules it to start again after the same timeout period. To disable it
 * permanently, call with a null movement or an infinite timeout.
 *
 * @param {number} timeout Timeout period in milliseconds.
 * @param {function} movement Automatic movement function, or null to disable.
 */ $ecbddfc8b3d27744$var$Viewer.prototype.setIdleMovement = function(timeout, movement) {
    this._idleTimer.setDuration(timeout);
    this._idleMovement = movement;
};
/**
 * Stops the idle movement. It will be started again after the timeout set by
 * {@link Viewer#setIdleMovement}.
 */ $ecbddfc8b3d27744$var$Viewer.prototype.breakIdleMovement = function() {
    this.stopMovement();
    this._resetIdleTimer();
};
$ecbddfc8b3d27744$var$Viewer.prototype._resetIdleTimer = function() {
    this._idleTimer.start();
};
$ecbddfc8b3d27744$var$Viewer.prototype._triggerIdleTimer = function() {
    var idleMovement = this._idleMovement;
    if (!idleMovement) return;
    this.startMovement(idleMovement);
};
var $ecbddfc8b3d27744$var$defaultSwitchDuration = 1000;
function $ecbddfc8b3d27744$var$defaultTransitionUpdate(val, newScene, oldScene) {
    var layers = newScene.listLayers();
    layers.forEach(function(layer) {
        layer.mergeEffects({
            opacity: val
        });
    });
    newScene._hotspotContainer.domElement().style.opacity = val;
}
/**
 * Switches to another {@link Scene scene} with a fade transition. This scene
 * becomes the current one.
 *
 * If a transition is already taking place, it is interrupted before the new one
 * starts.
 *
 * @param {Scene} newScene The scene to switch to.
 * @param {Object} opts Transition options.
 * @param {number} [opts.transitionDuration=1000] Transition duration, in
 *     milliseconds.
 * @param {number} [opts.transitionUpdate=defaultTransitionUpdate]
 *     Transition update function, with signature `f(t, newScene, oldScene)`.
 *     This function is called on each frame with `t` increasing from 0 to 1.
 *     An initial call with `t=0` and a final call with `t=1` are guaranteed.
 *     The default function sets the opacity of the new scene to `t`.
 * @param {function} done Function to call when the transition finishes or is
 *     interrupted. If the new scene is equal to the old one, no transition
 *     takes place, but this function is still called.
 */ $ecbddfc8b3d27744$var$Viewer.prototype.switchScene = function(newScene, opts, done) {
    var self = this;
    opts = opts || {};
    done = done || $exIfG;
    var stage = this._stage;
    var oldScene = this._currentScene;
    // Do nothing if the target scene is the current one.
    if (oldScene === newScene) {
        done();
        return;
    }
    if (this._scenes.indexOf(newScene) < 0) throw new Error("No such scene in viewer");
    // Cancel an already ongoing transition. This ensures that the stage contains
    // layers from exactly one scene before the transition begins.
    if (this._cancelCurrentTween) {
        this._cancelCurrentTween();
        this._cancelCurrentTween = null;
    }
    var oldSceneLayers = oldScene ? oldScene.listLayers() : [];
    var newSceneLayers = newScene.listLayers();
    var stageLayers = stage.listLayers();
    // Check that the stage contains exactly as many layers as the current scene,
    // and that the top layer is the right one. If this test fails, either there
    // is a bug or the user tried to modify the stage concurrently.
    if (oldScene && (stageLayers.length !== oldSceneLayers.length || stageLayers.length > 1 && stageLayers[0] != oldSceneLayers[0])) throw new Error("Stage not in sync with viewer");
    // Get the transition parameters.
    var duration = opts.transitionDuration != null ? opts.transitionDuration : $ecbddfc8b3d27744$var$defaultSwitchDuration;
    var update = opts.transitionUpdate != null ? opts.transitionUpdate : $ecbddfc8b3d27744$var$defaultTransitionUpdate;
    // Add new scene layers into the stage before starting the transition.
    for(var i = 0; i < newSceneLayers.length; i++)this._addLayerToStage(newSceneLayers[i]);
    // Update function to be called on every frame.
    function tweenUpdate(val) {
        update(val, newScene, oldScene);
    }
    // Once the transition is complete, remove old scene layers from the stage and
    // remove the event listeners. If the old scene was destroyed during the
    // transition, this has already been taken care of. Otherwise, we still need
    // to get a fresh copy of the scene's layers, since they might have changed
    // during the transition.
    function tweenDone() {
        if (self._replacedScene) {
            self._removeSceneEventListeners(self._replacedScene);
            oldSceneLayers = self._replacedScene.listLayers();
            for(var i = 0; i < oldSceneLayers.length; i++)self._removeLayerFromStage(oldSceneLayers[i]);
            self._replacedScene = null;
        }
        self._cancelCurrentTween = null;
        done();
    }
    // Store the cancelable for the transition.
    this._cancelCurrentTween = $28mhx(duration, tweenUpdate, tweenDone);
    // Update the current and replaced scene.
    this._currentScene = newScene;
    this._replacedScene = oldScene;
    // Emit scene and view change events.
    this.emit("sceneChange");
    this.emit("viewChange");
    // Add event listeners to the new scene.
    // Note that event listeners can only be removed from the old scene once the
    // transition is complete, since layers might get added or removed in the
    // interim.
    this._addSceneEventListeners(newScene);
};
module.exports = $ecbddfc8b3d27744$var$Viewer;

});
parcelRegister("9kjMi", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $gouN9 = parcelRequire("gouN9");

var $8U6hQ = parcelRequire("8U6hQ");

var $a3AC3 = parcelRequire("a3AC3");

var $6mia6 = parcelRequire("6mia6");

var $azWbw = parcelRequire("azWbw");

var $exIfG = parcelRequire("exIfG");

var $fXp6t = parcelRequire("fXp6t");

var $9eJDl = parcelRequire("9eJDl");

var $2Xxut = parcelRequire("2Xxut");
/**
 * Signals that the scene's view has changed. See {@link View#event:change}.
 * @event Scene#viewChange
 */ /**
 * Signals that the scene's layers have changed.
 * @event Scene#layerChange
 */ /**
 * @class Scene
 * @classdesc
 *
 * A Scene is a stack of {@link Layer layers} sharing the same {@link View view}
 * and {@link HotspotContainer hotspot container}. It belongs to the
 * {@link Viewer viewer} inside which it is displayed.
 *
 * Clients should call {@link Viewer#createScene} instead of invoking the
 * constructor directly.
 *
 * @param {Viewer} viewer The viewer this scene belongs to.
 * @param {View} view The scene's underlying view.
 */ function $6ca552c9bda8c935$var$Scene(viewer, view) {
    this._viewer = viewer;
    this._view = view;
    this._layers = [];
    // Hotspot container. Assume it occupies a full rect.
    this._hotspotContainer = new $a3AC3(viewer._controlContainer, viewer.stage(), this._view, viewer.renderLoop());
    // The current movement.
    this._movement = null;
    this._movementStartTime = null;
    this._movementStep = null;
    this._movementParams = null;
    this._movementCallback = null;
    // Event listener for updating the view according to the current movement.
    // The listener is set/unset on the render loop when a movement starts/stops.
    this._updateMovementHandler = this._updateMovement.bind(this);
    // Show or hide hotspots when scene changes.
    this._updateHotspotContainerHandler = this._updateHotspotContainer.bind(this);
    this._viewer.addEventListener("sceneChange", this._updateHotspotContainerHandler);
    // Emit event when view changes.
    this._viewChangeHandler = this.emit.bind(this, "viewChange");
    this._view.addEventListener("change", this._viewChangeHandler);
    // Update the hotspot container.
    this._updateHotspotContainer();
}
$6mia6($6ca552c9bda8c935$var$Scene);
/**
 * Destructor. Clients should call {@link Viewer#destroyScene} instead.
 */ $6ca552c9bda8c935$var$Scene.prototype.destroy = function() {
    this._view.removeEventListener("change", this._viewChangeHandler);
    this._viewer.removeEventListener("sceneChange", this._updateHotspotContainerHandler);
    if (this._movement) this.stopMovement();
    this._hotspotContainer.destroy();
    this.destroyAllLayers();
    $2Xxut(this);
};
/**
 * Returns the {@link HotspotContainer hotspot container} for the scene.
 * @return {Layer}
 */ $6ca552c9bda8c935$var$Scene.prototype.hotspotContainer = function() {
    return this._hotspotContainer;
};
/**
 * Returns the first of the {@link Layer layers} belonging to the scene, or
 * null if the scene has no layers.
 *
 * This method is equivalent to `Scene#listLayers[0]`. It may be removed in the
 * future.
 *
 * @return {Layer}
 */ $6ca552c9bda8c935$var$Scene.prototype.layer = function() {
    return this._layers[0];
};
/**
* Returns a list of all {@link Layer layers} belonging to the scene. The
* returned list is in display order, background to foreground.
* @return {Layer[]}
 */ $6ca552c9bda8c935$var$Scene.prototype.listLayers = function() {
    return [].concat(this._layers);
};
/**
 * Returns the scene's underlying {@link View view}.
 * @return {View}
 */ $6ca552c9bda8c935$var$Scene.prototype.view = function() {
    return this._view;
};
/**
 * Returns the {@link Viewer viewer} the scene belongs to.
 * @return {Viewer}
 */ $6ca552c9bda8c935$var$Scene.prototype.viewer = function() {
    return this._viewer;
};
/**
 * Returns whether the scene is currently visible.
 * @return {boolean}
 */ $6ca552c9bda8c935$var$Scene.prototype.visible = function() {
    return this._viewer.scene() === this;
};
/**
 * Creates a new {@link Layer layer} and adds it into the scene in the
 * foreground position.
 *
 * @param {Object} opts Layer creation options.
 * @param {Source} opts.source The layer's underlying {@link Source}.
 * @param {Source} opts.geometry The layer's underlying {@link Geometry}.
 * @param {boolean} [opts.pinFirstLevel=false] Whether to pin the first level to
 *     provide a fallback of last resort, at the cost of memory consumption.
 * @param {Object} [opts.textureStoreOpts={}] Options to pass to the
 *     {@link TextureStore} constructor.
 * @param {Object} [opts.layerOpts={}] Options to pass to the {@link Layer}
 *     constructor.
 * @return {Layer}
 */ $6ca552c9bda8c935$var$Scene.prototype.createLayer = function(opts) {
    opts = opts || {};
    var textureStoreOpts = opts.textureStoreOpts || {};
    var layerOpts = opts.layerOpts || {};
    var source = opts.source;
    var geometry = opts.geometry;
    var view = this._view;
    var stage = this._viewer.stage();
    var textureStore = new $8U6hQ(source, stage, textureStoreOpts);
    var layer = new $gouN9(source, geometry, view, textureStore, layerOpts);
    this._layers.push(layer);
    if (opts.pinFirstLevel) layer.pinFirstLevel();
    // Signal that the layers have changed.
    this.emit("layerChange");
    return layer;
};
/**
 * Destroys a {@link Layer layer} and removes it from the scene.
 * @param {Layer} layer
 * @throws An error if the layer does not belong to the scene.
 */ $6ca552c9bda8c935$var$Scene.prototype.destroyLayer = function(layer) {
    var i = this._layers.indexOf(layer);
    if (i < 0) throw new Error("No such layer in scene");
    this._layers.splice(i, 1);
    // Signal that the layers have changed.
    this.emit("layerChange");
    layer.textureStore().destroy();
    layer.destroy();
};
/**
 * Destroys all {@link Layer layers} and removes them from the scene.
 */ $6ca552c9bda8c935$var$Scene.prototype.destroyAllLayers = function() {
    while(this._layers.length > 0)this.destroyLayer(this._layers[0]);
};
/**
 * Switches to the scene.
 *
 * This is equivalent to calling {@link Viewer#switchScene} on this scene.
 *
 * @param {Object} opts Options to pass into {@link Viewer#switchScene}.
 * @param {function} done Function to call when the switch is complete.
 */ $6ca552c9bda8c935$var$Scene.prototype.switchTo = function(opts, done) {
    return this._viewer.switchScene(this, opts, done);
};
/**
 * Tweens the scene's underlying {@link View view}.
 *
 * @param {Object} params Target view parameters.
 * @param {Object} opts Transition options.
 * @param {function} [opts.ease=easeInOutQuad] Tween easing function
 * @param {number} [opts.controlsInterrupt=false] allow controls to interrupt
 *     an ongoing tween.
 * @param {number} [opts.transitionDuration=1000] Tween duration, in
 *     milliseconds.
 * @param {number} [opts.closest=true] Whether to tween through the shortest
 *    path between the initial and final view parameters. This requires
 *    {@link View#normalizeToClosest} to be implemented, and does nothing
 *    otherwise.
 * @param {function} done Function to call when the tween finishes or is
 *    interrupted.
 */ $6ca552c9bda8c935$var$Scene.prototype.lookTo = function(params, opts, done) {
    opts = opts || {};
    done = done || $exIfG;
    if ($fXp6t(params) !== "object") throw new Error("Target view parameters must be an object");
    // Quadratic in/out easing.
    var easeInOutQuad = function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k;
        return -0.5 * (--k * (k - 2) - 1);
    };
    var ease = opts.ease != null ? opts.ease : easeInOutQuad;
    var controlsInterrupt = opts.controlsInterrupt != null ? opts.controlsInterrupt : false;
    var duration = opts.transitionDuration != null ? opts.transitionDuration : 1000;
    var shortest = opts.shortest != null ? opts.shortest : true;
    var view = this._view;
    var initialParams = view.parameters();
    var finalParams = {};
    $9eJDl(finalParams, params);
    $9eJDl(finalParams, initialParams);
    // Tween through the shortest path if requested.
    // The view must implement the normalizeToClosest() method.
    if (shortest && view.normalizeToClosest) view.normalizeToClosest(finalParams, finalParams);
    var movement = function() {
        var finalUpdate = false;
        return function(params, elapsed) {
            if (elapsed >= duration && finalUpdate) return null;
            var delta = Math.min(elapsed / duration, 1);
            for(var param in params){
                var start = initialParams[param];
                var end = finalParams[param];
                params[param] = start + ease(delta) * (end - start);
            }
            finalUpdate = elapsed >= duration;
            return params;
        };
    };
    var reenableControls = this._viewer.controls().enabled();
    if (!controlsInterrupt) this._viewer.controls().disable();
    this.startMovement(movement, function() {
        if (reenableControls) this._viewer.controls().enable();
        done();
    });
};
/**
 * Starts a movement, possibly replacing the current movement.
 *
 * @param {function} fn The movement function.
 * @param {function} done Function to be called when the movement finishes or is
 *     interrupted.
 */ $6ca552c9bda8c935$var$Scene.prototype.startMovement = function(fn, done) {
    var renderLoop = this._viewer.renderLoop();
    if (this._movement) this.stopMovement();
    var step = fn();
    if (typeof step !== "function") throw new Error("Bad movement");
    this._movement = fn;
    this._movementStep = step;
    this._movementStartTime = $azWbw();
    this._movementParams = {};
    this._movementCallback = done;
    renderLoop.addEventListener("beforeRender", this._updateMovementHandler);
    renderLoop.renderOnNextFrame();
};
/**
 * Stops the current movement.
 */ $6ca552c9bda8c935$var$Scene.prototype.stopMovement = function() {
    var renderLoop = this._viewer.renderLoop();
    if (!this._movement) return;
    if (this._movementCallback) this._movementCallback();
    renderLoop.removeEventListener("beforeRender", this._updateMovementHandler);
    this._movement = null;
    this._movementStep = null;
    this._movementStartTime = null;
    this._movementParams = null;
    this._movementCallback = null;
};
/**
 * Returns the current movement.
 * @return {function}
 */ $6ca552c9bda8c935$var$Scene.prototype.movement = function() {
    return this._movement;
};
$6ca552c9bda8c935$var$Scene.prototype._updateMovement = function() {
    if (!this._movement) throw new Error("Should not call update");
    var renderLoop = this._viewer.renderLoop();
    var view = this._view;
    var elapsed = $azWbw() - this._movementStartTime;
    var step = this._movementStep;
    var params = this._movementParams;
    params = view.parameters(params);
    params = step(params, elapsed);
    if (params == null) this.stopMovement();
    else {
        view.setParameters(params);
        renderLoop.renderOnNextFrame();
    }
};
$6ca552c9bda8c935$var$Scene.prototype._updateHotspotContainer = function() {
    if (this.visible()) this._hotspotContainer.show();
    else this._hotspotContainer.hide();
};
module.exports = $6ca552c9bda8c935$var$Scene;

});
parcelRegister("a3AC3", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $6mia6 = parcelRequire("6mia6");

var $028gl = parcelRequire("028gl");

var $8pjZz = parcelRequire("8pjZz");

var $emB94 = parcelRequire("emB94");

var $eC4zG = parcelRequire("eC4zG");

var $752695bb2a9c28d8$require$setAbsolute = (parcelRequire("dBMHD")).setAbsolute;

var $752695bb2a9c28d8$require$setOverflowHidden = (parcelRequire("dBMHD")).setOverflowHidden;

var $752695bb2a9c28d8$require$setOverflowVisible = (parcelRequire("dBMHD")).setOverflowVisible;

var $752695bb2a9c28d8$require$setNullSize = (parcelRequire("dBMHD")).setNullSize;

var $752695bb2a9c28d8$require$setPixelSize = (parcelRequire("dBMHD")).setPixelSize;

var $752695bb2a9c28d8$var$setPointerEvents = (parcelRequire("dBMHD")).setWithVendorPrefix("pointer-events");

var $2Xxut = parcelRequire("2Xxut");
/**
 * Signals that a hotspot has been created or destroyed on the container.
 * @event HotspotContainer#hotspotsChange
 */ /**
 * @class HotspotContainer
 * @classdesc
 *
 * Creates a DOM element to hold {@link Hotspot hotspots} and updates their
 * position when necessary.
 *
 * @param {Element} parentDomElement The DOM element inside which the container
 *     should be created.
 * @param {Stage} stage The underlying stage.
 * @param {View} view The view according to which the hotspots are positioned.
 * @param {RenderLoop} renderLoop The render loop indicating when the hotspots
 *     must be rendered.
 * @param {Object} opts
 * @param {RectSpec} opts.rect Rectangular region covered by the container. See
 *    {@link Effects#rect}.
 */ function $752695bb2a9c28d8$var$HotspotContainer(parentDomElement, stage, view, renderLoop, opts) {
    opts = opts || {};
    this._parentDomElement = parentDomElement;
    this._stage = stage;
    this._view = view;
    this._renderLoop = renderLoop;
    // Hotspot list.
    this._hotspots = [];
    // Whether the hotspot container should be visible.
    // It may still be hidden if a rect effect is set on a browser without
    // pointer-events support.
    this._visible = true;
    // The current rect.
    this._rect = opts.rect;
    // Whether the visibility or the rect have changed since the last DOM update.
    this._visibilityOrRectChanged = true;
    // The last seen stage dimensions.
    this._stageWidth = null;
    this._stageHeight = null;
    // Temporary variable to hold the calculated position and size.
    this._tmpRect = {};
    // Wrapper element. When the rect effect is set, the wrapper will have nonzero
    // dimensions and `pointer-events: none` so that hotspots outside the rect are
    // hidden, but no mouse events are hijacked. The exception is browsers without
    // pointer-events support, where we refuse to show the hotspots when a rect is
    // set as it would prevent the controls from receiving mouse events.
    this._hotspotContainerWrapper = document.createElement("div");
    $752695bb2a9c28d8$require$setAbsolute(this._hotspotContainerWrapper);
    $752695bb2a9c28d8$var$setPointerEvents(this._hotspotContainerWrapper, "none");
    this._parentDomElement.appendChild(this._hotspotContainerWrapper);
    // Hotspot container element. It has zero dimensions and `pointer-events: all`
    // to override the `pointer-events: none` on the wrapper and allow hotspots to
    // be interacted with.
    this._hotspotContainer = document.createElement("div");
    $752695bb2a9c28d8$require$setAbsolute(this._hotspotContainer);
    $752695bb2a9c28d8$var$setPointerEvents(this._hotspotContainer, "all");
    this._hotspotContainerWrapper.appendChild(this._hotspotContainer);
    // Update when the hotspots change or scene is re-rendered.
    this._updateHandler = this._update.bind(this);
    this._renderLoop.addEventListener("afterRender", this._updateHandler);
}
$6mia6($752695bb2a9c28d8$var$HotspotContainer);
/**
 * Destructor.
 */ $752695bb2a9c28d8$var$HotspotContainer.prototype.destroy = function() {
    while(this._hotspots.length)this.destroyHotspot(this._hotspots[0]);
    this._parentDomElement.removeChild(this._hotspotContainerWrapper);
    this._renderLoop.removeEventListener("afterRender", this._updateHandler);
    $2Xxut(this);
};
/**
 * @return {Element}
 */ $752695bb2a9c28d8$var$HotspotContainer.prototype.domElement = function() {
    return this._hotspotContainer;
};
/**
 * @param {Rect} rect
 */ $752695bb2a9c28d8$var$HotspotContainer.prototype.setRect = function(rect) {
    if (rect && !$emB94() && typeof console !== "undefined") console.warn("Using a rect effect is not fully supported on this browser. Hotspots may not be shown.");
    this._rect = rect;
    this._visibilityOrRectChanged = true;
};
/**
 * @return {Rect}
 */ $752695bb2a9c28d8$var$HotspotContainer.prototype.rect = function() {
    return this._rect;
};
/**
 * Creates a new hotspot in this container.
 *
 * @param {Element} domElement DOM element to use for the hotspot
 * @param {Object} coords The hotspot coordinates.
 *     Use {@link RectilinearViewCoords}` for a {@link RectilinearView} or
 *     {@link FlatViewCoords} for a {@link FlatView}.
 * @param {Object} opts Options in the same format as the `opts` argument to
 *     the {@link Hotspot} constructor.
 * @return {Hotspot}
 */ $752695bb2a9c28d8$var$HotspotContainer.prototype.createHotspot = function(domElement, coords, opts) {
    coords = coords || {};
    var hotspot = new $028gl(domElement, this._hotspotContainer, this._view, coords, opts);
    this._hotspots.push(hotspot);
    hotspot._update();
    this.emit("hotspotsChange");
    return hotspot;
};
/**
 * @param {Hotspot} hotspot
 * @return {boolean}
 */ $752695bb2a9c28d8$var$HotspotContainer.prototype.hasHotspot = function(hotspot) {
    return this._hotspots.indexOf(hotspot) >= 0;
};
/**
 * @return {Hotspot[]}
 */ $752695bb2a9c28d8$var$HotspotContainer.prototype.listHotspots = function() {
    return [].concat(this._hotspots);
};
/**
 * Removes a hotspot from the container.
 *
 * @param {Hotspot} hotspot
 */ $752695bb2a9c28d8$var$HotspotContainer.prototype.destroyHotspot = function(hotspot) {
    var i = this._hotspots.indexOf(hotspot);
    if (i < 0) throw new Error("No such hotspot");
    this._hotspots.splice(i, 1);
    hotspot.destroy();
    this.emit("hotspotsChange");
};
/**
 * Hide the container's DOM element, causing every contained {@link Hotspot} to
 * be hidden.
 */ $752695bb2a9c28d8$var$HotspotContainer.prototype.hide = function() {
    if (this._visible) {
        this._visible = false;
        this._visibilityOrRectChanged = true;
        this._update();
    }
};
/**
 * Show the container's DOM element, causing every contained {@link Hotspot} to
 * be shown.
 */ $752695bb2a9c28d8$var$HotspotContainer.prototype.show = function() {
    if (!this._visible) {
        this._visible = true;
        this._visibilityOrRectChanged = true;
        this._update();
    }
};
$752695bb2a9c28d8$var$HotspotContainer.prototype._update = function() {
    var wrapper = this._hotspotContainerWrapper;
    var width = this._stage.width();
    var height = this._stage.height();
    var tmpRect = this._tmpRect;
    // Avoid updating the wrapper DOM unless necessary.
    if (this._visibilityOrRectChanged || this._rect && (width !== this._stageWidth || height !== this._stageHeight)) {
        var visible = this._visible && !(this._rect && !$emB94());
        wrapper.style.display = visible ? "block" : "none";
        if (visible) {
            if (this._rect) {
                $8pjZz(width, height, this._rect, tmpRect);
                $eC4zG(wrapper, width * tmpRect.x, height * tmpRect.y);
                $752695bb2a9c28d8$require$setPixelSize(wrapper, width * tmpRect.width, height * tmpRect.height);
                $752695bb2a9c28d8$require$setOverflowHidden(wrapper);
            } else {
                $eC4zG(wrapper, 0, 0);
                $752695bb2a9c28d8$require$setNullSize(wrapper);
                $752695bb2a9c28d8$require$setOverflowVisible(wrapper);
            }
        }
        this._stageWidth = width;
        this._stageHeight = height;
        this._visibilityOrRectChanged = false;
    }
    // Update hotspots unconditionally, as the view parameters may have changed.
    for(var i = 0; i < this._hotspots.length; i++)this._hotspots[i]._update();
};
module.exports = $752695bb2a9c28d8$var$HotspotContainer;

});
parcelRegister("028gl", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $6mia6 = parcelRequire("6mia6");

var $3owNE = parcelRequire("3owNE");

var $eC4zG = parcelRequire("eC4zG");

var $dBMHD = parcelRequire("dBMHD");
var $006698c92bcc7dff$require$setTransform = $dBMHD.setTransform;

var $2Xxut = parcelRequire("2Xxut");
/**
 * @class Hotspot
 * @classdesc
 *
 * A Hotspot allows a DOM element to be placed at a fixed position in the
 * image. The position is updated automatically when the {@link View view}
 * changes.
 *
 * Positioning is performed with the `transform` CSS property when available,
 * falling back to the `position`, `left` and `top` properties when not.
 * In both cases, the top left corner of the element is placed in the requested
 * position; clients are expected to use additional children elements or other
 * CSS properties to achieve more sophisticated layouts.
 *
 * There are two kinds of hotspots: regular and embedded. A regular hotspot
 * does not change size depending on the zoom level. An embedded hotspot is
 * displayed at a fixed size relative to the panorama, always covering the
 * same portion of the image. Embedded hotspots require CSS 3D transform
 * support.
 *
 * Clients should call {@link HotspotContainer#createHotspot} instead of
 * invoking the constructor directly.
 *
 * @param {Element} domElement The DOM element.
 * @param {View} view The view.
 * @param {Object} coords The hotspot coordinates.
 *     Use {@link RectilinearViewCoords} for a {@link RectilinearView} or
 *     {@link FlatViewCoords} for a {@link FlatView}.
 * @param {Object} opts Additional options.
 * @param {Object} opts.perspective Perspective options for embedded hotspots.
 * @param {number} [opts.perspective.radius=null] If set, embed the hotspot
 *     into the image by transforming it into the surface of a sphere with this
 *     radius.
 * @param {string} [opts.perspective.extraTransforms=null] If set, append this
 *     value to the CSS `transform` property used to position the hotspot. This
 *     may be used to rotate an embedded hotspot.
 */ function $006698c92bcc7dff$var$Hotspot(domElement, parentDomElement, view, coords, opts) {
    opts = opts || {};
    opts.perspective = opts.perspective || {};
    opts.perspective.extraTransforms = opts.perspective.extraTransforms != null ? opts.perspective.extraTransforms : "";
    if ((opts.perspective.radius || opts.perspective.extraTransforms) && !$3owNE()) throw new Error("CSS transforms on hotspots are not supported on this browser");
    this._domElement = domElement;
    this._parentDomElement = parentDomElement;
    this._view = view;
    this._coords = {};
    this._perspective = {};
    this.setPosition(coords);
    // Add hotspot into the DOM.
    this._parentDomElement.appendChild(this._domElement);
    this.setPerspective(opts.perspective);
    // Whether the hotspot is visible.
    // The hotspot may still be hidden if it's inside a hidden HotspotContainer.
    this._visible = true;
    // The current calculated screen position.
    this._position = {
        x: 0,
        y: 0
    };
}
$6mia6($006698c92bcc7dff$var$Hotspot);
/**
 * Destructor.
 * Clients should call {@link HotspotContainer#destroyHotspot} instead.
 */ $006698c92bcc7dff$var$Hotspot.prototype.destroy = function() {
    this._parentDomElement.removeChild(this._domElement);
    $2Xxut(this);
};
/**
 * @return {Element}
 */ $006698c92bcc7dff$var$Hotspot.prototype.domElement = function() {
    return this._domElement;
};
/**
 * @return {Object}
 */ $006698c92bcc7dff$var$Hotspot.prototype.position = function() {
    return this._coords;
};
/**
 * @param {Object} coords
 */ $006698c92bcc7dff$var$Hotspot.prototype.setPosition = function(coords) {
    for(var key in coords)this._coords[key] = coords[key];
    this._update();
// TODO: We should probably emit a hotspotsChange event on the parent
// HotspotContainer. What's the best way to do so?
};
/**
 * @return {Object}
 */ $006698c92bcc7dff$var$Hotspot.prototype.perspective = function() {
    return this._perspective;
};
/**
 * @param {Object}
 */ $006698c92bcc7dff$var$Hotspot.prototype.setPerspective = function(perspective) {
    for(var key in perspective)this._perspective[key] = perspective[key];
    this._update();
};
/**
 * Show the hotspot
 */ $006698c92bcc7dff$var$Hotspot.prototype.show = function() {
    if (!this._visible) {
        this._visible = true;
        this._update();
    }
};
/**
 * Hide the hotspot
 */ $006698c92bcc7dff$var$Hotspot.prototype.hide = function() {
    if (this._visible) {
        this._visible = false;
        this._update();
    }
};
$006698c92bcc7dff$var$Hotspot.prototype._update = function() {
    var element = this._domElement;
    var params = this._coords;
    var position = this._position;
    var x, y;
    var isVisible = false;
    if (this._visible) {
        var view = this._view;
        if (this._perspective.radius) {
            // Hotspots that are embedded in the panorama may be visible even when
            // positioned behind the camera.
            isVisible = true;
            this._setEmbeddedPosition(view, params);
        } else {
            // Regular hotspots are only visible when positioned in front of the
            // camera. Note that they may be partially visible when positioned outside
            // the viewport.
            view.coordinatesToScreen(params, position);
            x = position.x;
            y = position.y;
            if (x != null && y != null) {
                isVisible = true;
                this._setPosition(x, y);
            }
        }
    }
    // Show if visible, hide if not.
    if (isVisible) {
        element.style.display = "block";
        element.style.position = "absolute";
    } else {
        element.style.display = "none";
        element.style.position = "";
    }
};
$006698c92bcc7dff$var$Hotspot.prototype._setEmbeddedPosition = function(view, params) {
    var transform = view.coordinatesToPerspectiveTransform(params, this._perspective.radius, this._perspective.extraTransforms);
    $006698c92bcc7dff$require$setTransform(this._domElement, transform);
};
$006698c92bcc7dff$var$Hotspot.prototype._setPosition = function(x, y) {
    $eC4zG(this._domElement, x, y, this._perspective.extraTransforms);
};
module.exports = $006698c92bcc7dff$var$Hotspot;

});
parcelRegister("eC4zG", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $3owNE = parcelRequire("3owNE");

var $dBMHD = parcelRequire("dBMHD");
var $aa3829baedec433a$require$setTransform = $dBMHD.setTransform;

var $dBMHD = parcelRequire("dBMHD");
var $aa3829baedec433a$require$setPixelPosition = $dBMHD.setPixelPosition;

var $asoyN = parcelRequire("asoyN");
// This cannot belong in util/dom.js because support/Css also depends on it
// and it would cause a circular dependency.
function $aa3829baedec433a$var$positionAbsolutely(element, x, y, extraTransforms) {
    extraTransforms = extraTransforms || "";
    if ($3owNE()) {
        // Use CSS 3D transforms when the browser supports them.
        // A translateZ(0) transform improves performance on Chrome by creating a
        // new layer for the element, which prevents unnecessary repaints.
        var transform = "translateX(" + $asoyN(x) + "px) translateY(" + $asoyN(y) + "px) translateZ(0) " + extraTransforms;
        $aa3829baedec433a$require$setTransform(element, transform);
    } else // Fall back to absolute positioning.
    $aa3829baedec433a$require$setPixelPosition(element, x, y);
}
module.exports = $aa3829baedec433a$var$positionAbsolutely;

});


parcelRegister("emB94", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $W9Vbx = parcelRequire("W9Vbx");
// Detect CSS pointer-events support.
function $a74fef1002bdcb47$var$checkCssPointerEventsSupported() {
    // Check for existence of CSS property.
    var style = document.createElement("a").style;
    style.cssText = "pointer-events:auto";
    var hasCssProperty = style.pointerEvents === "auto";
    // The above result is spurious on emulation mode for IE 8-10.
    var isOldIE = $W9Vbx.msie && parseFloat($W9Vbx.version) < 11;
    return hasCssProperty && !isOldIE;
}
// Cache result.
var $a74fef1002bdcb47$var$supported;
function $a74fef1002bdcb47$var$cssPointerEventsSupported() {
    if ($a74fef1002bdcb47$var$supported !== undefined) return $a74fef1002bdcb47$var$supported;
    return $a74fef1002bdcb47$var$supported = $a74fef1002bdcb47$var$checkCssPointerEventsSupported();
}
module.exports = $a74fef1002bdcb47$var$cssPointerEventsSupported;

});



parcelRegister("460G7", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $6mia6 = parcelRequire("6mia6");

var $9eJDl = parcelRequire("9eJDl");

var $azWbw = parcelRequire("azWbw");
var $2fb83fa82b12c3d0$var$defaultOptions = {
    duration: Infinity
};
/**
 * Signals a timeout.
 * @event Timer#timeout
 */ /**
 * @class Timer
 * @classdesc
 *
 * A Timer provides a mechanism to receive an event after a timeout.
 *
 * A timer has a set duration, and is either started or stopped at a given time.
 * The timer is initially stopped. When the timer is started, a timeout event is
 * scheduled to fire once the set duration elapses. When the timer is stopped,
 * the scheduled timeout event is cancelled. When a timeout event fires, the
 * timer returns to the stopped state.
 *
 * @param {number} [opts.duration=Infinity] Timeout in milliseconds.
 */ function $2fb83fa82b12c3d0$var$Timer(opts) {
    opts = $9eJDl(opts || {}, $2fb83fa82b12c3d0$var$defaultOptions);
    this._duration = opts.duration;
    this._startTime = null;
    this._handle = null;
    this._check = this._check.bind(this);
}
$6mia6($2fb83fa82b12c3d0$var$Timer);
/**
 * Starts the timer. If the timer is already started, this has the effect of
 * stopping and starting again (i.e. resetting the timer).
 */ $2fb83fa82b12c3d0$var$Timer.prototype.start = function() {
    this._startTime = $azWbw();
    if (this._handle == null && this._duration < Infinity) this._setup(this._duration);
};
/**
 * Returns whether the timer is in the started state.
 * @return {boolean}
 */ $2fb83fa82b12c3d0$var$Timer.prototype.started = function() {
    return this._startTime != null;
};
/**
 * Stops the timer.
 */ $2fb83fa82b12c3d0$var$Timer.prototype.stop = function() {
    this._startTime = null;
    if (this._handle != null) {
        clearTimeout(this._handle);
        this._handle = null;
    }
};
$2fb83fa82b12c3d0$var$Timer.prototype._setup = function(interval) {
    this._handle = setTimeout(this._check, interval);
};
$2fb83fa82b12c3d0$var$Timer.prototype._teardown = function() {
    clearTimeout(this._handle);
    this._handle = null;
};
$2fb83fa82b12c3d0$var$Timer.prototype._check = function() {
    var currentTime = $azWbw();
    var elapsed = currentTime - this._startTime;
    var remaining = this._duration - elapsed;
    this._teardown();
    if (remaining <= 0) {
        this.emit("timeout");
        this._startTime = null;
    } else if (remaining < Infinity) this._setup(remaining);
};
/**
 * Returns the currently set duration.
 */ $2fb83fa82b12c3d0$var$Timer.prototype.duration = function() {
    return this._duration;
};
/**
 * Sets the duration. If the timer is already started, the timeout event is
 * rescheduled to occur once the new duration has elapsed since the last call
 * to start. In particular, if an amount of time larger than the new duration
 * has already elapsed, the timeout event fires immediately.
 * @param {number}
 */ $2fb83fa82b12c3d0$var$Timer.prototype.setDuration = function(duration) {
    this._duration = duration;
    if (this._startTime != null) this._check();
};
module.exports = $2fb83fa82b12c3d0$var$Timer;

});

parcelRegister("1dJzJ", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $9eJDl = parcelRequire("9eJDl");

var $2Xxut = parcelRequire("2Xxut");
var $0e3a5ba42d387393$var$defaultOpts = {
    active: "move",
    inactive: "default",
    disabled: "default"
};
/**
 * @class ControlCursor
 * @classdesc
 *
 * Sets the CSS cursor on a DOM element according to the state of a
 * {@link ControlMethod}.
 *
 * @param {Controls} controls Controls instance containing the control method.
 * @param {string} id ID of the control method.
 * @param {Element} element DOM element where the cursor should be set.
 * @param {Object} opts The control cursors. Each field must be a valid value
 *     for the `cursor` CSS property.
 * @param {string} [opts.active='move'] Cursor to set when the control method
 *     is enabled and active.
 * @param {string} [opts.inactive='default'] Cursor to set when the control
 *     method is enabled and inactive.
 * @param {string} [opts.disabled='default'] Cursor to set when the control
 *     method is disabled.
 */ function $0e3a5ba42d387393$var$ControlCursor(controls, id, element, opts) {
    opts = $9eJDl(opts || {}, $0e3a5ba42d387393$var$defaultOpts);
    // TODO: This class may misbehave if the control method is unregistered and a
    // different control method is registered under the same id.
    this._element = element;
    this._controls = controls;
    this._id = id;
    this._attached = false;
    this._setActiveCursor = this._setCursor.bind(this, opts.active);
    this._setInactiveCursor = this._setCursor.bind(this, opts.inactive);
    this._setDisabledCursor = this._setCursor.bind(this, opts.disabled);
    this._setOriginalCursor = this._setCursor.bind(this, this._element.style.cursor);
    this._updateAttachmentHandler = this._updateAttachment.bind(this);
    controls.addEventListener("methodEnabled", this._updateAttachmentHandler);
    controls.addEventListener("methodDisabled", this._updateAttachmentHandler);
    controls.addEventListener("enabled", this._updateAttachmentHandler);
    controls.addEventListener("disabled", this._updateAttachmentHandler);
    this._updateAttachment();
}
/**
 * Destructor.
 */ $0e3a5ba42d387393$var$ControlCursor.prototype.destroy = function() {
    this._detachFromControlMethod(this._controls.method(this._id));
    this._setOriginalCursor();
    this._controls.removeEventListener("methodEnabled", this._updateAttachmentHandler);
    this._controls.removeEventListener("methodDisabled", this._updateAttachmentHandler);
    this._controls.removeEventListener("enabled", this._updateAttachmentHandler);
    this._controls.removeEventListener("disabled", this._updateAttachmentHandler);
    $2Xxut(this);
};
$0e3a5ba42d387393$var$ControlCursor.prototype._updateAttachment = function() {
    var controls = this._controls;
    var id = this._id;
    if (controls.enabled() && controls.method(id).enabled) this._attachToControlMethod(controls.method(id));
    else this._detachFromControlMethod(controls.method(id));
};
$0e3a5ba42d387393$var$ControlCursor.prototype._attachToControlMethod = function(controlMethod) {
    if (!this._attached) {
        controlMethod.instance.addEventListener("active", this._setActiveCursor);
        controlMethod.instance.addEventListener("inactive", this._setInactiveCursor);
        if (controlMethod.active) this._setActiveCursor();
        else this._setInactiveCursor();
        this._attached = true;
    }
};
$0e3a5ba42d387393$var$ControlCursor.prototype._detachFromControlMethod = function(controlMethod) {
    if (this._attached) {
        controlMethod.instance.removeEventListener("active", this._setActiveCursor);
        controlMethod.instance.removeEventListener("inactive", this._setInactiveCursor);
        this._setDisabledCursor();
        this._attached = false;
    }
};
$0e3a5ba42d387393$var$ControlCursor.prototype._setCursor = function(cursor) {
    this._element.style.cursor = cursor;
};
module.exports = $0e3a5ba42d387393$var$ControlCursor;

});

parcelRegister("9aEkC", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $9eJDl = parcelRequire("9eJDl");

var $efdW7 = parcelRequire("efdW7");

var $kjQCu = parcelRequire("kjQCu");

var $fCy8Y = parcelRequire("fCy8Y");

var $2cyzb = parcelRequire("2cyzb");

var $kniT1 = parcelRequire("kniT1");
var $6ad4553db4969957$var$defaultOptions = {
    mouseViewMode: "drag"
};
/**
 * Instantiate and register some commonly used {@link ControlMethod} instances.
 *
 * The following instances are registered:
 *   - mouseViewDrag
 *   - mouseViewQtvr
 *   - touchView
 *   - pinch
 *   - arrowKeys
 *   - plusMinusKeys
 *   - wasdKeys
 *   - qeKeys
 *
 * @param {Controls} controls Where to register the instances.
 * @param {Element} element Element to listen for events.
 * @param {Object} opts
 * @param {'drag'|'qtvr'} mouseViewMode
 */ function $6ad4553db4969957$var$registerDefaultControls(controls, element, opts) {
    opts = $9eJDl(opts || {}, $6ad4553db4969957$var$defaultOptions);
    var controlMethods = {
        mouseViewDrag: new $efdW7(element, "mouse"),
        mouseViewQtvr: new $kjQCu(element, "mouse"),
        touchView: new $efdW7(element, "touch"),
        pinch: new $2cyzb(element, "touch"),
        leftArrowKey: new $kniT1(37, "x", -0.7, 3),
        rightArrowKey: new $kniT1(39, "x", 0.7, 3),
        upArrowKey: new $kniT1(38, "y", -0.7, 3),
        downArrowKey: new $kniT1(40, "y", 0.7, 3),
        plusKey: new $kniT1(107, "zoom", -0.7, 3),
        minusKey: new $kniT1(109, "zoom", 0.7, 3),
        wKey: new $kniT1(87, "y", -0.7, 3),
        aKey: new $kniT1(65, "x", -0.7, 3),
        sKey: new $kniT1(83, "y", 0.7, 3),
        dKey: new $kniT1(68, "x", 0.7, 3),
        qKey: new $kniT1(81, "roll", 0.7, 3),
        eKey: new $kniT1(69, "roll", -0.7, 3)
    };
    if (opts.scrollZoom !== false) controlMethods.scrollZoom = new $fCy8Y(element); //{ frictionTime: 0 }
    var controlMethodGroups = {
        arrowKeys: [
            "leftArrowKey",
            "rightArrowKey",
            "upArrowKey",
            "downArrowKey"
        ],
        plusMinusKeys: [
            "plusKey",
            "minusKey"
        ],
        wasdKeys: [
            "wKey",
            "aKey",
            "sKey",
            "dKey"
        ],
        qeKeys: [
            "qKey",
            "eKey"
        ]
    };
    var enabledControls = [
        "scrollZoom",
        "touchView",
        "pinch"
    ];
    switch(opts.mouseViewMode){
        case "drag":
            enabledControls.push("mouseViewDrag");
            break;
        case "qtvr":
            enabledControls.push("mouseViewQtvr");
            break;
        default:
            throw new Error("Unknown mouse view mode: " + opts.mouseViewMode);
    }
    for(var id in controlMethods){
        var method = controlMethods[id];
        controls.registerMethod(id, method);
        if (enabledControls.indexOf(id) >= 0) controls.enableMethod(id);
    }
    for(var groupId in controlMethodGroups){
        var methodGroup = controlMethodGroups[groupId];
        controls.addMethodGroup(groupId, methodGroup);
    }
    return controlMethods;
}
module.exports = $6ad4553db4969957$var$registerDefaultControls;

});

parcelRegister("28mhx", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $azWbw = parcelRequire("azWbw");
function $18dd9cd7bf18fb2e$var$tween(duration, update, done) {
    var cancelled = false;
    var startTime = $azWbw();
    function runUpdate() {
        if (cancelled) return;
        var tweenVal = ($azWbw() - startTime) / duration;
        if (tweenVal < 1) {
            update(tweenVal);
            requestAnimationFrame(runUpdate);
        } else {
            update(1);
            done();
        }
    }
    update(0);
    requestAnimationFrame(runUpdate);
    return function cancel() {
        cancelled = true;
        done.apply(null, arguments);
    };
}
module.exports = $18dd9cd7bf18fb2e$var$tween;

});


parcelRegister("j8BiC", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $c3mW8 = parcelRequire("c3mW8");
var $8QvoZ = parcelRequire("8QvoZ");
var $deebb28bbaed009d$require$vec4 = $8QvoZ;

var $c3mW8 = parcelRequire("c3mW8");
var $8QvoZ = parcelRequire("8QvoZ");
var $deebb28bbaed009d$require$mat4 = $c3mW8;
/**
 * Helper functions for color transformation {@link Effects}.
 *
 * References:
 *
 *   - [ColorMatrix Guide](http://docs.rainmeter.net/tips/colormatrix-guide)
 *   - [Matrix Operations for Image Processing](http://www.graficaobscura.com/matrix/index.html)
 *   - [WebGLImageFilter](https://github.com/phoboslab/WebGLImageFilter)
 *   - [glfx.js](https://github.com/evanw/glfx.js)
 *
 * @namespace colorEffects
 */ /**
 * A vector and matrix corresponding to an identity transformation.
 *
 * @param {Object} result Object to store result
 * @param {vec4} result.colorOffset Array with zeroes.
 * @param {mat4} result.colorMatrix Identity matrix.
 *
 * @memberof colorEffects
 */ function $deebb28bbaed009d$var$identity(resultArg) {
    var result = resultArg || {};
    result.colorOffset = result.colorOffset || $deebb28bbaed009d$require$vec4.create();
    result.colorMatrix = result.colorMatrix || $deebb28bbaed009d$require$mat4.create();
    return result;
}
/**
 * Apply color effects to a single pixel
 *
 * @param {vec4} pixel Values in range [0,1]
 * @param {Object} effect
 * @param {vec4} effect.colorOffset
 * @param {mat4} effect.colorMatrix
 * @param {vec4} result Object to store result
 *
 * @memberof colorEffects
 */ function $deebb28bbaed009d$var$applyToPixel(pixel, effect, result) {
    $deebb28bbaed009d$var$vec4TransformMat4Transposed(result, pixel, effect.colorMatrix);
    $deebb28bbaed009d$require$vec4.add(result, result, effect.colorOffset);
}
// Oddly, the colorTransform matrix needs to be transposed to be used with
// vec4.transformMat4. It is strange that transformMat4 dosn't work the same
// way as multiplying on the shader.
// TODO: investigate this further
function $deebb28bbaed009d$var$vec4TransformMat4Transposed(out, a, m) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    out[0] = m[0] * x + m[1] * y + m[2] * z + m[3] * w;
    out[1] = m[4] * x + m[5] * y + m[6] * z + m[7] * w;
    out[2] = m[8] * x + m[9] * y + m[10] * z + m[11] * w;
    out[3] = m[12] * x + m[13] * y + m[14] * z + m[15] * w;
    return out;
}
/**
 * Apply color effects to an ImageData
 *
 * @param {ImageData} imageData This object will be mutated
 * @param {Object} effect
 * @param {vec4} effect.colorOffset
 * @param {mat4} effect.colorMatrix
 *
 * @memberof colorEffects
 */ var $deebb28bbaed009d$var$tmpPixel = $deebb28bbaed009d$require$vec4.create();
function $deebb28bbaed009d$var$applyToImageData(imageData, effect) {
    var width = imageData.width;
    var height = imageData.height;
    var data = imageData.data;
    for(var i = 0; i < width * height; i++){
        $deebb28bbaed009d$require$vec4.set($deebb28bbaed009d$var$tmpPixel, data[i * 4 + 0] / 255, data[i * 4 + 1] / 255, data[i * 4 + 2] / 255, data[i * 4 + 3] / 255);
        $deebb28bbaed009d$var$applyToPixel($deebb28bbaed009d$var$tmpPixel, effect, $deebb28bbaed009d$var$tmpPixel);
        data[i * 4 + 0] = $deebb28bbaed009d$var$tmpPixel[0] * 255;
        data[i * 4 + 1] = $deebb28bbaed009d$var$tmpPixel[1] * 255;
        data[i * 4 + 2] = $deebb28bbaed009d$var$tmpPixel[2] * 255;
        data[i * 4 + 3] = $deebb28bbaed009d$var$tmpPixel[3] * 255;
    }
}
module.exports = {
    identity: $deebb28bbaed009d$var$identity,
    applyToPixel: $deebb28bbaed009d$var$applyToPixel,
    applyToImageData: $deebb28bbaed009d$var$applyToImageData
};

});

parcelRegister("eoK70", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";

var $9eJDl = parcelRequire("9eJDl");
var $a7b71372e62ccc29$var$defaultSpeed = 0.1;
var $a7b71372e62ccc29$var$defaultAccel = 0.01;
var $a7b71372e62ccc29$var$defaultOptions = {
    yawSpeed: $a7b71372e62ccc29$var$defaultSpeed,
    pitchSpeed: $a7b71372e62ccc29$var$defaultSpeed,
    fovSpeed: $a7b71372e62ccc29$var$defaultSpeed,
    yawAccel: $a7b71372e62ccc29$var$defaultAccel,
    pitchAccel: $a7b71372e62ccc29$var$defaultAccel,
    fovAccel: $a7b71372e62ccc29$var$defaultAccel,
    targetPitch: 0,
    targetFov: null
};
/**
 * @param {Object} opts
 * @param {Number} [opts.yawSpeed=0.1] Yaw maximum speed
 * @param {Number} [opts.pitchSpeed=0.1] Pitch maximum speed
 * @param {Number} [opts.fovSpeed=0.1] Fov maximum speed
 * @param {Number} [opts.yawAccel=0.01] Yaw acceleration
 * @param {Number} [opts.pitchAccel=0.01] Pitch acceleration
 * @param {Number} [opts.fovAccel=0.01] Fov acceleration
 * @param {Number} [opts.targetPitch=0] Value that pitch converges to. `null` means that the pitch will not change.
 * @param {Number} [opts.targetFov=null] Value that fov converges to. `null` means that the fov will not change.
 * @returns Movement function that can be passed to {@link Viewer#setIdleMovement} or {@link Scene#startMovement}
*/ function $a7b71372e62ccc29$var$autorotate(opts) {
    opts = $9eJDl(opts || {}, $a7b71372e62ccc29$var$defaultOptions);
    var yawSpeed = opts.yawSpeed;
    var pitchSpeed = opts.pitchSpeed;
    var fovSpeed = opts.fovSpeed;
    var yawAccel = opts.yawAccel;
    var pitchAccel = opts.pitchAccel;
    var fovAccel = opts.fovAccel;
    var targetPitch = opts.targetPitch;
    var targetFov = opts.targetFov;
    return function start() {
        var lastTime = 0;
        var lastYawSpeed = 0;
        var lastPitchSpeed = 0;
        var lastFovSpeed = 0;
        var currentYawSpeed = 0;
        var currentPitchSpeed = 0;
        var currentFovSpeed = 0;
        var timeDelta;
        var yawDelta;
        var pitchDelta;
        var fovDelta;
        return function step(params, currentTime) {
            timeDelta = (currentTime - lastTime) / 1000;
            currentYawSpeed = Math.min(lastYawSpeed + timeDelta * yawAccel, yawSpeed);
            yawDelta = currentYawSpeed * timeDelta;
            params.yaw = params.yaw + yawDelta;
            if (targetPitch != null && params.pitch !== targetPitch) {
                var pitchThresh = 0.5 * lastPitchSpeed * lastPitchSpeed / pitchAccel;
                if (Math.abs(targetPitch - params.pitch) > pitchThresh) // Acceleration phase
                currentPitchSpeed = Math.min(lastPitchSpeed + timeDelta * pitchAccel, pitchSpeed);
                else // Deceleration phase
                currentPitchSpeed = Math.max(lastPitchSpeed - timeDelta * pitchAccel, 0);
                // currentPitchSpeed is the absolute value (>= 0)
                pitchDelta = currentPitchSpeed * timeDelta;
                if (targetPitch < params.pitch) params.pitch = Math.max(targetPitch, params.pitch - pitchDelta);
                if (targetPitch > params.pitch) params.pitch = Math.min(targetPitch, params.pitch + pitchDelta);
            }
            if (targetFov != null && params.fov !== targetPitch) {
                var fovThresh = 0.5 * lastFovSpeed * lastFovSpeed / fovAccel;
                if (Math.abs(targetFov - params.fov) > fovThresh) // Acceleration phase
                currentFovSpeed = Math.min(lastFovSpeed + timeDelta * fovAccel, fovSpeed);
                else // Deceleration phase
                currentFovSpeed = Math.max(lastFovSpeed - timeDelta * fovAccel, 0);
                // currentFovSpeed is the absolute value (>= 0)
                fovDelta = currentFovSpeed * timeDelta;
                if (targetFov < params.fov) params.fov = Math.max(targetFov, params.fov - fovDelta);
                if (targetFov > params.fov) params.fov = Math.min(targetFov, params.fov + fovDelta);
            }
            lastTime = currentTime;
            lastYawSpeed = currentYawSpeed;
            lastPitchSpeed = currentPitchSpeed;
            lastFovSpeed = currentFovSpeed;
            return params;
        };
    };
}
module.exports = $a7b71372e62ccc29$var$autorotate;

});

parcelRegister("82Ddh", function(module, exports) {
/*
 * Copyright 2016 Google Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ "use strict";
/**
 * @memberof util
 * @param {number} deg
 * @return {number}
 */ function $5daced8ae2d4e021$var$degToRad(deg) {
    return deg * Math.PI / 180;
}
module.exports = $5daced8ae2d4e021$var$degToRad;

});

parcelRegister("d1IHX", function(module, exports) {

$parcel$export(module.exports, "glMatrix", function () { return (parcelRequire("rqjzO")); });
$parcel$export(module.exports, "mat2", function () { return (parcelRequire("fuSIX")); });
$parcel$export(module.exports, "mat2d", function () { return (parcelRequire("kERd8")); });
$parcel$export(module.exports, "mat3", function () { return (parcelRequire("67rGA")); });
$parcel$export(module.exports, "mat4", function () { return (parcelRequire("c3mW8")); });
$parcel$export(module.exports, "quat", function () { return (parcelRequire("f8Ox0")); });
$parcel$export(module.exports, "quat2", function () { return (parcelRequire("89cfF")); });
$parcel$export(module.exports, "vec2", function () { return (parcelRequire("5VJvE")); });
$parcel$export(module.exports, "vec3", function () { return (parcelRequire("fwwPx")); });
$parcel$export(module.exports, "vec4", function () { return (parcelRequire("8QvoZ")); });

var $rqjzO = parcelRequire("rqjzO");

var $fuSIX = parcelRequire("fuSIX");

var $kERd8 = parcelRequire("kERd8");

var $67rGA = parcelRequire("67rGA");

var $c3mW8 = parcelRequire("c3mW8");

var $f8Ox0 = parcelRequire("f8Ox0");

var $89cfF = parcelRequire("89cfF");

var $5VJvE = parcelRequire("5VJvE");

var $fwwPx = parcelRequire("fwwPx");

var $8QvoZ = parcelRequire("8QvoZ");

});
parcelRegister("fuSIX", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $b4841b6800dd1e2b$export$185802fd694ee1f5; });
$parcel$export(module.exports, "clone", function () { return $b4841b6800dd1e2b$export$9cd59f9826255e47; });
$parcel$export(module.exports, "copy", function () { return $b4841b6800dd1e2b$export$784d13d8ee351f07; });
$parcel$export(module.exports, "identity", function () { return $b4841b6800dd1e2b$export$f0954fd7d5368655; });
$parcel$export(module.exports, "fromValues", function () { return $b4841b6800dd1e2b$export$a82be99ed2a44a7d; });
$parcel$export(module.exports, "set", function () { return $b4841b6800dd1e2b$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "transpose", function () { return $b4841b6800dd1e2b$export$9cb09a71b7d66923; });
$parcel$export(module.exports, "invert", function () { return $b4841b6800dd1e2b$export$6897c284b6f9f4dc; });
$parcel$export(module.exports, "adjoint", function () { return $b4841b6800dd1e2b$export$33f3c024b4ae00a1; });
$parcel$export(module.exports, "determinant", function () { return $b4841b6800dd1e2b$export$a04698f914c55ed9; });
$parcel$export(module.exports, "multiply", function () { return $b4841b6800dd1e2b$export$2060d2db72cce88f; });
$parcel$export(module.exports, "rotate", function () { return $b4841b6800dd1e2b$export$bb628a54ab399bc9; });
$parcel$export(module.exports, "scale", function () { return $b4841b6800dd1e2b$export$dcdf75081b88279d; });
$parcel$export(module.exports, "fromRotation", function () { return $b4841b6800dd1e2b$export$926fc125ff3c666c; });
$parcel$export(module.exports, "fromScaling", function () { return $b4841b6800dd1e2b$export$832ca188ffb1955d; });
$parcel$export(module.exports, "str", function () { return $b4841b6800dd1e2b$export$42d51816ce590c93; });
$parcel$export(module.exports, "frob", function () { return $b4841b6800dd1e2b$export$326827e8268e9cdb; });
$parcel$export(module.exports, "LDU", function () { return $b4841b6800dd1e2b$export$c7126d0da24b9100; });
$parcel$export(module.exports, "add", function () { return $b4841b6800dd1e2b$export$e16d8520af44a096; });
$parcel$export(module.exports, "subtract", function () { return $b4841b6800dd1e2b$export$4e2d2ead65e5f7e3; });
$parcel$export(module.exports, "exactEquals", function () { return $b4841b6800dd1e2b$export$f2599a5cf1109d8; });
$parcel$export(module.exports, "equals", function () { return $b4841b6800dd1e2b$export$e9bab7fafb253603; });
$parcel$export(module.exports, "multiplyScalar", function () { return $b4841b6800dd1e2b$export$c697bed75648cdb7; });
$parcel$export(module.exports, "multiplyScalarAndAdd", function () { return $b4841b6800dd1e2b$export$553579f63bdd7137; });
$parcel$export(module.exports, "mul", function () { return $b4841b6800dd1e2b$export$6e3a27864ab166fe; });
$parcel$export(module.exports, "sub", function () { return $b4841b6800dd1e2b$export$f93b5905241a7cca; });

var $rqjzO = parcelRequire("rqjzO");
function $b4841b6800dd1e2b$export$185802fd694ee1f5() {
    var out = new $rqjzO.ARRAY_TYPE(4);
    if ($rqjzO.ARRAY_TYPE != Float32Array) {
        out[1] = 0;
        out[2] = 0;
    }
    out[0] = 1;
    out[3] = 1;
    return out;
}
function $b4841b6800dd1e2b$export$9cd59f9826255e47(a) {
    var out = new $rqjzO.ARRAY_TYPE(4);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $b4841b6800dd1e2b$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $b4841b6800dd1e2b$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    return out;
}
function $b4841b6800dd1e2b$export$a82be99ed2a44a7d(m00, m01, m10, m11) {
    var out = new $rqjzO.ARRAY_TYPE(4);
    out[0] = m00;
    out[1] = m01;
    out[2] = m10;
    out[3] = m11;
    return out;
}
function $b4841b6800dd1e2b$export$adaa4cf7ef1b65be(out, m00, m01, m10, m11) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m10;
    out[3] = m11;
    return out;
}
function $b4841b6800dd1e2b$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache
    // some values
    if (out === a) {
        var a1 = a[1];
        out[1] = a[2];
        out[2] = a1;
    } else {
        out[0] = a[0];
        out[1] = a[2];
        out[2] = a[1];
        out[3] = a[3];
    }
    return out;
}
function $b4841b6800dd1e2b$export$6897c284b6f9f4dc(out, a) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3]; // Calculate the determinant
    var det = a0 * a3 - a2 * a1;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = a3 * det;
    out[1] = -a1 * det;
    out[2] = -a2 * det;
    out[3] = a0 * det;
    return out;
}
function $b4841b6800dd1e2b$export$33f3c024b4ae00a1(out, a) {
    // Caching this value is nessecary if out == a
    var a0 = a[0];
    out[0] = a[3];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = a0;
    return out;
}
function $b4841b6800dd1e2b$export$a04698f914c55ed9(a) {
    return a[0] * a[3] - a[2] * a[1];
}
function $b4841b6800dd1e2b$export$2060d2db72cce88f(out, a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = a0 * b0 + a2 * b1;
    out[1] = a1 * b0 + a3 * b1;
    out[2] = a0 * b2 + a2 * b3;
    out[3] = a1 * b2 + a3 * b3;
    return out;
}
function $b4841b6800dd1e2b$export$bb628a54ab399bc9(out, a, rad) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    out[0] = a0 * c + a2 * s;
    out[1] = a1 * c + a3 * s;
    out[2] = a0 * -s + a2 * c;
    out[3] = a1 * -s + a3 * c;
    return out;
}
function $b4841b6800dd1e2b$export$dcdf75081b88279d(out, a, v) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var v0 = v[0], v1 = v[1];
    out[0] = a0 * v0;
    out[1] = a1 * v0;
    out[2] = a2 * v1;
    out[3] = a3 * v1;
    return out;
}
function $b4841b6800dd1e2b$export$926fc125ff3c666c(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    out[0] = c;
    out[1] = s;
    out[2] = -s;
    out[3] = c;
    return out;
}
function $b4841b6800dd1e2b$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = v[1];
    return out;
}
function $b4841b6800dd1e2b$export$42d51816ce590c93(a) {
    return "mat2(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
function $b4841b6800dd1e2b$export$326827e8268e9cdb(a) {
    return Math.hypot(a[0], a[1], a[2], a[3]);
}
function $b4841b6800dd1e2b$export$c7126d0da24b9100(L, D, U, a) {
    L[2] = a[2] / a[0];
    U[0] = a[0];
    U[1] = a[1];
    U[3] = a[3] - L[2] * U[1];
    return [
        L,
        D,
        U
    ];
}
function $b4841b6800dd1e2b$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    return out;
}
function $b4841b6800dd1e2b$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    return out;
}
function $b4841b6800dd1e2b$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
}
function $b4841b6800dd1e2b$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    return Math.abs(a0 - b0) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3));
}
function $b4841b6800dd1e2b$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    return out;
}
function $b4841b6800dd1e2b$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    return out;
}
var $b4841b6800dd1e2b$export$6e3a27864ab166fe = $b4841b6800dd1e2b$export$2060d2db72cce88f;
var $b4841b6800dd1e2b$export$f93b5905241a7cca = $b4841b6800dd1e2b$export$4e2d2ead65e5f7e3;

});

parcelRegister("kERd8", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $f0a0d1a73421ff92$export$185802fd694ee1f5; });
$parcel$export(module.exports, "clone", function () { return $f0a0d1a73421ff92$export$9cd59f9826255e47; });
$parcel$export(module.exports, "copy", function () { return $f0a0d1a73421ff92$export$784d13d8ee351f07; });
$parcel$export(module.exports, "identity", function () { return $f0a0d1a73421ff92$export$f0954fd7d5368655; });
$parcel$export(module.exports, "fromValues", function () { return $f0a0d1a73421ff92$export$a82be99ed2a44a7d; });
$parcel$export(module.exports, "set", function () { return $f0a0d1a73421ff92$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "invert", function () { return $f0a0d1a73421ff92$export$6897c284b6f9f4dc; });
$parcel$export(module.exports, "determinant", function () { return $f0a0d1a73421ff92$export$a04698f914c55ed9; });
$parcel$export(module.exports, "multiply", function () { return $f0a0d1a73421ff92$export$2060d2db72cce88f; });
$parcel$export(module.exports, "rotate", function () { return $f0a0d1a73421ff92$export$bb628a54ab399bc9; });
$parcel$export(module.exports, "scale", function () { return $f0a0d1a73421ff92$export$dcdf75081b88279d; });
$parcel$export(module.exports, "translate", function () { return $f0a0d1a73421ff92$export$d73ee8ef04f5226a; });
$parcel$export(module.exports, "fromRotation", function () { return $f0a0d1a73421ff92$export$926fc125ff3c666c; });
$parcel$export(module.exports, "fromScaling", function () { return $f0a0d1a73421ff92$export$832ca188ffb1955d; });
$parcel$export(module.exports, "fromTranslation", function () { return $f0a0d1a73421ff92$export$bc9e79e74e9fddf6; });
$parcel$export(module.exports, "str", function () { return $f0a0d1a73421ff92$export$42d51816ce590c93; });
$parcel$export(module.exports, "frob", function () { return $f0a0d1a73421ff92$export$326827e8268e9cdb; });
$parcel$export(module.exports, "add", function () { return $f0a0d1a73421ff92$export$e16d8520af44a096; });
$parcel$export(module.exports, "subtract", function () { return $f0a0d1a73421ff92$export$4e2d2ead65e5f7e3; });
$parcel$export(module.exports, "multiplyScalar", function () { return $f0a0d1a73421ff92$export$c697bed75648cdb7; });
$parcel$export(module.exports, "multiplyScalarAndAdd", function () { return $f0a0d1a73421ff92$export$553579f63bdd7137; });
$parcel$export(module.exports, "exactEquals", function () { return $f0a0d1a73421ff92$export$f2599a5cf1109d8; });
$parcel$export(module.exports, "equals", function () { return $f0a0d1a73421ff92$export$e9bab7fafb253603; });
$parcel$export(module.exports, "mul", function () { return $f0a0d1a73421ff92$export$6e3a27864ab166fe; });
$parcel$export(module.exports, "sub", function () { return $f0a0d1a73421ff92$export$f93b5905241a7cca; });

var $rqjzO = parcelRequire("rqjzO");
function $f0a0d1a73421ff92$export$185802fd694ee1f5() {
    var out = new $rqjzO.ARRAY_TYPE(6);
    if ($rqjzO.ARRAY_TYPE != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[4] = 0;
        out[5] = 0;
    }
    out[0] = 1;
    out[3] = 1;
    return out;
}
function $f0a0d1a73421ff92$export$9cd59f9826255e47(a) {
    var out = new $rqjzO.ARRAY_TYPE(6);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    return out;
}
function $f0a0d1a73421ff92$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    return out;
}
function $f0a0d1a73421ff92$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    return out;
}
function $f0a0d1a73421ff92$export$a82be99ed2a44a7d(a, b, c, d, tx, ty) {
    var out = new $rqjzO.ARRAY_TYPE(6);
    out[0] = a;
    out[1] = b;
    out[2] = c;
    out[3] = d;
    out[4] = tx;
    out[5] = ty;
    return out;
}
function $f0a0d1a73421ff92$export$adaa4cf7ef1b65be(out, a, b, c, d, tx, ty) {
    out[0] = a;
    out[1] = b;
    out[2] = c;
    out[3] = d;
    out[4] = tx;
    out[5] = ty;
    return out;
}
function $f0a0d1a73421ff92$export$6897c284b6f9f4dc(out, a) {
    var aa = a[0], ab = a[1], ac = a[2], ad = a[3];
    var atx = a[4], aty = a[5];
    var det = aa * ad - ab * ac;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = ad * det;
    out[1] = -ab * det;
    out[2] = -ac * det;
    out[3] = aa * det;
    out[4] = (ac * aty - ad * atx) * det;
    out[5] = (ab * atx - aa * aty) * det;
    return out;
}
function $f0a0d1a73421ff92$export$a04698f914c55ed9(a) {
    return a[0] * a[3] - a[1] * a[2];
}
function $f0a0d1a73421ff92$export$2060d2db72cce88f(out, a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5];
    out[0] = a0 * b0 + a2 * b1;
    out[1] = a1 * b0 + a3 * b1;
    out[2] = a0 * b2 + a2 * b3;
    out[3] = a1 * b2 + a3 * b3;
    out[4] = a0 * b4 + a2 * b5 + a4;
    out[5] = a1 * b4 + a3 * b5 + a5;
    return out;
}
function $f0a0d1a73421ff92$export$bb628a54ab399bc9(out, a, rad) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5];
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    out[0] = a0 * c + a2 * s;
    out[1] = a1 * c + a3 * s;
    out[2] = a0 * -s + a2 * c;
    out[3] = a1 * -s + a3 * c;
    out[4] = a4;
    out[5] = a5;
    return out;
}
function $f0a0d1a73421ff92$export$dcdf75081b88279d(out, a, v) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5];
    var v0 = v[0], v1 = v[1];
    out[0] = a0 * v0;
    out[1] = a1 * v0;
    out[2] = a2 * v1;
    out[3] = a3 * v1;
    out[4] = a4;
    out[5] = a5;
    return out;
}
function $f0a0d1a73421ff92$export$d73ee8ef04f5226a(out, a, v) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5];
    var v0 = v[0], v1 = v[1];
    out[0] = a0;
    out[1] = a1;
    out[2] = a2;
    out[3] = a3;
    out[4] = a0 * v0 + a2 * v1 + a4;
    out[5] = a1 * v0 + a3 * v1 + a5;
    return out;
}
function $f0a0d1a73421ff92$export$926fc125ff3c666c(out, rad) {
    var s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c;
    out[1] = s;
    out[2] = -s;
    out[3] = c;
    out[4] = 0;
    out[5] = 0;
    return out;
}
function $f0a0d1a73421ff92$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = v[1];
    out[4] = 0;
    out[5] = 0;
    return out;
}
function $f0a0d1a73421ff92$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = v[0];
    out[5] = v[1];
    return out;
}
function $f0a0d1a73421ff92$export$42d51816ce590c93(a) {
    return "mat2d(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ")";
}
function $f0a0d1a73421ff92$export$326827e8268e9cdb(a) {
    return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], 1);
}
function $f0a0d1a73421ff92$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    return out;
}
function $f0a0d1a73421ff92$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    return out;
}
function $f0a0d1a73421ff92$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    return out;
}
function $f0a0d1a73421ff92$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    return out;
}
function $f0a0d1a73421ff92$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5];
}
function $f0a0d1a73421ff92$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5];
    return Math.abs(a0 - b0) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5));
}
var $f0a0d1a73421ff92$export$6e3a27864ab166fe = $f0a0d1a73421ff92$export$2060d2db72cce88f;
var $f0a0d1a73421ff92$export$f93b5905241a7cca = $f0a0d1a73421ff92$export$4e2d2ead65e5f7e3;

});

parcelRegister("67rGA", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $4748df579585fbcb$export$185802fd694ee1f5; });
$parcel$export(module.exports, "fromMat4", function () { return $4748df579585fbcb$export$b4ad467060d346fe; });
$parcel$export(module.exports, "clone", function () { return $4748df579585fbcb$export$9cd59f9826255e47; });
$parcel$export(module.exports, "copy", function () { return $4748df579585fbcb$export$784d13d8ee351f07; });
$parcel$export(module.exports, "fromValues", function () { return $4748df579585fbcb$export$a82be99ed2a44a7d; });
$parcel$export(module.exports, "set", function () { return $4748df579585fbcb$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "identity", function () { return $4748df579585fbcb$export$f0954fd7d5368655; });
$parcel$export(module.exports, "transpose", function () { return $4748df579585fbcb$export$9cb09a71b7d66923; });
$parcel$export(module.exports, "invert", function () { return $4748df579585fbcb$export$6897c284b6f9f4dc; });
$parcel$export(module.exports, "adjoint", function () { return $4748df579585fbcb$export$33f3c024b4ae00a1; });
$parcel$export(module.exports, "determinant", function () { return $4748df579585fbcb$export$a04698f914c55ed9; });
$parcel$export(module.exports, "multiply", function () { return $4748df579585fbcb$export$2060d2db72cce88f; });
$parcel$export(module.exports, "translate", function () { return $4748df579585fbcb$export$d73ee8ef04f5226a; });
$parcel$export(module.exports, "rotate", function () { return $4748df579585fbcb$export$bb628a54ab399bc9; });
$parcel$export(module.exports, "scale", function () { return $4748df579585fbcb$export$dcdf75081b88279d; });
$parcel$export(module.exports, "fromTranslation", function () { return $4748df579585fbcb$export$bc9e79e74e9fddf6; });
$parcel$export(module.exports, "fromRotation", function () { return $4748df579585fbcb$export$926fc125ff3c666c; });
$parcel$export(module.exports, "fromScaling", function () { return $4748df579585fbcb$export$832ca188ffb1955d; });
$parcel$export(module.exports, "fromMat2d", function () { return $4748df579585fbcb$export$68f5977575fae9bf; });
$parcel$export(module.exports, "fromQuat", function () { return $4748df579585fbcb$export$2ff2bbe382249af7; });
$parcel$export(module.exports, "normalFromMat4", function () { return $4748df579585fbcb$export$966b25ab6dc1b1f9; });
$parcel$export(module.exports, "projection", function () { return $4748df579585fbcb$export$b74061472fe7c07; });
$parcel$export(module.exports, "str", function () { return $4748df579585fbcb$export$42d51816ce590c93; });
$parcel$export(module.exports, "frob", function () { return $4748df579585fbcb$export$326827e8268e9cdb; });
$parcel$export(module.exports, "add", function () { return $4748df579585fbcb$export$e16d8520af44a096; });
$parcel$export(module.exports, "subtract", function () { return $4748df579585fbcb$export$4e2d2ead65e5f7e3; });
$parcel$export(module.exports, "multiplyScalar", function () { return $4748df579585fbcb$export$c697bed75648cdb7; });
$parcel$export(module.exports, "multiplyScalarAndAdd", function () { return $4748df579585fbcb$export$553579f63bdd7137; });
$parcel$export(module.exports, "exactEquals", function () { return $4748df579585fbcb$export$f2599a5cf1109d8; });
$parcel$export(module.exports, "equals", function () { return $4748df579585fbcb$export$e9bab7fafb253603; });
$parcel$export(module.exports, "mul", function () { return $4748df579585fbcb$export$6e3a27864ab166fe; });
$parcel$export(module.exports, "sub", function () { return $4748df579585fbcb$export$f93b5905241a7cca; });

var $rqjzO = parcelRequire("rqjzO");
function $4748df579585fbcb$export$185802fd694ee1f5() {
    var out = new $rqjzO.ARRAY_TYPE(9);
    if ($rqjzO.ARRAY_TYPE != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[5] = 0;
        out[6] = 0;
        out[7] = 0;
    }
    out[0] = 1;
    out[4] = 1;
    out[8] = 1;
    return out;
}
function $4748df579585fbcb$export$b4ad467060d346fe(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[4];
    out[4] = a[5];
    out[5] = a[6];
    out[6] = a[8];
    out[7] = a[9];
    out[8] = a[10];
    return out;
}
function $4748df579585fbcb$export$9cd59f9826255e47(a) {
    var out = new $rqjzO.ARRAY_TYPE(9);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $4748df579585fbcb$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $4748df579585fbcb$export$a82be99ed2a44a7d(m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    var out = new $rqjzO.ARRAY_TYPE(9);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m10;
    out[4] = m11;
    out[5] = m12;
    out[6] = m20;
    out[7] = m21;
    out[8] = m22;
    return out;
}
function $4748df579585fbcb$export$adaa4cf7ef1b65be(out, m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m10;
    out[4] = m11;
    out[5] = m12;
    out[6] = m20;
    out[7] = m21;
    out[8] = m22;
    return out;
}
function $4748df579585fbcb$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $4748df579585fbcb$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a12 = a[5];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a01;
        out[5] = a[7];
        out[6] = a02;
        out[7] = a12;
    } else {
        out[0] = a[0];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a[1];
        out[4] = a[4];
        out[5] = a[7];
        out[6] = a[2];
        out[7] = a[5];
        out[8] = a[8];
    }
    return out;
}
function $4748df579585fbcb$export$6897c284b6f9f4dc(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    var b01 = a22 * a11 - a12 * a21;
    var b11 = -a22 * a10 + a12 * a20;
    var b21 = a21 * a10 - a11 * a20; // Calculate the determinant
    var det = a00 * b01 + a01 * b11 + a02 * b21;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = b01 * det;
    out[1] = (-a22 * a01 + a02 * a21) * det;
    out[2] = (a12 * a01 - a02 * a11) * det;
    out[3] = b11 * det;
    out[4] = (a22 * a00 - a02 * a20) * det;
    out[5] = (-a12 * a00 + a02 * a10) * det;
    out[6] = b21 * det;
    out[7] = (-a21 * a00 + a01 * a20) * det;
    out[8] = (a11 * a00 - a01 * a10) * det;
    return out;
}
function $4748df579585fbcb$export$33f3c024b4ae00a1(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    out[0] = a11 * a22 - a12 * a21;
    out[1] = a02 * a21 - a01 * a22;
    out[2] = a01 * a12 - a02 * a11;
    out[3] = a12 * a20 - a10 * a22;
    out[4] = a00 * a22 - a02 * a20;
    out[5] = a02 * a10 - a00 * a12;
    out[6] = a10 * a21 - a11 * a20;
    out[7] = a01 * a20 - a00 * a21;
    out[8] = a00 * a11 - a01 * a10;
    return out;
}
function $4748df579585fbcb$export$a04698f914c55ed9(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
}
function $4748df579585fbcb$export$2060d2db72cce88f(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    var b00 = b[0], b01 = b[1], b02 = b[2];
    var b10 = b[3], b11 = b[4], b12 = b[5];
    var b20 = b[6], b21 = b[7], b22 = b[8];
    out[0] = b00 * a00 + b01 * a10 + b02 * a20;
    out[1] = b00 * a01 + b01 * a11 + b02 * a21;
    out[2] = b00 * a02 + b01 * a12 + b02 * a22;
    out[3] = b10 * a00 + b11 * a10 + b12 * a20;
    out[4] = b10 * a01 + b11 * a11 + b12 * a21;
    out[5] = b10 * a02 + b11 * a12 + b12 * a22;
    out[6] = b20 * a00 + b21 * a10 + b22 * a20;
    out[7] = b20 * a01 + b21 * a11 + b22 * a21;
    out[8] = b20 * a02 + b21 * a12 + b22 * a22;
    return out;
}
function $4748df579585fbcb$export$d73ee8ef04f5226a(out, a, v) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], x = v[0], y = v[1];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a10;
    out[4] = a11;
    out[5] = a12;
    out[6] = x * a00 + y * a10 + a20;
    out[7] = x * a01 + y * a11 + a21;
    out[8] = x * a02 + y * a12 + a22;
    return out;
}
function $4748df579585fbcb$export$bb628a54ab399bc9(out, a, rad) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c * a00 + s * a10;
    out[1] = c * a01 + s * a11;
    out[2] = c * a02 + s * a12;
    out[3] = c * a10 - s * a00;
    out[4] = c * a11 - s * a01;
    out[5] = c * a12 - s * a02;
    out[6] = a20;
    out[7] = a21;
    out[8] = a22;
    return out;
}
function $4748df579585fbcb$export$dcdf75081b88279d(out, a, v) {
    var x = v[0], y = v[1];
    out[0] = x * a[0];
    out[1] = x * a[1];
    out[2] = x * a[2];
    out[3] = y * a[3];
    out[4] = y * a[4];
    out[5] = y * a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $4748df579585fbcb$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = v[0];
    out[7] = v[1];
    out[8] = 1;
    return out;
}
function $4748df579585fbcb$export$926fc125ff3c666c(out, rad) {
    var s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = -s;
    out[4] = c;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $4748df579585fbcb$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = v[1];
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $4748df579585fbcb$export$68f5977575fae9bf(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = 0;
    out[3] = a[2];
    out[4] = a[3];
    out[5] = 0;
    out[6] = a[4];
    out[7] = a[5];
    out[8] = 1;
    return out;
}
function $4748df579585fbcb$export$2ff2bbe382249af7(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var yx = y * x2;
    var yy = y * y2;
    var zx = z * x2;
    var zy = z * y2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - yy - zz;
    out[3] = yx - wz;
    out[6] = zx + wy;
    out[1] = yx + wz;
    out[4] = 1 - xx - zz;
    out[7] = zy - wx;
    out[2] = zx - wy;
    out[5] = zy + wx;
    out[8] = 1 - xx - yy;
    return out;
}
function $4748df579585fbcb$export$966b25ab6dc1b1f9(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32; // Calculate the determinant
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    return out;
}
function $4748df579585fbcb$export$b74061472fe7c07(out, width, height) {
    out[0] = 2 / width;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = -2 / height;
    out[5] = 0;
    out[6] = -1;
    out[7] = 1;
    out[8] = 1;
    return out;
}
function $4748df579585fbcb$export$42d51816ce590c93(a) {
    return "mat3(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ")";
}
function $4748df579585fbcb$export$326827e8268e9cdb(a) {
    return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
}
function $4748df579585fbcb$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    return out;
}
function $4748df579585fbcb$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    return out;
}
function $4748df579585fbcb$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    return out;
}
function $4748df579585fbcb$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    out[6] = a[6] + b[6] * scale;
    out[7] = a[7] + b[7] * scale;
    out[8] = a[8] + b[8] * scale;
    return out;
}
function $4748df579585fbcb$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8];
}
function $4748df579585fbcb$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7], a8 = a[8];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8];
    return Math.abs(a0 - b0) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a8), Math.abs(b8));
}
var $4748df579585fbcb$export$6e3a27864ab166fe = $4748df579585fbcb$export$2060d2db72cce88f;
var $4748df579585fbcb$export$f93b5905241a7cca = $4748df579585fbcb$export$4e2d2ead65e5f7e3;

});

parcelRegister("f8Ox0", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $b05eccd75d26bd5a$export$185802fd694ee1f5; });
$parcel$export(module.exports, "identity", function () { return $b05eccd75d26bd5a$export$f0954fd7d5368655; });
$parcel$export(module.exports, "setAxisAngle", function () { return $b05eccd75d26bd5a$export$4286ddefc8f49512; });
$parcel$export(module.exports, "getAxisAngle", function () { return $b05eccd75d26bd5a$export$3f70be5e7d7dc51; });
$parcel$export(module.exports, "getAngle", function () { return $b05eccd75d26bd5a$export$b363da9ded343252; });
$parcel$export(module.exports, "dot", function () { return $b05eccd75d26bd5a$export$94132a0e348806d4; });
$parcel$export(module.exports, "multiply", function () { return $b05eccd75d26bd5a$export$2060d2db72cce88f; });
$parcel$export(module.exports, "rotateX", function () { return $b05eccd75d26bd5a$export$a59c8716592e09af; });
$parcel$export(module.exports, "rotateY", function () { return $b05eccd75d26bd5a$export$cf71e4d4ca4d1cfd; });
$parcel$export(module.exports, "rotateZ", function () { return $b05eccd75d26bd5a$export$ea6eae3365de5b9c; });
$parcel$export(module.exports, "calculateW", function () { return $b05eccd75d26bd5a$export$fb72b72e8d764d4e; });
$parcel$export(module.exports, "exp", function () { return $b05eccd75d26bd5a$export$b310ec824aaee37f; });
$parcel$export(module.exports, "ln", function () { return $b05eccd75d26bd5a$export$876cb1b29620556f; });
$parcel$export(module.exports, "pow", function () { return $b05eccd75d26bd5a$export$9c297f60e22e3389; });
$parcel$export(module.exports, "scale", function () { return $b05eccd75d26bd5a$export$dcdf75081b88279d; });
$parcel$export(module.exports, "slerp", function () { return $b05eccd75d26bd5a$export$1544d9bc2995de08; });
$parcel$export(module.exports, "random", function () { return $b05eccd75d26bd5a$export$4385e60b38654f68; });
$parcel$export(module.exports, "invert", function () { return $b05eccd75d26bd5a$export$6897c284b6f9f4dc; });
$parcel$export(module.exports, "conjugate", function () { return $b05eccd75d26bd5a$export$7679f47e72c62560; });
$parcel$export(module.exports, "fromMat3", function () { return $b05eccd75d26bd5a$export$272a1eb8e5a4b55b; });
$parcel$export(module.exports, "fromEuler", function () { return $b05eccd75d26bd5a$export$7a404a587ea85af; });
$parcel$export(module.exports, "str", function () { return $b05eccd75d26bd5a$export$42d51816ce590c93; });
$parcel$export(module.exports, "clone", function () { return $b05eccd75d26bd5a$export$9cd59f9826255e47; });
$parcel$export(module.exports, "fromValues", function () { return $b05eccd75d26bd5a$export$a82be99ed2a44a7d; });
$parcel$export(module.exports, "copy", function () { return $b05eccd75d26bd5a$export$784d13d8ee351f07; });
$parcel$export(module.exports, "set", function () { return $b05eccd75d26bd5a$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "add", function () { return $b05eccd75d26bd5a$export$e16d8520af44a096; });
$parcel$export(module.exports, "mul", function () { return $b05eccd75d26bd5a$export$6e3a27864ab166fe; });
$parcel$export(module.exports, "lerp", function () { return $b05eccd75d26bd5a$export$3a89f8d6f6bf6c9f; });
$parcel$export(module.exports, "length", function () { return $b05eccd75d26bd5a$export$f24224f1c91d8156; });
$parcel$export(module.exports, "len", function () { return $b05eccd75d26bd5a$export$fc1400facf92c78; });
$parcel$export(module.exports, "squaredLength", function () { return $b05eccd75d26bd5a$export$ab44e1323ffc8376; });
$parcel$export(module.exports, "sqrLen", function () { return $b05eccd75d26bd5a$export$99d8dd3f32a3435; });
$parcel$export(module.exports, "normalize", function () { return $b05eccd75d26bd5a$export$a3295358bff77e; });
$parcel$export(module.exports, "exactEquals", function () { return $b05eccd75d26bd5a$export$f2599a5cf1109d8; });
$parcel$export(module.exports, "equals", function () { return $b05eccd75d26bd5a$export$e9bab7fafb253603; });
$parcel$export(module.exports, "rotationTo", function () { return $b05eccd75d26bd5a$export$72d66f5842c00904; });
$parcel$export(module.exports, "sqlerp", function () { return $b05eccd75d26bd5a$export$699b0866ca50f6cb; });
$parcel$export(module.exports, "setAxes", function () { return $b05eccd75d26bd5a$export$937ca0a544b2d712; });

var $rqjzO = parcelRequire("rqjzO");

var $67rGA = parcelRequire("67rGA");

var $fwwPx = parcelRequire("fwwPx");

var $8QvoZ = parcelRequire("8QvoZ");
function $b05eccd75d26bd5a$export$185802fd694ee1f5() {
    var out = new $rqjzO.ARRAY_TYPE(4);
    if ($rqjzO.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    out[3] = 1;
    return out;
}
function $b05eccd75d26bd5a$export$f0954fd7d5368655(out) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    return out;
}
function $b05eccd75d26bd5a$export$4286ddefc8f49512(out, axis, rad) {
    rad = rad * 0.5;
    var s = Math.sin(rad);
    out[0] = s * axis[0];
    out[1] = s * axis[1];
    out[2] = s * axis[2];
    out[3] = Math.cos(rad);
    return out;
}
function $b05eccd75d26bd5a$export$3f70be5e7d7dc51(out_axis, q) {
    var rad = Math.acos(q[3]) * 2.0;
    var s = Math.sin(rad / 2.0);
    if (s > $rqjzO.EPSILON) {
        out_axis[0] = q[0] / s;
        out_axis[1] = q[1] / s;
        out_axis[2] = q[2] / s;
    } else {
        // If s is zero, return any axis (no rotation - axis does not matter)
        out_axis[0] = 1;
        out_axis[1] = 0;
        out_axis[2] = 0;
    }
    return rad;
}
function $b05eccd75d26bd5a$export$b363da9ded343252(a, b) {
    var dotproduct = $b05eccd75d26bd5a$export$94132a0e348806d4(a, b);
    return Math.acos(2 * dotproduct * dotproduct - 1);
}
function $b05eccd75d26bd5a$export$2060d2db72cce88f(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bx = b[0], by = b[1], bz = b[2], bw = b[3];
    out[0] = ax * bw + aw * bx + ay * bz - az * by;
    out[1] = ay * bw + aw * by + az * bx - ax * bz;
    out[2] = az * bw + aw * bz + ax * by - ay * bx;
    out[3] = aw * bw - ax * bx - ay * by - az * bz;
    return out;
}
function $b05eccd75d26bd5a$export$a59c8716592e09af(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bx = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw + aw * bx;
    out[1] = ay * bw + az * bx;
    out[2] = az * bw - ay * bx;
    out[3] = aw * bw - ax * bx;
    return out;
}
function $b05eccd75d26bd5a$export$cf71e4d4ca4d1cfd(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var by = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw - az * by;
    out[1] = ay * bw + aw * by;
    out[2] = az * bw + ax * by;
    out[3] = aw * bw - ay * by;
    return out;
}
function $b05eccd75d26bd5a$export$ea6eae3365de5b9c(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bz = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw + ay * bz;
    out[1] = ay * bw - ax * bz;
    out[2] = az * bw + aw * bz;
    out[3] = aw * bw - az * bz;
    return out;
}
function $b05eccd75d26bd5a$export$fb72b72e8d764d4e(out, a) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = Math.sqrt(Math.abs(1.0 - x * x - y * y - z * z));
    return out;
}
function $b05eccd75d26bd5a$export$b310ec824aaee37f(out, a) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    var r = Math.sqrt(x * x + y * y + z * z);
    var et = Math.exp(w);
    var s = r > 0 ? et * Math.sin(r) / r : 0;
    out[0] = x * s;
    out[1] = y * s;
    out[2] = z * s;
    out[3] = et * Math.cos(r);
    return out;
}
function $b05eccd75d26bd5a$export$876cb1b29620556f(out, a) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    var r = Math.sqrt(x * x + y * y + z * z);
    var t = r > 0 ? Math.atan2(r, w) / r : 0;
    out[0] = x * t;
    out[1] = y * t;
    out[2] = z * t;
    out[3] = 0.5 * Math.log(x * x + y * y + z * z + w * w);
    return out;
}
function $b05eccd75d26bd5a$export$9c297f60e22e3389(out, a, b) {
    $b05eccd75d26bd5a$export$876cb1b29620556f(out, a);
    $b05eccd75d26bd5a$export$dcdf75081b88279d(out, out, b);
    $b05eccd75d26bd5a$export$b310ec824aaee37f(out, out);
    return out;
}
function $b05eccd75d26bd5a$export$1544d9bc2995de08(out, a, b, t) {
    // benchmarks:
    //    http://jsperf.com/quaternion-slerp-implementations
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bx = b[0], by = b[1], bz = b[2], bw = b[3];
    var omega, cosom, sinom, scale0, scale1; // calc cosine
    cosom = ax * bx + ay * by + az * bz + aw * bw; // adjust signs (if necessary)
    if (cosom < 0.0) {
        cosom = -cosom;
        bx = -bx;
        by = -by;
        bz = -bz;
        bw = -bw;
    } // calculate coefficients
    if (1.0 - cosom > $rqjzO.EPSILON) {
        // standard case (slerp)
        omega = Math.acos(cosom);
        sinom = Math.sin(omega);
        scale0 = Math.sin((1.0 - t) * omega) / sinom;
        scale1 = Math.sin(t * omega) / sinom;
    } else {
        // "from" and "to" quaternions are very close
        //  ... so we can do a linear interpolation
        scale0 = 1.0 - t;
        scale1 = t;
    } // calculate final values
    out[0] = scale0 * ax + scale1 * bx;
    out[1] = scale0 * ay + scale1 * by;
    out[2] = scale0 * az + scale1 * bz;
    out[3] = scale0 * aw + scale1 * bw;
    return out;
}
function $b05eccd75d26bd5a$export$4385e60b38654f68(out) {
    // Implementation of http://planning.cs.uiuc.edu/node198.html
    // TODO: Calling random 3 times is probably not the fastest solution
    var u1 = $rqjzO.RANDOM();
    var u2 = $rqjzO.RANDOM();
    var u3 = $rqjzO.RANDOM();
    var sqrt1MinusU1 = Math.sqrt(1 - u1);
    var sqrtU1 = Math.sqrt(u1);
    out[0] = sqrt1MinusU1 * Math.sin(2.0 * Math.PI * u2);
    out[1] = sqrt1MinusU1 * Math.cos(2.0 * Math.PI * u2);
    out[2] = sqrtU1 * Math.sin(2.0 * Math.PI * u3);
    out[3] = sqrtU1 * Math.cos(2.0 * Math.PI * u3);
    return out;
}
function $b05eccd75d26bd5a$export$6897c284b6f9f4dc(out, a) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var dot = a0 * a0 + a1 * a1 + a2 * a2 + a3 * a3;
    var invDot = dot ? 1.0 / dot : 0; // TODO: Would be faster to return [0,0,0,0] immediately if dot == 0
    out[0] = -a0 * invDot;
    out[1] = -a1 * invDot;
    out[2] = -a2 * invDot;
    out[3] = a3 * invDot;
    return out;
}
function $b05eccd75d26bd5a$export$7679f47e72c62560(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = a[3];
    return out;
}
function $b05eccd75d26bd5a$export$272a1eb8e5a4b55b(out, m) {
    // Algorithm in Ken Shoemake's article in 1987 SIGGRAPH course notes
    // article "Quaternion Calculus and Fast Animation".
    var fTrace = m[0] + m[4] + m[8];
    var fRoot;
    if (fTrace > 0.0) {
        // |w| > 1/2, may as well choose w > 1/2
        fRoot = Math.sqrt(fTrace + 1.0); // 2w
        out[3] = 0.5 * fRoot;
        fRoot = 0.5 / fRoot; // 1/(4w)
        out[0] = (m[5] - m[7]) * fRoot;
        out[1] = (m[6] - m[2]) * fRoot;
        out[2] = (m[1] - m[3]) * fRoot;
    } else {
        // |w| <= 1/2
        var i = 0;
        if (m[4] > m[0]) i = 1;
        if (m[8] > m[i * 3 + i]) i = 2;
        var j = (i + 1) % 3;
        var k = (i + 2) % 3;
        fRoot = Math.sqrt(m[i * 3 + i] - m[j * 3 + j] - m[k * 3 + k] + 1.0);
        out[i] = 0.5 * fRoot;
        fRoot = 0.5 / fRoot;
        out[3] = (m[j * 3 + k] - m[k * 3 + j]) * fRoot;
        out[j] = (m[j * 3 + i] + m[i * 3 + j]) * fRoot;
        out[k] = (m[k * 3 + i] + m[i * 3 + k]) * fRoot;
    }
    return out;
}
function $b05eccd75d26bd5a$export$7a404a587ea85af(out, x, y, z) {
    var halfToRad = 0.5 * Math.PI / 180.0;
    x *= halfToRad;
    y *= halfToRad;
    z *= halfToRad;
    var sx = Math.sin(x);
    var cx = Math.cos(x);
    var sy = Math.sin(y);
    var cy = Math.cos(y);
    var sz = Math.sin(z);
    var cz = Math.cos(z);
    out[0] = sx * cy * cz - cx * sy * sz;
    out[1] = cx * sy * cz + sx * cy * sz;
    out[2] = cx * cy * sz - sx * sy * cz;
    out[3] = cx * cy * cz + sx * sy * sz;
    return out;
}
function $b05eccd75d26bd5a$export$42d51816ce590c93(a) {
    return "quat(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
var $b05eccd75d26bd5a$export$9cd59f9826255e47 = $8QvoZ.clone;
var $b05eccd75d26bd5a$export$a82be99ed2a44a7d = $8QvoZ.fromValues;
var $b05eccd75d26bd5a$export$784d13d8ee351f07 = $8QvoZ.copy;
var $b05eccd75d26bd5a$export$adaa4cf7ef1b65be = $8QvoZ.set;
var $b05eccd75d26bd5a$export$e16d8520af44a096 = $8QvoZ.add;
var $b05eccd75d26bd5a$export$6e3a27864ab166fe = $b05eccd75d26bd5a$export$2060d2db72cce88f;
var $b05eccd75d26bd5a$export$dcdf75081b88279d = $8QvoZ.scale;
var $b05eccd75d26bd5a$export$94132a0e348806d4 = $8QvoZ.dot;
var $b05eccd75d26bd5a$export$3a89f8d6f6bf6c9f = $8QvoZ.lerp;
var $b05eccd75d26bd5a$export$f24224f1c91d8156 = $8QvoZ.length;
var $b05eccd75d26bd5a$export$fc1400facf92c78 = $b05eccd75d26bd5a$export$f24224f1c91d8156;
var $b05eccd75d26bd5a$export$ab44e1323ffc8376 = $8QvoZ.squaredLength;
var $b05eccd75d26bd5a$export$99d8dd3f32a3435 = $b05eccd75d26bd5a$export$ab44e1323ffc8376;
var $b05eccd75d26bd5a$export$a3295358bff77e = $8QvoZ.normalize;
var $b05eccd75d26bd5a$export$f2599a5cf1109d8 = $8QvoZ.exactEquals;
var $b05eccd75d26bd5a$export$e9bab7fafb253603 = $8QvoZ.equals;
var $b05eccd75d26bd5a$export$72d66f5842c00904 = function() {
    var tmpvec3 = $fwwPx.create();
    var xUnitVec3 = $fwwPx.fromValues(1, 0, 0);
    var yUnitVec3 = $fwwPx.fromValues(0, 1, 0);
    return function(out, a, b) {
        var dot = $fwwPx.dot(a, b);
        if (dot < -0.999999) {
            $fwwPx.cross(tmpvec3, xUnitVec3, a);
            if ($fwwPx.len(tmpvec3) < 0.000001) $fwwPx.cross(tmpvec3, yUnitVec3, a);
            $fwwPx.normalize(tmpvec3, tmpvec3);
            $b05eccd75d26bd5a$export$4286ddefc8f49512(out, tmpvec3, Math.PI);
            return out;
        } else if (dot > 0.999999) {
            out[0] = 0;
            out[1] = 0;
            out[2] = 0;
            out[3] = 1;
            return out;
        } else {
            $fwwPx.cross(tmpvec3, a, b);
            out[0] = tmpvec3[0];
            out[1] = tmpvec3[1];
            out[2] = tmpvec3[2];
            out[3] = 1 + dot;
            return $b05eccd75d26bd5a$export$a3295358bff77e(out, out);
        }
    };
}();
var $b05eccd75d26bd5a$export$699b0866ca50f6cb = function() {
    var temp1 = $b05eccd75d26bd5a$export$185802fd694ee1f5();
    var temp2 = $b05eccd75d26bd5a$export$185802fd694ee1f5();
    return function(out, a, b, c, d, t) {
        $b05eccd75d26bd5a$export$1544d9bc2995de08(temp1, a, d, t);
        $b05eccd75d26bd5a$export$1544d9bc2995de08(temp2, b, c, t);
        $b05eccd75d26bd5a$export$1544d9bc2995de08(out, temp1, temp2, 2 * t * (1 - t));
        return out;
    };
}();
var $b05eccd75d26bd5a$export$937ca0a544b2d712 = function() {
    var matr = $67rGA.create();
    return function(out, view, right, up) {
        matr[0] = right[0];
        matr[3] = right[1];
        matr[6] = right[2];
        matr[1] = up[0];
        matr[4] = up[1];
        matr[7] = up[2];
        matr[2] = -view[0];
        matr[5] = -view[1];
        matr[8] = -view[2];
        return $b05eccd75d26bd5a$export$a3295358bff77e(out, $b05eccd75d26bd5a$export$272a1eb8e5a4b55b(out, matr));
    };
}();

});

parcelRegister("89cfF", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $5ee8aaf15329a338$export$185802fd694ee1f5; });
$parcel$export(module.exports, "clone", function () { return $5ee8aaf15329a338$export$9cd59f9826255e47; });
$parcel$export(module.exports, "fromValues", function () { return $5ee8aaf15329a338$export$a82be99ed2a44a7d; });
$parcel$export(module.exports, "fromRotationTranslationValues", function () { return $5ee8aaf15329a338$export$31d4759777f5e259; });
$parcel$export(module.exports, "fromRotationTranslation", function () { return $5ee8aaf15329a338$export$9545ac307f2a256b; });
$parcel$export(module.exports, "fromTranslation", function () { return $5ee8aaf15329a338$export$bc9e79e74e9fddf6; });
$parcel$export(module.exports, "fromRotation", function () { return $5ee8aaf15329a338$export$926fc125ff3c666c; });
$parcel$export(module.exports, "fromMat4", function () { return $5ee8aaf15329a338$export$b4ad467060d346fe; });
$parcel$export(module.exports, "copy", function () { return $5ee8aaf15329a338$export$784d13d8ee351f07; });
$parcel$export(module.exports, "identity", function () { return $5ee8aaf15329a338$export$f0954fd7d5368655; });
$parcel$export(module.exports, "set", function () { return $5ee8aaf15329a338$export$adaa4cf7ef1b65be; });
$parcel$export(module.exports, "getReal", function () { return $5ee8aaf15329a338$export$850568f5e3cdb212; });
$parcel$export(module.exports, "getDual", function () { return $5ee8aaf15329a338$export$6b62e6fd886a6462; });
$parcel$export(module.exports, "setReal", function () { return $5ee8aaf15329a338$export$611329ee5753c868; });
$parcel$export(module.exports, "setDual", function () { return $5ee8aaf15329a338$export$c5d0e0cf08580c3f; });
$parcel$export(module.exports, "getTranslation", function () { return $5ee8aaf15329a338$export$202e99f82f7f0395; });
$parcel$export(module.exports, "translate", function () { return $5ee8aaf15329a338$export$d73ee8ef04f5226a; });
$parcel$export(module.exports, "rotateX", function () { return $5ee8aaf15329a338$export$a59c8716592e09af; });
$parcel$export(module.exports, "rotateY", function () { return $5ee8aaf15329a338$export$cf71e4d4ca4d1cfd; });
$parcel$export(module.exports, "rotateZ", function () { return $5ee8aaf15329a338$export$ea6eae3365de5b9c; });
$parcel$export(module.exports, "rotateByQuatAppend", function () { return $5ee8aaf15329a338$export$7da74d4771545cc5; });
$parcel$export(module.exports, "rotateByQuatPrepend", function () { return $5ee8aaf15329a338$export$82e307635ffa6e66; });
$parcel$export(module.exports, "rotateAroundAxis", function () { return $5ee8aaf15329a338$export$1b0030ab84d46e01; });
$parcel$export(module.exports, "add", function () { return $5ee8aaf15329a338$export$e16d8520af44a096; });
$parcel$export(module.exports, "multiply", function () { return $5ee8aaf15329a338$export$2060d2db72cce88f; });
$parcel$export(module.exports, "mul", function () { return $5ee8aaf15329a338$export$6e3a27864ab166fe; });
$parcel$export(module.exports, "scale", function () { return $5ee8aaf15329a338$export$dcdf75081b88279d; });
$parcel$export(module.exports, "dot", function () { return $5ee8aaf15329a338$export$94132a0e348806d4; });
$parcel$export(module.exports, "lerp", function () { return $5ee8aaf15329a338$export$3a89f8d6f6bf6c9f; });
$parcel$export(module.exports, "invert", function () { return $5ee8aaf15329a338$export$6897c284b6f9f4dc; });
$parcel$export(module.exports, "squaredLength", function () { return $5ee8aaf15329a338$export$ab44e1323ffc8376; });
$parcel$export(module.exports, "conjugate", function () { return $5ee8aaf15329a338$export$7679f47e72c62560; });
$parcel$export(module.exports, "length", function () { return $5ee8aaf15329a338$export$f24224f1c91d8156; });
$parcel$export(module.exports, "len", function () { return $5ee8aaf15329a338$export$fc1400facf92c78; });
$parcel$export(module.exports, "sqrLen", function () { return $5ee8aaf15329a338$export$99d8dd3f32a3435; });
$parcel$export(module.exports, "normalize", function () { return $5ee8aaf15329a338$export$a3295358bff77e; });
$parcel$export(module.exports, "str", function () { return $5ee8aaf15329a338$export$42d51816ce590c93; });
$parcel$export(module.exports, "exactEquals", function () { return $5ee8aaf15329a338$export$f2599a5cf1109d8; });
$parcel$export(module.exports, "equals", function () { return $5ee8aaf15329a338$export$e9bab7fafb253603; });

var $rqjzO = parcelRequire("rqjzO");

var $f8Ox0 = parcelRequire("f8Ox0");

var $c3mW8 = parcelRequire("c3mW8");
function $5ee8aaf15329a338$export$185802fd694ee1f5() {
    var dq = new $rqjzO.ARRAY_TYPE(8);
    if ($rqjzO.ARRAY_TYPE != Float32Array) {
        dq[0] = 0;
        dq[1] = 0;
        dq[2] = 0;
        dq[4] = 0;
        dq[5] = 0;
        dq[6] = 0;
        dq[7] = 0;
    }
    dq[3] = 1;
    return dq;
}
function $5ee8aaf15329a338$export$9cd59f9826255e47(a) {
    var dq = new $rqjzO.ARRAY_TYPE(8);
    dq[0] = a[0];
    dq[1] = a[1];
    dq[2] = a[2];
    dq[3] = a[3];
    dq[4] = a[4];
    dq[5] = a[5];
    dq[6] = a[6];
    dq[7] = a[7];
    return dq;
}
function $5ee8aaf15329a338$export$a82be99ed2a44a7d(x1, y1, z1, w1, x2, y2, z2, w2) {
    var dq = new $rqjzO.ARRAY_TYPE(8);
    dq[0] = x1;
    dq[1] = y1;
    dq[2] = z1;
    dq[3] = w1;
    dq[4] = x2;
    dq[5] = y2;
    dq[6] = z2;
    dq[7] = w2;
    return dq;
}
function $5ee8aaf15329a338$export$31d4759777f5e259(x1, y1, z1, w1, x2, y2, z2) {
    var dq = new $rqjzO.ARRAY_TYPE(8);
    dq[0] = x1;
    dq[1] = y1;
    dq[2] = z1;
    dq[3] = w1;
    var ax = x2 * 0.5, ay = y2 * 0.5, az = z2 * 0.5;
    dq[4] = ax * w1 + ay * z1 - az * y1;
    dq[5] = ay * w1 + az * x1 - ax * z1;
    dq[6] = az * w1 + ax * y1 - ay * x1;
    dq[7] = -ax * x1 - ay * y1 - az * z1;
    return dq;
}
function $5ee8aaf15329a338$export$9545ac307f2a256b(out, q, t) {
    var ax = t[0] * 0.5, ay = t[1] * 0.5, az = t[2] * 0.5, bx = q[0], by = q[1], bz = q[2], bw = q[3];
    out[0] = bx;
    out[1] = by;
    out[2] = bz;
    out[3] = bw;
    out[4] = ax * bw + ay * bz - az * by;
    out[5] = ay * bw + az * bx - ax * bz;
    out[6] = az * bw + ax * by - ay * bx;
    out[7] = -ax * bx - ay * by - az * bz;
    return out;
}
function $5ee8aaf15329a338$export$bc9e79e74e9fddf6(out, t) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = t[0] * 0.5;
    out[5] = t[1] * 0.5;
    out[6] = t[2] * 0.5;
    out[7] = 0;
    return out;
}
function $5ee8aaf15329a338$export$926fc125ff3c666c(out, q) {
    out[0] = q[0];
    out[1] = q[1];
    out[2] = q[2];
    out[3] = q[3];
    out[4] = 0;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    return out;
}
function $5ee8aaf15329a338$export$b4ad467060d346fe(out, a) {
    //TODO Optimize this
    var outer = $f8Ox0.create();
    $c3mW8.getRotation(outer, a);
    var t = new $rqjzO.ARRAY_TYPE(3);
    $c3mW8.getTranslation(t, a);
    $5ee8aaf15329a338$export$9545ac307f2a256b(out, outer, t);
    return out;
}
function $5ee8aaf15329a338$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    return out;
}
function $5ee8aaf15329a338$export$f0954fd7d5368655(out) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    return out;
}
function $5ee8aaf15329a338$export$adaa4cf7ef1b65be(out, x1, y1, z1, w1, x2, y2, z2, w2) {
    out[0] = x1;
    out[1] = y1;
    out[2] = z1;
    out[3] = w1;
    out[4] = x2;
    out[5] = y2;
    out[6] = z2;
    out[7] = w2;
    return out;
}
var $5ee8aaf15329a338$export$850568f5e3cdb212 = $f8Ox0.copy;
function $5ee8aaf15329a338$export$6b62e6fd886a6462(out, a) {
    out[0] = a[4];
    out[1] = a[5];
    out[2] = a[6];
    out[3] = a[7];
    return out;
}
var $5ee8aaf15329a338$export$611329ee5753c868 = $f8Ox0.copy;
function $5ee8aaf15329a338$export$c5d0e0cf08580c3f(out, q) {
    out[4] = q[0];
    out[5] = q[1];
    out[6] = q[2];
    out[7] = q[3];
    return out;
}
function $5ee8aaf15329a338$export$202e99f82f7f0395(out, a) {
    var ax = a[4], ay = a[5], az = a[6], aw = a[7], bx = -a[0], by = -a[1], bz = -a[2], bw = a[3];
    out[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
    out[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
    out[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
    return out;
}
function $5ee8aaf15329a338$export$d73ee8ef04f5226a(out, a, v) {
    var ax1 = a[0], ay1 = a[1], az1 = a[2], aw1 = a[3], bx1 = v[0] * 0.5, by1 = v[1] * 0.5, bz1 = v[2] * 0.5, ax2 = a[4], ay2 = a[5], az2 = a[6], aw2 = a[7];
    out[0] = ax1;
    out[1] = ay1;
    out[2] = az1;
    out[3] = aw1;
    out[4] = aw1 * bx1 + ay1 * bz1 - az1 * by1 + ax2;
    out[5] = aw1 * by1 + az1 * bx1 - ax1 * bz1 + ay2;
    out[6] = aw1 * bz1 + ax1 * by1 - ay1 * bx1 + az2;
    out[7] = -ax1 * bx1 - ay1 * by1 - az1 * bz1 + aw2;
    return out;
}
function $5ee8aaf15329a338$export$a59c8716592e09af(out, a, rad) {
    var bx = -a[0], by = -a[1], bz = -a[2], bw = a[3], ax = a[4], ay = a[5], az = a[6], aw = a[7], ax1 = ax * bw + aw * bx + ay * bz - az * by, ay1 = ay * bw + aw * by + az * bx - ax * bz, az1 = az * bw + aw * bz + ax * by - ay * bx, aw1 = aw * bw - ax * bx - ay * by - az * bz;
    $f8Ox0.rotateX(out, a, rad);
    bx = out[0];
    by = out[1];
    bz = out[2];
    bw = out[3];
    out[4] = ax1 * bw + aw1 * bx + ay1 * bz - az1 * by;
    out[5] = ay1 * bw + aw1 * by + az1 * bx - ax1 * bz;
    out[6] = az1 * bw + aw1 * bz + ax1 * by - ay1 * bx;
    out[7] = aw1 * bw - ax1 * bx - ay1 * by - az1 * bz;
    return out;
}
function $5ee8aaf15329a338$export$cf71e4d4ca4d1cfd(out, a, rad) {
    var bx = -a[0], by = -a[1], bz = -a[2], bw = a[3], ax = a[4], ay = a[5], az = a[6], aw = a[7], ax1 = ax * bw + aw * bx + ay * bz - az * by, ay1 = ay * bw + aw * by + az * bx - ax * bz, az1 = az * bw + aw * bz + ax * by - ay * bx, aw1 = aw * bw - ax * bx - ay * by - az * bz;
    $f8Ox0.rotateY(out, a, rad);
    bx = out[0];
    by = out[1];
    bz = out[2];
    bw = out[3];
    out[4] = ax1 * bw + aw1 * bx + ay1 * bz - az1 * by;
    out[5] = ay1 * bw + aw1 * by + az1 * bx - ax1 * bz;
    out[6] = az1 * bw + aw1 * bz + ax1 * by - ay1 * bx;
    out[7] = aw1 * bw - ax1 * bx - ay1 * by - az1 * bz;
    return out;
}
function $5ee8aaf15329a338$export$ea6eae3365de5b9c(out, a, rad) {
    var bx = -a[0], by = -a[1], bz = -a[2], bw = a[3], ax = a[4], ay = a[5], az = a[6], aw = a[7], ax1 = ax * bw + aw * bx + ay * bz - az * by, ay1 = ay * bw + aw * by + az * bx - ax * bz, az1 = az * bw + aw * bz + ax * by - ay * bx, aw1 = aw * bw - ax * bx - ay * by - az * bz;
    $f8Ox0.rotateZ(out, a, rad);
    bx = out[0];
    by = out[1];
    bz = out[2];
    bw = out[3];
    out[4] = ax1 * bw + aw1 * bx + ay1 * bz - az1 * by;
    out[5] = ay1 * bw + aw1 * by + az1 * bx - ax1 * bz;
    out[6] = az1 * bw + aw1 * bz + ax1 * by - ay1 * bx;
    out[7] = aw1 * bw - ax1 * bx - ay1 * by - az1 * bz;
    return out;
}
function $5ee8aaf15329a338$export$7da74d4771545cc5(out, a, q) {
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3], ax = a[0], ay = a[1], az = a[2], aw = a[3];
    out[0] = ax * qw + aw * qx + ay * qz - az * qy;
    out[1] = ay * qw + aw * qy + az * qx - ax * qz;
    out[2] = az * qw + aw * qz + ax * qy - ay * qx;
    out[3] = aw * qw - ax * qx - ay * qy - az * qz;
    ax = a[4];
    ay = a[5];
    az = a[6];
    aw = a[7];
    out[4] = ax * qw + aw * qx + ay * qz - az * qy;
    out[5] = ay * qw + aw * qy + az * qx - ax * qz;
    out[6] = az * qw + aw * qz + ax * qy - ay * qx;
    out[7] = aw * qw - ax * qx - ay * qy - az * qz;
    return out;
}
function $5ee8aaf15329a338$export$82e307635ffa6e66(out, q, a) {
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3], bx = a[0], by = a[1], bz = a[2], bw = a[3];
    out[0] = qx * bw + qw * bx + qy * bz - qz * by;
    out[1] = qy * bw + qw * by + qz * bx - qx * bz;
    out[2] = qz * bw + qw * bz + qx * by - qy * bx;
    out[3] = qw * bw - qx * bx - qy * by - qz * bz;
    bx = a[4];
    by = a[5];
    bz = a[6];
    bw = a[7];
    out[4] = qx * bw + qw * bx + qy * bz - qz * by;
    out[5] = qy * bw + qw * by + qz * bx - qx * bz;
    out[6] = qz * bw + qw * bz + qx * by - qy * bx;
    out[7] = qw * bw - qx * bx - qy * by - qz * bz;
    return out;
}
function $5ee8aaf15329a338$export$1b0030ab84d46e01(out, a, axis, rad) {
    //Special case for rad = 0
    if (Math.abs(rad) < $rqjzO.EPSILON) return $5ee8aaf15329a338$export$784d13d8ee351f07(out, a);
    var axisLength = Math.hypot(axis[0], axis[1], axis[2]);
    rad = rad * 0.5;
    var s = Math.sin(rad);
    var bx = s * axis[0] / axisLength;
    var by = s * axis[1] / axisLength;
    var bz = s * axis[2] / axisLength;
    var bw = Math.cos(rad);
    var ax1 = a[0], ay1 = a[1], az1 = a[2], aw1 = a[3];
    out[0] = ax1 * bw + aw1 * bx + ay1 * bz - az1 * by;
    out[1] = ay1 * bw + aw1 * by + az1 * bx - ax1 * bz;
    out[2] = az1 * bw + aw1 * bz + ax1 * by - ay1 * bx;
    out[3] = aw1 * bw - ax1 * bx - ay1 * by - az1 * bz;
    var ax = a[4], ay = a[5], az = a[6], aw = a[7];
    out[4] = ax * bw + aw * bx + ay * bz - az * by;
    out[5] = ay * bw + aw * by + az * bx - ax * bz;
    out[6] = az * bw + aw * bz + ax * by - ay * bx;
    out[7] = aw * bw - ax * bx - ay * by - az * bz;
    return out;
}
function $5ee8aaf15329a338$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    return out;
}
function $5ee8aaf15329a338$export$2060d2db72cce88f(out, a, b) {
    var ax0 = a[0], ay0 = a[1], az0 = a[2], aw0 = a[3], bx1 = b[4], by1 = b[5], bz1 = b[6], bw1 = b[7], ax1 = a[4], ay1 = a[5], az1 = a[6], aw1 = a[7], bx0 = b[0], by0 = b[1], bz0 = b[2], bw0 = b[3];
    out[0] = ax0 * bw0 + aw0 * bx0 + ay0 * bz0 - az0 * by0;
    out[1] = ay0 * bw0 + aw0 * by0 + az0 * bx0 - ax0 * bz0;
    out[2] = az0 * bw0 + aw0 * bz0 + ax0 * by0 - ay0 * bx0;
    out[3] = aw0 * bw0 - ax0 * bx0 - ay0 * by0 - az0 * bz0;
    out[4] = ax0 * bw1 + aw0 * bx1 + ay0 * bz1 - az0 * by1 + ax1 * bw0 + aw1 * bx0 + ay1 * bz0 - az1 * by0;
    out[5] = ay0 * bw1 + aw0 * by1 + az0 * bx1 - ax0 * bz1 + ay1 * bw0 + aw1 * by0 + az1 * bx0 - ax1 * bz0;
    out[6] = az0 * bw1 + aw0 * bz1 + ax0 * by1 - ay0 * bx1 + az1 * bw0 + aw1 * bz0 + ax1 * by0 - ay1 * bx0;
    out[7] = aw0 * bw1 - ax0 * bx1 - ay0 * by1 - az0 * bz1 + aw1 * bw0 - ax1 * bx0 - ay1 * by0 - az1 * bz0;
    return out;
}
var $5ee8aaf15329a338$export$6e3a27864ab166fe = $5ee8aaf15329a338$export$2060d2db72cce88f;
function $5ee8aaf15329a338$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    return out;
}
var $5ee8aaf15329a338$export$94132a0e348806d4 = $f8Ox0.dot;
function $5ee8aaf15329a338$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var mt = 1 - t;
    if ($5ee8aaf15329a338$export$94132a0e348806d4(a, b) < 0) t = -t;
    out[0] = a[0] * mt + b[0] * t;
    out[1] = a[1] * mt + b[1] * t;
    out[2] = a[2] * mt + b[2] * t;
    out[3] = a[3] * mt + b[3] * t;
    out[4] = a[4] * mt + b[4] * t;
    out[5] = a[5] * mt + b[5] * t;
    out[6] = a[6] * mt + b[6] * t;
    out[7] = a[7] * mt + b[7] * t;
    return out;
}
function $5ee8aaf15329a338$export$6897c284b6f9f4dc(out, a) {
    var sqlen = $5ee8aaf15329a338$export$ab44e1323ffc8376(a);
    out[0] = -a[0] / sqlen;
    out[1] = -a[1] / sqlen;
    out[2] = -a[2] / sqlen;
    out[3] = a[3] / sqlen;
    out[4] = -a[4] / sqlen;
    out[5] = -a[5] / sqlen;
    out[6] = -a[6] / sqlen;
    out[7] = a[7] / sqlen;
    return out;
}
function $5ee8aaf15329a338$export$7679f47e72c62560(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = a[3];
    out[4] = -a[4];
    out[5] = -a[5];
    out[6] = -a[6];
    out[7] = a[7];
    return out;
}
var $5ee8aaf15329a338$export$f24224f1c91d8156 = $f8Ox0.length;
var $5ee8aaf15329a338$export$fc1400facf92c78 = $5ee8aaf15329a338$export$f24224f1c91d8156;
var $5ee8aaf15329a338$export$ab44e1323ffc8376 = $f8Ox0.squaredLength;
var $5ee8aaf15329a338$export$99d8dd3f32a3435 = $5ee8aaf15329a338$export$ab44e1323ffc8376;
function $5ee8aaf15329a338$export$a3295358bff77e(out, a) {
    var magnitude = $5ee8aaf15329a338$export$ab44e1323ffc8376(a);
    if (magnitude > 0) {
        magnitude = Math.sqrt(magnitude);
        var a0 = a[0] / magnitude;
        var a1 = a[1] / magnitude;
        var a2 = a[2] / magnitude;
        var a3 = a[3] / magnitude;
        var b0 = a[4];
        var b1 = a[5];
        var b2 = a[6];
        var b3 = a[7];
        var a_dot_b = a0 * b0 + a1 * b1 + a2 * b2 + a3 * b3;
        out[0] = a0;
        out[1] = a1;
        out[2] = a2;
        out[3] = a3;
        out[4] = (b0 - a0 * a_dot_b) / magnitude;
        out[5] = (b1 - a1 * a_dot_b) / magnitude;
        out[6] = (b2 - a2 * a_dot_b) / magnitude;
        out[7] = (b3 - a3 * a_dot_b) / magnitude;
    }
    return out;
}
function $5ee8aaf15329a338$export$42d51816ce590c93(a) {
    return "quat2(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ")";
}
function $5ee8aaf15329a338$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7];
}
function $5ee8aaf15329a338$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7];
    return Math.abs(a0 - b0) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $rqjzO.EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7));
}

});





parcelRequire("96HUf");

//# sourceMappingURL=index.e9cecaf3.js.map
